import { F as z, c as o, Q as i, f as e, a as mt, b as k, B as j, p as ut, d as U, e as X } from "./index-d0ae5922.js";
import { f as t } from "./creditFigmaToken-9b4c3a39.js";
import { F as N } from "./index-e6249aa0.js";
import { F as Y } from "./index-e9bdff4d.js";
import { Sizes as gt } from "@ucl/shared-icons";
const _ = (a) => !!(a && typeof a == "object" && !Array.isArray(a)), H = (a, c) => {
  const m = { ...a };
  return Object.entries(c).forEach(([w, v]) => {
    _(m[w]) && _(v) ? m[w] = Object.keys(v).length > 0 ? H(m[w], v) : {} : _(v) ? m[w] = H({}, v) : m[w] = v;
  }), m;
};
function Tw(a, c, m) {
  return typeof c == "string" ? { [`@container ${c} ${a}`]: m } : { [`@container ${a}`]: c };
}
const Ww = (a, c) => ({ [`@media ${a}`]: c });
function p(a, c, m) {
  return typeof c == "string" ? {
    [`@media ${a}`]: m,
    [`@container ${c} ${a}`]: m
    /* Container Query */
  } : {
    [`@media ${a}`]: c,
    [`@container ${a}`]: c
    /* Container Query */
  };
}
const xt = z, ht = {
  height: o("btnSize", o("btnHeight", "auto")),
  width: o("btnSize", o("btnWidth", "auto")),
  padding: o("btnPadding", `7px ${t.primitive.space["5x"].value}`),
  ...t.semanticMode1.body2.bold.value,
  lineHeight: t.semanticMode1.lineHeights[10].value,
  // 24px -> Same as icon size
  "&--fullWidth": o({ btnWidth: "100%" }),
  [`@media ${i.mobile}`]: {
    "&--fullWidthMobile": {
      ...o({ btnWidth: "100%" }),
      maxWidth: "100%"
    }
  }
}, bt = {
  ...o({
    _btnBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnBgColor")}`,
    _btnHoverBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnHoverBgColor")}`,
    _btnTextColor: t.primitive.color.twilight["000"].value,
    _btnHoverTextColor: t.primitive.color.twilight["000"].value,
    _btnDisabledBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnDisabledBgColor")}`,
    _btnDisabledTextColor: t.semanticMode1.color.icon.onLight.subtleDisabled.value,
    _btnDisabledBgColor: t.semanticMode1.color.fill.onLight.disabled.value,
    _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus.value}`,
    _btnFocusOutlineOffset: t.primitive.border["2x"].value
  }),
  "&.Button": {
    "&--default, &--onColor": o({
      _btnBgColor: t.semanticMode1.color.fill.onDark.strongest.value,
      _btnHoverBgColor: t.semanticMode1.color.fill.onDark.strong.value,
      _btnTextColor: t.semanticMode1.color.text.onLight.strong.value,
      _btnHoverTextColor: t.semanticMode1.color.text.onLight.strong.value,
      _btnDisabledTextColor: t.semanticMode1.color.text.onDark.subtlestDisabled.value,
      _btnDisabledBgColor: t.semanticMode1.color.fill.onDark.disabled.value,
      _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onDark.strong.value}`
    }),
    "&--success": o({
      _btnBgColor: t.semanticMode1.color.fill.onDark.successStrong.value,
      _btnHoverBgColor: t.primitive.color.green[1200].value
    }),
    "&--caution": o({
      _btnBgColor: t.semanticMode1.color.fill.onDark.cautionStrong.value,
      _btnHoverBgColor: t.primitive.color.amber[1200].value
    }),
    "&--danger": o({
      _btnBgColor: t.semanticMode1.color.fill.onDark.dangerStrong.value,
      _btnHoverBgColor: t.primitive.color.red[1200].value
    }),
    "&--black": o({
      _btnBgColor: t.semanticMode1.color.fill.onDark.interactive.value,
      _btnHoverBgColor: t.semanticMode1.color.fill.onDark.interactiveHover.value
    })
  }
}, ft = {
  ...o({
    _btnBgColor: "transparent",
    _btnHoverBgColor: "transparent",
    _btnBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnTextColor")}`,
    _btnHoverBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnHoverTextColor")}`,
    _btnDisabledBgColor: "transparent",
    _btnDisabledBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnDisabledTextColor")}`,
    _btnDisabledTextColor: t.semanticMode1.color.icon.onLight.subtleDisabled.value,
    _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus.value}`,
    _btnFocusOutlineOffset: t.primitive.border["2x"].value
  }),
  "&.Button": {
    "&--default, &--onColor": o({
      _btnTextColor: t.primitive.color.twilight[300].value,
      _btnHoverTextColor: t.primitive.color.twilight["000"].value,
      _btnDisabledTextColor: t.semanticMode1.color.text.onDark.subtlestDisabled.value,
      _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onDark.strong.value}`
    }),
    "&--success": o({
      _btnTextColor: t.semanticMode1.color.text.onDark.success.value,
      _btnHoverTextColor: t.primitive.color.green[1200].value
    }),
    "&--caution": o({
      _btnTextColor: t.semanticMode1.color.text.onDark.caution.value,
      _btnHoverTextColor: t.primitive.color.amber[1200].value
    }),
    "&--danger": o({
      _btnTextColor: t.semanticMode1.color.text.onDark.danger.value,
      _btnHoverTextColor: t.primitive.color.red[1200].value
    }),
    "&--black": o({
      _btnTextColor: t.semanticMode1.color.stroke.onDark.interactive.value,
      _btnHoverTextColor: t.semanticMode1.color.stroke.onDark.interactiveHover.value
    })
  }
}, vt = {
  ...o({
    _btnBgColor: "transparent",
    _btnHoverBgColor: "transparent",
    _btnBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnBgColor")}`,
    _btnHoverBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnHoverBgColor")}`,
    _btnDisabledBgColor: "transparent",
    _btnDisabledBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnDisabledBgColor")}`,
    _btnDisabledTextColor: t.semanticMode1.color.text.onLight.subtlestDisabled.value,
    _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus.value}`,
    _btnFocusOutlineOffset: t.primitive.border["2x"].value
  }),
  "&.Button": {
    "&--default, &--onColor": o({
      _btnTextColor: t.primitive.color.twilight[300].value,
      _btnHoverTextColor: t.primitive.color.twilight["000"].value,
      _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onDark.strong.value}`,
      _btnDisabledTextColor: t.semanticMode1.color.text.onDark.subtlestDisabled.value
    }),
    "&--success": o({
      _btnTextColor: t.semanticMode1.color.fill.onDark.successStrong.value,
      _btnHoverTextColor: t.primitive.color.green[1200].value
    }),
    "&--caution": o({
      _btnTextColor: t.semanticMode1.color.fill.onDark.cautionStrong.value,
      _btnHoverTextColor: t.primitive.color.amber[1200].value
    }),
    "&--danger": o({
      _btnTextColor: t.semanticMode1.color.fill.onDark.dangerStrong.value,
      _btnHoverTextColor: t.primitive.color.red[1200].value
    }),
    "&--black": o({
      _btnTextColor: t.semanticMode1.color.stroke.onDark.interactive.value,
      _btnHoverTextColor: t.semanticMode1.color.stroke.onDark.interactiveHover.value
    })
  }
}, yt = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  verticalAlign: "middle",
  textDecoration: "none",
  cursor: "pointer",
  overflow: "hidden",
  flexShrink: 0,
  gap: o("btnGap", t.primitive.space["2x"].value),
  borderRadius: o("btnBorderRadius", t.primitive.radius.full.value),
  ...ht,
  "&--underlined": {
    textDecoration: "underline"
  },
  "&--primary": bt,
  "&--secondary": ft,
  "&--tertiary, &--text": vt,
  color: o.fallback("_btnTextColor"),
  border: o.fallback("_btnBorder"),
  backgroundColor: o.fallback("_btnBgColor"),
  "&:hover, &:active, &--active": {
    color: o.fallback("_btnHoverTextColor"),
    border: o.fallback("_btnHoverBorder"),
    backgroundColor: o.fallback("_btnHoverBgColor")
  },
  "&:focus-visible": {
    outline: o.fallback("_btnFocusOutline"),
    outlineOffset: o.fallback("_btnFocusOutlineOffset")
  },
  "&--disabled, &:disabled": {
    color: o.fallback("_btnDisabledTextColor"),
    border: o.fallback("_btnDisabledBorder"),
    backgroundColor: o.fallback("_btnDisabledBgColor"),
    pointerEvents: "none"
  }
}, Ct = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  ...o({ _btnIconSize: t.primitive.space["5x"].value }),
  height: o.fallback("_btnIconSize"),
  width: o.fallback("_btnIconSize")
}, $t = {
  Button: yt,
  IconWrapper: Ct
}, wt = {
  height: o("btnSize", o("btnHeight", "auto")),
  width: o("btnSize", o("btnWidth", "fit-content")),
  padding: o.fallback("_btnPadding"),
  maxWidth: "100%",
  "&--fullWidth": o({ btnWidth: "100%" }),
  [`@media ${i.mobile}`]: {
    "&--fullWidthMobile": {
      ...o({ btnWidth: "100%" }),
      maxWidth: "100%"
    }
  },
  "&--small": {
    ...o({
      _btnPadding: `${e.semantic.space["1x"]} ${e.semantic.space["4x"]}`
    }),
    ...e.semantic.typography.body.medium.S
  },
  "&--medium": {
    ...o({
      _btnPadding: `6px ${e.semantic.space["6x"]}`
    }),
    ...e.semantic.typography.body.medium.M
  },
  "&--large": {
    ...o({
      _btnPadding: `${e.semantic.space["2x"]} ${e.semantic.space["8x"]}`
    }),
    ...e.semantic.typography.body.medium.L
  }
}, kt = {
  ...o({
    _btnBorder: `${e.semantic.borderWidth["2x"]} solid ${o.fallback("_btnBgColor")}`,
    _btnHoverBorder: `${e.semantic.borderWidth["2x"]} solid ${o.fallback("_btnHoverBgColor")}`,
    _btnTextColor: e.semantic.color.text.onColor,
    _btnHoverTextColor: e.semantic.color.text.onColor,
    _btnDisabledBorder: `${e.semantic.borderWidth["2x"]} solid ${o.fallback("_btnDisabledBgColor")}`,
    _btnDisabledTextColor: e.semantic.color.text.onColor,
    _btnDisabledBgColor: e.semantic.color.text.disabled,
    _btnFocusOutline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.fill.primaryStrong}`,
    _btnFocusOutlineOffset: e.semantic.borderWidth["2x"]
  }),
  "&.Button": {
    "&--default, &--success, &--caution, &--black": o({
      _btnBgColor: e.semantic.color.fill.primaryStrong,
      _btnHoverBgColor: e.semantic.color.action.hover
    }),
    "&--danger": o({
      _btnBgColor: e.semantic.color.fill.dangerStrong,
      _btnHoverBgColor: e.semantic.color.action.dangerHover
    }),
    "&--onColor": o({
      _btnBgColor: e.semantic.color.fill.default,
      _btnHoverBgColor: e.semantic.color.fill.neutralSubtle,
      _btnTextColor: e.primitive.color.neutral[1e3],
      _btnHoverTextColor: e.primitive.color.neutral[1e3],
      _btnDisabledTextColor: e.primitive.color.neutral[400],
      _btnDisabledBgColor: e.primitive.color.neutral[600]
    })
  }
}, St = {
  ...o({
    _btnBgColor: "transparent",
    _btnHoverBgColor: "transparent",
    _btnBorder: `${e.semantic.borderWidth["2x"]} solid ${o.fallback("_btnTextColor")}`,
    _btnHoverBorder: `${e.semantic.borderWidth["2x"]} solid ${o.fallback("_btnHoverTextColor")}`,
    _btnDisabledBgColor: "transparent",
    _btnDisabledBorder: `${e.semantic.borderWidth["2x"]} solid ${o.fallback("_btnDisabledTextColor")}`,
    _btnDisabledTextColor: e.semantic.color.text.disabled,
    _btnFocusOutline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.fill.primaryStrong}`,
    _btnFocusOutlineOffset: e.semantic.borderWidth["2x"]
  }),
  "&.Button": {
    "&--default, &--success, &--caution, &--black": o({
      _btnTextColor: e.semantic.color.text.primaryStrong,
      _btnHoverTextColor: e.semantic.color.icon.primary,
      _btnHoverBgColor: e.primitive.color.skyview[100]
    }),
    "&--danger": o({
      _btnTextColor: e.semantic.color.text.dangerStrong,
      _btnHoverTextColor: e.semantic.color.text.dangerStrong,
      _btnHoverBgColor: e.semantic.color.action.dangerHoverSubtle
    }),
    "&--onColor": o({
      _btnTextColor: e.semantic.color.text.onColor,
      _btnHoverTextColor: e.semantic.color.text.onColor,
      _btnHoverBgColor: e.semantic.color.opacity.surface.default[20],
      _btnDisabledTextColor: e.primitive.color.neutral[600]
    })
  }
}, Z = {
  ...o({
    _btnBgColor: "transparent",
    _btnHoverBgColor: "transparent",
    _btnBorder: `${e.semantic.borderWidth["2x"]} solid ${o.fallback("_btnBgColor")}`,
    _btnHoverBorder: `${e.semantic.borderWidth["2x"]} solid ${o.fallback("_btnHoverBgColor")}`,
    _btnDisabledBgColor: "transparent",
    _btnDisabledBorder: `${e.semantic.borderWidth["2x"]} solid ${o.fallback("_btnDisabledBgColor")}`,
    _btnDisabledTextColor: e.semantic.color.text.disabled,
    _btnFocusOutline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.fill.primaryStrong}`,
    _btnFocusOutlineOffset: e.semantic.borderWidth["2x"]
  }),
  "&.Button": {
    "&--default, &--success, &--caution, &--black": o({
      _btnTextColor: e.semantic.color.text.primaryStrong,
      _btnHoverTextColor: e.semantic.color.icon.primary,
      _btnHoverBgColor: e.primitive.color.skyview[100]
    }),
    "&--danger": o({
      _btnTextColor: e.semantic.color.text.dangerStrong,
      _btnHoverTextColor: e.semantic.color.text.dangerStrong,
      _btnHoverBgColor: e.semantic.color.action.dangerHoverSubtle
    }),
    "&--onColor": o({
      _btnTextColor: e.semantic.color.text.onColor,
      _btnHoverTextColor: e.semantic.color.text.onColor,
      _btnHoverBgColor: e.semantic.color.fill.neutralModerate,
      _btnDisabledBgColor: e.semantic.color.fill.neutralModerate
    })
  }
}, Bt = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  verticalAlign: "middle",
  textDecoration: "none",
  cursor: "pointer",
  overflow: "hidden",
  gap: o("btnGap", e.semantic.space["2x"]),
  borderRadius: o("btnBorderRadius", e.semantic.radius["2x"]),
  ...wt,
  "&--underlined": {
    textDecoration: "underline"
  },
  "&--primary": kt,
  "&--secondary": St,
  "&--tertiary, &--text": Z,
  color: o.fallback("_btnTextColor"),
  border: o.fallback("_btnBorder"),
  backgroundColor: o.fallback("_btnBgColor"),
  "&:hover, &:active, &--active": {
    color: o.fallback("_btnHoverTextColor"),
    border: o.fallback("_btnHoverBorder"),
    backgroundColor: o.fallback("_btnHoverBgColor")
  },
  "&:focus-visible": {
    outline: o.fallback("_btnFocusOutline"),
    outlineOffset: o.fallback("_btnFocusOutlineOffset")
  },
  "&--disabled, &:disabled": {
    color: o.fallback("_btnDisabledTextColor"),
    border: o.fallback("_btnDisabledBorder"),
    backgroundColor: o.fallback("_btnDisabledBgColor"),
    pointerEvents: "none"
  }
}, Tt = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  ...o({ _btnIconSize: e.semantic.size["5x"] }),
  // 20px
  height: o.fallback("_btnIconSize"),
  width: o.fallback("_btnIconSize"),
  "&--small": o({ _btnIconSize: e.semantic.size["4x"] })
  // 16px
}, K = {
  Button: Bt,
  IconWrapper: Tt
}, Wt = K, Lt = {
  height: o("btnSize", o("btnHeight", "auto")),
  width: o("btnSize", o("btnWidth", "auto")),
  padding: o("btnPadding", `7px ${t.primitive.space["5x"].value}`),
  ...t.semanticMode1.body2.bold.value,
  lineHeight: t.semanticMode1.lineHeights[10].value,
  // 24px -> Same as icon size
  "&--fullWidth": o({ btnWidth: "100%" }),
  [`@media ${i.mobile}`]: {
    "&--fullWidthMobile": {
      ...o({ btnWidth: "100%" }),
      maxWidth: "100%"
    }
  }
}, _t = {
  ...o({
    _btnBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnBgColor")}`,
    _btnHoverBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnHoverBgColor")}`,
    _btnTextColor: t.primitive.color.twilight["000"].value,
    _btnHoverTextColor: t.primitive.color.twilight["000"].value,
    _btnDisabledBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnDisabledBgColor")}`,
    _btnDisabledTextColor: t.semanticMode1.color.icon.onLight.subtleDisabled.value,
    _btnDisabledBgColor: t.semanticMode1.color.fill.onLight.disabled.value,
    _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus.value}`,
    _btnFocusOutlineOffset: t.primitive.border["2x"].value
  }),
  "&.Button": {
    "&--default": o({
      _btnBgColor: t.semanticMode1.color.fill.onLight.interactive.value,
      _btnHoverBgColor: t.semanticMode1.color.fill.onLight.interactiveHover.value
    }),
    "&--success": o({
      _btnBgColor: t.semanticMode1.color.fill.onLight.successStrong.value,
      _btnHoverBgColor: t.primitive.color.green[1200].value
    }),
    "&--caution": o({
      _btnBgColor: t.semanticMode1.color.fill.onLight.cautionStrong.value,
      _btnHoverBgColor: t.primitive.color.amber[1200].value
    }),
    "&--danger": o({
      _btnBgColor: t.semanticMode1.color.fill.onLight.dangerStrong.value,
      _btnHoverBgColor: t.primitive.color.red[1200].value
    }),
    "&--black": o({
      _btnBgColor: t.semanticMode1.color.fill.onLight.strongest.value,
      _btnHoverBgColor: t.semanticMode1.color.text.onLight.moderateDefault.value
    }),
    "&--onColor": o({
      _btnBgColor: t.semanticMode1.color.fill.onDark.strongest.value,
      _btnHoverBgColor: t.semanticMode1.color.fill.onDark.strong.value,
      _btnTextColor: t.semanticMode1.color.text.onLight.strong.value,
      _btnHoverTextColor: t.semanticMode1.color.text.onLight.strong.value,
      _btnDisabledTextColor: t.semanticMode1.color.text.onDark.subtlestDisabled.value,
      _btnDisabledBgColor: t.semanticMode1.color.fill.onDark.disabled.value,
      _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onDark.strong.value}`
    })
  }
}, It = {
  ...o({
    _btnBgColor: "transparent",
    _btnHoverBgColor: "transparent",
    _btnBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnTextColor")}`,
    _btnHoverBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnHoverTextColor")}`,
    _btnDisabledBgColor: "transparent",
    _btnDisabledBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnDisabledTextColor")}`,
    _btnDisabledTextColor: t.semanticMode1.color.icon.onLight.subtleDisabled.value,
    _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus.value}`,
    _btnFocusOutlineOffset: t.primitive.border["2x"].value
  }),
  "&.Button": {
    "&--default": o({
      _btnTextColor: t.semanticMode1.color.stroke.onLight.interactive.value,
      _btnHoverTextColor: t.semanticMode1.color.stroke.onLight.interactiveHover.value
    }),
    "&--success": o({
      _btnTextColor: t.semanticMode1.color.fill.onLight.successStrong.value,
      _btnHoverTextColor: t.primitive.color.green[1200].value
    }),
    "&--caution": o({
      _btnTextColor: t.semanticMode1.color.fill.onLight.cautionStrong.value,
      _btnHoverTextColor: t.primitive.color.amber[1200].value
    }),
    "&--danger": o({
      _btnTextColor: t.semanticMode1.color.fill.onLight.dangerStrong.value,
      _btnHoverTextColor: t.primitive.color.red[1200].value
    }),
    "&--black": o({
      _btnTextColor: t.semanticMode1.color.fill.onLight.strongest.value,
      _btnHoverTextColor: t.semanticMode1.color.text.onLight.moderateDefault.value
    }),
    "&--onColor": o({
      _btnTextColor: t.primitive.color.twilight[300].value,
      _btnHoverTextColor: t.primitive.color.twilight["000"].value,
      _btnDisabledTextColor: t.semanticMode1.color.text.onDark.subtlestDisabled.value,
      _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onDark.strong.value}`
    })
  }
}, Q = {
  ...o({
    _btnBgColor: "transparent",
    _btnHoverBgColor: "transparent",
    _btnBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnBgColor")}`,
    _btnHoverBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnHoverBgColor")}`,
    _btnDisabledBgColor: "transparent",
    _btnDisabledBorder: `${t.primitive.border["1x"].value} solid ${o.fallback("_btnDisabledBgColor")}`,
    _btnDisabledTextColor: t.semanticMode1.color.text.onLight.subtlestDisabled.value,
    _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus.value}`,
    _btnFocusOutlineOffset: t.primitive.border["2x"].value
  }),
  "&.Button": {
    "&--default": o({
      _btnTextColor: t.semanticMode1.color.stroke.onLight.interactive.value,
      _btnHoverTextColor: t.semanticMode1.color.stroke.onLight.interactiveHover.value
    }),
    "&--success": o({
      _btnTextColor: t.semanticMode1.color.fill.onLight.successStrong.value,
      _btnHoverTextColor: t.primitive.color.green[1200].value
    }),
    "&--caution": o({
      _btnTextColor: t.semanticMode1.color.fill.onLight.cautionStrong.value,
      _btnHoverTextColor: t.primitive.color.amber[1200].value
    }),
    "&--danger": o({
      _btnTextColor: t.semanticMode1.color.fill.onLight.dangerStrong.value,
      _btnHoverTextColor: t.primitive.color.red[1200].value
    }),
    "&--black": o({
      _btnTextColor: t.semanticMode1.color.fill.onLight.strongest.value,
      _btnHoverTextColor: t.semanticMode1.color.text.onLight.moderateDefault.value
    }),
    "&--onColor": o({
      _btnTextColor: t.primitive.color.twilight[300].value,
      _btnHoverTextColor: t.primitive.color.twilight["000"].value,
      _btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onDark.strong.value}`,
      _btnDisabledTextColor: t.semanticMode1.color.text.onDark.subtlestDisabled.value
    })
  }
}, Mt = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  verticalAlign: "middle",
  textDecoration: "none",
  cursor: "pointer",
  overflow: "hidden",
  gap: o("btnGap", t.primitive.space["2x"].value),
  borderRadius: o("btnBorderRadius", t.primitive.radius.full.value),
  ...Lt,
  "&--underlined": {
    textDecoration: "underline"
  },
  "&--primary": _t,
  "&--secondary": It,
  "&--tertiary, &--text": Q,
  color: o.fallback("_btnTextColor"),
  border: o.fallback("_btnBorder"),
  backgroundColor: o.fallback("_btnBgColor"),
  "&:hover, &:active, &--active": {
    color: o.fallback("_btnHoverTextColor"),
    border: o.fallback("_btnHoverBorder"),
    backgroundColor: o.fallback("_btnHoverBgColor")
  },
  "&:focus-visible": {
    outline: o.fallback("_btnFocusOutline"),
    outlineOffset: o.fallback("_btnFocusOutlineOffset")
  },
  "&--disabled, &:disabled": {
    color: o.fallback("_btnDisabledTextColor"),
    border: o.fallback("_btnDisabledBorder"),
    backgroundColor: o.fallback("_btnDisabledBgColor"),
    pointerEvents: "none"
  }
}, Dt = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  ...o({ _btnIconSize: t.primitive.space["5x"].value }),
  // 24px
  height: o.fallback("_btnIconSize"),
  width: o.fallback("_btnIconSize")
}, Ht = {
  Button: Mt,
  IconWrapper: Dt
}, Rt = {
  width: "100%",
  flex: 1,
  display: "flex",
  flexWrap: "wrap",
  gap: "1.5rem",
  [`@media ${i.mobile}`]: {
    flexDirection: "column"
  }
}, zt = {
  width: "100%",
  minWidth: "232px",
  flex: "1",
  containerType: "inline-size",
  containerName: "Card",
  [`@media ${i.tabletAndUp}`]: {
    minWidth: "290px"
  }
}, At = {
  display: "flex",
  overflow: "hidden",
  boxSizing: "border-box",
  width: "100%",
  borderRadius: t.semanticMode1.radius.md.value,
  flexDirection: "row",
  "&--full-height": { height: "100%" },
  "&--align-footer .Card__body": { flex: "auto" },
  "&--vertical": { flexDirection: "column" },
  "&--horizontal&": { flexDirection: "row" },
  "&--default": {
    border: `${t.primitive.border["1x"].value} solid ${t.primitive.color.neutral[400].value}`,
    backgroundColor: t.primitive.color.neutral["000"].value
  },
  "&--ghost&": {
    border: "none",
    backgroundColor: "transparent",
    overflow: "clip",
    overflowClipMargin: t.semanticMode1.space.sm.value,
    gap: t.semanticMode1.space["2xl"].value,
    // 32px,
    "&--vertical": { gap: t.semanticMode1.space.xl.value }
    // 24px
  },
  "&--defaultGray": {
    backgroundColor: t.semanticMode1.color.fill.onLight.subtlest.value,
    border: "none"
  }
}, Ft = {
  height: "auto",
  width: "100%",
  position: "relative",
  overflow: "hidden",
  maxHeight: "100%",
  minHeight: "auto",
  "&--ghost": { borderRadius: t.semanticMode1.radius.md.value },
  ".Hero__overlay": { display: "none" }
}, Pt = {
  "--card-content-gap": t.semanticMode1.space.md.value,
  // 24px
  width: "100%",
  boxSizing: "border-box",
  padding: t.semanticMode1.space["2xl"].value,
  // 32px
  display: "flex",
  flexDirection: "column",
  flex: "auto",
  gap: "var(--card-content-gap)",
  "&--ghost&": {
    padding: 0,
    "&--horizontal&": {
      paddingBottom: t.semanticMode1.space.xs.value,
      paddingTop: t.semanticMode1.space["2xl"].value
    }
  },
  ".Card__TagGroup": { marginBottom: "var(--card-content-gap)" },
  "&:empty": { display: "none" },
  "&--align-footer .Card__body": { flex: "auto" }
}, Ot = {
  margin: 0,
  ...t.semanticMode1.headline2.regular.large.value,
  "&--extraLarge": {
    ...t.semanticMode1.headline2.regular.large.value,
    [`@container Card ${i.mobile}`]: t.semanticMode1.headline2.regular.small.value
  },
  "&--large": {
    ...t.semanticMode1.headline3.regular.large.value,
    [`@container Card ${i.mobile}`]: t.semanticMode1.headline3.regular.small.value
  },
  "&--medium": t.semanticMode1.title.medium.value,
  "&:empty": { display: "none" }
}, Et = {
  margin: 0,
  ...t.semanticMode1.subtitle.regular.value,
  color: t.primitive.color.neutral[900].value,
  "&:empty": { display: "none" }
}, Vt = {
  ...t.semanticMode1.body1.regular.value,
  "&:empty": { display: "none" }
}, Gt = {
  display: "flex",
  flexWrap: "wrap",
  gap: t.primitive.space["3x"].value,
  marginTop: "var(--card-content-gap)",
  "&:empty": { display: "none" },
  /* Ensures that the 12px gap between adjacent footers is maintained by removing the default margin. */
  "&:not(:empty) + &": { marginTop: "calc(-1 * var(--card-content-gap) / 2 )" }
}, b = {
  CardGroupContainer: Rt,
  Container: zt,
  Card: At,
  Media: Ft,
  Content: Pt,
  Title: Ot,
  Subtitle: Et,
  Body: Vt,
  Footer: Gt
}, jt = {
  ...b.Card,
  border: "none",
  backgroundColor: t.primitive.color.twilight[900].value,
  "&--default": {
    border: "none",
    backgroundColor: t.primitive.color.twilight[900].value
  },
  "&--ghost&": {},
  "&--defaultGray": {}
  /* Ensures deleting defaultGray styles from  FordCreditLightCard.Card*/
}, Ut = {
  ...b.Media,
  "&--ghost": {}
}, Xt = {
  ...b.Content,
  "&--ghost&": {}
  /* Ensures deleting ghost styles from  FordCreditLightCard.Card*/
}, Nt = H(b.Title, {
  "&--extraLarge": {
    color: t.primitive.color.neutral[100].value,
    [`@container Card ${i.mobile}`]: {
      color: t.primitive.color.neutral[100].value
    }
  },
  "&--large": {
    color: t.primitive.color.neutral[100].value,
    [`@container Card ${i.mobile}`]: {
      color: t.primitive.color.neutral[100].value
    }
  },
  "&--medium": {
    color: t.primitive.color.neutral[100].value
  }
}), Yt = {
  ...b.Subtitle,
  color: t.primitive.color.neutral[100].value
}, Zt = {
  ...b.Body,
  color: t.primitive.color.neutral[100].value
}, Kt = {
  ...b,
  Card: jt,
  Media: Ut,
  Content: Xt,
  Title: Nt,
  Subtitle: Yt,
  Body: Zt
}, Qt = {
  width: "100%",
  flex: 1,
  display: "flex",
  flexWrap: "wrap",
  gap: "1.5rem",
  [`@media ${i.mobile}`]: {
    flexDirection: "column"
  }
}, qt = {
  width: "100%",
  minWidth: "232px",
  flex: "1",
  containerType: "inline-size",
  containerName: "Card"
}, Jt = {
  display: "flex",
  overflow: "hidden",
  boxSizing: "border-box",
  flexDirection: "column",
  width: "100%",
  color: e.semantic.color.text.subtle,
  borderRadius: e.semantic.radius["2x"],
  "&--full-height": { height: "100%" },
  "&--align-footer .Card__body": { flex: "auto" },
  "&--vertical": { flexDirection: "column" },
  "&--horizontal": { flexDirection: "row" },
  "&--default, &--defaultGray": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
    boxShadow: `0px ${e.semantic.borderWidth["2x"]} ${e.semantic.borderWidth["8x"]} 0px rgba(0, 0, 0, 0.1)`,
    backgroundColor: e.semantic.color.fill.default
  },
  "&--ghost&": {
    border: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
    overflow: "clip",
    overflowClipMargin: e.semantic.space["2x"],
    "&--vertical": { gap: e.semantic.space["4x"] },
    "&--horizontal": { gap: e.semantic.space["10x"] }
  }
}, eo = {
  height: "auto",
  width: "100%",
  position: "relative",
  overflow: "hidden",
  maxHeight: "100%",
  minHeight: "auto",
  "&--ghost": {
    height: "fit-content",
    borderRadius: e.semantic.radius["2x"]
  },
  ".Hero__overlay": { display: "none" }
}, to = {
  "--card-content-gap": e.semantic.space["3x"],
  // 12px
  width: "100%",
  boxSizing: "border-box",
  color: e.semantic.color.text.subtle,
  display: "flex",
  flexDirection: "column",
  flex: "auto",
  gap: "var(--card-content-gap)",
  "&--horizontal": {
    paddingInline: e.semantic.space["10x"],
    paddingBlock: e.semantic.space["12x"]
  },
  "&--vertical": { padding: e.semantic.space["8x"] },
  "&--ghost&": {
    "&--horizontal": { padding: 0 },
    "&--vertical": { padding: 0 }
  },
  "&:empty": { display: "none" }
}, oo = {
  margin: 0,
  color: e.semantic.color.text.default,
  ...e.semantic.typography.headline.XL,
  "&--extraLarge": e.semantic.typography.headline.XL,
  "&--large": e.semantic.typography.headline.L,
  "&--medium": e.semantic.typography.headline.M,
  "&:empty": { display: "none" }
}, io = {
  margin: 0,
  ...e.semantic.typography.body.semiBold.M,
  color: e.semantic.color.text.subtle,
  "&:empty": { display: "none" }
}, ro = {
  ...e.semantic.typography.body.regular.M,
  color: e.semantic.color.text.subtle,
  "&:empty": { display: "none" }
}, ao = {
  display: "flex",
  flexWrap: "wrap",
  marginTop: "var(--card-content-gap)",
  columnGap: e.semantic.space["4x"],
  rowGap: e.semantic.space["3x"],
  [`@container Card ${i.tabletAndUp}`]: { columnGap: e.semantic.space["6x"] },
  "&:empty": { display: "none" },
  /* Ensures that the 12px gap between adjacent footers is maintained by removing the default margin. */
  "&:not(:empty) + &": { marginTop: 0 }
}, q = {
  CardGroupContainer: Qt,
  Container: qt,
  Card: Jt,
  Media: eo,
  Content: to,
  Title: oo,
  Subtitle: io,
  Body: ro,
  Footer: ao
}, no = q, lo = {
  card: Kt,
  button: $t,
  richText: mt
}, so = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  "&--box": {
    gap: t.primitive.space["3x"].value
  }
}, co = {
  display: "flex",
  flexDirection: "column",
  borderTop: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.moderateDefault.value}`,
  background: t.primitive.color.twilight["000"].value,
  "&:not(&--disabled):not(&--inactive).AccordionItem": {
    "&:hover": {
      borderTop: `${t.primitive.border["1x"].value} solid ${t.primitive.color.skyView[1e3].value}`
    },
    "&:has(.AccordionItem__summary:focus-visible)": {
      outline: "none",
      borderTop: `${t.primitive.border["2x"].value} solid ${t.primitive.color.skyView[1e3].value}`
    },
    "&--inactive": {
      "&:hover": {
        borderTop: `${t.primitive.border["1x"].value} solid ${t.primitive.color.twilight[400].value}`
      },
      "&:has(.AccordionItem__summary:focus-visible)": {
        borderTop: 0
      }
    },
    "&--box": {
      "&:hover": {
        outline: `${t.primitive.border["1x"].value} solid ${t.primitive.color.skyView[1e3].value}`,
        borderTop: 0
      },
      "&:has(.AccordionItem__summary:focus-visible)": {
        outline: `${t.primitive.border["2x"].value} solid`,
        outlineColor: t.primitive.color.skyView[1e3].value,
        borderTop: 0
      }
    },
    "&--inactive&--box": {
      "&:hover": {
        outline: `${t.primitive.border["1x"].value} solid ${t.primitive.color.twilight[400].value}`
      },
      "&:has(.AccordionItem__summary:focus-visible)": {
        outlineColor: t.primitive.color.twilight[400].value
      }
    }
  },
  "&--box": {
    borderRadius: t.primitive.radius["2x"].value,
    outline: `${t.primitive.border["1x"].value} solid ${t.primitive.color.twilight[400].value}`,
    borderTop: 0
  },
  "&--disabled&--box": {
    background: t.primitive.color.twilight[200].value
  },
  "&--disabled, &--inactive": {
    cursor: "not-allowed"
  }
}, po = {
  display: "flex",
  padding: `${t.semanticMode1.space.xl.value} ${t.semanticMode1.space.lg.value}`,
  background: t.primitive.color.twilight["000"].value,
  flexDirection: "row",
  alignItems: "center",
  cursor: "pointer",
  border: "none",
  flex: 1,
  "&:focus-visible": {
    outline: "none"
  },
  ".AccordionItem__summary-dropdown": {
    marginRight: "-8px"
  },
  "&--disabled, &--inactive": {
    cursor: "not-allowed"
  },
  "&--disabled&--box": {
    background: t.primitive.color.twilight[200].value
  }
}, A = {
  display: "flex",
  alignItems: "center",
  gap: t.primitive.space["2x"].value,
  flex: 1,
  "--title-color": t.semanticMode1.color.text.onLight.moderateDefault.value,
  "--sub-title-color": t.semanticMode1.color.text.onLight.subtle.value,
  color: "var(--title-color)",
  "&--open": {
    "--title-color": t.semanticMode1.color.text.onLight.interactive.value,
    "--sub-title-color": t.semanticMode1.color.text.onLight.interactive.value
  },
  "&:not(&--disabled, &--inactive):hover": {
    "--title-color": t.semanticMode1.color.text.onLight.interactiveHover.value,
    "--sub-title-color": t.semanticMode1.color.text.onLight.interactiveHover.value
  },
  "&--disabled": {
    "--title-color": t.primitive.color.twilight[500].value,
    "--sub-title-color": t.primitive.color.twilight[500].value
  }
}, mo = {
  display: "flex",
  minHeight: t.primitive.space["6x"].value,
  justifyContent: "center",
  alignItems: "center",
  svg: {
    width: t.primitive.space["5x"].value,
    height: t.primitive.space["5x"].value,
    color: A.color
  }
}, uo = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: 1,
  flexShrink: 0,
  "& .accordion-title-tag": {
    marginBottom: t.primitive.space["1x"].value
  },
  h6: {
    "&:first-of-type": {
      marginTop: t.primitive.space["1x"].value
    },
    margin: 0,
    ...t.semanticMode1.subtitle.regular.value,
    color: "var(--sub-title-color)"
  },
  ".Accordion__title-content": {
    margin: 0,
    ...t.semanticMode1.title.medium.value,
    color: "var(--title-color)"
  }
}, go = {
  margin: 0
}, xo = {
  display: "flex",
  width: t.primitive.space["6x"].value,
  height: t.primitive.space["6x"].value,
  justifyContent: "center",
  alignItems: "center",
  transition: "none",
  transform: "rotate(-180deg)",
  color: A.color,
  "&--animate": {
    transition: "transform 0.3s ease-in-out"
  },
  "&--open": {
    transform: "rotate(0deg)"
  }
}, ho = {
  overflow: "hidden",
  boxSizing: "border-box",
  "&--disabled": {
    pointerEvents: "none"
  }
}, bo = {
  width: "100%",
  boxSizing: "border-box",
  color: t.primitive.color.twilight[800].value,
  paddingInline: t.semanticMode1.space.lg.value,
  paddingBottom: t.semanticMode1.space.lg.value
}, fo = {
  AccordionContainer: so,
  AccordionItem: co,
  Summary: po,
  LeadingIcon: mo,
  TitleWrapper: A,
  Title: uo,
  TrailingIcon: xo,
  Content: ho,
  AccordionPanel: bo,
  TitleContent: go
}, vo = {
  position: "relative",
  overflow: "hidden",
  ">": {
    "img, video, iframe": {
      width: "100%",
      height: "100%",
      position: "absolute",
      inset: "0"
    }
  },
  "&--default": {
    backgroundColor: t.primitive.color.twilight[400].value
  },
  "&--neutral": {
    backgroundColor: t.primitive.color.neutral[500].value
  }
}, yo = {
  AspectRatio: vo
}, Co = {
  position: "relative",
  overflow: "hidden",
  isolation: "isolate",
  ">": {
    "img, video, iframe": {
      width: "100%",
      height: "100%",
      position: "absolute",
      inset: "0"
    }
  },
  "&--default": {
    backgroundColor: e.semantic.color.stroke.default
  },
  "&--neutral": {
    backgroundColor: e.semantic.color.stroke.neutralSubtle
  }
}, $o = {
  AspectRatio: Co
}, wo = {
  backgroundColor: {
    primary: e.semantic.color.fill.secondaryStrong,
    accent: e.semantic.color.fill.primaryStrong,
    default: e.semantic.color.fill.secondaryStrong
  },
  height: {
    large: e.semantic.size["12x"],
    medium: e.semantic.size["10x"],
    small: e.semantic.size["8x"],
    extraSmall: e.semantic.size["6x"],
    default: e.semantic.size["10x"]
  },
  width: {
    large: e.semantic.size["12x"],
    medium: e.semantic.size["10x"],
    small: e.semantic.size["8x"],
    extraSmall: e.semantic.size["6x"],
    default: e.semantic.size["10x"]
  },
  boxSizing: "border-box",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  textAlign: "center"
}, ko = {
  textSize: {
    large: e.semantic.typography.body.medium.L,
    medium: e.semantic.typography.body.medium.M,
    small: e.semantic.typography.body.medium.S,
    extraSmall: e.semantic.typography.body.semiBold.XS,
    default: e.semantic.typography.body.medium.M
  },
  display: "inline-flex",
  boxSizing: "border-box",
  justifyContent: "center",
  alignItems: "center",
  color: e.semantic.color.text.onColor,
  textAlign: "center",
  fontStyle: "normal"
}, So = {
  AvatarContent: ko,
  AvatarContainer: wo
}, Bo = {
  backgroundColor: {
    primary: e.semantic.color.fill.secondaryStrong,
    accent: e.semantic.color.fill.primaryStrong,
    default: e.semantic.color.fill.secondaryStrong
  },
  height: {
    large: e.semantic.size["12x"],
    medium: e.semantic.size["10x"],
    small: e.semantic.size["8x"],
    extraSmall: e.semantic.size["6x"],
    default: e.semantic.size["10x"]
  },
  width: {
    large: e.semantic.size["12x"],
    medium: e.semantic.size["10x"],
    small: e.semantic.size["8x"],
    extraSmall: e.semantic.size["6x"],
    default: e.semantic.size["10x"]
  },
  boxSizing: "border-box",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  textAlign: "center"
}, To = {
  textSize: {
    large: e.semantic.typography.body.medium.L,
    medium: e.semantic.typography.body.medium.M,
    small: e.semantic.typography.body.medium.S,
    extraSmall: e.semantic.typography.body.semiBold.XS,
    default: e.semantic.typography.body.medium.M
  },
  display: "inline-flex",
  boxSizing: "border-box",
  justifyContent: "center",
  alignItems: "center",
  color: e.semantic.color.text.onColor,
  textAlign: "center",
  fontStyle: "normal"
}, Wo = {
  AvatarContent: To,
  AvatarContainer: Bo
};
function Lo(a, c) {
  switch (!0) {
    case (a === "large" && c !== void 0):
      return e.semantic.space["6x"];
    case (a === "medium" && c !== void 0):
      return e.semantic.space["5x"];
    case (a === "small" && c !== void 0):
      return e.semantic.space["4x"];
    case (a === "large" && c === void 0):
      return e.semantic.space["4x"];
    case (a === "medium" && c === void 0):
      return e.semantic.space["3x"];
    case (a === "small" && c === void 0):
      return e.semantic.space["2x"];
    default:
      return e.semantic.space["5x"];
  }
}
const _o = {
  badgeTextColor: {
    emphasis: {
      high: e.semantic.color.text.onColor,
      low: {
        primary: e.semantic.color.text.primaryStrong,
        neutral: e.semantic.color.text.subtle,
        danger: e.semantic.color.text.dangerStrong,
        success: e.semantic.color.text.successStrong,
        warning: e.semantic.color.text.cautionStrong,
        default: e.semantic.color.text.primaryStrong
      }
    }
  },
  badgeBackgroundColor: {
    emphasis: {
      high: {
        primary: e.semantic.color.fill.primaryStrong,
        neutral: e.semantic.color.fill.neutralStrong,
        danger: e.semantic.color.fill.dangerStrong,
        success: e.semantic.color.text.successStrongest,
        warning: e.semantic.color.fill.cautionStrong,
        default: e.semantic.color.fill.primaryStrong
      },
      low: {
        primary: e.semantic.color.fill.primarySubtlest,
        neutral: e.semantic.color.fill.neutralSubtle,
        danger: e.semantic.color.fill.dangerSubtlest,
        success: e.semantic.color.fill.successSubtlest,
        warning: e.semantic.color.fill.cautionSubtlest,
        default: e.semantic.color.fill.primarySubtlest
      }
    }
  },
  valueWidth: {
    small: e.semantic.space["6x"],
    default: e.semantic.space["2x"]
  },
  padding: {
    length: {
      1: `0px ${e.semantic.space["1x"]}`
    },
    default: "unset"
  },
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  width: "fit-content",
  borderRadius: e.semantic.radius["3x"],
  textAlign: "center",
  boxSizing: "border-box"
}, Io = {
  height: {
    small: e.semantic.size["4x"],
    medium: e.semantic.size["5x"],
    large: e.semantic.size["6x"]
  },
  textStyle: {
    small: e.semantic.typography.body.semiBold.XS,
    medium: e.semantic.typography.body.semiBold.S,
    large: e.semantic.typography.body.semiBold.M
  },
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  width: "auto",
  textAlign: "center"
}, J = {
  getBadgeSize: Lo,
  BadgeContainer: _o,
  BadgeValue: Io
}, Mo = J, Do = {
  height: "100%",
  width: "100%",
  overflowX: "auto",
  apexchartsYaxistooltip: {
    padding: "0"
  },
  ApxLegendPositionBottom: {
    maxHeight: "100px"
  },
  apexchartsLegendSeries: {
    display: "flex",
    alignItems: "center",
    padding: e.semantic.space["1x"],
    gap: "10px",
    apexchartsLegendText: {
      paddingLeft: "unset",
      marginLeft: "unset"
    }
  },
  vertical: {
    apexchartsLegendSeries: {
      display: "inline-flex",
      alignItems: "flex-start",
      padding: e.semantic.space["1x"],
      paddingLeft: e.semantic.space["2x"],
      margin: "0",
      width: "100%"
    },
    legendItem: {
      width: "100%"
    },
    apexchartsLegendText: {
      pointerEvents: "none",
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      lineHeight: e.primitive.typography.lineHeights[500]
    },
    totalLabel: {
      position: "absolute",
      fontWeight: e.primitive.typography.fontWeights.inter.medium,
      left: "0px",
      margin: "0px",
      paddingTop: e.semantic.space["2x"],
      width: "100%"
    },
    totalText: {
      marginLeft: "0px"
    }
  }
}, Ho = {
  whiteSpace: "normal",
  border: `1px solid ${e.semantic.color.stroke.neutralStrong}`,
  boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.06)"
}, Ro = {
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["3x"]}`,
  letterSpacing: 0,
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.medium.M
}, zo = {
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["3x"]}`
}, ee = {
  Wrapper: Do,
  CustomTooltipStyles: Ho,
  TooltipTitleStyles: Ro,
  TooltipBodyStyles: zo
}, Ao = ee, S = "218px", B = "436px", T = "689px", Fo = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "1224px",
  margin: e.semantic.space["8x"] + " auto",
  width: "100%"
}, Po = {
  ...e.semantic.typography.headline.XL,
  lineHeight: e.primitive.typography.lineHeights[800],
  //32px
  color: e.semantic.color.text.default
}, Oo = {
  ...e.semantic.typography.headline.M,
  lineHeight: e.primitive.typography.lineHeights[600],
  //24px
  marginTop: e.semantic.space["4x"],
  color: e.semantic.color.text.default,
  tabletAndUp: {
    marginTop: e.semantic.space["12x"]
  }
}, Eo = {
  marginTop: e.semantic.space["2x"],
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.M
}, Vo = {
  marginTop: e.semantic.space["4x"],
  position: "relative",
  background: e.primitive.color.twilight[1200],
  borderRadius: e.semantic.radius["1x"],
  maxHeight: S,
  minHeight: S,
  height: S,
  iframe: {
    borderRadius: e.semantic.radius["1x"]
  },
  tabletAndUp: {
    marginTop: e.semantic.space["6x"],
    borderRadius: e.semantic.radius["2x"],
    minWidth: "300px",
    height: B,
    maxHeight: B,
    iframe: {
      borderRadius: e.semantic.radius["2x"]
    }
  },
  laptopAndUp: {
    height: T,
    maxHeight: T
  }
}, Go = {
  background: e.primitive.color.twilight[1200],
  position: "absolute",
  borderRadius: e.semantic.radius["1x"],
  cursor: "pointer",
  maxWidth: "100%",
  width: "100%",
  height: S,
  objectFit: "cover",
  tabletAndUp: {
    borderRadius: e.semantic.radius["2x"],
    height: B,
    maxHeight: B
  },
  laptopAndUp: {
    height: T,
    maxHeight: T
  }
}, jo = {
  position: "absolute",
  left: e.semantic.space["8x"],
  bottom: e.semantic.space["6x"],
  zIndex: 2,
  tabletAndUp: {
    left: e.semantic.space["10x"],
    bottom: e.semantic.space["8x"]
  }
}, Uo = {
  width: "100%",
  height: "100%",
  zIndex: 1,
  position: "absolute",
  borderRadius: e.semantic.radius["1x"],
  cursor: "pointer",
  background: "linear-gradient(180deg, rgba(0, 20, 46, 0) 15.29%, rgba(0, 20, 46, 0.65) 100%)",
  tabletAndUp: {
    borderRadius: e.semantic.radius["2x"]
  }
}, te = {
  Wrapper: Fo,
  HeadlineWrapper: Po,
  SubheadlineWrapper: Oo,
  BodyWrapper: Eo,
  VideoContainerWrapper: Vo,
  CoverImageElement: Go,
  PlayButtonElement: jo,
  GradientOverlay: Uo
}, Xo = te, No = {
  display: "inline-flex",
  flexWrap: "wrap",
  listStyle: "none",
  padding: 0,
  margin: 0,
  alignItems: "center"
}, Yo = {
  display: "inline-flex",
  color: t.primitive.color.skyView[900].value,
  marginRight: t.primitive.space["2x"].value
}, Zo = {
  color: t.primitive.color.neutral[900].value,
  "&--small": {
    width: "5px",
    height: "1lh",
    ...t.semanticMode1.body2.regular.value
  },
  "&--medium, &--large": {
    width: "5px",
    height: "1lh",
    ...t.semanticMode1.body1.regular.value
  },
  fontStyle: "normal",
  marginRight: t.primitive.space["2x"].value,
  marginLeft: t.primitive.space["2x"].value
}, Ko = {
  display: "flex",
  padding: 0,
  margin: 0,
  "& *": {
    margin: 0
  },
  listStyle: "none",
  alignItems: "center",
  "&--last .Breadcrumb__list-separator": {
    display: "none"
  },
  "&.Breadcrumb__list-item--last": {
    "&--small": {
      ...t.semanticMode1.body2.regular.value,
      color: t.primitive.color.neutral[900].value
    },
    "&--medium": {
      ...t.semanticMode1.body1.regular.value,
      color: t.primitive.color.neutral[900].value
    },
    "&--large": {
      ...t.semanticMode1.body1.regular.value,
      color: t.primitive.color.neutral[900].value
    }
  }
}, Qo = {
  BreadcrumbList: No,
  MobileCaretLeftIcon: Yo,
  Separator: Zo,
  BreadcrumbItem: Ko
}, qo = {
  display: "inline-flex",
  flexWrap: "wrap",
  listStyle: "none",
  padding: 0,
  margin: 0,
  alignItems: "center"
}, Jo = {
  display: "inline-flex",
  color: e.semantic.color.icon.primary,
  marginRight: e.semantic.space["2x"]
}, ei = {
  color: e.semantic.color.stroke.neutralModerate,
  width: "6px",
  height: "1lh",
  ...e.semantic.typography.body.medium.M,
  fontStyle: "normal",
  marginRight: e.semantic.space["2x"],
  marginLeft: e.semantic.space["2x"]
}, ti = {
  display: "flex",
  padding: 0,
  margin: 0,
  "& *": {
    margin: 0
  },
  listStyle: "none",
  alignItems: "center",
  "& .Breadcrumb__list-item__link": {
    "&--xsmall, &--small, &--medium, &--large ": {
      ...e.semantic.typography.body.medium.M,
      textUnderlineOffset: "5px"
    }
  },
  "&--last .Breadcrumb__list-separator": {
    display: "none"
  },
  "&.Breadcrumb__list-item--last": {
    ...e.semantic.typography.body.medium.M,
    color: e.semantic.color.link.neutralStrong
  }
}, oi = {
  BreadcrumbList: qo,
  MobileCaretLeftIcon: Jo,
  Separator: ei,
  BreadcrumbItem: ti
}, ii = {
  width: "100%",
  display: "flex",
  gap: e.semantic.space["3x"],
  borderRadius: e.semantic.radius["2x"],
  paddingBlock: e.semantic.space["4x"],
  paddingInline: e.semantic.space["8x"],
  backgroundColor: e.semantic.color.fill.neutralStrong,
  color: e.semantic.color.text.onColor,
  justifyContent: "space-between",
  alignItems: "center",
  boxSizing: "border-box",
  containerType: "inline-size"
}, ri = {
  width: "50%",
  display: "flex",
  gap: e.semantic.space["3x"],
  alignItems: "center",
  ".Text": {
    color: "inherit"
  }
}, ai = {
  width: "100%",
  display: "flex",
  gap: e.semantic.space["1x"],
  alignItems: "center",
  ".BulkActionBar__Summary_Title_Wrapper": {
    "&-label": {
      wordBreak: "break-word",
      hyphens: "auto"
    },
    "&-count": {
      alignSelf: "baseline"
    }
  }
}, ni = {
  textAlign: "end",
  width: "50%",
  overflow: "hidden",
  "&--no-menu": {
    flex: "auto",
    ".BulkActionBar__Actions-ButtonGroup": {
      flexWrap: "wrap",
      width: "100%",
      ...o({ btnWidth: "100%" })
    }
  },
  "&-mobile": {
    width: "fit-content",
    overflow: "unset"
  },
  "&-no-summary": {
    width: "100%"
  }
}, li = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "flex-end",
  columnGap: e.semantic.space["6x"],
  rowGap: e.semantic.space["4x"],
  width: "max-content"
}, oe = {
  BulkActionBar: ii,
  Summary: ri,
  Actions: ni,
  ButtonGroup: li,
  StyledSummaryTextWrapper: ai
}, si = oe, ci = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: t.semanticMode1.space.lg.value,
  [`@media ${i.tabletAndUp}`]: {
    flexDirection: "row",
    gap: t.semanticMode1.space.lg.value
  },
  "&:empty": {
    display: "none"
  }
}, di = {
  Container: ci
}, pi = {
  display: "flex",
  flexDirection: "column",
  padding: `0 ${t.primitive.space["3x"].value}`,
  width: "100%",
  gap: t.primitive.space["3x"].value,
  boxSizing: "border-box",
  flex: "1",
  "&--leftAlign": {
    textAlign: "left",
    alignItems: "flex-start"
  },
  "&--centerAlign": {
    textAlign: "center",
    alignItems: "center"
  },
  [`@media ${i.mobile}`]: {
    minWidth: "232px"
  }
}, mi = {
  display: "flex",
  "&--small": {
    height: t.primitive.lineHeights[7].value,
    width: t.primitive.lineHeights[7].value
    //48px
  },
  "&--medium": {
    height: t.primitive.space["9x"].value,
    width: t.primitive.space["9x"].value
    // 64px
  },
  "&--large": {
    height: t.primitive.lineHeights[4].value,
    width: t.primitive.lineHeights[4].value
    //72px
  },
  "&--xxLarge": {
    height: t.primitive.space["12x"].value,
    width: t.primitive.space["12x"].value
    //112px
  }
}, ui = {
  svg: {
    color: t.semanticMode1.color.text.onLight.moderateDefault.value
  },
  "&--xxs": {
    svg: {
      height: t.primitive.space["4x"].value,
      // 16px,
      width: t.primitive.space["4x"].value
    }
  },
  "&--xs": {
    svg: {
      height: t.primitive.lineHeights[12].value,
      //20px
      width: t.primitive.lineHeights[12].value
    }
  },
  "&--s": {
    svg: {
      height: t.primitive.space["5x"].value,
      //24px
      width: t.primitive.space["4x"].value
    }
  },
  "&--m": {
    svg: {
      height: t.primitive.space["6x"].value,
      //32px
      width: t.primitive.space["5x"].value
    }
  },
  "&--l": {
    svg: {
      height: t.primitive.lineHeights[7].value,
      //48px
      width: t.primitive.lineHeights[7].value
    }
  },
  "&--xl": {
    svg: {
      height: t.primitive.space["9x"].value,
      //64px
      width: t.primitive.space["9x"].value
    }
  },
  "&--xxl": {
    svg: {
      height: t.primitive.lineHeights[4].value,
      //72px
      width: t.primitive.lineHeights[4].value
    }
  }
}, gi = {
  "&--xLarge": {
    ...t.semanticMode1.headline3.regular.large.value
    // 32px
  },
  "&--xxLarge": {
    ...t.semanticMode1.headline2.regular.large.value
    // 40px
  },
  "&--large, &--medium": {
    ...t.semanticMode1.headline4.regular.large.value
  }
}, xi = {
  ...t.semanticMode1.body1.regular.value
}, hi = {
  width: "100%"
}, bi = {
  Wrapper: pi,
  ImageContainer: mi,
  IconContainer: ui,
  TitleWrapper: gi,
  DescriptionWrapper: xi,
  ButtonContainer: hi
}, fi = {
  display: "flex",
  flexDirection: "column",
  padding: `0 ${e.semantic.space["3x"]}`,
  minWidth: "264px",
  maxWidth: "496px",
  gap: e.semantic.space["3x"],
  boxSizing: "border-box",
  flex: "1",
  "&--leftAlign": {
    textAlign: "left",
    alignItems: "flex-start"
  },
  "&--centerAlign": {
    textAlign: "center",
    alignItems: "center"
  },
  [`@media ${i.tabletAndUp}`]: {
    minWidth: "215px"
  }
}, vi = {
  display: "flex",
  "&--small": {
    height: e.semantic.space["12x"],
    width: e.semantic.space["12x"]
  },
  "&--medium": {
    height: e.semantic.space["16x"],
    width: e.semantic.space["16x"]
  },
  "&--large": {
    height: e.semantic.space["18x"],
    width: e.semantic.space["18x"]
  },
  "&--xxLarge": {
    height: e.semantic.space["28x"],
    width: e.semantic.space["28x"]
  }
}, yi = {
  svg: {
    color: e.semantic.color.icon.default
  },
  "&--xxs": {
    svg: {
      height: e.semantic.space["4x"],
      width: e.semantic.space["4x"]
    }
  },
  "&--xs": {
    svg: {
      height: e.semantic.space["5x"],
      width: e.semantic.space["5x"]
    }
  },
  "&--s": {
    svg: {
      height: e.semantic.space["6x"],
      width: e.semantic.space["6x"]
    }
  },
  "&--m": {
    svg: {
      height: e.semantic.space["8x"],
      width: e.semantic.space["8x"]
    }
  },
  "&--l": {
    svg: {
      height: e.semantic.space["12x"],
      width: e.semantic.space["12x"]
    }
  },
  "&--xl": {
    svg: {
      height: e.semantic.space["16x"],
      width: e.semantic.space["16x"]
    }
  },
  "&--xxl": {
    svg: {
      height: e.semantic.space["18x"],
      width: e.semantic.space["18x"]
    }
  }
}, Ci = {
  color: e.semantic.color.text.default,
  "&--xLarge": {
    ...e.semantic.typography.headline.XL
  },
  "&--xxLarge": {
    ...e.semantic.typography.headline.XXL
  },
  "&--large": {
    ...e.semantic.typography.headline.L
  },
  "&--medium": {
    ...e.semantic.typography.headline.M
  }
}, $i = {
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.M
}, wi = {
  width: "100%"
}, ki = {
  Wrapper: fi,
  ImageContainer: vi,
  IconContainer: yi,
  TitleWrapper: Ci,
  DescriptionWrapper: $i,
  ButtonContainer: wi
}, Si = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  "&--raisedSurface": {
    marginBottom: "48px"
    // Doesn't exist in tokens yet. Confirmed with Dan, figma tokens needs a update in the future.
  },
  "&--featureTextDisabled": {
    marginTop: "48px"
    // Doesn't exist in tokens yet. Confirmed with Dan, figma tokens needs a update in the future.
  }
}, Bi = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  "--card-illustration-group-gap": t.primitive.space["5x"].value,
  "--card-illustration-col": "1",
  gap: "var(--card-illustration-group-gap)",
  flexWrap: "wrap",
  [`@media ${i.tablet}`]: {
    "--card-illustration-col": "2"
  },
  [`@media ${i.laptopAndUp}`]: {
    "--card-illustration-col": "4"
  },
  ".CardIllustration": {
    "--card-illustration-flex-basis-width": "calc(100% / var(--card-illustration-col))",
    "--card-illustration-acc-gap": "calc(var(--card-illustration-group-gap) * calc(var(--card-illustration-col) - 1))",
    flexBasis: "calc(var(--card-illustration-flex-basis-width) - var(--card-illustration-acc-gap))",
    "& .CardIllustration__DescriptionWrapper": {
      "> p": {
        marginBlock: t.primitive.space["0x"].value,
        // removes the user agent style-sheet margin from paragraph when authored in AEM
        marginInline: t.primitive.space["0x"].value
        // removes the user agent style-sheet margin from paragraph when authored in AEM
      }
    }
  }
}, Ti = {
  width: "100%",
  marginBottom: "48px",
  // Doesn't exist in tokens yet. Confirmed with Dan, figma tokens needs a update in the future.
  "&--raisedSurface": {
    marginTop: "48px"
    // Doesn't exist in tokens yet. Confirmed with Dan, figma tokens needs a update in the future.
  }
}, Wi = {
  CardIllustrationSectionWrapper: Si,
  FeatureTextContainer: Ti,
  CardIllustrationGroup: Bi
}, Li = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  "&--raisedSurface": {
    marginBottom: e.semantic.space["12x"]
  },
  "&--featureTextDisabled": {
    marginTop: e.semantic.space["12x"]
  }
}, _i = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  "--card-illustration-group-gap": e.semantic.space["6x"],
  "--card-illustration-col": "1",
  gap: "var(--card-illustration-group-gap)",
  flexWrap: "wrap",
  [`@media ${i.tablet}`]: {
    "--card-illustration-col": "2"
  },
  [`@media ${i.laptopAndUp}`]: {
    "--card-illustration-col": "4"
  },
  ".CardIllustration": {
    "--card-illustration-flex-basis-width": "calc(100% / var(--card-illustration-col))",
    "--card-illustration-acc-gap": "calc(var(--card-illustration-group-gap) * calc(var(--card-illustration-col) - 1))",
    flexBasis: "calc(var(--card-illustration-flex-basis-width) - var(--card-illustration-acc-gap))",
    "& .CardIllustration__DescriptionWrapper": {
      "> p": {
        marginBlock: e.semantic.space["0x"],
        // removes the user agent style-sheet margin from paragraph when authored in AEM
        marginInline: e.semantic.space["0x"]
        // removes the user agent style-sheet margin from paragraph when authored in AEM
      }
    }
  }
}, Ii = {
  width: "100%",
  marginBottom: e.semantic.space["12x"],
  "&--raisedSurface": {
    marginTop: e.semantic.space["12x"]
  }
}, Mi = {
  CardIllustrationSectionWrapper: Li,
  FeatureTextContainer: Ii,
  CardIllustrationGroup: _i
}, Di = {
  position: "relative",
  maxWidth: "100%",
  width: "fit-content",
  overflow: "hidden",
  flex: 1,
  boxSizing: "border-box",
  isolation: "isolate",
  "--carousel-gradient-width": t.primitive.space["4x"].value,
  display: "flex",
  alignItems: "center",
  "&--left": {
    "&::after": {
      content: '" "',
      position: "absolute",
      width: "var(--carousel-gradient-width)",
      height: "100%",
      top: 0,
      left: 0,
      backgroundImage: "linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%)"
    }
  },
  "&--right": {
    "&::before": {
      content: '" "',
      position: "absolute",
      width: "var(--carousel-gradient-width)",
      height: "100%",
      top: 0,
      right: 0,
      backgroundImage: "linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0) 100%)",
      zIndex: 1
    }
  }
}, Hi = {
  zIndex: 1,
  "&.IconButton--primary.IconButton--oncolor": o({
    iconBtnHeight: "100%",
    iconBtnHoverBgColor: o("btnColor"),
    iconBtnBorderRadius: "none"
  })
}, Ri = {
  zIndex: 1,
  "&.IconButton--primary.IconButton--oncolor": o({
    iconBtnHeight: "100%",
    iconBtnHoverBgColor: o("btnColor"),
    iconBtnBorderRadius: "none"
  })
}, zi = {
  overflowX: "auto",
  scrollBehavior: "smooth",
  overscrollBehavior: "contain",
  "&::-webkit-scrollbar": {
    display: "none"
  },
  "-ms-overflow-style": "none",
  scrollbarWidth: "none"
}, Ai = {
  Carousel: Di,
  PreviousButton: Hi,
  NextButton: Ri,
  CarouselContent: zi
}, Fi = {
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.medium.XS,
  legendFontSize: e.primitive.typography.fontSize[350],
  legendFontWeight: e.primitive.typography.fontWeights.inter.semiBold,
  axisFontWeight: e.primitive.typography.fontWeights.inter.semiBold,
  tooltipBorderColor: e.semantic.color.stroke.neutralStrong
}, Pi = {
  borderColor: e.semantic.color.stroke.default
}, Oi = {
  markers: {
    strokeColor: e.semantic.color.stroke.onColor
  },
  total: {
    fontWeight: e.primitive.typography.fontWeights.inter.medium
  }
}, Ei = {
  axisBorder: { color: e.semantic.color.text.subtlest }
}, Vi = {
  axisBorder: {
    color: e.semantic.color.text.subtlest
  }
}, Gi = {
  donut: {
    labels: {
      total: {
        fontSize: e.primitive.typography.fontSize[400]
      },
      name: {
        fontSize: e.primitive.typography.fontSize[400]
      },
      value: {
        fontSize: e.primitive.typography.fontSize[1e3]
      }
    }
  }
}, ji = {
  custom: {
    default: {
      span: {
        padding: "10px 15px 0 15px",
        color: e.semantic.color.text.default,
        ...e.semantic.typography.body.semiBold.M,
        fontStyle: "normal"
      },
      ul: {
        listStyleType: "none",
        padding: "0 15px",
        color: e.semantic.color.text.subtle,
        ...e.semantic.typography.body.medium.M,
        fontStyle: "normal"
      }
    },
    scatter: {
      divCustomTooltip: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: `${e.semantic.space["1x"]} 10px`
      },
      divSeriesMarker: {
        height: "12px",
        width: "12px",
        borderRadius: e.semantic.radius["3x"],
        marginRight: "10px"
      },
      div: {
        padding: "6px 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: e.primitive.typography.fontSize[300],
        fontFamily: e.primitive.typography.fontFamilies.inter,
        color: e.semantic.color.text.subtle,
        divChildOne: {
          marginRight: "5px"
        },
        divChildTwo: {
          fontWeight: e.primitive.typography.fontWeights.inter.medium
        }
      }
    }
  }
}, Ui = {
  tooltipStyles: {
    apexchartsTooltip: {
      border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.neutralStrong}`,
      color: e.semantic.color.text.subtle
    },
    apexchartsTooltipSeriesGroup: {
      paddingTop: e.semantic.space["1x"]
    }
  },
  legendStrapStyle: {
    apexchartsLegendSeries: {
      display: "flex",
      flexDirection: "column",
      gap: e.semantic.space["1x"]
    },
    apexchartsLegendSeriesFirstOfType: {
      borderTopLeftRadius: e.semantic.radius["1x"],
      borderBottomLeftRadius: e.semantic.radius["1x"]
    },
    apexchartsLegendSeriesLastOfType: {
      borderTopRightRadius: e.semantic.radius["1x"],
      borderBottomRightRadius: e.semantic.radius["1x"]
    }
  },
  legendLeftRightPositionStyle: {
    apexchartsLegendApxLegendPositionRight: {
      justifyContent: "center",
      marginTop: "-50px"
    },
    apexchartsLegendApxLegendPositionLeft: {
      justifyContent: "center",
      marginTop: "-50px",
      left: "0"
    }
  },
  legendStyles: {
    barColumnScatter: {
      verical: {
        apexchartsLegend: {
          flexDirection: { vertical: "column", default: "unset" },
          maxHeight: "unset",
          overflow: "auto",
          flexWrap: {
            horizontalTopBottom: "wrap",
            default: "unset  "
          },
          justifyContent: {
            horizontal: {
              right: "flex-end",
              left: "flex-start",
              default: "center"
            },
            vertical: "unset"
          },
          alignItems: {
            horizontal: {
              right: "flex-end",
              left: "flex-start",
              default: "center"
            }
          }
        }
      },
      default: {
        apexchartsLegendSeries: {
          display: "flex",
          alignItems: "center",
          padding: e.semantic.space["1x"],
          gap: "10px",
          apexchartsLegendText: {
            paddingLeft: "unset",
            marginLeft: "unset"
          }
        },
        apexchartsLegendMarker: {
          marginRight: "unset"
        }
      }
    },
    donut: {
      apxLegendPositionRightLeft: {
        top: "0px",
        height: "100%",
        padding: "0px",
        width: "38%"
      },
      apexchartsLegendSeries: {
        display: "inline-flex",
        alignItems: "flex-start",
        padding: e.semantic.space["1x"],
        paddingLeft: e.semantic.space["2x"]
      },
      apexchartsLegendTextAll: {
        pointerEvents: "none",
        display: "flex",
        /* gap: 10px; */
        justifyContent: "space-between",
        marginLeft: "10px"
      },
      apexchartsLegendText: {
        width: "100%",
        lineHeight: e.primitive.typography.lineHeights[500]
      },
      apexchartsLegendMarker: {
        top: e.semantic.space["1x"]
      },
      totalLabel: {
        position: "absolute",
        fontWeight: "500",
        left: "0px",
        margin: "0px",
        paddingTop: e.semantic.space["2x"],
        width: "100%"
      },
      totalText: {
        marginLeft: "0px"
      },
      mobile: {
        apexchartsLegendSeries: {
          display: "flex"
        },
        apexchartsLegend: {
          display: "block",
          width: "70%",
          margin: "0 auto"
        }
      }
    }
  },
  gridStyles: {
    apexchartsGridlinesVertical: {
      firstChild: {
        display: "none"
      }
    }
  }
}, Xi = {
  defaultFont: Fi,
  loadGridStyles: Pi,
  loadLegendStyles: Oi,
  loadXaxisStyles: Ei,
  loadYaxisStyles: Vi,
  loadPlotOptionsStyles: Gi,
  loadTooltipStyles: ji,
  customStyles: Ui
}, Ni = {
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.medium.XS,
  legendFontSize: e.primitive.typography.fontSize[350],
  legendFontWeight: e.primitive.typography.fontWeights.inter.semiBold,
  axisFontWeight: e.primitive.typography.fontWeights.inter.semiBold,
  tooltipBorderColor: e.semantic.color.stroke.neutralStrong
}, Yi = {
  borderColor: e.semantic.color.stroke.default
}, Zi = {
  markers: {
    strokeColor: e.semantic.color.stroke.onColor
  },
  total: {
    fontWeight: e.primitive.typography.fontWeights.inter.medium
  }
}, Ki = {
  axisBorder: { color: e.semantic.color.text.subtlest }
}, Qi = {
  axisBorder: {
    color: e.semantic.color.text.subtlest
  }
}, qi = {
  donut: {
    labels: {
      total: {
        fontSize: e.primitive.typography.fontSize[400]
      },
      name: {
        fontSize: e.primitive.typography.fontSize[400]
      },
      value: {
        fontSize: e.primitive.typography.fontSize[1e3]
      }
    }
  }
}, Ji = {
  custom: {
    default: {
      span: {
        padding: "10px 15px 0 15px",
        color: e.semantic.color.text.default,
        ...e.semantic.typography.body.semiBold.M,
        fontStyle: "normal"
      },
      ul: {
        listStyleType: "none",
        padding: "0 15px",
        color: e.semantic.color.text.subtle,
        ...e.semantic.typography.body.medium.S,
        fontStyle: "normal"
      }
    },
    scatter: {
      divCustomTooltip: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: `${e.semantic.space["1x"]} 10px`
      },
      divSeriesMarker: {
        height: "12px",
        width: "12px",
        borderRadius: e.semantic.radius["3x"],
        marginRight: "10px"
      },
      div: {
        padding: "6px 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: e.primitive.typography.fontSize[300],
        fontFamily: e.primitive.typography.fontFamilies.inter,
        color: e.semantic.color.text.subtle,
        divChildOne: {
          marginRight: "5px"
        },
        divChildTwo: {
          fontWeight: e.primitive.typography.fontWeights.inter.medium
        }
      }
    }
  }
}, er = {
  tooltipStyles: {
    apexchartsTooltip: {
      border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.neutralStrong}`,
      color: e.semantic.color.text.subtle
    },
    apexchartsTooltipSeriesGroup: {
      paddingTop: e.semantic.space["1x"]
    }
  },
  legendStrapStyle: {
    apexchartsLegendSeries: {
      display: "flex",
      flexDirection: "column",
      gap: e.semantic.space["1x"]
    },
    apexchartsLegendSeriesFirstOfType: {
      borderTopLeftRadius: e.semantic.radius["1x"],
      borderBottomLeftRadius: e.semantic.radius["1x"]
    },
    apexchartsLegendSeriesLastOfType: {
      borderTopRightRadius: e.semantic.radius["1x"],
      borderBottomRightRadius: e.semantic.radius["1x"]
    }
  },
  legendLeftRightPositionStyle: {
    apexchartsLegendApxLegendPositionRight: {
      justifyContent: "center",
      marginTop: "-50px"
    },
    apexchartsLegendApxLegendPositionLeft: {
      justifyContent: "center",
      marginTop: "-50px",
      left: "0"
    }
  },
  legendStyles: {
    barColumnScatter: {
      verical: {
        apexchartsLegend: {
          flexDirection: { vertical: "column", default: "unset" },
          maxHeight: "unset",
          overflow: "auto",
          flexWrap: {
            horizontalTopBottom: "wrap",
            default: "unset  "
          },
          justifyContent: {
            horizontal: {
              right: "flex-end",
              left: "flex-start",
              default: "center"
            },
            vertical: "unset"
          },
          alignItems: {
            horizontal: {
              right: "flex-end",
              left: "flex-start",
              default: "center"
            }
          }
        }
      },
      default: {
        apexchartsLegendSeries: {
          display: "flex",
          alignItems: "center",
          padding: e.semantic.space["1x"],
          gap: "10px",
          apexchartsLegendText: {
            paddingLeft: "unset",
            marginLeft: "unset"
          }
        },
        apexchartsLegendMarker: {
          marginRight: "unset"
        }
      }
    },
    donut: {
      apxLegendPositionRightLeft: {
        top: "0px",
        height: "100%",
        padding: "0px",
        width: "38%"
      },
      apexchartsLegendSeries: {
        display: "inline-flex",
        alignItems: "flex-start",
        padding: e.semantic.space["1x"],
        paddingLeft: e.semantic.space["2x"]
      },
      apexchartsLegendTextAll: {
        pointerEvents: "none",
        display: "flex",
        /* gap: 10px; */
        justifyContent: "space-between",
        marginLeft: "10px"
      },
      apexchartsLegendText: {
        width: "100%",
        lineHeight: e.primitive.typography.lineHeights[500]
      },
      apexchartsLegendMarker: {
        top: e.semantic.space["1x"]
      },
      totalLabel: {
        position: "absolute",
        fontWeight: "500",
        left: "0px",
        margin: "0px",
        paddingTop: e.semantic.space["2x"],
        width: "100%"
      },
      totalText: {
        marginLeft: "0px"
      },
      mobile: {
        apexchartsLegendSeries: {
          display: "flex"
        },
        apexchartsLegend: {
          display: "block",
          width: "70%",
          margin: "0 auto"
        }
      }
    }
  },
  gridStyles: {
    apexchartsGridlinesVertical: {
      firstChild: {
        display: "none"
      }
    }
  }
}, tr = {
  defaultFont: Ni,
  loadGridStyles: Yi,
  loadLegendStyles: Zi,
  loadXaxisStyles: Ki,
  loadYaxisStyles: Qi,
  loadPlotOptionsStyles: qi,
  loadTooltipStyles: Ji,
  customStyles: er
}, or = {
  display: "flex",
  flexDirection: "row",
  gap: t.primitive.space["3x"].value
}, ir = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "12px"
}, rr = {
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: t.primitive.space["2x"].value,
  position: "relative",
  userSelect: "none",
  cursor: "pointer",
  color: t.primitive.color.neutral[1e3].value,
  "&--disabled": {
    color: t.primitive.color.neutral[600].value,
    cursor: "auto"
  },
  "&:empty": {
    display: "none"
  },
  "&--media": {
    width: "196px"
  }
}, ar = {
  height: t.primitive.space["5x"].value,
  width: t.primitive.space["5x"].value,
  lineHeight: t.primitive.space["5x"].value,
  top: "0px",
  position: "relative",
  alignSelf: "flex-start",
  flexShrink: 0
}, nr = {
  height: t.primitive.space["5x"].value,
  width: t.primitive.space["5x"].value,
  appearance: "none",
  margin: 0,
  boxSizing: "border-box",
  overflow: "hidden",
  position: "absolute",
  transition: "all 0.12s linear",
  cursor: "pointer",
  borderWidth: "1px",
  borderStyle: "solid",
  outlineOffset: "0px",
  borderColor: t.primitive.color.neutral[600].value,
  borderRadius: t.primitive.radius["1x"].value,
  backgroundColor: t.primitive.color.neutral["000"].value,
  "&:not(:disabled):focus-visible": {
    outline: `2px solid ${t.primitive.color.neutral[1200].value}`
  },
  "&:not(:disabled):hover": {
    borderWidth: "2px",
    borderColor: t.primitive.color.skyView[1200].value
  },
  "&:checked": {
    borderColor: t.componentMode1.checkbox.onLight.default.value,
    backgroundColor: t.componentMode1.checkbox.onLight.default.value,
    "&:not(:disabled):hover": {
      borderColor: t.componentMode1.checkbox.onLight.hover.value,
      backgroundColor: t.componentMode1.checkbox.onLight.hover.value
    }
  },
  "&--error": {
    borderColor: t.primitive.color.red[1e3].value,
    "&:not(:disabled):hover": {
      borderColor: t.primitive.color.red[1e3].value
    },
    "&:checked": {
      borderColor: t.primitive.color.red[1e3].value,
      backgroundColor: t.primitive.color.red[1e3].value,
      "&:not(:disabled):hover": {
        borderColor: t.primitive.color.red[1200].value,
        backgroundColor: t.primitive.color.red[1200].value
      }
    }
  },
  "&:disabled": {
    borderColor: t.primitive.color.neutral[600].value,
    backgroundColor: t.primitive.color.neutral[200].value
  }
}, lr = {
  "--checkmark-color": t.primitive.color.neutral["000"].value,
  position: "absolute",
  cursor: "pointer",
  color: "var(--checkmark-color)",
  "&--error": {
    "--checkmark-color": t.primitive.color.neutral["000"].value
  },
  "&--disabled": {
    cursor: "auto",
    "--checkmark-color": t.primitive.color.neutral[600].value
  },
  "img, svg": {
    height: t.primitive.space["5x"].value,
    width: t.primitive.space["5x"].value,
    color: "var(--checkmark-color)"
  }
}, sr = {
  width: "100%",
  alignItems: "center",
  ".Label__text": {
    fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
    fontSize: t.primitive.fontSize[1].value,
    fontStyle: "normal",
    lineHeight: t.primitive.lineHeights[12].value
  }
}, cr = {
  display: "none",
  marginLeft: t.primitive.space["8x"].value,
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontSize: t.primitive.fontSize[1].value,
  overflowWrap: "break-word",
  color: t.primitive.color.neutral[1e3].value,
  "&--error": {
    color: t.primitive.color.red[1e3].value
  },
  "&--disabled": {
    color: t.primitive.color.twilight[600].value
  }
}, dr = {
  display: "flex",
  flexDirection: "column",
  rowGap: t.primitive.space["2x"].value,
  border: 0,
  margin: 0,
  padding: 0,
  ".CheckboxGroup__legend": {
    width: "100%",
    marginBottom: `${t.primitive.space["3x"].value}`
  }
}, pr = {
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  gap: t.primitive.space["3x"].value,
  "&--horizontal": {
    flexDirection: "row",
    gap: `${t.primitive.space["1x"].value} ${t.primitive.space["6x"].value}`
  }
}, mr = {
  display: "block",
  fontSize: t.primitive.fontSize[0].value,
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontWeight: 400,
  lineHeight: t.primitive.lineHeights[13].value,
  overflowWrap: "break-word",
  color: t.primitive.color.neutral[1e3].value,
  "&--error": {
    color: t.primitive.color.red[1e3].value
  }
}, ur = {
  display: "none"
}, gr = {}, xr = {
  Label: or,
  LabelContent: ir,
  Content: rr,
  CheckBoxInputWrapper: ar,
  CheckboxInput: nr,
  CheckmarkContainer: lr,
  LabelContainer: sr,
  HelperText: cr,
  CheckBoxGroupFieldSet: dr,
  CheckboxGroup: pr,
  CheckboxGroupHelperText: mr,
  Media: ur,
  TileImage: gr
}, hr = {
  display: "flex",
  flexDirection: "row",
  gap: e.semantic.space["3x"],
  "--checkbox-width": `var(--checkbox-group-width, ${e.semantic.space["5x"]})`,
  "--checkbox-height": `var(--checkbox-group-height, ${e.semantic.space["5x"]})`,
  "&--small": {
    ".Checkbox__input-wrapper": {
      top: "2px"
    }
  },
  "&--medium": {
    "--checkbox-width": e.semantic.space["6x"],
    "--checkbox-height": e.semantic.space["6x"]
  },
  "&--large": {
    "--checkbox-width": e.semantic.space["8x"],
    "--checkbox-height": e.semantic.space["8x"]
  },
  "&--tile": {
    "--_checkbox-tile-padding-inline": `var(--checkbox-tile-padding-inline, ${e.semantic.space["4x"]} )`,
    "--_checkbox-tile-padding-block": `var(--checkbox-tile-padding-block, ${e.semantic.space["6x"]} )`,
    "--_checkbox-tile-width": "var(--checkbox-tile-width, 362px)",
    display: "flex",
    alignItems: "center",
    borderRadius: e.semantic.space["2x"],
    border: `${e.semantic.space[".25x"]} solid ${e.semantic.color.stroke.neutralSubtle}`,
    paddingInline: "var(--_checkbox-tile-padding-inline)",
    paddingBlock: "var(--_checkbox-tile-padding-block)",
    gap: "32px",
    flexDirection: "row",
    width: `calc(
          var(--_checkbox-tile-width) - 
          calc(var(--_checkbox-tile-padding-inline) * 2)
           - ${e.semantic.space[".5x"]})`,
    justifyContent: "space-between",
    "&:has(.CheckBox:checked)": {
      border: `${e.semantic.space[".5x"]} solid ${e.semantic.color.stroke.focus}`,
      backgroundColor: e.semantic.color.fill.primarySubtlest,
      margin: "-1px"
    },
    "&:has(.CheckBox--error)": {
      border: `${e.semantic.space[".25x"]} solid ${e.semantic.color.stroke.danger}`,
      outline: "0px"
    },
    "&:has(.CheckBox:disabled)": {
      border: `${e.semantic.space[".25x"]} solid ${e.semantic.color.stroke.disabled}`,
      outline: "0px"
    },
    "&:has(.CheckBox:disabled):hover": {
      backgroundColor: "transparent"
    },
    "&:has(.CheckBox:focus-visible)": {
      outline: `${e.semantic.space[".5x"]} solid ${e.semantic.color.stroke.focus}`,
      outlineOffset: e.semantic.borderWidth["2x"]
    },
    "&:has(.CheckBox:checked.CheckBox--error)": {
      border: `${e.semantic.space[".5x"]} solid ${e.semantic.color.stroke.danger}`,
      backgroundColor: e.semantic.color.fill.dangerSubtlest
    },
    "&:hover": {
      backgroundColor: e.semantic.color.fill.hover
    },
    [`@media ${i.mobile}`]: {
      width: "100%"
    }
  },
  "&--tile&:not(&--disabled)": {
    cursor: "pointer"
  }
}, br = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: e.semantic.space["3x"]
}, fr = {
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  position: "relative",
  cursor: "pointer",
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.regular.M,
  "&--disabled": {
    color: e.semantic.color.text.placeholder,
    cursor: "auto"
  },
  "&:empty": {
    display: "none"
  },
  "&--tile&": {
    ...e.semantic.typography.body.semiBold.M,
    "&--disabled": {
      "& .Label__text": {
        color: `${e.semantic.color.text.disabled}`
      },
      ".HelperText": {
        color: `${e.semantic.color.text.disabled}`
      }
    }
  }
}, vr = {
  height: "var(--checkbox-height)",
  width: "var(--checkbox-width)",
  lineHeight: "var(--checkbox-height)",
  position: "relative",
  alignSelf: "flex-start",
  flexShrink: 0
}, yr = {
  left: 0,
  height: "var(--checkbox-height)",
  width: "var(--checkbox-width)",
  appearance: "none",
  margin: 0,
  boxSizing: "border-box",
  borderRadius: e.semantic.radius["1x"],
  overflow: "hidden",
  position: "absolute",
  transition: "all 0.12s linear",
  outlineStyle: "solid",
  cursor: "pointer",
  outlineWidth: e.semantic.borderWidth["1x"],
  outlineColor: e.semantic.color.stroke.neutralSubtle,
  backgroundColor: e.semantic.color.fill.default,
  "&:not(:disabled):focus-visible": {
    outlineOffset: "-1px",
    outlineWidth: e.semantic.borderWidth["2x"],
    outlineColor: e.semantic.color.stroke.focus
  },
  "&:not(:disabled):hover": {
    outlineOffset: "-1px",
    outlineWidth: e.semantic.borderWidth["2x"],
    outlineColor: e.semantic.color.stroke.primaryStrongest
  },
  "&:checked": {
    outlineColor: e.semantic.color.stroke.focus,
    backgroundColor: e.semantic.color.fill.primaryStrong,
    "&:not(:disabled):focus-visible": {
      outlineColor: e.semantic.color.stroke.focus,
      outlineOffset: "1px"
    },
    "&:not(:disabled):hover": {
      outlineColor: e.semantic.color.stroke.primaryStrongest,
      backgroundColor: e.semantic.color.action.hover
    }
  },
  "&--error": {
    outlineColor: e.semantic.color.stroke.danger,
    outlineWidth: e.semantic.borderWidth["1x"],
    "&:not(:disabled):focus-visible": {
      outlineColor: e.semantic.color.stroke.danger
    },
    "&:not(:disabled):hover": {
      outlineColor: e.semantic.color.stroke.danger,
      outlineWidth: e.semantic.borderWidth["2x"]
    },
    "&:checked": {
      outlineColor: e.semantic.color.stroke.danger,
      backgroundColor: e.semantic.color.fill.dangerStrong,
      "&:not(:disabled):focus-visible": {
        outlineColor: e.semantic.color.stroke.danger
      },
      "&:not(:disabled):hover": {
        outlineColor: e.semantic.color.action.dangerHover,
        backgroundColor: e.semantic.color.action.dangerHover
      }
    }
  },
  "&:disabled": {
    outlineColor: e.semantic.color.stroke.disabled,
    backgroundColor: e.semantic.color.fill.disabled,
    cursor: "auto",
    "&:focus-visible": {
      outlineColor: e.primitive.color.skyview[400],
      backgroundColor: e.semantic.color.fill.primarySubtle
    },
    "&:checked": {
      outlineColor: e.semantic.color.stroke.disabled,
      backgroundColor: e.semantic.color.action.disabled
    }
  }
}, Cr = {
  "--checkmark-color": e.semantic.color.icon.onColor,
  position: "absolute",
  cursor: "pointer",
  color: "var(--checkmark-color)",
  "&--error": {
    "--checkmark-color": e.semantic.color.icon.onColor
  },
  "&--disabled": {
    cursor: "auto",
    "--checkmark-color": e.semantic.color.fill.disabled
  },
  "img, svg": {
    height: "var(--checkbox-height)",
    width: "var(--checkbox-width)",
    color: "var(--checkmark-color)"
  }
}, $r = {
  width: "100%",
  alignItems: "flex-start",
  "& .Label__text": {
    ...e.semantic.typography.body.regular.M
  },
  fontStyle: "normal",
  ".CheckBox-wrapper--large && .Label__text": {
    ...e.semantic.typography.body.regular.L,
    marginTop: "2px"
  },
  "&--tile": {
    ".Label__text": {
      fontWeight: `${e.primitive.fontWeight.inter.semiBold}`
    }
  }
}, wr = {
  display: "flex",
  width: e.semantic.space["18x"],
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  "&--disabled": {
    opacity: "0.7"
  }
}, kr = {
  height: e.semantic.space["12x"],
  width: e.semantic.space["12x"]
}, Sr = {
  display: "flex",
  flexDirection: "column",
  rowGap: e.semantic.space["3x"],
  border: 0,
  margin: 0,
  padding: 0,
  "&--tile": {
    width: "fit-content",
    ".CheckboxGroup": {
      gap: `${e.semantic.space["6x"]}`,
      flexWrap: "wrap"
    }
  },
  ".CheckboxGroup__legend": {
    width: "100%",
    marginBottom: e.semantic.space["3x"]
  },
  [`@media ${i.mobile}`]: {
    width: "100%"
  }
}, Br = {
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  gap: e.semantic.space["4x"],
  "--checkbox-group-width": e.semantic.space["5x"],
  "--checkbox-group-height": e.semantic.space["5x"],
  "&--medium": {
    gap: e.semantic.space["5x"],
    "--checkbox-group-width": e.semantic.space["6x"],
    "--checkbox-group-height": e.semantic.space["6x"]
  },
  "&--large": {
    gap: e.semantic.space["6x"],
    "--checkbox-group-width": e.semantic.space["8x"],
    "--checkbox-group-height": e.semantic.space["8x"]
  },
  "&--horizontal": {
    flexDirection: "row",
    gap: `${e.semantic.space["1x"]} ${e.semantic.space["6x"]}`
  }
}, Tr = {
  display: "block",
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  overflowWrap: "break-word",
  color: e.semantic.color.text.default,
  letterSpacing: 0,
  margin: 0,
  "&--error": {
    color: e.semantic.color.text.dangerStrong
  }
}, Wr = {
  Label: hr,
  LabelContent: br,
  Content: fr,
  CheckBoxInputWrapper: vr,
  CheckboxInput: yr,
  CheckmarkContainer: Cr,
  LabelContainer: $r,
  CheckBoxGroupFieldSet: Sr,
  CheckboxGroup: Br,
  CheckboxGroupHelperText: Tr,
  TileImage: kr,
  Media: wr
}, Lr = {
  display: "inline-flex",
  boxSizing: "border-box",
  width: "fit-content",
  justifyContent: "center",
  gap: t.primitive.space["2x"].value,
  alignItems: "center",
  borderRadius: t.primitive.radius.full.value,
  userSelect: "none",
  background: t.primitive.color.neutral[200].value,
  color: t.primitive.color.twilight[800].value,
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontSize: t.primitive.fontSize[1].value,
  lineHeight: t.primitive.lineHeights[12].value,
  fontStyle: "normal",
  fontWeight: 400,
  outline: "none",
  ".Chip__close-btn": o({
    closeBtnBgColor: t.primitive.color.neutral["000"].value,
    closeBtnHoverBgColor: "transparent",
    closeBtnFocusOutlineOffset: "1px"
  }),
  "&:not(&--disabled)&--clickable": {
    cursor: "pointer",
    "&:hover": {
      background: t.primitive.color.opacityBlackHex[10].value,
      ".Chip__close-btn": o({
        closeBtnHoverBgColor: "transparent",
        closeBtnBgColor: "transparent"
      })
    },
    "&:focus-visible": {
      outline: `2px solid ${t.primitive.color.neutral[1200].value}`
    }
  },
  "&--small": {
    paddingInline: `${t.primitive.space["4x"].value} ${t.primitive.space["2x"].value}`,
    minHeight: t.primitive.space["5x"].value,
    ...o({ closeBtnSize: t.primitive.fontSize[2].value })
  },
  "&--medium": {
    paddingBlock: t.primitive.space["1x"].value,
    paddingInline: `${t.primitive.space["4x"].value} ${t.primitive.space["2x"].value}`,
    minHeight: t.primitive.space["6x"].value,
    ...o({ closeBtnSize: t.primitive.fontSize[3].value })
  },
  "&:not(&--removable)": {
    paddingInline: t.primitive.space["4x"].value
  },
  "&--disabled": {
    outline: "none",
    pointerEvents: "none"
  },
  ".Chip__badge": {
    display: "none"
  }
}, _r = {
  display: "flex",
  "img, svg": {
    width: t.primitive.space["4x"].value,
    height: t.primitive.space["4x"].value
  }
}, Ir = {
  padding: "5px",
  display: "flex",
  alignItems: "center",
  columnGap: t.primitive.space["2x"].value,
  rowGap: t.primitive.space["3x"].value,
  flexWrap: "wrap",
  "&:not(&.ModalBody)": {
    [`@media ${i.mobile}`]: {
      ".Chip:nth-of-type(n+6)": {
        display: "none"
        //for below 600 width, Max 5 chips will be visible
      }
    },
    [`@media ${i.tablet}`]: {
      ".Chip:nth-of-type(n+11)": {
        display: "none"
        //for between 600 to  1024 width, Max 10 chips will be visible
      }
    },
    [`@media ${i.laptopAndUp}`]: {
      ".Chip:nth-of-type(n+16)": {
        display: "none"
        //for above 1024 width, Max 15 chips will be visible
      }
    }
  }
}, Mr = {
  display: "flex",
  alignItems: "center",
  color: t.primitive.color.twilight[1e3].value,
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontSize: t.primitive.fontSize[1].value,
  fontWeight: 400,
  lineHeight: t.primitive.lineHeights[12].value,
  minHeight: "34px"
}, Dr = {
  display: "flex",
  alignItems: "center",
  gap: t.primitive.space["2x"].value
}, Hr = {
  display: "flex",
  alignItems: "center",
  columnGap: t.primitive.space["2x"].value,
  rowGap: t.primitive.space["3x"].value,
  flexWrap: "wrap",
  padding: "5px"
}, Rr = {
  display: "none",
  pointerEvents: "none"
}, zr = {
  "&--disabled": {
    span: { color: t.primitive.color.neutral["000"].value },
    backgroundColor: t.primitive.color.twilight[600].value
  }
}, Ar = {
  Chip: Lr,
  LeadingIconWrapper: _r,
  ChipGroup: Ir,
  ChipGroupLabel: Mr,
  ActionButtonWrapper: Dr,
  ModalBody: Hr,
  ToggleIcon: Rr,
  ChipBadge: zr
}, Fr = {
  display: "inline-flex",
  boxSizing: "border-box",
  maxWidth: "280px",
  minHeight: e.semantic.space["8x"],
  height: "fit-content",
  justifyContent: "center",
  alignItems: "center",
  gap: e.semantic.space["1x"],
  padding: `${e.semantic.space["1x"]} ${e.semantic.space["3x"]}`,
  border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  borderRadius: e.semantic.radius["2x"],
  userSelect: "none",
  background: e.semantic.color.fill.default,
  cursor: "pointer",
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.medium.S,
  fontStyle: "normal",
  wordBreak: "break-word",
  [`@container ${i.tabletAndUp}`]: {
    maxWidth: "264px"
  },
  [`@container ${i.laptopAndUp}`]: {
    maxWidth: "296px"
  },
  [`@container ${i.desktopAndUp}`]: {
    maxWidth: "288px"
  },
  [`@container ${i.ultraWideScreenAndUp}`]: {
    maxWidth: "360px"
  },
  "&--disabled": {
    background: e.semantic.color.fill.disabled,
    cursor: "not-allowed",
    outline: "none",
    pointerEvents: "none",
    color: e.semantic.color.text.onDisabledStrong
  },
  "&:not(&--disabled):hover": {
    background: e.semantic.color.fill.hover
  },
  "&--active:not(&--disabled)": {
    color: e.semantic.color.text.primaryStrong,
    background: e.semantic.color.fill.primarySubtlest,
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`,
    borderRadius: e.semantic.radius["2x"]
  },
  "&:not(&--disabled):focus-visible": {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    borderRadius: e.semantic.radius["2x"],
    outlineOffset: "2px"
  }
}, Pr = {
  display: "flex",
  "img, svg": {
    width: e.semantic.space["4x"],
    height: e.semantic.space["4x"]
  }
}, Or = {
  padding: "5px",
  display: "flex",
  width: "100%",
  containerType: "inline-size",
  alignItems: "center",
  columnGap: e.semantic.space["2x"],
  rowGap: e.semantic.space["3x"],
  flexWrap: "wrap",
  "&:not(&.ModalBody)": {
    [`@media ${i.mobile}`]: {
      ".Chip:nth-of-type(n+6)": {
        display: "none"
        //for below 600 width, Max 5 chips will be visible
      }
    },
    [`@media ${i.tablet}`]: {
      ".Chip:nth-of-type(n+11)": {
        display: "none"
        //for between 600 to  1024 width, Max 10 chips will be visible
      }
    },
    [`@media ${i.laptopAndUp}`]: {
      ".Chip:nth-of-type(n+16)": {
        display: "none"
        //for above 1024 width, Max 15 chips will be visible
      }
    }
  }
}, Er = {
  display: "flex",
  alignItems: "center",
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.medium.S,
  minHeight: "34px"
}, Vr = {
  display: "flex",
  alignItems: "center",
  gap: e.semantic.space["2x"],
  ".separator": {
    color: e.semantic.color.text.primaryStrong,
    paddingBottom: "2px"
  }
}, Gr = {
  display: "flex",
  alignItems: "center",
  columnGap: e.semantic.space["2x"],
  rowGap: e.semantic.space["3x"],
  flexWrap: "wrap",
  padding: "5px"
}, jr = {
  pointerEvents: "none"
}, Ur = {
  "&--disabled": {
    span: { color: e.semantic.color.text.onColor },
    backgroundColor: e.semantic.color.fill.neutralModerate
  }
}, Xr = {
  Chip: Fr,
  LeadingIconWrapper: Pr,
  ChipGroup: Or,
  ChipGroupLabel: Er,
  ActionButtonWrapper: Vr,
  ModalBody: Gr,
  ToggleIcon: jr,
  ChipBadge: Ur
}, Nr = {
  flexShrink: 0,
  ...o({
    iconBtnBorder: o("closeBtnBorder", "none"),
    iconBtnHoverBorder: o("closeBtnHoverBorder", "none")
  }),
  "&--large": o({
    iconBtnPadding: o("closeBtnPadding", t.semanticMode1.space.xs.value),
    // 4px
    iconBtnSize: o("closeBtnSize", t.semanticMode1.space["4xl"].value)
    // 56px
  }),
  "&--medium": o({
    iconBtnPadding: o("closeBtnPadding", t.semanticMode1.space.xs.value),
    // 4px
    iconBtnSize: o("closeBtnSize", t.semanticMode1.space["3xl"].value)
    // 40px
  }),
  "&--small": o({
    iconBtnPadding: o("closeBtnPadding", t.semanticMode1.space.xs.value),
    // 4px
    iconBtnSize: o("closeBtnSize", t.semanticMode1.space["2xl"].value)
    // 32px
  }),
  "&--xsmall": o({
    iconBtnPadding: o("closeBtnPadding", 0),
    iconBtnSize: o("closeBtnSize", t.semanticMode1.space.xl.value)
    // 24px
  }),
  "&--xxsmall": o({
    iconBtnPadding: o("closeBtnPadding", 0),
    iconBtnSize: o("closeBtnSize", t.semanticMode1.space.lg.value)
    // 16px
  }),
  "&--xxxsmall": o({
    iconBtnPadding: o("closeBtnPadding", 0),
    iconBtnSize: o("closeBtnSize", t.semanticMode1.space.md.value)
    // 12px
  })
}, Yr = {
  ...o({
    iconBtnFocusOutline: o(
      "closeBtnFocusOutline",
      `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onDark.strong.value}`
    )
  }),
  "&--default": o({
    iconBtnTextColor: o("closeBtnTextColor", t.primitive.color.twilight[300].value),
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", t.primitive.color.twilight["000"].value),
    iconBtnDisabledTextColor: o("closeBtnDisabledTextColor", t.semanticMode1.color.text.onDark.subtlestDisabled.value)
  })
}, Zr = {
  // fallbacks
  ...o.fallback({
    iconBtnSize: "closeBtnSize",
    iconBtnHeight: "closeBtnHeight",
    iconBtnWidth: "closeBtnWidth",
    iconBtnPadding: "closeBtnPadding",
    iconBtnBorderRadius: "closeBtnBorderRadius",
    iconBtnIconSize: "closeBtnIconSize",
    iconBtnTextColor: "closeBtnTextColor",
    iconBtnHoverTextColor: "closeBtnHoverTextColor",
    iconBtnBgColor: "closeBtnBgColor",
    iconBtnHoverBgColor: "closeBtnHoverBgColor",
    iconBtnBorder: "closeBtnBorder",
    iconBtnHoverBorder: "closeBtnHoverBorder",
    iconBtnFocusOutline: "closeBtnFocusOutline",
    iconBtnFocusOutlineOffset: "closeBtnFocusOutlineOffset",
    iconBtnDisabledTextColor: "closeBtnDisabledTextColor",
    iconBtnDisabledBorder: "closeBtnDisabledBorder",
    iconBtnDisabledBgColor: "closeBtnDisabledBgColor"
  }),
  ...Nr,
  "&--dark&": Yr
}, ie = { CloseButton: Zr }, Kr = {
  flexShrink: 0,
  ...o({
    iconBtnBorder: o("closeBtnBorder", "none"),
    iconBtnHoverBorder: o("closeBtnHoverBorder", "none")
  }),
  "&--large": o({
    iconBtnPadding: o("closeBtnPadding", e.semantic.space["2x"]),
    // 4px
    iconBtnBorderRadius: o("closeBtnBorderRadius", e.semantic.radius["2x"]),
    // 8px
    iconBtnSize: o("closeBtnSize", e.semantic.space["12x"])
    // 48px
  }),
  "&--medium": o({
    iconBtnPadding: o("closeBtnPadding", e.semantic.space["2x"]),
    // 4px
    iconBtnBorderRadius: o("closeBtnBorderRadius", e.semantic.radius["2x"]),
    // 8px
    iconBtnSize: o("closeBtnSize", e.semantic.space["10x"])
    // 40px
  }),
  "&--small": o({
    iconBtnPadding: o("closeBtnPadding", e.semantic.space["1x"]),
    // 4px
    iconBtnBorderRadius: o("closeBtnBorderRadius", e.semantic.radius["2x"]),
    // 8px
    iconBtnSize: o("closeBtnSize", e.semantic.space["8x"])
    // 32px
  }),
  "&--xsmall": o({
    iconBtnPadding: o("closeBtnPadding", 0),
    iconBtnBorderRadius: o("closeBtnBorderRadius", e.semantic.radius["1x"]),
    // 4px
    iconBtnSize: o("closeBtnSize", e.semantic.space["6x"])
    // 24px
  }),
  "&--xxsmall": o({
    iconBtnPadding: o("closeBtnPadding", 0),
    iconBtnBorderRadius: o("closeBtnBorderRadius", e.semantic.radius["1x"]),
    // 4px
    iconBtnSize: o("closeBtnSize", e.semantic.space["5x"])
    // 20px
  }),
  "&--xxxsmall": o({
    iconBtnPadding: o("closeBtnPadding", 0),
    iconBtnBorderRadius: o("closeBtnBorderRadius", e.semantic.radius["1x"]),
    // 4px
    iconBtnSize: o("closeBtnSize", e.semantic.space["4x"])
    // 16px
  })
}, Qr = {
  "&--default": o({
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", e.semantic.color.icon.default)
  }),
  "&--info": o({
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", e.semantic.color.icon.primaryStrongest)
  }),
  "&--success": o({
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", e.semantic.color.icon.successStrongest)
  }),
  "&--caution": o({
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", e.semantic.color.icon.cautionStrongest)
  }),
  "&--danger": o({
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", e.semantic.color.icon.dangerStrongest)
  })
}, qr = {
  "&--default": o({
    iconBtnTextColor: o("closeBtnTextColor", e.semantic.color.icon.onColor),
    iconBtnHoverBgColor: o("closeBtnHoverBgColor", e.semantic.color.opacity.scrim.white[20]),
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", e.semantic.color.icon.onColor)
  }),
  "&--info": o({
    iconBtnTextColor: o("closeBtnTextColor", e.primitive.color.skyview[500]),
    iconBtnHoverBgColor: o("closeBtnHoverBgColor", e.semantic.color.fill.primaryStrong),
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", e.primitive.color.skyview[500])
  }),
  "&--success": o({
    iconBtnTextColor: o("closeBtnTextColor", e.primitive.color.green[500]),
    iconBtnHoverBgColor: o("closeBtnHoverBgColor", e.semantic.color.icon.success),
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", e.primitive.color.green[500])
  }),
  "&--caution": o({
    iconBtnTextColor: o("closeBtnTextColor", e.primitive.color.amber[500]),
    iconBtnHoverBgColor: o("closeBtnHoverBgColor", e.semantic.color.fill.cautionStrong),
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", e.primitive.color.amber[500])
  }),
  "&--danger": o({
    iconBtnTextColor: o("closeBtnTextColor", e.primitive.color.red[500]),
    iconBtnHoverBgColor: o("closeBtnHoverBgColor", e.semantic.color.fill.dangerStrong),
    iconBtnHoverTextColor: o("closeBtnHoverTextColor", e.primitive.color.red[500])
  })
}, Jr = {
  // fallbacks
  ...o.fallback({
    iconBtnSize: "closeBtnSize",
    iconBtnHeight: "closeBtnHeight",
    iconBtnWidth: "closeBtnWidth",
    iconBtnPadding: "closeBtnPadding",
    iconBtnBorderRadius: "closeBtnBorderRadius",
    iconBtnIconSize: "closeBtnIconSize",
    iconBtnTextColor: "closeBtnTextColor",
    iconBtnHoverTextColor: "closeBtnHoverTextColor",
    iconBtnBgColor: "closeBtnBgColor",
    iconBtnHoverBgColor: "closeBtnHoverBgColor",
    iconBtnBorder: "closeBtnBorder",
    iconBtnHoverBorder: "closeBtnHoverBorder",
    iconBtnFocusOutline: "closeBtnFocusOutline",
    iconBtnFocusOutlineOffset: "closeBtnFocusOutlineOffset",
    iconBtnDisabledTextColor: "closeBtnDisabledTextColor",
    iconBtnDisabledBorder: "closeBtnDisabledBorder",
    iconBtnDisabledBgColor: "closeBtnDisabledBgColor"
  }),
  ...Kr,
  "&--light&": Qr,
  "&--dark&": qr
}, ea = {
  CloseButton: Jr
}, ta = {
  height: "100%",
  width: "100%",
  position: "relative",
  axisEle: {
    height: "0",
    overflow: "hidden",
    position: "absolute",
    top: 0,
    background: "white",
    apexChartsLegendAlignLeft: {
      visibility: "hidden"
    }
  }
}, oa = {
  height: "100%",
  width: "100%",
  overflowX: "auto",
  position: "relative",
  apexchartsYaxisTooltip: {
    padding: "0px"
  },
  apexchartsLegendPositionBottom: {
    maxHeight: "100px"
  },
  apexchartsLegendSeries: {
    display: "flex",
    alignItems: "center",
    padding: e.semantic.space["1x"],
    gap: "10px",
    apexchartsLegendText: {
      paddingLeft: "unset",
      marginLeft: "unset"
    }
  },
  vertical: {
    apexchartsLegendAlignLeftLegendSeries: {
      display: "inline-flex",
      alignItems: "flex-start",
      padding: e.semantic.space["1x"],
      paddingLeft: e.semantic.space["2x"],
      margin: "0",
      width: "100%"
    },
    legendItem: {
      width: "100%"
    },
    apexchartsLegendText: {
      pointerEvents: "none",
      display: "flex",
      justifyContent: "space-between",
      marginLeft: "10px",
      width: "100%",
      lineHeight: e.primitive.typography.lineHeights[500]
    },
    apexchartsLegendMarker: {
      top: e.semantic.space["1x"]
    },
    totalLabel: {
      position: "absolute",
      fontWeight: e.primitive.typography.fontWeights.inter.medium,
      left: "0px",
      margin: "0px",
      paddingTop: e.semantic.space["2x"],
      width: "100%"
    },
    totalText: {
      marginLeft: "0px"
    }
  }
}, ia = {
  Wrapper: ta,
  MainWrapper: oa
}, ra = {
  height: "100%",
  width: "100%",
  position: "relative",
  axisEle: {
    height: "0",
    overflow: "hidden",
    position: "absolute",
    top: 0,
    background: "white",
    apexChartsLegendAlignLeft: {
      visibility: "hidden"
    }
  }
}, aa = {
  height: "100%",
  width: "100%",
  overflowX: "auto",
  position: "relative",
  apexchartsYaxisTooltip: {
    padding: "0"
  },
  apexchartsLegendPositionBottom: {
    maxHeight: "100px"
  },
  apexchartsLegendSeries: {
    display: "flex",
    alignItems: "center",
    padding: e.semantic.space["1x"],
    gap: "10px",
    apexchartsLegendText: {
      paddingLeft: "unset",
      marginLeft: "unset"
    }
  },
  vertical: {
    apexchartsLegendAlignLeftLegendSeries: {
      display: "inline-flex",
      alignItems: "flex-start",
      padding: e.semantic.space["1x"],
      paddingLeft: e.semantic.space["2x"],
      margin: "0",
      width: "100%"
    },
    legendItem: {
      width: "100%"
    },
    apexchartsLegendText: {
      pointerEvents: "none",
      display: "flex",
      justifyContent: "space-between",
      marginLeft: "10px",
      width: "100%",
      lineHeight: e.primitive.typography.lineHeights[500]
    },
    apexchartsLegendMarker: {
      top: e.semantic.space["1x"]
    },
    totalLabel: {
      position: "absolute",
      fontWeight: e.primitive.typography.fontWeights.inter.medium,
      left: "0px",
      margin: "0px",
      paddingTop: e.semantic.space["2x"],
      width: "100%"
    },
    totalText: {
      marginLeft: "0px"
    }
  }
}, na = {
  Wrapper: ra,
  MainWrapper: aa
}, la = {
  "--svg-wrapper-width-global": {
    small: e.semantic.space["8x"],
    default: "36px"
  },
  "--svg-wrapper-height-global": {
    small: e.semantic.space["5x"],
    default: e.semantic.space["6x"]
  },
  input: {
    width: "100%"
  },
  inputNotDisabledPlaceholder: {
    color: e.semantic.color.text.placeholder
  },
  inputDisabledPlaceholder: {
    color: e.semantic.color.text.onDisabledStrong
  }
}, re = {
  Wrapper: la
}, sa = re, ca = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"]
}, da = {
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.regular.L,
  textAlign: "center"
}, pa = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"],
  padding: "0 10px"
}, ma = {
  display: "flex",
  flexDirection: "row",
  gap: e.semantic.space["2x"],
  justifyContent: "end",
  alignItems: "center"
}, ua = {
  "--animateTextFill": e.semantic.color.text.primaryStrong,
  "--animateTextDefault": e.semantic.color.text.onColor
}, ga = {
  position: "relative",
  padding: e.semantic.space["1x"],
  color: e.semantic.color.text.primaryStrong,
  background: "transparent",
  border: "none",
  overflow: "hidden",
  fontSize: e.primitive.typography.fontSize[400],
  outline: "none",
  borderRadius: e.semantic.radius["2x"],
  height: e.semantic.space["10x"],
  alignItems: "center",
  display: "flex",
  cursor: "unset",
  justifyContent: "center",
  "&.mobile": {
    width: "100%",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: e.semantic.color.action.hoverSubtle,
      color: e.semantic.color.text.primaryStrong
    }
  },
  "&.animate": {
    animation: "textColorChange 5s ease-out forwards 3",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      right: "0%",
      width: "100%",
      height: "100%",
      backgroundColor: e.semantic.color.fill.primaryStrong,
      animation: "slide-in-out 5s ease forwards 3",
      zIndex: 0
    }
  },
  "& > .contact": {
    color: "inherit",
    position: "relative",
    zIndex: 1,
    ...e.semantic.typography.body.medium.M,
    textAlign: "left"
  },
  "&:focus-visible": {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: `${e.semantic.borderWidth["2x"]}`
  }
}, ae = {
  CTAMobileWrapper: ca,
  CTATitle: da,
  CTAButtonWrapper: pa,
  CTADesktopWrapper: ma,
  CTAButtonContact: ga,
  CTAMainWrapper: ua
}, xa = ae, ha = {
  margin: "unset",
  color: t.semanticMode1.color.text.onLight.moderateDefault.value,
  width: "100%",
  "&--right": {
    input: {
      textAlign: "right"
    }
  },
  "&--left": {
    input: {
      textAlign: "left"
    }
  },
  "&--center": {
    input: {
      textAlign: "center"
    }
  }
}, ba = {
  display: "flex",
  alignItems: "center",
  color: t.semanticMode1.color.text.onLight.moderateDefault.value,
  "&--typed": {
    color: t.semanticMode1.color.text.onLight.strong.value
  },
  "&--small,&--medium,&--large": {
    ...t.semanticMode1.body2.regular.value
  },
  "&--disabled": {
    color: "unset"
  }
}, fa = {
  CurrencyInput: ha,
  AdornmentContainer: ba
}, va = {
  margin: "unset",
  "&--right": {
    input: {
      textAlign: "right"
    }
  },
  "&--left": {
    input: {
      textAlign: "left"
    }
  },
  "&--center": {
    input: {
      textAlign: "center"
    }
  }
}, ya = {
  display: "flex",
  alignItems: "center",
  color: "unset",
  "&--typed": {
    color: e.semantic.color.text.default
  },
  "&--small": {
    ...e.semantic.typography.body.regular.S
  },
  "&--medium": {
    ...e.semantic.typography.body.regular.M
  },
  "&--large": {
    ...e.semantic.typography.body.regular.L
  },
  "&--disabled": {
    color: "unset"
  }
}, Ca = {
  CurrencyInput: va,
  AdornmentContainer: ya
}, $a = "transparent", u = {
  xs: "24px",
  s: "40px",
  m: "56px",
  l: "72px"
}, wa = {
  padding: t.primitive.space["3x"].value,
  //12px
  cursor: "default",
  "&:hover": {
    backgroundColor: t.semanticMode1.color.text.onDark.moderateDefault.value
  },
  "&:focus-visible:not([disabled])": {
    "&--boxed": {
      outline: `${t.primitive.border["2x"].value} solid ${t.primitive.color.skyView[900].value}`,
      borderRadius: t.primitive.radius["2x"].value,
      //8px
      outlineOffset: "2px",
      zIndex: 2
    },
    " && > div": {
      outline: `${t.primitive.border["2x"].value} solid ${t.primitive.color.skyView[900].value}`,
      borderRadius: t.primitive.radius["1x"].value,
      //4px,
      outlineOffset: "2px",
      zIndex: 2
    }
  },
  "&--boxed": {
    padding: `${t.primitive.radius["2x"].value} ${t.primitive.space["3x"].value}`,
    //8px 12px
    borderRadius: `${t.primitive.radius["2x"].value}`,
    border: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.fill.onDark.moderate.value}`,
    boxSizing: "border-box",
    background: t.semanticMode1.color.fill.onDark.strongest.value
  },
  "&--action": {
    padding: t.primitive.space["3x"].value
  },
  "&--static": {
    background: $a
  },
  "&--active": {
    background: t.primitive.color.twilight[300].value
  },
  "&--event": {
    cursor: "pointer"
  },
  "&& > div": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: t.primitive.radius["2x"].value,
    zIndex: 1
  }
}, ka = {
  display: "flex",
  flexDirection: "column",
  width: "100%"
}, Sa = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  ...t.semanticMode1.body1.medium.value,
  fontStyle: "normal"
}, Ba = {
  display: "flex",
  flexDirection: "row",
  gap: t.primitive.radius["2x"].value,
  alignItems: "center",
  ...t.semanticMode1.body1.regular.value,
  fontStyle: "normal"
}, Ta = {
  zIndex: 1,
  "&--static": {
    borderBottom: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.fill.onDark.moderate.value}`,
    margin: "unset"
  },
  "&--action": {
    borderBottom: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.fill.onDark.moderate.value}`,
    margin: `-1px ${t.primitive.space["3x"].value} 0`
  }
}, Wa = {
  display: "flex",
  alignItems: "center",
  "&--l": {
    " && > img": {
      height: u.l,
      width: u.l,
      borderRadius: t.primitive.radius["1x"].value
      //4px
    }
  },
  "&--m": {
    " && > img": {
      height: u.m,
      width: u.m,
      borderRadius: t.primitive.radius["1x"].value
      //4px
    }
  },
  "&--s": {
    " && > img": {
      height: u.s,
      width: u.s,
      borderRadius: t.primitive.radius["1x"].value
      //4px
    }
  },
  "&--xs": {
    " && > img": {
      height: u.xs,
      width: u.xs,
      borderRadius: t.primitive.radius["1x"].value
      //4px
    }
  }
}, La = {
  display: "flex",
  alignSelf: "center"
}, _a = {
  ...t.semanticMode1.body2.regular.value,
  fontStyle: "normal",
  "&--top": {
    alignSelf: "flex-start"
  },
  alignSelf: "center",
  "&--padding": {
    padding: t.semanticMode1.space.xs.value
    //4px
  },
  display: "flex",
  svg: {
    color: t.semanticMode1.color.stroke.onLight.interactive.value
  },
  ".Switch__slider > svg": {
    color: t.semanticMode1.color.fill.onLight.moderate.value
  }
}, Ia = {
  display: "flex",
  flexDirection: "column",
  width: "100%"
}, Ma = {
  listStyle: "none",
  padding: "unset",
  margin: "unset",
  height: "auto",
  display: "flex",
  flexDirection: "column",
  "&--boxed": {
    gap: t.primitive.radius["2x"].value
  }
}, Da = {
  ListWrapper: wa,
  ListContent: ka,
  PrimaryContent: Sa,
  SecondaryContent: Ba,
  Rule: Ta,
  LeadingElementWrapper: Wa,
  SecondaryIconWrapper: La,
  TrailingElementWrapper: _a,
  TagsAndContent: Ia,
  DataList: Ma,
  elementSize: u
}, E = "transparent", g = {
  xs: "24px",
  s: "40px",
  m: "56px",
  l: "72px"
}, Ha = {
  padding: e.semantic.space["3x"],
  cursor: "default",
  "&:hover": {
    backgroundColor: e.semantic.color.fill.hover
  },
  "&:focus-visible:not([disabled])": {
    "&--boxed": {
      outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
      borderRadius: e.semantic.radius["2x"],
      outlineOffset: "2px",
      zIndex: 2
    },
    " && > div": {
      outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
      borderRadius: e.semantic.radius["1x"],
      outlineOffset: "2px",
      zIndex: 2
    }
  },
  "&--boxed": {
    padding: `${e.semantic.space["2x"]} ${e.semantic.space["3x"]}`,
    borderRadius: `${e.semantic.radius["2x"]}`,
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
    boxSizing: "border-box",
    background: e.semantic.color.fill.default
  },
  "&--action": {
    padding: e.semantic.space["3x"]
  },
  "&--static": {
    background: E,
    "&:hover": {
      backgroundColor: E
    }
  },
  "&--active": {
    background: e.semantic.color.fill.neutralSubtle
  },
  "&--event": {
    cursor: "pointer"
  },
  "&& > div": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: e.semantic.space["2x"],
    zIndex: 1
  }
}, Ra = {
  display: "flex",
  flexDirection: "column",
  width: "100%"
}, za = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.medium.M,
  fontStyle: "normal"
}, Aa = {
  display: "flex",
  flexDirection: "row",
  gap: e.semantic.space["2x"],
  alignItems: "center",
  color: e.semantic.color.text.subtlest,
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal"
}, Fa = {
  zIndex: 1,
  "&--static": {
    borderBottom: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
    margin: "unset"
  },
  "&--action": {
    borderBottom: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
    margin: `-1px ${e.semantic.space["3x"]} 0`
  }
}, Pa = {
  display: "flex",
  alignItems: "center",
  "&--l": {
    " && > img": {
      height: g.l,
      width: g.l,
      borderRadius: e.semantic.radius["1x"]
    }
  },
  "&--m": {
    " && > img": {
      height: g.m,
      width: g.m,
      borderRadius: e.semantic.radius["1x"]
    }
  },
  "&--s": {
    " && > img": {
      height: g.s,
      width: g.s,
      borderRadius: e.semantic.radius["1x"]
    }
  },
  "&--xs": {
    " && > img": {
      height: g.xs,
      width: g.xs,
      borderRadius: e.semantic.radius["1x"]
    }
  }
}, Oa = {
  display: "flex",
  alignSelf: "center"
}, Ea = {
  color: e.semantic.color.text.subtlest,
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  "&--top": {
    alignSelf: "flex-start"
  },
  alignSelf: "center",
  display: "flex",
  svg: {
    color: e.semantic.color.icon.primary
  }
}, Va = {
  display: "flex",
  flexDirection: "column",
  width: "100%"
}, Ga = {
  listStyle: "none",
  padding: "unset",
  margin: "unset",
  height: "auto",
  display: "flex",
  flexDirection: "column",
  "&--boxed": {
    gap: e.semantic.space["2x"]
  }
}, ja = {
  ListWrapper: Ha,
  ListContent: Ra,
  PrimaryContent: za,
  SecondaryContent: Aa,
  Rule: Fa,
  LeadingElementWrapper: Pa,
  SecondaryIconWrapper: Oa,
  TrailingElementWrapper: Ea,
  TagsAndContent: Va,
  DataList: Ga,
  elementSize: g
}, Ua = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["7x"],
  boxSizing: "border-box"
}, Xa = {
  Wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: e.semantic.space["4x"],
    onlyChild: { justifyContent: "right" },
    tabletView: { flexDirection: "row" }
  },
  Container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    gap: e.semantic.space["4x"],
    tabletView: {
      flexDirection: "row",
      justifyContent: "flex-start",
      width: "auto",
      paginationControl: {
        width: "160px"
      }
    },
    paginationControl: {
      width: "100%",
      minWidth: "160px"
    }
  },
  ItemsPerPageDisplay: {
    width: "fit-content",
    ...e.semantic.typography.body.regular.M,
    color: e.semantic.color.text.default
  }
}, Na = {
  Wrapper: {
    borderColor: "transparent",
    backgroundColor: "transparent",
    color: e.semantic.color.text.subtle
  }
}, Ya = {
  Container: {
    width: "100%",
    maxWidth: "315px"
  }
}, Za = {
  TableContainer: {
    borderRadius: e.semantic.radius["2x"],
    border: "1px solid var(--stroke-default, #d1d5d9)",
    width: "100%",
    overflowY: "auto",
    tabletView: {
      overflowX: "auto",
      position: "relative",
      justifyContent: "center",
      alignItems: "center"
    }
  },
  TableComponent: {
    display: "flex",
    background: `var(--color-fill-neutral-subtle, ${e.semantic.color.fill.neutralSubtle}) !important`,
    height: "280px",
    flexDirection: "column",
    width: "100%",
    thead: {
      position: "sticky",
      zIndex: 1,
      top: 0
    },
    mobileView: {
      checkboxEnabled: {
        th: {
          display: "none"
        }
      },
      checkboxDisabled: {
        th: {
          display: "none"
        }
      }
    },
    tabletView: {
      display: "table",
      flexDirection: "unset",
      borderCollapse: "collapse",
      checkboxEnabled: {
        th: {
          display: "table-cell"
        }
      },
      checkboxDisabled: {
        th: {
          display: "table-cell"
        }
      }
    }
  }
}, Ka = {
  borderRadius: "inherit",
  div: {
    alignItems: "flex-start",
    width: "unset",
    borderTop: "unset",
    borderBottom: "unset",
    borderRadius: "unset",
    tabletView: { display: "none" }
  },
  borderTop: "unset",
  borderBottom: "unset"
}, Qa = {
  backgroundColor: { isBackground: "#fafafb", none: "" },
  checkBoxSpan: {
    left: 0,
    top: 0
  },
  borderRadius: "inherit",
  padding: "12px 16px",
  "&& > div": {
    paddingLeft: "unset"
  },
  '[data-component="accordion-dropdown-wrapper"]': {
    color: "unset"
  },
  '[data-component="accordion-title-wrapper"]': {
    height: "unset",
    ...e.semantic.typography.body.regular.M,
    fontStyle: "normal"
  }
}, qa = {
  TableAccordionPanelContentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    gap: e.semantic.space["4x"],
    alignSelf: "stretch"
  },
  TableAccordionPanelContentData: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: e.semantic.space["2x"],
    div: {
      gap: e.semantic.space["3x"],
      alignItems: "center"
    },
    alignSelf: "stretch"
  }
}, Ja = {
  color: "var(--text-default, var(--primitive-color-neutral-1000, #00142e));",
  ...e.semantic.typography.body.regular.M,
  fontStyle: "normal"
}, en = {
  color: "var(--text-subtle, #38485c);",
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal"
}, tn = {
  width: "100%",
  height: "100%",
  justifyContent: "unset",
  margin: "unset",
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["4x"]} ${e.semantic.space["4x"]} ${e.semantic.space["6x"]}`,
  "&& > div": {
    color: "unset",
    fontFamily: "unset",
    fontSize: "unset",
    letterSpacing: "unset",
    lineHeight: "unset"
  }
}, on = {
  marketingBoxShadow: "1px 0px 1px 0px #d1d5d9",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  borderBottomRightRadius: e.semantic.radius["2x"],
  borderBottomLeftRadius: e.semantic.radius["2x"],
  "&& > div:nth-child(2n - 1)": {
    backgroundColor: `var(--fill-neutral-subtlest, ${e.semantic.color.background.neutral}) !important`
  },
  tabletView: {
    display: "table-row-group",
    isColumnButtonEnabled: {
      "&& > tr:last-child": {
        backgroundColor: "transparent !important",
        td: {
          paddingTop: e.semantic.space["6x"],
          height: "unset",
          paddingBottom: "unset"
        }
      }
    },
    "$isstickycolumn, $showcheckboxenabled": {
      td: {
        "nthChild: 2 &:before": {
          content: " ",
          position: "absolute",
          height: "100%",
          width: "10px",
          right: 0,
          top: 0,
          boxShadow: `${e.semantic.space["3x"]} 0px ${e.semantic.space["3x"]} 0px rgba(0, 0, 0, 0.12)`
        },
        firstChild: {
          position: "sticky",
          left: 0,
          backgroundColor: `var(--fill-neutral-subtlest, ${e.semantic.color.fill.default})`
        },
        "nthChild: 2": {
          left: "52px"
        }
      },
      "&& > tr:nth-child(2n)": {
        td: {
          firstChild: {
            backgroundColor: `var(--fill-neutral-subtlest, ${e.semantic.color.background.neutral}) !important`
          }
        }
      }
    },
    $isstickycolumn: {
      td: {
        firstChild: {
          position: "sticky",
          left: 0,
          backgroundColor: `var(--fill-neutral-subtlest, ${e.semantic.color.fill.default})`,
          "&:before": {
            content: " ",
            position: "absolute",
            height: "100%",
            width: "10px",
            right: 0,
            top: 0,
            boxShadow: `${e.semantic.space["3x"]} 0px ${e.semantic.space["3x"]} 0px rgba(0, 0, 0, 0.12)`
          }
        }
      },
      "&& > tr:nth-child(2n)": {
        td: {
          firstChild: {
            even: {
              backgroundColor: `var(--fill-neutral-subtlest, ${e.semantic.color.background.neutral}) !important`
            },
            odd: {
              backgroundColor: `var(--fill-neutral-subtlest, ${e.semantic.color.fill.default}) !important`
            }
          }
        }
      }
    }
  }
}, rn = {
  display: "flex",
  flexDirection: "row",
  gap: e.semantic.space["3x"],
  [i.tabletAndUp]: {
    display: "table-cell",
    height: "56px",
    padding: "4px 16px",
    "div:firstChild": {
      gap: "12px",
      alignItems: { left: "flex-start", right: "flex-end", center: "center" }
    }
  }
}, an = {
  display: "flex",
  '[data-component="checkbox-wrapper"]': {
    label: {
      paddingBottom: "0px"
    }
  }
}, nn = {
  display: "flex",
  justifyContent: "flex-start",
  alignSelf: "stretch",
  color: "var(--text-subtle, #38485c)",
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  marketingTable: {
    ...e.semantic.typography.body.regular.S,
    fontStyle: "normal"
  }
}, ln = {
  display: "flex",
  alignContent: "flex-start",
  justifyContent: "flex-start",
  alignItems: "center",
  color: "var(--semantic-color-text-subtle, #38485c)",
  label: {
    color: "inherit",
    fontWeight: e.primitive.typography.fontWeights.inter.medium
  },
  marketingComparisonTable: {
    small: {
      ...e.semantic.typography.body.semiBold.M,
      color: e.semantic.color.text.default,
      display: "unset",
      width: "100%",
      overflowWrap: "break-word"
    },
    medium: {
      ...e.semantic.typography.body.semiBold.L,
      color: e.semantic.color.text.default,
      display: "unset",
      width: "100%",
      overflowWrap: "break-word"
    },
    large: {
      fontFamily: e.primitive.typography.fontFamilies.inter,
      fontWeight: e.primitive.typography.fontWeights.inter.semiBold,
      lineHeight: e.primitive.typography.lineHeights[700],
      fontSize: e.primitive.typography.fontSize[500],
      color: e.semantic.color.text.default,
      display: "unset",
      width: "100%",
      overflowWrap: "break-word"
    },
    paddingLeft: e.semantic.space["3x"],
    paddingRight: e.semantic.space["3x"],
    buttonWrapper: {
      paddingLeft: e.semantic.space["3x"],
      paddingRight: e.semantic.space["3x"]
    },
    padding: e.semantic.space["4x"],
    height: "100%"
  },
  tabletView: {
    ...e.semantic.typography.body.regular.M,
    fontStyle: "normal"
  },
  showAllContent: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical"
  }
}, sn = {
  height: "32px",
  verticalAlign: "baseline",
  paddingCheckbox: "12px 16px 12px 0px",
  padding: "12px 16px 12px 16px",
  alignItems: "center",
  div: {
    gap: "16px",
    alignItems: "center",
    ...e.semantic.typography.body.medium.M,
    fontStyle: "normal"
  },
  textAlign: "left",
  backgroundColor: "var(--fill-neutral-subtlest, #f2f4f8)",
  tabletView: {
    height: "55px",
    padding: "0px 16px",
    div: {
      ":first-child": {
        gap: e.semantic.space["2x"]
      },
      ":last-child": {
        marginBottom: e.semantic.space["6x"]
      }
    }
  }
}, cn = {
  display: "flex",
  alignItems: "center",
  borderBottom: "1px solid var(--stroke-default, #d1d5d9)",
  backgroundColor: "var(--fill-neutral-subtlest, #fafafb)",
  borderRadius: `${e.semantic.radius["2x"]} ${e.semantic.radius["2x"]} 0 0`,
  th: {
    div: {
      firstChild: {
        div: {
          firstChild: {
            display: "flex"
          }
        }
      }
    }
  },
  tabletView: {
    display: "table-header-group",
    flexDirection: "unset",
    th: {
      position: "sticky",
      zIndex: 1,
      top: 0
    },
    "$isstickycolumn $showcheckboxenabled": {
      th: {
        "nthChild: 2 &before:": {
          content: " ",
          position: "absolute",
          height: "100%",
          width: "10px",
          right: 0,
          top: 0,
          boxShadow: "12px 0px 12px 0px rgba(0, 0, 0, 0.12)"
        }
      },
      firstChild: {
        position: "sticky",
        left: 0,
        zIndex: 2
      },
      "nthChild: 2": {
        left: "52px"
      }
    },
    $isstickycolumn: {
      firstChild: {
        position: "sticky",
        left: 0,
        zIndex: 2,
        before: {
          content: " ",
          position: "absolute",
          height: "100%",
          width: "10px",
          right: 0,
          top: 0,
          boxShadow: "12px 0px 12px 0px rgba(0, 0, 0, 0.12)"
        }
      }
    }
  }
}, dn = {
  display: "table-row",
  borderRadius: "inherit",
  tabletView: {
    display: "table-row",
    "td:not(:first-child)": {
      "div:first-child:only-child": {
        color: "var(--text-subtle, #38485c)"
      }
    }
  },
  width: "100%"
}, pn = {
  width: "100%",
  height: "200px",
  minHeight: "200px",
  backgroundColor: "inherit"
}, mn = {
  display: "flex",
  position: "absolute",
  width: `calc(100% - ${e.semantic.space["6x"]})`,
  height: "200px",
  minHeight: "200px",
  padding: `var(--spacing-3x, ${e.semantic.space["3x"]})`,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: `var(--spacing-2x, ${e.semantic.space["2x"]})`,
  borderBottomRightRadius: e.semantic.space["2x"],
  borderBottomLeftRadius: e.semantic.space["2x"],
  color: `var(--color-text-default, ${e.semantic.color.text.default})`,
  textAlign: "center",
  background: `var(--color-fill-neutral-subtle, ${e.semantic.color.fill.neutralSubtle}) !important`,
  ...e.semantic.typography.body.medium.S,
  fontStyle: "normal",
  "&--marketingTable": {
    borderBottomLeftRadius: "unset",
    borderBottomRightRadius: "unset"
  },
  "&--mobile": {
    position: "unset",
    width: "unset",
    padding: "unset",
    height: "100%",
    minHeight: "unset"
  }
}, un = {
  [`@media ${i.mobile}`]: {
    display: "flex",
    width: "100%",
    backgroundColor: "var(--fill-neutral-subtlest, #f2f4f8)"
  }
}, F = {
  TableContainer: Ua,
  TablePaginationView: Xa,
  TableSortingView: Na,
  TableV1: Za,
  TableAccordionData: Ka,
  TableAccordionItemData: Qa,
  TableAccordionPanelContent: qa,
  TableAccordionPanelContentColumnData: Ja,
  TableAccordionPanelContentTableData: en,
  TableAccordionPanelData: tn,
  TableBody: on,
  TableData: rn,
  TableDataContentContainer: an,
  TableDataDescription: nn,
  TableDataTextContainer: ln,
  TableHeader: sn,
  TableRow: dn,
  TableSearchView: Ya,
  TableHead: cn,
  TableEmptyViewContainer: pn,
  TableEmptyViewWrapper: mn,
  TableHeadTR: un
}, gn = t.semanticMode1.color.stroke.onLight.subtleDividers.value, ne = { ...F.TableBody };
ne.marketingBoxShadow = `1px 0px 1px 0px ${gn}`;
const xn = {
  ...F,
  TableBody: ne
}, hn = {
  position: "relative",
  display: "inline-block",
  paddingBottom: "0",
  width: "fit-content",
  minWidth: "320px",
  "&--fullwidth": {
    width: "100%"
  },
  "&--small": {
    minWidth: "320px"
  },
  "&--large": {
    minWidth: "320px"
  }
}, bn = {
  backgroundColor: "rgba(0 , 0, 0, 0)",
  width: "100vw",
  height: "100vh",
  zIndex: 0,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  position: "fixed"
}, fn = {
  "--svg-wrapper-width-global": "20px",
  "--svg-wrapper-height-global": "20px",
  "&& input": {
    "&::placeholder": {
      color: t.primitive.color.neutral[700].value
    },
    "&:hover:not(:disabled)": {
      cursor: "pointer"
    }
  },
  "&--disabled": {
    "&& input::placeholder": {
      color: t.primitive.color.neutral[600].value
    }
  },
  "&--editable": {
    "&& input:hover:not(:disabled)": {
      cursor: "text"
    }
  }
}, vn = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "20px",
  width: "20px",
  "& > svg": {
    color: t.primitive.color.neutral[900].value,
    "&:focus": {
      borderRadius: t.primitive.radius["3x"].value,
      outline: `2px solid ${t.primitive.color.neutral[1200].value}`,
      outlineOffset: "0"
    }
  },
  "& .DatePicker__Input--icon": {
    cursor: "pointer",
    zIndex: 1,
    height: "20px",
    width: "20px"
  }
}, yn = {
  display: "flex",
  alignItems: "center",
  padding: `${t.primitive.space["2x"]} 0`,
  ...t.semanticMode1.body2.medium.value,
  [`@media ${i.tabletAndUp}`]: {
    padding: 0
  }
}, Cn = {
  lineHeight: 0,
  zIndex: 1,
  opacity: 1,
  cursor: "pointer",
  transition: "opacity 0.2s, transform 0.2s",
  background: "transparent",
  "&--hidden": {
    opacity: 0,
    pointerEvents: "none"
  }
}, $n = {
  flex: 1,
  position: "relative"
}, wn = {
  display: "flex",
  alignItems: "center",
  position: "absolute",
  top: 0,
  bottom: 0,
  left: "50%",
  willChange: "transform, opacity",
  backfaceVisibility: "hidden",
  transform: "translateZ(0)",
  transition: "opacity var(--animation-duration), transform var(--animation-duration)",
  "& > *": {
    padding: "0.2em, 0.5em",
    border: "1px solid transparent",
    display: "flex",
    justifyContent: "content",
    alignItems: "center",
    transform: "translateX(0) scale(1)",
    willChange: "transform",
    borderRadius: "5px"
  },
  "& .Button--default": {
    ...t.semanticMode1.body2.medium.value,
    color: t.primitive.color.skyView[1e3].value
  },
  "&.-hiddenNext": {
    opacity: 0,
    transform: "translateX(50%)"
  },
  "&.-hiddenPrevious": {
    opacity: 0,
    transform: "translateX(-150%)"
  },
  "&.-shown": {
    opacity: 1,
    marginTop: "auto",
    marginBottom: "auto",
    transform: "translateX(-50%)"
  },
  "&.-shownAnimated": {
    animation: "var(--animation-duration) fadeTextToCenter forwards"
  },
  "&:not(.-shown) > *, > *.-hidden": {
    cursor: "default",
    pointerEvents: "none"
  },
  "&:not(.-shown) > *": {
    pointerEvents: "none"
  }
}, kn = {
  "&.Calendar__yearText.-hidden": {
    transform: "translateX(50%)",
    opacity: 0
  },
  "&.Calendar__monthText.-hidden": {
    transform: "translateX(-50%)",
    opacity: 0
  },
  width: "fit-content"
}, Sn = {
  position: "absolute",
  width: "100%",
  height: "84%",
  right: 0,
  left: 0,
  bottom: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  borderRadius: `0 0 ${t.primitive.radius["3x"].value} ${t.primitive.radius["3x"].value}`,
  "&.-open": {
    zIndex: 10,
    borderTop: `0.25px solid ${t.primitive.color.neutral[400].value}`
  }
}, Bn = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, Tn = {
  display: "flex",
  flexWrap: "wrap",
  position: "relative",
  zIndex: 2,
  gap: t.primitive.space["1x"].value,
  backgroundColor: t.primitive.color.neutral["000"].value,
  transform: "translateY(-150%)",
  willChange: "transform",
  transition: "transform 0.6s",
  height: "100%",
  alignContent: "flex-start",
  scrollBarWidth: "none",
  overflow: "scroll",
  width: "100%",
  padding: `0 ${t.primitive.space["2x"].value}`,
  "-ms-overflow-style": "none",
  "&::-webkit-scrollbar": {
    display: "none"
  },
  [`@media ${i.tabletAndUp}`]: {
    padding: `0 ${t.primitive.space["4x"].value}`
  },
  "&.-open": {
    transform: "translateY(0)"
  },
  "&.monthSelector": {
    alignContent: "center",
    borderRadius: `0 0 ${t.primitive.space["3x"].value} ${t.primitive.space["3x"].value}`,
    padding: `0 ${t.primitive.space["2x"].value}`,
    [`@media ${i.tabletAndUp}`]: {
      padding: `0 ${t.primitive.space["4x"].value}`
    }
  }
}, Wn = {
  width: "calc(25% - 3px)",
  display: "flex",
  justifyContent: "center",
  "&:not(.-active) .Calendar__yearSelectorText:not(:disabled)": {
    "&:hover, &:focus": {
      color: t.primitive.color.skyView[1200].value
    }
  },
  "&.-active .Calendar__yearSelectorText": {
    backgroundColor: t.primitive.color.skyView[1e3].value,
    color: t.primitive.color.neutral["000"].value,
    "&:focus-visible": {
      outline: `1px solid ${t.primitive.color.skyView[1e3].value} !important`,
      outlineOffset: "2px"
    },
    opacity: 1
  }
}, Ln = {
  border: "none",
  height: "36px",
  width: "68px",
  cursor: "pointer",
  background: "none",
  borderRadius: t.semanticMode1.radius.sm.value,
  transition: "opacity 0.3s, transform 0.3s",
  ...t.semanticMode1.body2.regular.value,
  color: t.primitive.color.neutral[1200].value,
  "&:focus": {
    background: "none"
  },
  "&:disabled": {
    opacity: 0.5,
    cursor: "default"
  }
}, _n = {
  width: "calc(25% - 3px)",
  display: "flex",
  justifyContent: "center",
  "&:not(.-active) .Calendar__monthSelectorItemText:not(:disabled)": {
    "&:hover, &:focus": {
      color: t.primitive.color.skyView[1200].value
    }
  },
  "&.-active .Calendar__monthSelectorItemText": {
    color: t.primitive.color.neutral["000"].value,
    background: t.primitive.color.skyView[1e3].value,
    "&:focus-visible": {
      outline: `1px solid ${t.primitive.color.skyView[1e3].value}`,
      outlineOffset: "2px"
    },
    opacity: 1
  }
}, In = {
  position: "relative",
  overflow: "hidden",
  minHeight: "260px"
}, Mn = {
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  top: 0,
  left: 0,
  gap: t.primitive.space["1x"].value,
  width: "100%",
  willChange: "transform, opacity",
  transform: "translateZ(0)",
  backfaceVisibility: "hidden",
  transition: "var(--animation-duration)",
  "&.-hiddenPrevious": {
    opacity: "0.5",
    transform: "translateX(-100%)"
  },
  "&.-hiddenNext": {
    opacity: "0.5",
    transform: "translateX(100%)"
  },
  "&.-shown": {
    opacity: "1",
    transform: "translateX(0)"
  },
  "&.-shownAnimated": {
    animation: "var(--animation-duration) FadeContentToCenter forwards"
  }
}, Dn = {
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  "&:last-of-type": {
    justifyContent: "flex-start",
    ".Calendar__day": {
      marginRight: "0",
      [`@media ${i.tabletAndUp}`]: {
        marginRight: "3.5px"
      }
    }
  }
}, Hn = {
  minWidth: t.primitive.space["7x"].value,
  height: t.primitive.space["7x"].value,
  textAlign: "center",
  padding: 0,
  margin: 0,
  transition: "background 0.2s, transform 0.2s, opacity 0.2s",
  border: "1px solid transparent",
  ...t.semanticMode1.body2.regular.value,
  borderRadius: t.primitive.space["1x"].value,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  position: "relative",
  "&:not(.-blank):not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween):not(.-selected)": {
    "&:focus": {
      borderRadius: t.semanticMode1.radius.sm.value,
      borderColor: t.primitive.color.skyView[1e3].value,
      borderWidth: t.primitive.border["1x"].value
    },
    "&:not(.-disabled)&:hover": {
      backgroundColor: t.semanticMode1.color.fill.onLight.subtlest.value
    }
  },
  "&.-selected, &.-selectedStart, &.-selectedEnd": {
    color: t.primitive.color.neutral["000"].value,
    backgroundColor: t.primitive.color.neutral[100].value
  },
  "&.-ltr.-selectedStart, &.-rtl.-selectedStart": {
    selectedBorderRadius: "100em 0 0 100em"
  },
  "&.-selectedBetween": {
    backgroundColor: t.primitive.color.skyView[1e3].value,
    borderRadius: 0
  },
  "&.-selectedEnd": {
    "&.-ltr": {
      borderTopRightRadius: "100em",
      borderBottomRightRadius: "100em"
    },
    "&.-rtl": {
      borderTopLeftRadius: "100em",
      borderBottomLeftRadius: "100em"
    }
  },
  "&.-selectedStart": {
    "&.-rtl": {
      borderTopRightRadius: "100em",
      borderBottomRightRadius: "100em"
    },
    "&.-ltr": {
      borderTopLeftRadius: "100em",
      borderBottomLeftRadius: "100em"
    }
  },
  [`&.-weekend:not(.-selected):not(.-blank):not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween), 
    &.-outofmonth:not(.-selected):not(.-blank):not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween)`]: {
    color: t.primitive.color.neutral[600].value
  },
  "&.-disabled ": {
    cursor: "not-allowed",
    pointerEvents: "all",
    "&:not(.-selected)": {
      color: t.semanticMode1.color.text.onLight.subtlestDisabled.value,
      backgroundColor: t.semanticMode1.color.fill.onLight.subtle.value
    }
  },
  "&.-selected": {
    borderRadius: t.semanticMode1.radius.sm.value,
    borderWidth: t.primitive.border["1x"].value,
    backgroundColor: t.primitive.color.skyView[1e3].value
  },
  "&.-today": {
    "&:not(&.-text) ::after": {
      content: "'•' / ''",
      position: "absolute",
      background: "transparent",
      top: "22px",
      left: "17px",
      fontSize: "12px",
      opacity: 1
    },
    "&.-disabled ": {
      "&:not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween)": {
        cursor: "not-allowed",
        pointerEvents: "all",
        borderRadius: t.semanticMode1.radius.sm.value,
        borderColor: t.primitive.color.neutral[600].value,
        borderWidth: t.primitive.border["1x"].value,
        "& span": {
          color: t.primitive.color.neutral[600].value
        }
      }
    }
  },
  "&.-blank": {
    color: "transparent",
    cursor: "default",
    pointerEvents: "none"
  },
  "&.-text": {
    "& > div:first-child": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      "& > span.Calendar__day--text-marker": {
        fontSize: "10px",
        lineHeight: "14px",
        maxWidth: "40px",
        overflow: "hidden",
        textOverflow: "clip",
        whiteSpace: "nowrap"
      }
    },
    "&.-outlined:not(.-disabled)": {
      "&:not(.-selected)": {
        border: "1px solid",
        borderRadius: t.semanticMode1.radius.sm.value,
        borderColor: t.semanticMode1.color.stroke.onLight.interactive.value,
        color: t.semanticMode1.color.stroke.onLight.interactive.value,
        "&.-outofmonth": {
          borderColor: t.primitive.color.neutral[600].value,
          color: t.primitive.color.neutral[600].value
        }
      }
    }
  }
}, le = {
  margin: 0,
  boxSizing: "border-box",
  direction: "rtl",
  "--animation-duration": "0.4s",
  background: t.primitive.color.neutral["000"].value,
  boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.1)",
  borderRadius: t.primitive.radius["3x"].value,
  position: "relative",
  userSelect: "none",
  display: "flex",
  flexDirection: "column",
  zIndex: 10,
  gap: t.primitive.space["2x"].value,
  padding: t.primitive.space["2x"].value,
  width: "320px",
  [`@media ${i.tabletAndUp}`]: {
    padding: t.primitive.space["2x"].value
  },
  "*": {
    margin: 0,
    boxSizing: "border-box",
    direction: "ltr"
  },
  "&.-rtl *": {
    direction: "rtl"
  },
  "&.-rtl .Calendar__section.-hiddenPrevious": {
    transform: "translateX(100%)"
  },
  "&.-rtl .Calendar__section.-hiddenNext": {
    transform: "translateX(-100%)"
  },
  "&.-noFocusOutline *:focus": {
    outline: "none"
  },
  "&.-rtl .Calendar__monthArrowWrapper.-left": {
    transform: "rotate(-90deg)"
  },
  "&.-rtl .Calendar__monthArrowWrapper.-right": {
    transform: "rotate(90deg)"
  },
  "&.-rtl .Calendar__monthYear.-hiddenNext": {
    transform: "translateX(-150%)"
  },
  "&.-rtl .Calendar__monthYear.-hiddenPrevious": {
    transform: "translateX(50%)"
  },
  "&.-rtl .Calendar__monthText:hover": {
    transform: "translateX(0.2em) scale(0.95)"
  },
  "&.-rtl .Calendar__yearText:hover": {
    transform: "translateX(-0.2em) scale(0.95)"
  },
  "&.-rtl .Calendar__monthYear .Calendar__yearText.-hidden": {
    transform: "translateX(-50%)"
  },
  "&.-rtl .Calendar__monthYear .Calendar__monthText.-hidden": {
    transform: "translateX(50%)"
  }
}, Rn = {
  display: "flex",
  justifyContent: "space-between",
  ...t.semanticMode1.body2.regular.value,
  padding: 0,
  position: "relative"
}, zn = {
  minWidth: t.primitive.space["7x"].value,
  height: "20px",
  display: "block",
  padding: "2px",
  textAlign: "center",
  textDecoration: "none"
}, An = {
  position: "absolute",
  top: "calc(100% + 2px)",
  left: "0",
  width: "100%",
  transform: "translateY(0)",
  opacity: 1,
  animation: "fadeCalendar 0.3s forwards",
  zIndex: 2,
  "&--exceedOverflow": {
    position: "fixed",
    width: le.width,
    left: "unset"
  },
  "&.-top": {
    top: "auto",
    bottom: "calc(100% - 20px)"
  }
}, Fn = {
  // Component styles
  StyledTransparentBackground: bn,
  StyledDatePickerWrapper: hn,
  StyledDatePickerCalenderContainer: An,
  // Calendar Input
  StyledCalendarPickerInput: fn,
  StyledIconWrapper: vn,
  // Calender Header
  StyledCalenderHeader: yn,
  StyledIconButton: Cn,
  StyledMonthYearContainer: $n,
  StyledMonthYearWrapper: wn,
  StyledButton: kn,
  // Calender Selector
  StyledCalendarSelectorAnimationWrapper: Sn,
  StyledCalendarSelectorWrapper: Bn,
  StyledCalendarSelector: Tn,
  StyledCalendarYearSelectorItem: Wn,
  StyledCalendarSelectorText: Ln,
  StyledCalenderMonthSelectorItem: _n,
  // DayList
  StyledCalendarSectionWrapper: In,
  StyledCalendarSection: Mn,
  StyledCalendarWeekRow: Dn,
  StyledCalendarDay: Hn,
  // Calender
  StyledCalendar: le,
  StyledCalendarWeekDays: Rn,
  StyledCalendarWeekDay: zn
}, Pn = {
  textAlign: "left",
  ...t.semanticMode1.caption.regular.value,
  color: t.primitive.color.neutral["000"].value,
  letterSpacing: "unset",
  "& *": {
    color: t.primitive.color.neutral[700].value
  }
}, On = { Disclosure: Pn }, En = {
  textAlign: "left",
  ...e.semantic.typography.body.medium.S,
  letterSpacing: "unset",
  color: e.semantic.color.text.onColor,
  "& *": {
    color: e.semantic.color.text.placeholder
  }
}, Vn = { Disclosure: En }, Gn = {
  "--divider-color": t.primitive.color.neutral[200].value,
  backgroundColor: "var(--divider-color)",
  flex: "1px",
  boxSizing: "border-box"
}, jn = {
  Divider: Gn
}, Un = {
  "--divider-color": e.semantic.color.stroke.default,
  backgroundColor: "var(--divider-color)",
  flex: "1px",
  boxSizing: "border-box"
}, Xn = {
  Divider: Un
}, Nn = {
  apexchartsTooltip: {
    background: e.semantic.color.fill.default
  },
  minHeight: "350px",
  apxLegendPositionLeftRight: {
    justifyContent: {
      legendScroll: "unset",
      default: "center"
    }
  },
  apexLegendSeries: {
    display: "flex",
    margin: "0 auto",
    width: "70%"
  },
  apexLegend: {
    display: "block",
    width: "70%",
    margin: "0 auto"
  },
  mobile: {
    minHeight: "450px",
    apexchartsLegend: {
      maxHeight: "200"
    }
  }
}, se = {
  Wrapper: Nn
}, Yn = se, s = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  contentOverVideo: 15,
  mediaDisclosureButton: 500,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modalOverlay: 8499,
  modal: 8500,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800,
  popupTip: 9999
}, y = {
  LARGE: "700px",
  MEDIUM: "500px",
  SMALL: "400px"
}, Zn = {
  display: "flex",
  flexDirection: "column",
  position: "fixed",
  top: "0",
  height: "100%",
  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.5)",
  backgroundColor: e.semantic.color.fill.default,
  width: "100%",
  "&--left": {
    left: "0"
  },
  "&--right": {
    right: "calc(max(700px * -1, -100%))"
  },
  maxWidth: "unset",
  [`@media ${i.tabletAndUp}`]: {
    "&--small": {
      maxWidth: y.SMALL,
      right: `calc(max(${y.SMALL} * -1, -100%))`
    },
    "&--medium": {
      maxWidth: y.MEDIUM,
      right: `calc(max(${y.MEDIUM} * -1, -100%))`
    },
    "&--large": {
      maxWidth: y.LARGE,
      right: `calc(max(${y.LARGE} * -1, -100%))`
    }
  },
  "&--noBackDrop": {
    position: "static",
    boxShadow: "none",
    borderRight: `1px solid ${e.semantic.color.stroke.default}`,
    display: "flex",
    minWidth: "296px",
    [`@media ${i.laptopAndUp}`]: {
      maxWidth: "296px"
    },
    [`@media ${i.desktopAndUp}`]: {
      maxWidth: "288px"
    },
    [`@media ${i.ultraWideScreenAndUp}`]: {
      maxWidth: "360px"
    }
  }
}, Kn = {
  position: "fixed",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 20, 46, 0.3)",
  zIndex: s.overlay,
  "&--noBackDrop": {
    display: "contents"
  }
}, Qn = {
  minHeight: "80px",
  display: "flex",
  boxSizing: "border-box",
  justifyContent: "space-between",
  alignItems: "center",
  padding: `${e.semantic.space["4x"]} ${e.semantic.space["6x"]}`,
  borderBottom: `${e.semantic.borderWidth["1x"]} solid
    ${e.semantic.color.stroke.default}`,
  color: e.semantic.color.text.default
}, qn = {
  display: "flex",
  maxHeight: "83px",
  borderTop: `${e.semantic.borderWidth["1x"]} solid
    ${e.semantic.color.stroke.default}`,
  justifyContent: "flex-end",
  alignItems: "center",
  padding: `${e.semantic.space["4x"]} ${e.semantic.space["6x"]}`
}, Jn = {
  flexGrow: "1",
  overflowY: "auto",
  padding: e.semantic.space["6x"],
  color: e.semantic.color.text.default,
  marginBlockStart: "unset",
  marginBlockEnd: "unset",
  marginInlineStart: "unset",
  marginInlineEnd: "unset"
}, el = {
  display: "flex",
  flexDirection: "column",
  marginTop: "auto",
  marginBottom: "auto"
}, tl = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
}, ol = {
  marginTop: e.semantic.space["1x"],
  marginRight: e.semantic.space["2x"]
}, il = {
  ...e.semantic.typography.body.medium.L,
  color: e.semantic.color.text.default
}, rl = {
  ...e.semantic.typography.body.regular.S,
  color: e.semantic.color.text.subtlest
}, al = {
  marginRight: e.semantic.space["4x"]
}, nl = {
  display: "flex",
  ".menu-alignment": {
    marginRight: e.semantic.space["2x"]
  }
}, ce = {
  DrawerContainer: Zn,
  Overlay: Kn,
  DrawerHeaderWrapper: Qn,
  DrawerFooterWrapper: qn,
  DrawerChildrenWrapper: Jn,
  DrawerTitleWrapper: el,
  DrawerHeaderButtonsWrapper: tl,
  MenuWrapper: ol,
  Title: il,
  SubtitleWrapper: rl,
  BadgeWrapper: al,
  HeaderActionButtonWrapper: nl
}, ll = ce, sl = {
  width: "100%"
}, cl = {
  Control: sl
}, dl = {
  width: "100%"
}, pl = {
  Control: dl
}, ml = {
  position: "relative",
  display: "inline-block",
  "&--full-width": {
    width: "100%"
  }
}, ul = {
  width: "auto",
  "&--disabled": {
    filter: "grayscale(1)",
    opacity: 0.7,
    pointerEvents: "none",
    ".no-filter &": {
      filter: "unset",
      opacity: "unset"
    }
  }
}, gl = {
  ".scroll": {
    color: t.primitive.color.twilight[300].value,
    gap: "10px"
  },
  display: "none",
  transformOrigin: "top center",
  animation: "menuClose 120ms ease-in-out forwards",
  position: "absolute",
  zIndex: s.dropdown,
  boxSizing: "border-box",
  minHeight: t.semanticMode1.lineHeights[6].value,
  //48px
  padding: `${t.primitive.space["2x"].value} 0`,
  border: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.subtleDividers.value}`,
  borderRadius: t.primitive.space["2x"].value,
  //8px
  backgroundColor: t.semanticMode1.color.text.onDark.strong.value,
  boxShadow: `0px -1px ${t.primitive.border["2x"].value} 0px #0000000F`,
  "&--exceed": {
    position: "fixed",
    width: "max-content"
  },
  "&--menu-open": {
    display: "block",
    animation: "menuOpen 120ms ease-in-out forwards"
  },
  "&-direction--up_left": {
    transformOrigin: "bottom center",
    bottom: `calc(100% + ${t.primitive.space["2x"].value})`,
    left: 0
  },
  "&-direction--up_right": {
    transformOrigin: "bottom center",
    bottom: `calc(100% + ${t.primitive.space["2x"].value})`,
    right: 0
  },
  "&-direction--down_left": {
    top: `calc(100% + ${t.primitive.space["2x"].value})`,
    left: 0
  },
  "&-direction--down_right": {
    top: `calc(100% + ${t.primitive.space["2x"].value})`,
    right: 0
  }
}, xl = {
  listStyle: "none",
  padding: "2px 0",
  margin: "unset",
  height: "auto",
  overflowY: "auto",
  li: {
    display: "none"
  },
  "li.active:not([hover])": {
    backgroundColor: t.semanticMode1.color.fill.onLight.informationalSubtle.value
  },
  "&--searchable": {
    " && > *": {
      "&:not(.list-item)": {
        display: "none"
      }
    }
  },
  "&::-webkit-scrollbar": {
    width: t.primitive.space["2x"].value,
    height: t.primitive.space["1x"].value
  },
  "&::-webkit-scrollbar-corner": {
    background: t.primitive.color.twilight[300].value
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: t.semanticMode1.color.fill.onDark.subtle.value,
    borderRadius: "8px",
    transform: "translateX(calc(100% - 10px))"
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: t.primitive.color.twilight[300].value,
    borderRadius: t.primitive.space["2x"].value
  }
}, hl = {
  display: "block",
  borderBottom: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.subtleDividers.value}`,
  margin: `${t.primitive.space["2x"].value} 0`
}, bl = {
  ...t.semanticMode1.caption.semibold.value,
  color: t.semanticMode1.color.text.onLight.moderateDefault.value,
  fontStyle: "normal",
  letterSpacing: "0.96px",
  textTransform: "uppercase",
  padding: t.primitive.space["2x"].value,
  margin: `0 ${t.primitive.space["2x"].value}`
}, fl = {
  width: "100%"
}, vl = {
  "& > div": {
    padding: `${t.primitive.space["1x"].value} ${t.semanticMode1.space.md.value}`,
    boxSizing: "border-box",
    label: {
      margin: "unset"
    },
    "span[role='alert']": {
      margin: "unset"
    }
  }
}, yl = {
  margin: `0 ${t.primitive.space["2x"].value}`,
  padding: `${t.semanticMode1.space.sm.value}`,
  cursor: "pointer",
  "& > span": {
    label: {
      ".CheckBox__label-container": {
        fontStyle: "normal",
        fontWeight: t.semanticMode1.body1.regular.value.fontWeight,
        lineHeight: "150%",
        color: t.semanticMode1.body1.regular.value.color
      },
      'label[for="select-all"]': {
        ...t.semanticMode1.body1.regular.value
      }
    }
  },
  "& .CheckBox__label": {
    "&:focus-within": {
      outline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.subtleDividers.value}`,
      outlineOffset: "3px",
      borderRadius: t.primitive.space["2x"].value
    },
    "& input[type='checkbox']:focus-visible": {
      outlineColor: t.semanticMode1.color.fill.onDark.subtle.value,
      outlineStyle: "solid",
      outlineWidth: `${t.primitive.border["1x"].value}`,
      outlineOffset: "0px"
    }
  }
}, Cl = {
  display: "flex",
  padding: t.primitive.space["2x"].value,
  justifyContent: "center",
  alignItems: "center",
  gap: t.primitive.space["2x"].value,
  alignSelf: "stretch",
  textAlign: "center",
  ...t.semanticMode1.body1.regular.value,
  color: t.semanticMode1.color.text.onLight.subtle.value,
  fontStyle: "normal"
}, $l = {
  borderRadius: t.primitive.radius["2x"].value,
  backgroundColor: t.semanticMode1.color.text.onDark.strong.value,
  margin: `0 ${t.primitive.space["2x"].value}`,
  "&:focus-visible": {
    outline: "none"
  },
  "&:hover:not([disabled])": {
    backgroundColor: t.semanticMode1.color.fill.onLight.subtlest.value
  },
  "&:focus-visible:not([disabled])": {
    outline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.subtleDividers.value}`,
    borderRadius: t.primitive.radius["2x"].value
    //8px
  },
  "&&.hide": {
    display: "none"
  }
}, wl = {
  all: "unset",
  width: "100%",
  display: "flex",
  gap: t.primitive.space["3x"].value,
  //4px
  padding: t.primitive.space["2x"].value,
  boxSizing: "border-box",
  wordWrap: "break-word",
  alignItems: "flex-start",
  cursor: "pointer",
  ...t.semanticMode1.body2.regular.value,
  color: t.semanticMode1.color.text.onLight.subtle.value,
  fontStyle: "normal",
  letterSpacing: 0,
  "&--disable": {
    color: t.semanticMode1.color.icon.onLight.subtleDisabled.value,
    cursor: "auto",
    "&& .DropdownBaseItem__Item-text-title": {
      color: t.semanticMode1.color.icon.onLight.subtleDisabled.value
    }
  },
  ".DropdownBaseItem__Item-text-title": {
    ...t.semanticMode1.body1.regular.value,
    fontStyle: "normal"
  }
}, kl = {
  display: "flex",
  alignItems: "center",
  color: t.semanticMode1.color.stroke.onLight.strong.value,
  "&--disable": {
    color: t.semanticMode1.color.icon.onLight.subtleDisabled.value
  },
  img: {
    width: t.semanticMode1.space.xl.value,
    height: t.semanticMode1.space.xl.value
  },
  ".radio-section": {
    pointerEvents: "none",
    marginTop: "-2px"
  }
}, Sl = {
  display: "inline",
  color: t.semanticMode1.color.stroke.onLight.strong.value,
  "&--disable": {
    color: t.semanticMode1.color.icon.onLight.subtleDisabled.value
  },
  marginLeft: "auto",
  img: {
    width: t.semanticMode1.space.xl.value,
    height: t.semanticMode1.space.xl.value
  }
}, Bl = {
  MainWrapper: ml,
  TriggerWrapper: ul,
  ContentWrapper: gl,
  ContentList: xl,
  Divider: hl,
  Title: bl,
  Control: fl,
  LocalSearchWrapper: vl,
  SelectAllWrapper: yl,
  NoResult: Cl,
  ListWrapper: $l,
  ItemText: wl,
  LeadingElementWrapper: kl,
  TrailingElementWrapper: Sl
}, Tl = {
  position: "relative",
  display: "inline-block",
  "&--full-width": {
    width: "100%"
  }
}, Wl = {
  width: "auto",
  "&--disabled": {
    filter: "grayscale(1)",
    opacity: 0.7,
    pointerEvents: "none",
    ".no-filter &": {
      filter: "unset",
      opacity: "unset"
    }
  }
}, Ll = {
  ".scroll": {
    marginRight: e.semantic.space["2x"]
  },
  display: "none",
  transformOrigin: "top center",
  animation: "menuClose 120ms ease-in-out forwards",
  position: "absolute",
  zIndex: s.dropdown,
  boxSizing: "border-box",
  minHeight: e.semantic.space["12x"],
  padding: `${e.semantic.space["2x"]} 0`,
  border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  borderRadius: e.semantic.space["2x"],
  backgroundColor: e.semantic.color.fill.default,
  boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.1)",
  "&--exceed": {
    position: "fixed",
    width: "max-content"
  },
  "&--menu-open": {
    display: "block",
    animation: "menuOpen 120ms ease-in-out forwards"
  },
  "&-direction--up_left": {
    transformOrigin: "bottom center",
    bottom: `calc(100% + ${e.semantic.space["2x"]})`,
    left: 0
  },
  "&-direction--up_right": {
    transformOrigin: "bottom center",
    bottom: `calc(100% + ${e.semantic.space["2x"]})`,
    right: 0
  },
  "&-direction--down_left": {
    top: `calc(100% + ${e.semantic.space["2x"]})`,
    left: 0
  },
  "&-direction--down_right": {
    top: `calc(100% + ${e.semantic.space["2x"]})`,
    right: 0
  }
}, _l = {
  listStyle: "none",
  padding: "2px 0",
  margin: "unset",
  height: "auto",
  overflowY: "auto",
  "& > li": {
    display: "none"
  },
  "li.active:not([hover])": {
    backgroundColor: e.semantic.color.fill.primarySubtlest,
    color: e.semantic.color.text.primaryStrongest,
    "div[type]": {
      "span[role='status']": {
        color: e.semantic.color.text.onColor
      }
    },
    "*": {
      color: e.semantic.color.text.primaryStrongest
    }
  },
  "&--searchable": {
    " && > *": {
      "&:not(.list-item)": {
        display: "none"
      }
    }
  },
  "&::-webkit-scrollbar": {
    width: e.semantic.space["2x"],
    height: e.semantic.space["1x"]
  },
  "&::-webkit-scrollbar-corner": {
    background: e.primitive.color.twilight[1200]
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: e.semantic.color.stroke.neutralSubtle,
    borderRadius: "8px",
    transform: "translateX(calc(100% - 10px))"
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: e.semantic.color.fill.neutralSubtle,
    borderRadius: e.semantic.space["2x"]
  }
}, Il = {
  display: "block",
  borderBottom: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  margin: `${e.semantic.space["2x"]} 0`
}, Ml = {
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.semiBold.XS,
  fontStyle: "normal",
  letterSpacing: "0.96px",
  textTransform: "uppercase",
  padding: e.semantic.space["2x"],
  margin: `0 ${e.semantic.space["2x"]}`
}, Dl = {
  width: "100%"
}, Hl = {
  "& > div": {
    padding: `${e.semantic.space["1x"]} ${e.semantic.space["3x"]}`,
    boxSizing: "border-box",
    label: {
      margin: "unset"
    },
    "span[role='alert']": {
      margin: "unset"
    }
  }
}, Rl = {
  padding: `0 ${e.semantic.space["4x"]} 0 ${e.semantic.space["4x"]}`,
  cursor: "pointer",
  "& > span": {
    label: {
      ".CheckBox__label-container": {
        fontStyle: "normal",
        fontWeight: e.primitive.typography.fontWeights.inter.regular,
        lineHeight: "150%",
        color: e.semantic.color.text.default
      }
    }
  },
  "& .CheckBox__label": {
    "&:focus-within": {
      outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
      outlineOffset: "3px",
      borderRadius: e.semantic.space["1x"]
    },
    "& input[type='checkbox']:focus-visible": {
      outlineColor: e.semantic.color.stroke.neutralSubtle,
      outlineStyle: "solid",
      outlineWidth: `${e.semantic.borderWidth["1x"]}`,
      outlineOffset: "0px"
    }
  }
}, zl = {
  display: "flex",
  padding: e.semantic.space["2x"],
  justifyContent: "center",
  alignItems: "center",
  gap: e.semantic.space["2x"],
  alignSelf: "stretch",
  color: e.semantic.color.text.subtle,
  textAlign: "center",
  ...e.semantic.typography.body.regular.M,
  fontStyle: "normal"
}, Al = {
  borderRadius: e.semantic.radius["2x"],
  backgroundColor: e.semantic.color.fill.default,
  margin: `0 ${e.semantic.space["2x"]}`,
  "&:focus-visible": {
    outline: "none"
  },
  "&:hover:not([disabled])": {
    backgroundColor: e.semantic.color.fill.hover
  },
  "&:focus-visible:not([disabled])": {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    borderRadius: e.semantic.radius["2x"]
  },
  "&&.hide": {
    display: "none"
  }
}, Fl = {
  all: "unset",
  width: "100%",
  display: "flex",
  gap: e.semantic.space["3x"],
  padding: e.semantic.space["2x"],
  boxSizing: "border-box",
  wordWrap: "break-word",
  alignItems: "flex-start",
  cursor: "pointer",
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  letterSpacing: 0,
  "&--disable": {
    color: e.semantic.color.text.disabled,
    cursor: "auto",
    "&& .DropdownBaseItem__Item-text-title": {
      color: e.semantic.color.text.disabled
    }
  },
  ".DropdownBaseItem__Item-text-title": {
    color: e.semantic.color.text.default,
    ...e.semantic.typography.body.regular.M,
    fontStyle: "normal"
  }
}, Pl = {
  display: "flex",
  alignItems: "center",
  color: e.semantic.color.text.subtle,
  "&--disable": {
    color: e.semantic.color.text.disabled
  },
  img: {
    width: e.semantic.space["6x"],
    height: e.semantic.space["6x"]
  },
  ".radio-section": {
    pointerEvents: "none"
  }
}, Ol = {
  display: "inline",
  color: e.semantic.color.text.subtle,
  "&--disable": {
    color: e.semantic.color.text.disabled
  },
  marginLeft: "auto",
  img: {
    width: e.semantic.space["6x"],
    height: e.semantic.space["6x"]
  }
}, El = {
  MainWrapper: Tl,
  TriggerWrapper: Wl,
  ContentWrapper: Ll,
  ContentList: _l,
  Divider: Il,
  Title: Ml,
  Control: Dl,
  LocalSearchWrapper: Hl,
  SelectAllWrapper: Rl,
  NoResult: zl,
  ListWrapper: Al,
  ItemText: Fl,
  LeadingElementWrapper: Pl,
  TrailingElementWrapper: Ol
}, Vl = {
  display: "flex",
  flexDirection: "column",
  rowGap: t.primitive.space["5x"].value,
  justifyContent: "space-around"
}, Gl = {
  display: "flex",
  flexDirection: "column",
  gap: t.primitive.space["3x"].value,
  alignItems: "unset",
  textAlign: "unset",
  "&--center&": {
    "not(&--showButtonGroup)": {
      gap: t.primitive.space["1x"].value
    },
    alignItems: "center",
    textAlign: "center"
  }
}, jl = {
  "&--large": k.h4,
  "&--extraLarge": k.h3,
  "&--xxLarge": k.h2,
  color: t.semanticMode1.color.text.onLight.moderateDefault.value
}, Ul = {
  ...t.semanticMode1.body1.regular.value,
  color: t.semanticMode1.color.text.onLight.moderateDefault.value,
  fontStyle: "normal"
}, Xl = {
  display: "flex",
  gap: t.primitive.space["3x"].value,
  flexDirection: "column",
  [`@media ${i.tabletAndUp}`]: {
    flexDirection: "row",
    gap: t.primitive.space["6x"].value,
    justifyContent: "unset",
    "&--center": {
      justifyContent: "center"
    }
  }
}, Nl = {
  ActionButtonWrapper: Xl,
  DescriptionWrapper: Ul,
  FeatureTextWrapper: Gl,
  TitleWrapper: jl,
  FeatureText: Vl
}, Yl = {
  display: "flex",
  flexDirection: "column",
  rowGap: e.semantic.space["6x"],
  justifyContent: "space-around",
  padding: `0px ${e.semantic.space["5x"]}`,
  [`@media ${i.laptopAndUp}`]: {
    padding: "0"
  }
}, Zl = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["3x"],
  alignItems: "unset",
  textAlign: "unset",
  "&--center&": {
    "not(&--showButtonGroup)": {
      gap: e.semantic.space["1x"]
    },
    alignItems: "center",
    textAlign: "center"
  }
}, Kl = {
  "&--large": {
    ...e.semantic.typography.headline.L
  },
  "&--extraLarge": {
    ...e.semantic.typography.headline.XL
  },
  "&--xxLarge": {
    ...e.semantic.typography.headline.XXL
  },
  color: e.semantic.color.text.default
}, Ql = {
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.M,
  fontStyle: "normal"
}, ql = {
  display: "flex",
  gap: e.semantic.space["4x"],
  flexDirection: "column",
  [`@media ${i.tabletAndUp}`]: {
    flexDirection: "row",
    gap: e.semantic.space["6x"],
    justifyContent: "unset",
    "&--center": {
      justifyContent: "center"
    }
  }
}, Jl = {
  ActionButtonWrapper: ql,
  DescriptionWrapper: Ql,
  FeatureTextWrapper: Zl,
  TitleWrapper: Kl,
  FeatureText: Yl
}, es = {
  primitive: {
    color: {
      fordBlue: {
        100: {
          value: "#e6e6ef",
          type: "color",
          description: "This is the Ford Blue brand color with 90% white added."
        },
        200: {
          value: "#cccede",
          type: "color",
          description: "This is the Ford Blue brand color with 80% white added."
        },
        300: {
          value: "#b3b5ce",
          type: "color",
          description: "This is the Ford Blue brand color with 70% white added."
        },
        400: {
          value: "#999dbd",
          type: "color",
          description: "This is the Ford Blue brand color with 60% white added."
        },
        500: {
          value: "#8084ad",
          type: "color",
          description: "This is the Ford Blue brand color with 50% white added."
        },
        600: {
          value: "#666b9d",
          type: "color",
          description: "This is the Ford Blue brand color with 40% white added."
        },
        700: {
          value: "#4d538c",
          type: "color",
          description: "This is the Ford Blue brand color with 30% white added."
        },
        800: {
          value: "#333a7c",
          type: "color",
          description: "This is the Ford Blue brand color with 20% white added."
        },
        900: {
          value: "#1a226b",
          type: "color",
          description: "This is the Ford Blue brand color with 10% white added."
        },
        1e3: {
          value: "#00095b",
          type: "color",
          description: "This is the Ford Blue brand color."
        },
        1100: {
          value: "#000852",
          type: "color",
          description: "This is the Ford Blue brand color with 10% black added."
        },
        1200: {
          value: "#000749",
          type: "color",
          description: "This is the Ford Blue brand color with 20% black added."
        },
        1300: {
          value: "#000640",
          type: "color",
          description: "This is the Ford Blue brand color with 30% black added."
        },
        1400: {
          value: "#00052E",
          type: "color",
          description: "This is the Ford Blue brand color with 50% black added."
        }
      },
      grabber: {
        100: {
          value: "#e8e6fe",
          type: "color",
          description: "This is the Ford Grabber brand color with 90% white added."
        },
        200: {
          value: "#d1ccfd",
          type: "color",
          description: "This is the Ford Grabber brand color with 80% white added."
        },
        300: {
          value: "#b9b3fc",
          type: "color",
          description: "This is the Ford Grabber brand color with 70% white added."
        },
        400: {
          value: "#a299fb",
          type: "color",
          description: "This is the Ford Grabber brand color with 60% white added."
        },
        500: {
          value: "#8b80fa",
          type: "color",
          description: "This is the Ford Grabber brand color with 50% white added."
        },
        600: {
          value: "#7466f8",
          type: "color",
          description: "This is the Ford Grabber brand color with 40% white added."
        },
        700: {
          value: "#5d4df7",
          type: "color",
          description: "This is the Ford Grabber brand color with 30% white added."
        },
        800: {
          value: "#4533f6",
          type: "color",
          description: "This is the Ford Grabber brand color with 20% white added."
        },
        900: {
          value: "#2e19f5",
          type: "color",
          description: "This is the Ford Grabber brand color with 10% white added."
        },
        1e3: {
          value: "#1700f4",
          type: "color",
          description: "This is the Ford Grabber brand color."
        },
        1100: {
          value: "#1500dc",
          type: "color",
          description: "This is the Ford Grabber brand color with 10% black added."
        },
        1200: {
          value: "#1200c3",
          type: "color",
          description: "This is the Ford Grabber brand color with 20% black added."
        },
        1300: {
          value: "#1000AB",
          type: "color",
          description: "This is the Ford Grabber brand color with 30% black added."
        },
        1400: {
          value: "#0C007A",
          type: "color",
          description: "This is the Ford Grabber brand color with 50% black added."
        }
      },
      skyview: {
        100: {
          value: "#e6f1fd",
          type: "color",
          description: "This is the Ford Skyview brand color with 90% white added."
        },
        200: {
          value: "#cde2fc",
          type: "color",
          description: "This is the Ford Skyview brand color with 80% white added."
        },
        300: {
          value: "#b4d4fa",
          type: "color",
          description: "This is the Ford Skyview brand color with 70% white added."
        },
        400: {
          value: "#9bc5f9",
          type: "color",
          description: "This is the Ford Skyview brand color with 60% white added."
        },
        500: {
          value: "#83b7f7",
          type: "color",
          description: "This is the Ford Skyview brand color with 50% white added."
        },
        600: {
          value: "#6aa9f5",
          type: "color",
          description: "This is the Ford Skyview brand color with 40% white added."
        },
        700: {
          value: "#519af4",
          type: "color",
          description: "This is the Ford Skyview brand color with 30% white added."
        },
        800: {
          value: "#388cf2",
          type: "color",
          description: "This is the Ford Skyview brand color with 20% white added."
        },
        900: {
          value: "#1f7df1",
          type: "color",
          description: "This is the Ford Skyview brand color with 10% white added."
        },
        1e3: {
          value: "#066fef",
          type: "color",
          description: "This is the Ford Skyview brand color."
        },
        1100: {
          value: "#0564d7",
          type: "color",
          description: "This is the Ford Skyview brand color with 10% black added."
        },
        1200: {
          value: "#0559bf",
          type: "color",
          description: "This is the Ford Skyview brand color with 20% black added."
        },
        1300: {
          value: "#044EA7",
          type: "color",
          description: "This is the Ford Skyview brand color with 30% black added."
        },
        1400: {
          value: "#033878",
          type: "color",
          description: "This is the Ford Skyview brand color with 50% black added."
        }
      },
      neutral: {
        "000": {
          value: "#ffffff",
          type: "color",
          description: "White 100%"
        },
        100: {
          value: "#fafafb",
          type: "color",
          description: "This is the Twilight brand color with 90% white added."
        },
        200: {
          value: "#f5f6f7",
          type: "color",
          description: "This is the Twilight brand color with 80% white added."
        },
        300: {
          value: "#e6e8ea",
          type: "color",
          description: "This is the Twilight brand color with 70% white added."
        },
        400: {
          value: "#d1d5d9",
          type: "color",
          description: "This is the Twilight brand color with 60% white added."
        },
        500: {
          value: "#9ca3ad",
          type: "color",
          description: "This is the Twilight brand color with 50% white added."
        },
        600: {
          value: "#6b7786",
          type: "color",
          description: "This is the Twilight brand color with 40% white added."
        },
        700: {
          value: "#4d5b6d",
          type: "color",
          description: "This is the Twilight brand color with 30% white added."
        },
        800: {
          value: "#38485c",
          type: "color",
          description: "This is the Twilight brand color with 20% white added."
        },
        900: {
          value: "#1f3047",
          type: "color",
          description: "This is the Twilight brand color with 10% white added."
        },
        1e3: {
          value: "#00142e",
          type: "color",
          description: "This is the Twilight brand color."
        },
        1100: {
          value: "#001025",
          type: "color",
          description: "This is the Twilight brand color with 10% black added."
        },
        1200: {
          value: "#000000",
          type: "color",
          description: "Black 100%"
        }
      },
      green: {
        100: {
          value: "#e6f3e6",
          type: "color",
          description: "This is the green color with 90% white added."
        },
        200: {
          value: "#cce6cc",
          type: "color",
          description: "This is the green color with 80% white added."
        },
        300: {
          value: "#b3dab3",
          type: "color",
          description: "This is the green color with 70% white added."
        },
        400: {
          value: "#99cd99",
          type: "color",
          description: "This is the green color with 60% white added."
        },
        500: {
          value: "#80c180",
          type: "color",
          description: "This is the green color with 50% white added."
        },
        600: {
          value: "#66b466",
          type: "color",
          description: "This is the green color with 40% white added."
        },
        700: {
          value: "#4da84d",
          type: "color",
          description: "This is the green color with 30% white added."
        },
        800: {
          value: "#339b33",
          type: "color",
          description: "This is the green color with 20% white added."
        },
        900: {
          value: "#198f19",
          type: "color",
          description: "This is the green color with 10% white added."
        },
        1e3: {
          value: "#008200",
          type: "color",
          description: "This is the green colour."
        },
        1100: {
          value: "#007500",
          type: "color",
          description: "This is the green color with 10% black added."
        },
        1200: {
          value: "#006800",
          type: "color",
          description: "This is the green color with 20% black added."
        },
        1300: {
          value: "#005B00",
          type: "color",
          description: "This is the green color with 30% black added."
        },
        1400: {
          value: "#004100",
          type: "color",
          description: "This is the green color with 50% black added."
        }
      },
      amber: {
        100: {
          value: "#FCF2E6",
          type: "color",
          description: "This is the amber color with 90% white added."
        },
        200: {
          value: "#F8E4CC",
          type: "color",
          description: "This is the amber color with 80% white added."
        },
        300: {
          value: "#F5D7B3",
          type: "color",
          description: "This is the amber color with 70% white added."
        },
        400: {
          value: "#F1CA99",
          type: "color",
          description: "This is the amber color with 60% white added."
        },
        500: {
          value: "#EEBC80",
          type: "color",
          description: "This is the amber color with 50% white added."
        },
        600: {
          value: "#E7A24D",
          type: "color",
          description: "This is the amber color with 40% white added."
        },
        700: {
          value: "#E0871A",
          type: "color",
          description: "This is the amber color with 30% white added."
        },
        800: {
          value: "#DD7A01",
          type: "color",
          description: "This is the amber color with 20% white added."
        },
        900: {
          value: "#C76E01",
          type: "color",
          description: "This is the amber color with 10% white added."
        },
        1e3: {
          value: "#B16201",
          type: "color",
          description: "This is the amber color."
        },
        1100: {
          value: "#9B5501",
          type: "color",
          description: "This is the amber color with 10% black added."
        },
        1200: {
          value: "#854901",
          type: "color",
          description: "This is the amber color with 20% black added."
        },
        1300: {
          value: "#6F3D01",
          type: "color",
          description: "This is the amber color with 30% black added."
        },
        1400: {
          value: "#583100",
          type: "color",
          description: "This is the amber color with 50% black added."
        }
      },
      red: {
        100: {
          value: "#fbeae7",
          type: "color",
          description: "This is the red color with 90% white added."
        },
        200: {
          value: "#f7d5ce",
          type: "color",
          description: "This is the red color with 80% white added."
        },
        300: {
          value: "#f3c0b6",
          type: "color",
          description: "This is the red color with 70% white added."
        },
        400: {
          value: "#efab9d",
          type: "color",
          description: "This is the red color with 60% white added."
        },
        500: {
          value: "#eb9685",
          type: "color",
          description: "This is the red color with 50% white added."
        },
        600: {
          value: "#e6816c",
          type: "color",
          description: "This is the red color with 40% white added."
        },
        700: {
          value: "#e26c54",
          type: "color",
          description: "This is the red color with 30% white added."
        },
        800: {
          value: "#de573b",
          type: "color",
          description: "This is the red color with 20% white added."
        },
        900: {
          value: "#da4223",
          type: "color",
          description: "This is the red color with 10% white added."
        },
        1e3: {
          value: "#d62d0a",
          type: "color",
          description: "This is the red color."
        },
        1100: {
          value: "#c12909",
          type: "color",
          description: "This is the red color with 10% black added."
        },
        1200: {
          value: "#ab2408",
          type: "color",
          description: "This is the red color with 20% black added."
        },
        1300: {
          value: "#962007",
          type: "color",
          description: "This is the red color with 30% black added."
        },
        1400: {
          value: "#6B1705",
          type: "color",
          description: "This is the red color with 50% black added."
        }
      },
      opacity: {
        light: {
          10: {
            value: "#00142e14",
            type: "color"
          },
          20: {
            value: "#00142e33",
            type: "color"
          },
          30: {
            value: "#00142e4d",
            type: "color"
          },
          40: {
            value: "#00142e66",
            type: "color"
          },
          50: {
            value: "#00142e80",
            type: "color"
          },
          60: {
            value: "#00142e99",
            type: "color"
          },
          70: {
            value: "#00142eb3",
            type: "color"
          },
          80: {
            value: "#00142ecc",
            type: "color"
          },
          90: {
            value: "#00142ee6",
            type: "color"
          },
          100: {
            value: "#00142e",
            type: "color"
          },
          "00": {
            value: "#00142e00",
            type: "color"
          }
        },
        dark: {
          10: {
            value: "#ffffff1a",
            type: "color"
          },
          20: {
            value: "#ffffff33",
            type: "color"
          },
          30: {
            value: "#ffffff4d",
            type: "color"
          },
          40: {
            value: "#ffffff66",
            type: "color"
          },
          50: {
            value: "#ffffff80",
            type: "color"
          },
          60: {
            value: "#ffffff99",
            type: "color"
          },
          70: {
            value: "#ffffffb3",
            type: "color"
          },
          80: {
            value: "#ffffffcc",
            type: "color"
          },
          90: {
            value: "#ffffffe6",
            type: "color"
          },
          100: {
            value: "#ffffff",
            type: "color"
          },
          "00": {
            value: "#ffffff00",
            type: "color"
          }
        }
      },
      yellow: {
        100: {
          value: "#FFF9E5",
          type: "color",
          description: "This is the yellow color with 90% white added."
        },
        200: {
          value: "#FFF2CC",
          type: "color",
          description: "This is the yellow color with 80% white added."
        },
        300: {
          value: "#FFECB2",
          type: "color",
          description: "This is the yellow color with 70% white added."
        },
        400: {
          value: "#FFE699",
          type: "color",
          description: "This is the yellow color with 60% white added."
        },
        500: {
          value: "#FFDF80",
          type: "color",
          description: "This is the yellow color with 50% white added."
        },
        600: {
          value: "#FFD966",
          type: "color",
          description: "This is the yellow color with 40% white added."
        },
        700: {
          value: "#FFD34D",
          type: "color",
          description: "This is the yellow color with 30% white added."
        },
        800: {
          value: "#FFCD33",
          type: "color",
          description: "This is the yellow color with 20% white added."
        },
        900: {
          value: "#FFC61A",
          type: "color",
          description: "This is the yellow color with 10% white added."
        },
        1e3: {
          value: "#FFC000",
          type: "color",
          description: "This is the yellow colour."
        },
        1100: {
          value: "#E5AD00",
          type: "color",
          description: "This is the yellow color with 10% black added."
        },
        1200: {
          value: "#CC9A00",
          type: "color",
          description: "This is the yellow color with 20% black added."
        },
        1300: {
          value: "#B28600",
          type: "color",
          description: "This is the yellow color with 30% black added."
        },
        1400: {
          value: "#664D00",
          type: "color",
          description: "This is the yellow color with 50% black added."
        }
      },
      twilight: {
        100: {
          value: "#fafafb",
          type: "color",
          description: "This is the Twilight brand color with 90% white added."
        },
        200: {
          value: "#f5f6f7",
          type: "color",
          description: "This is the Twilight brand color with 80% white added."
        },
        300: {
          value: "#e6e8ea",
          type: "color",
          description: "This is the Twilight brand color with 70% white added."
        },
        400: {
          value: "#d1d5d9",
          type: "color",
          description: "This is the Twilight brand color with 60% white added."
        },
        500: {
          value: "#9ca3ad",
          type: "color",
          description: "This is the Twilight brand color with 50% white added."
        },
        600: {
          value: "#6b7786",
          type: "color",
          description: "This is the Twilight brand color with 40% white added."
        },
        700: {
          value: "#4d5b6d",
          type: "color",
          description: "This is the Twilight brand color with 30% white added."
        },
        800: {
          value: "#38485c",
          type: "color",
          description: "This is the Twilight brand color with 20% white added."
        },
        900: {
          value: "#1f3047",
          type: "color",
          description: "This is the Twilight brand color with 10% white added."
        },
        1e3: {
          value: "#00142e",
          type: "color",
          description: "This is the Twilight brand color."
        },
        1100: {
          value: "#001025",
          type: "color",
          description: "This is the Twilight brand color with 10% black added."
        },
        1200: {
          value: "#000000",
          type: "color",
          description: "Black 100%"
        },
        1300: {
          value: "#000E20",
          type: "color",
          description: "This is the Ford Twilight brand color with 30% black added."
        },
        1400: {
          value: "#000A17",
          type: "color",
          description: "This is the Ford Twilight brand color with 50% black added."
        },
        "000": {
          value: "#ffffff",
          type: "color",
          description: "White 100%"
        }
      },
      teal: {
        800: {
          value: "#00A5A5",
          type: "color"
        },
        900: {
          value: "#088D95",
          type: "color"
        },
        1e3: {
          value: "#0C7483",
          type: "color",
          description: "Teal base color."
        },
        1100: {
          value: "#0b6778",
          type: "color"
        },
        1200: {
          value: "#085A6E",
          type: "color"
        },
        1300: {
          value: "#034c60",
          type: "color"
        },
        1400: {
          value: "#003F54",
          type: "color"
        }
      },
      orange: {
        800: {
          value: "#E67205",
          type: "color",
          description: "Orange base color"
        },
        900: {
          value: "#C85E0E",
          type: "color"
        },
        1e3: {
          value: "#A84A0E",
          type: "color"
        },
        1100: {
          value: "#973F0C",
          type: "color"
        },
        1200: {
          value: "#86350A",
          type: "color"
        },
        1300: {
          value: "#742A06",
          type: "color"
        },
        1400: {
          value: "#612004",
          type: "color"
        }
      },
      magenta: {
        800: {
          value: "#F644BB",
          type: "color"
        },
        900: {
          value: "#DB199A",
          type: "color",
          description: "Magenta base color"
        },
        1e3: {
          value: "#B11C7E",
          type: "color"
        },
        1100: {
          value: "#981A6C",
          type: "color"
        },
        1200: {
          value: "#7F165B",
          type: "color"
        },
        1300: {
          value: "#650F48",
          type: "color"
        },
        1400: {
          value: "#4B0735",
          type: "color"
        }
      },
      purple: {
        800: {
          value: "#BB6FF9",
          type: "color"
        },
        900: {
          value: "#A15BE0",
          type: "color"
        },
        1e3: {
          value: "#8746C6",
          type: "color",
          description: "Purple base color"
        },
        1100: {
          value: "#793ab8",
          type: "color"
        },
        1200: {
          value: "#6B2EAA",
          type: "color"
        },
        1300: {
          value: "#5D1F9C",
          type: "color"
        },
        1400: {
          value: "#50098E",
          type: "color"
        }
      },
      surface: {
        100: {
          value: "#18222E",
          type: "color",
          description: "Surface level 01dp"
        },
        200: {
          value: "#1D2632",
          type: "color",
          description: "Surface level 02dp"
        },
        300: {
          value: "#1F2935",
          type: "color",
          description: "Surface level 03dp"
        },
        400: {
          value: "#222B37",
          type: "color",
          description: "Surface level 04dp"
        },
        500: {
          value: "#27303B",
          type: "color",
          description: "Surface level 06dp"
        },
        600: {
          value: "#29323D",
          type: "color",
          description: "Surface level 08dp"
        },
        700: {
          value: "#2E3742",
          type: "color",
          description: "Surface level 12dp"
        },
        800: {
          value: "#303944",
          type: "color",
          description: "Surface level 16dp"
        },
        900: {
          value: "#464E58",
          type: "color",
          description: "Surface level 24dp"
        },
        "000": {
          value: "#0C1623",
          type: "color",
          description: "Dark mode background color"
        }
      }
    },
    size: {
      x1: {
        value: "4px",
        type: "sizing",
        description: "4px Radius"
      },
      "2x": {
        value: "8px",
        type: "sizing",
        description: "8px size"
      },
      "3x": {
        value: "12px",
        type: "sizing",
        description: "12px size"
      },
      "4x": {
        value: "16px",
        type: "sizing",
        description: "16px size"
      },
      "5x": {
        value: "20px",
        type: "sizing",
        description: "20px size"
      },
      "6x": {
        value: "24px",
        type: "sizing",
        description: "24px size"
      },
      "7x": {
        value: "28px",
        type: "sizing",
        description: "28px size"
      },
      "8x": {
        value: "32px",
        type: "sizing",
        description: "32px size"
      },
      "10x": {
        value: "40px",
        type: "sizing",
        description: "40px size"
      },
      "12x": {
        value: "48px",
        type: "sizing",
        description: "48px size"
      },
      "15x": {
        value: "60px",
        type: "sizing",
        description: "60px size"
      },
      "16x": {
        value: "64px",
        type: "sizing",
        description: "64px size"
      }
    },
    space: {
      "1x": {
        value: "4px",
        type: "spacing",
        description: "4px spacing"
      },
      "2x": {
        value: "8px",
        type: "spacing",
        description: "8px spacing"
      },
      "3x": {
        value: "12px",
        type: "spacing",
        description: "12px spacing"
      },
      "4x": {
        value: "16px",
        type: "spacing",
        description: "16px spacing"
      },
      "5x": {
        value: "20px",
        type: "spacing",
        description: "20px spacing"
      },
      "6x": {
        value: "24px",
        type: "spacing",
        description: "24px spacing"
      },
      "7x": {
        value: "28px",
        type: "spacing",
        description: "28px spacing"
      },
      "8x": {
        value: "32px",
        type: "spacing",
        description: "32px spacing"
      },
      "10x": {
        value: "40px",
        type: "spacing",
        description: "40px spacing"
      },
      "12x": {
        value: "48px",
        type: "spacing",
        description: "48px spacing"
      },
      "14x": { value: "56px", type: "spacing", description: "56px spacing" },
      "15x": {
        value: "60px",
        type: "spacing",
        description: "60px spacing"
      },
      "16x": {
        value: "64px",
        type: "spacing",
        description: "64px spacing"
      },
      "28x": { value: "112px", type: "spacing", description: "112px spacing" }
    },
    radius: {
      "1x": {
        value: "4px",
        type: "borderRadius",
        description: "4px radius"
      },
      "2x": {
        value: "8px",
        type: "borderRadius",
        description: "8px radius"
      },
      "3x": {
        value: "12px",
        type: "borderRadius",
        description: "12px radius"
      },
      "4x": {
        value: "16px",
        type: "borderRadius",
        description: "16px radius"
      },
      "5x": {
        value: "20px",
        type: "borderRadius",
        description: "20px radius"
      },
      "6x": {
        value: "24px",
        type: "borderRadius",
        description: "24px radius"
      },
      "7x": {
        value: "28px",
        type: "borderRadius",
        description: "28px radius"
      },
      "8x": {
        value: "32px",
        type: "borderRadius",
        description: "32px radius"
      },
      "10x": {
        value: "40px",
        type: "borderRadius",
        description: "40px radius"
      },
      "15x": {
        value: "60px",
        type: "borderRadius",
        description: "60px radius"
      }
    },
    lineHeights: {
      xsmall: {
        value: "16px",
        type: "lineHeights"
      },
      small: {
        value: "20px",
        type: "lineHeights"
      },
      medium: {
        value: "24px",
        type: "lineHeights"
      },
      large: {
        value: "28px",
        type: "lineHeights"
      },
      xlarge: {
        value: "32px",
        type: "lineHeights"
      },
      xxlarge: {
        value: "40px",
        type: "lineHeights"
      },
      xxxlarge: {
        value: "48px",
        type: "lineHeights"
      }
    },
    fontFamilies: {
      fordF1: {
        value: "Ford F-1, sans-serif",
        type: "fontFamilies"
      },
      inter: {
        value: "Inter, sans-serif",
        type: "fontFamilies"
      }
    },
    fontWeights: {
      300: {
        value: "300",
        type: "fontWeights",
        description: "Use for regular weight text."
      },
      400: {
        value: "400",
        type: "fontWeights",
        description: "Use for Medium weight text."
      },
      500: {
        value: "500",
        type: "fontWeights",
        description: "Use for semi-Bold weight Text."
      },
      semiBold: {
        value: "500",
        type: "fontWeights"
      },
      medium: {
        value: "400",
        type: "fontWeights"
      },
      regular: {
        value: "300",
        type: "fontWeights"
      }
    },
    fontSize: {
      xxxsmall: {
        value: "10px",
        type: "fontSizes"
      },
      xxsmall: {
        value: "12px",
        type: "fontSizes"
      },
      xsmall: {
        value: "14px",
        type: "fontSizes"
      },
      small: {
        value: "16px",
        type: "fontSizes"
      },
      medium: {
        value: "18px",
        type: "fontSizes"
      },
      large: {
        value: "20px",
        type: "fontSizes"
      },
      xlarge: {
        value: "22px",
        type: "fontSizes"
      },
      xxlarge: {
        value: "24px",
        type: "fontSizes"
      },
      xxxlarge: {
        value: "28px",
        type: "fontSizes"
      },
      xxxxlarge: {
        value: "32px",
        type: "fontSizes"
      },
      xxxxxlarge: {
        value: "40px",
        type: "fontSizes"
      }
    },
    borderWidth: {
      "1x": {
        value: "1px",
        type: "borderWidth",
        description: "1px width"
      },
      "2x": {
        value: "2px",
        type: "borderWidth",
        description: "2px width"
      },
      "4x": {
        value: "4px",
        type: "borderWidth",
        description: "4px width"
      },
      "8x": {
        value: "8px",
        type: "borderWidth",
        description: "8px width"
      }
    }
  }
}, de = {
  marginBlockStart: "unset",
  marginBlockEnd: "unset",
  marginInlineStart: "unset",
  marginInlineEnd: "unset"
}, ts = {
  display: "flex",
  padding: "unset",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: t.semanticMode1.space.lg.value,
  width: "100%"
}, os = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: t.semanticMode1.space.xs.value
}, is = {
  ...de,
  ...t.semanticMode1.caption.regular.value,
  color: t.semanticMode1.color.text.onLight.subtle.value,
  fontStyle: "normal"
}, rs = {
  boxSizing: "border-box",
  display: "flex",
  height: "160px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: t.semanticMode1.space.sm.value,
  alignSelf: "stretch",
  borderRadius: t.semanticMode1.radius.md.value,
  textAlign: "center",
  border: `${t.primitive.border["1x"].value} dashed ${t.semanticMode1.color.stroke.onLight.subtleDividers.value}`,
  "&:hover": {
    border: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactive.value}`,
    background: es.primitive.color.skyview[100].value
  },
  "&:focus": {
    outline: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus.value}`,
    border: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus.value}`
  },
  "&--disabled": {
    color: t.semanticMode1.color.text.onLight.subtlestDisabled.value,
    border: `${t.primitive.border["1x"].value} dashed ${t.semanticMode1.color.stroke.onLight.disabled.value}`,
    "&:hover": {
      border: `${t.primitive.border["1x"].value} dashed ${t.semanticMode1.color.stroke.onLight.disabled.value}`,
      background: "none"
    },
    "&:focus": {
      border: `${t.primitive.border["1x"].value} dashed ${t.semanticMode1.color.stroke.onLight.disabled.value}`,
      outline: "none"
    }
  }
}, as = {
  width: t.semanticMode1.space["2xl"].value,
  height: t.semanticMode1.space["2xl"].value,
  "& > svg": {
    width: t.semanticMode1.space["2xl"].value,
    height: t.semanticMode1.space["2xl"].value,
    fill: t.semanticMode1.color.icon.onLight.strongDefault.value,
    "& > *": {
      fill: t.semanticMode1.color.icon.onLight.strongDefault.value
    }
  },
  "&--disabled": {
    "& > svg": {
      fill: t.semanticMode1.color.icon.onLight.subtleDisabled.value,
      "& > *": {
        fill: t.semanticMode1.color.icon.onLight.subtleDisabled.value
      }
    }
  }
}, ns = {
  ...de,
  pointerEvents: "none",
  textAlign: "center",
  ...t.semanticMode1.body2.light.value,
  color: t.semanticMode1.color.text.onLight.subtle.value,
  "& > span": {
    color: t.semanticMode1.color.text.onLight.interactive.value,
    pointerEvents: "all",
    cursor: "pointer"
  },
  "&--disabled": {
    color: t.semanticMode1.color.text.onLight.subtlestDisabled.value,
    "& > span": {
      color: t.semanticMode1.color.text.onLight.subtlestDisabled.value
    }
  }
}, ls = {
  width: "100%",
  display: "flex",
  boxSizing: "border-box",
  padding: `${t.semanticMode1.space.lg.value} ${t.semanticMode1.space.lg.value} ${t.semanticMode1.space.lg.value} ${t.semanticMode1.space.xl.value}`,
  flexDirection: "column",
  alignItems: "flex-start",
  gap: `${t.semanticMode1.space.xl.value}`,
  flexShrink: 0,
  borderRadius: `${t.semanticMode1.radius.md.value}`,
  border: `${t.primitive.border["1x"]} solid ${t.semanticMode1.color.stroke.onLight.moderateDefault}`
}, ss = {
  display: "flex",
  width: "100%",
  flexDirection: "row",
  gap: t.semanticMode1.space.sm.value,
  "& .Label__wrapper": {
    width: "100%"
  }
}, cs = {
  padding: `${t.semanticMode1.space.sm.value} 0`,
  paddingLeft: t.semanticMode1.space.sm.value,
  paddingRight: t.semanticMode1.space.sm.value,
  boxSizing: "content-box",
  display: "flex",
  alignItems: "center",
  gap: t.semanticMode1.space.sm.value,
  color: t.semanticMode1.color.icon.onLight.strongDefault.value,
  "& .Icon": {
    cursor: "pointer",
    "&.disabled": {
      cursor: "default",
      color: t.semanticMode1.color.icon.onLight.subtleDisabled.value
    }
  }
}, ds = {
  StyledFileUploadContainer: ts,
  StyledFileHeader: os,
  StyledFileHeaderHelperText: is,
  StyledDropZoneWrapper: rs,
  StyledDropZoneIconWrapper: as,
  StyledDropzoneTextwrapper: ns,
  StyledFileProgressContainer: ls,
  StyledProgressWrapper: ss,
  StyledIconWrapper: cs
}, pe = {
  marginBlockStart: "unset",
  marginBlockEnd: "unset",
  marginInlineStart: "unset",
  marginInlineEnd: "unset"
}, ps = {
  display: "flex",
  padding: "unset",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: `${e.semantic.space["4x"]}`,
  width: "100%"
}, ms = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: `${e.semantic.space["2x"]}`
}, us = {
  ...pe,
  color: e.semantic.color.text.subtlest,
  ...e.semantic.typography.body.medium.XS,
  fontStyle: "normal"
}, gs = {
  boxSizing: "border-box",
  display: "flex",
  height: "160px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: `${e.semantic.space["2x"]}`,
  alignSelf: "stretch",
  borderRadius: `${e.semantic.radius["2x"]}`,
  textAlign: "center",
  border: `${e.semantic.borderWidth["1x"]} dashed ${e.semantic.color.stroke.neutralSubtle}`,
  "&:hover": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.primaryStrongest}`,
    background: e.semantic.color.action.hoverSubtle
  },
  "&:focus": {
    outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.primaryStrongest}`,
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.primaryStrongest}`
  },
  "&--disabled": {
    color: e.semantic.color.text.disabled,
    border: `${e.semantic.borderWidth["1x"]} dashed ${e.semantic.color.stroke.disabled}`,
    "&:hover": {
      border: `${e.semantic.borderWidth["1x"]} dashed ${e.semantic.color.stroke.disabled}`,
      background: "none"
    },
    "&:focus": {
      border: `${e.semantic.borderWidth["1x"]} dashed ${e.semantic.color.stroke.disabled}`,
      outline: "none"
    }
  }
}, xs = {
  width: e.semantic.space["8x"],
  height: e.semantic.space["8x"],
  "& > svg": {
    width: e.semantic.space["8x"],
    height: e.semantic.space["8x"],
    fill: e.semantic.color.icon.neutralStrong,
    "& > *": {
      fill: e.semantic.color.icon.neutralStrong
    }
  },
  "&--disabled": {
    "& > svg": {
      fill: e.semantic.color.icon.disabled,
      "& > *": {
        fill: e.semantic.color.icon.disabled
      }
    }
  }
}, hs = {
  ...pe,
  pointerEvents: "none",
  color: e.semantic.color.text.subtle,
  textAlign: "center",
  ...e.semantic.typography.body.regular.XS,
  fontStyle: "normal",
  "& > span": {
    color: e.semantic.color.text.primaryStrong,
    pointerEvents: "all",
    cursor: "pointer"
  },
  "&--disabled": {
    color: e.semantic.color.text.disabled,
    "& > span": {
      color: e.semantic.color.text.disabled
    }
  }
}, bs = {
  width: "100%",
  display: "flex",
  boxSizing: "border-box",
  padding: `${e.semantic.space["4x"]} ${e.semantic.space["4x"]} ${e.semantic.space["4x"]} ${e.semantic.space["5x"]}`,
  flexDirection: "column",
  alignItems: "flex-start",
  gap: `${e.semantic.space["6x"]}`,
  flexShrink: 0,
  borderRadius: `${e.semantic.radius["2x"]}`,
  border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`
}, fs = {
  display: "flex",
  width: "100%",
  flexDirection: "row",
  gap: `${e.semantic.space["2x"]}`,
  "& .Label__wrapper": {
    width: "100%"
  }
}, vs = {
  padding: `${e.semantic.space["2x"]} 0`,
  paddingLeft: e.semantic.space["2x"],
  paddingRight: e.semantic.space["2x"],
  boxSizing: "content-box",
  display: "flex",
  alignItems: "center",
  gap: `${e.semantic.space["2x"]}`,
  color: e.semantic.color.icon.default,
  "& .Icon": {
    cursor: "pointer",
    "&.disabled": {
      cursor: "default",
      color: e.semantic.color.text.disabled
    }
  },
  svg: {
    width: `${e.semantic.space["6x"]} !important`,
    height: `${e.semantic.space["6x"]} !important`
  }
}, ys = {
  StyledFileUploadContainer: ps,
  StyledFileHeader: ms,
  StyledFileHeaderHelperText: us,
  StyledDropZoneWrapper: gs,
  StyledDropZoneIconWrapper: xs,
  StyledDropzoneTextwrapper: hs,
  StyledFileProgressContainer: bs,
  StyledProgressWrapper: fs,
  StyledIconWrapper: vs
}, Cs = {
  display: "flex",
  gap: e.semantic.space["2x"],
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "flex-start",
  "& > *": {
    width: "fit-content "
  }
}, $s = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["6x"],
  flexWrap: "wrap"
}, ws = {
  display: "flex",
  gap: e.semantic.space["2x"],
  flexWrap: "wrap"
}, ks = {
  width: "100%"
}, me = {
  FilterGroup: Cs,
  FilterContainer: $s,
  ChipGroupContainer: ks,
  TableFilterContainer: ws
}, Ss = me, Bs = {
  border: `1px solid ${t.primitive.color.twilight[400].value}`,
  backgroundColor: {
    primary: t.primitive.color.skyView[1e3].value,
    white: t.primitive.color.neutral["000"].value,
    twilight: t.primitive.color.twilight[1200].value,
    defaultGrey: t.primitive.color.neutral[50].value,
    lightGrey: t.primitive.color.neutral[300].value,
    midGrey: t.primitive.color.neutral[400].value,
    darkGrey: t.primitive.color.twilight[500].value,
    transparent: "transparent"
  }
}, Ts = {
  Container: Bs
}, Ws = {
  border: `1px solid ${e.semantic.color.stroke.default}`,
  backgroundColor: {
    primary: e.primitive.color.skyview[1e3],
    white: e.primitive.color.neutral["000"],
    twilight: e.primitive.color.twilight[1200],
    defaultGrey: e.primitive.color.neutral[300],
    lightGrey: e.primitive.color.neutral[300],
    midGrey: e.primitive.color.neutral[400],
    darkGrey: e.primitive.color.twilight[500],
    transparent: "transparent"
  }
}, Ls = {
  Container: Ws
}, _s = {
  backgroundColor: e.semantic.color.fill.default,
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  laptopAndUp: {
    flexDirection: "row",
    minHeight: "172px"
  },
  desktopAndUp: {
    minHeight: "188px"
  }
}, Is = {
  padding: e.semantic.space["8x"],
  display: "flex",
  alignItems: { enableButton: "center", default: "flex-start" },
  justifyContent: { enableButton: "center", default: "flex-start" },
  flexDirection: "column",
  borderTop: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  wordBreak: "break-word",
  laptopAndUp: {
    width: "100%",
    padding: e.semantic.space["6x"],
    borderTop: "unset",
    borderLeft: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`
  },
  desktopAndUp: {
    padding: e.semantic.space["8x"]
  }
}, Ms = {
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: e.semantic.space["2x"],
  width: "100%",
  a: {
    ...e.semantic.typography.body.medium.S
  }
}, Ds = {
  laptopAndUp: {
    gap: "unset"
  }
}, Hs = {
  color: e.semantic.color.text.subtle,
  textAlign: "start",
  ...e.semantic.typography.body.medium.S
}, Rs = {
  ...e.semantic.typography.headline.XL,
  textAlign: "start",
  color: e.semantic.color.text.default
}, zs = {
  display: "flex",
  alignItems: "center",
  gap: e.semantic.space["2x"]
}, As = { color: e.semantic.color.text.subtle }, ue = {
  GlobalWrapper: _s,
  ItemWrapper: Is,
  ItemInnerWrapper: Ms,
  ItemDataWrapper: Ds,
  TitleWrapper: Hs,
  ValueWrapper: Rs,
  DescriptionWrapper: As,
  DescriptionContainer: zs
}, Fs = {
  ...ue
}, Ps = {
  width: "100%",
  height: "auto",
  overflow: "unset !important"
}, Os = {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  height: "auto",
  boxSizing: "border-box"
}, Es = {
  width: "auto",
  minWidth: "8.33%",
  flexGrow: "1",
  height: "auto",
  boxSizing: "border-box",
  padding: "0",
  startItem: {
    paddingLeft: "unset"
  },
  endItem: {
    paddingRight: "unset"
  }
}, Vs = {
  height: "auto",
  boxSizing: "border-box",
  padding: "0",
  startItem: {
    paddingLeft: "unset"
  },
  endItem: {
    paddingRight: "unset"
  }
}, Gs = {
  FlexGridWrapper: Es,
  GridItemWrapper: Vs,
  GridWrapper: Os,
  MainWrapper: Ps
}, js = {
  width: "100%",
  height: "auto",
  overflow: "unset !important"
}, Us = {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  height: "auto",
  boxSizing: "border-box"
}, Xs = {
  width: "auto",
  minWidth: "8.33%",
  flexGrow: "1",
  height: "auto",
  boxSizing: "border-box",
  padding: "0",
  startItem: {
    paddingLeft: "unset"
  },
  endItem: {
    paddingRight: "unset"
  }
}, Ns = {
  height: "auto",
  boxSizing: "border-box",
  padding: "0",
  startItem: {
    paddingLeft: "unset"
  },
  endItem: {
    paddingRight: "unset"
  }
}, Ys = {
  FlexGridWrapper: Xs,
  GridItemWrapper: Ns,
  GridWrapper: Us,
  MainWrapper: js
}, Zs = {
  overflowX: "auto",
  mobile: {
    maxWidth: "100%",
    overflowX: "auto"
  }
}, Ks = {
  markerWidth: "68.5px",
  markerHeight: e.semantic.space["2x"]
}, Qs = {
  Wrapper: Zs,
  strapMarkerWidthAndHeight: Ks
}, qs = {
  overflowX: "auto",
  mobile: {
    maxWidth: "100%",
    overflowX: "auto"
  }
}, Js = {
  markerWidth: "68.5px",
  markerHeight: e.semantic.space["2x"]
}, ec = {
  Wrapper: qs,
  strapMarkerWidthAndHeight: Js
}, tc = {
  display: "flex",
  flexDirection: "column",
  gap: t.primitive.space["1x"].value,
  alignSelf: "stretch",
  cursor: "default"
}, oc = {
  paddingTop: "2px"
}, ic = {
  display: "flex",
  gap: t.primitive.space["2x"].value,
  textAlign: "left",
  wordBreak: "break-word",
  flex: "1 0 0",
  alignItems: "center",
  ...t.semanticMode1.caption.regular.value,
  color: t.primitive.color.neutral[700].value,
  pointerEvents: "none",
  "&--error": {
    color: t.primitive.color.red[1e3].value
  },
  "&--caution": {
    color: t.primitive.color.amber[1e3].value
  },
  "&--success": {
    color: t.primitive.color.green[1e3].value
  },
  "&--disabled": {
    color: t.primitive.color.neutral[700].value
  },
  "& > span": {
    paddingTop: "2px"
  }
}, rc = {
  HelperTextWrapper: tc,
  Icon: oc,
  StyledHelperText: ic
}, ac = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"],
  alignSelf: "stretch",
  cursor: "default"
}, nc = {
  paddingTop: "2px"
}, lc = {
  display: "flex",
  gap: e.semantic.space["2x"],
  textAlign: "left",
  wordBreak: "break-word",
  flex: "1 0 0",
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  color: e.semantic.color.text.subtle,
  pointerEvents: "none",
  "&--error": {
    color: `${e.semantic.color.text.dangerStrong} !important`
  },
  "&--disabled": {
    color: e.semantic.color.text.subtle
  },
  "&--caution": {
    color: "#854901"
  },
  "&--success": {
    color: e.semantic.color.text.successStrong
  }
}, sc = {
  HelperTextWrapper: ac,
  Icon: nc,
  StyledHelperText: lc
}, cc = {
  "--_hero-container": "var(--hero-container, Hero / inline-size)",
  "--_hero-min-height": "var(--hero-min-height, 680px)",
  display: "flex",
  height: "auto",
  width: "100%",
  position: "relative",
  overflow: "hidden",
  isolation: "isolate",
  container: "var(--_hero-container)",
  minHeight: "var(--_hero-min-height)",
  [`@media ${i.mobile}`]: {
    "--_hero-min-height": "var(--hero-min-height, 80dvh)"
  },
  "&--dark": {
    "--_hero-text-color": `var(--hero-text-color, ${t.semanticMode1.color.text.onDark.moderateDefault.value})`,
    "--_hero-bg-color": `var(--hero-bg-color, ${t.primitive.color.opacityBlack[100].value})`
  },
  "&--light": {
    "--_hero-text-color": "var(--hero-text-color, currentColor)",
    "--_hero-bg-color": `var(--hero-bg-color, ${t.primitive.color.opacityWhite[100].value})`
  }
}, dc = {
  position: "absolute",
  inset: 0,
  zIndex: 0,
  width: "100%",
  height: "100%",
  background: `linear-gradient(
    to bottom,
    color-mix(in srgb, var(--_hero-overlay-color), transparent 80%) 0%,
    transparent 50%,
    color-mix(in srgb, var(--_hero-overlay-color), transparent 0%) 100%
  )`,
  "&--dark": {
    "--_hero-overlay-color": `var(--hero-overlay-color, ${t.primitive.color.opacityBlack[100].value})`,
    "--_hero-overlay-color-opacity": "var(--hero-overlay-color-opacity, 80%)"
  },
  "&--dark&--playing": {
    "--_hero-overlay-color-opacity": "var(--hero-overlay-playing-color-opacity, 80%)"
  },
  "&--light": {
    "--_hero-overlay-color": `var(--hero-overlay-color, ${t.primitive.color.opacityWhite[100].value})`,
    "--_hero-overlay-color-opacity": "var(--hero-overlay-color-opacity, 50%)"
  },
  "&--light&--playing": {
    "--_hero-overlay-color-opacity": "var(--hero-overlay-playing-color-opacity, 50%)"
  }
}, pc = {
  "--_hero-content-gap": `var(--hero-content-gap, ${t.semanticMode1.space.sm.value})`,
  "--_hero-content-padding-block": "var(--hero-content-padding-block, 56px)",
  "--_hero-content-padding-inline": "var(--hero-content-padding-inline, 56px)",
  "--_hero-navbar-height": "var(--hero-navbar-height, 80px)",
  "--_hero-content-max-width": `var(--hero-content-max-width, ${j.desktopMin}px)`,
  position: "relative",
  zIndex: 1,
  display: "inline-flex",
  boxSizing: "border-box",
  flexDirection: "column",
  gap: "var(--_hero-content-gap)",
  width: "100%",
  marginInline: "auto",
  paddingInline: "var(--_hero-content-padding-inline, 56px)",
  paddingBlock: "var(--_hero-content-padding-block, 56px)",
  overflow: "hidden",
  color: "var(--_hero-text-color)",
  maxWidth: "var(--_hero-content-max-width)",
  "&--left, &--top-left, &--bottom-left": {
    alignItems: "start",
    textAlign: "left"
  },
  "&--right, &--top-right, &--bottom-right": {
    alignItems: "end",
    textAlign: "right"
  },
  "&--center, &--top, &--bottom": {
    alignItems: "center",
    textAlign: "center"
  },
  "&--cover-navbar&": {
    marginTop: "var(--_hero-navbar-height)"
  },
  [`@container Hero ${i.mobile}`]: {
    "--_hero-content-padding-inline": "var(--hero-content-padding-inline, 16px)",
    "--_hero-content-padding-block": "var(--hero-content-padding-block, 48px)",
    paddingInline: "var(--_hero-content-padding-inline, 16px)",
    paddingBlock: "var(--_hero-content-padding-block, 48px)"
  },
  ".Text": {
    textWrap: "pretty",
    color: "var(--_hero-text-color, currentColor)"
  },
  ">*:only-child, >*:first-child": {
    margin: 0
  },
  "&:empty": {
    display: "none"
  }
}, mc = {
  ...t.semanticMode1.display3.regular.large.value,
  margin: 0,
  textWrap: "balance",
  color: "var(--_hero-text-color, currentColor)",
  [`@container Hero ${i.mobile}`]: {
    ...t.semanticMode1.display3.regular.small.value,
    color: "var(--_hero-text-color, currentColor)"
  }
}, uc = {
  ...t.semanticMode1.subtitle.regular.value,
  margin: 0,
  textWrap: "pretty",
  color: "var(--_hero-text-color, currentColor)",
  maxWidth: "850px"
}, gc = {
  "--_hero-btn-group-gap": `var(--hero-btn-group-gap, ${t.semanticMode1.space.lg.value})`,
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  marginTop: "calc(16px - var(--_hero-content-gap))",
  gap: "var(--_hero-btn-group-gap)",
  [`@container Hero ${i.mobile}`]: {
    width: "100%",
    ".Button:not(.IconButton)": {
      width: "100%",
      textAlign: "center",
      whiteSpace: "normal"
    }
  },
  "&:empty": {
    display: "none"
  }
}, xc = {
  [`@container Hero ${i.tabletAndUp}`]: {
    marginInline: `calc(${t.semanticMode1.space.xl.value} - var(--_hero-btn-group-gap))`
  },
  "&--floating": {
    position: "absolute",
    zIndex: "1",
    top: "auto",
    inset: "var(--_hero-floating-playback-button-position)",
    "--_hero-floating-playback-button-position": `var(--hero-floating-playback-button-position, auto auto ${t.primitive.space["5x"].value} ${t.primitive.space["5x"].value})`
  }
}, hc = {
  inset: "var(--_hero-disclosure-position)",
  "--_hero-disclosure-position": "var(--hero-disclosure-position, auto 20px 16px auto)"
}, bc = {
  Hero: cc,
  PlaybackButton: xc,
  MediaOverlay: dc,
  DisclosureButtons: hc,
  Contents: pc,
  Title: mc,
  Body: uc,
  ButtonGroup: gc
}, fc = "1440px", vc = {
  zIndex: "0",
  aspectRatio: "9/16",
  alignItems: "center",
  display: "flex",
  position: "relative",
  justifyContent: {
    contentAlignmentCenter: "center",
    contentAlignmentRight: "flex-end",
    contentAlignmentLeft: "flex-start"
  },
  tabletAndUp: {
    aspectRatio: "16/9"
  }
}, yc = {
  position: "relative",
  zIndex: s.contentOverVideo,
  marginLeft: "26px",
  marginRight: "26px",
  width: "100%",
  letterSpacing: "0",
  textAlign: {
    contentAlignmentCenter: "center",
    contentAlignmentRight: "right",
    contentAlignmentLeft: "left"
  },
  laptopAndUp: {
    marginRight: {
      contentAlignmentCenter: "auto",
      default: "68px"
    },
    marginLeft: {
      contentAlignmentCenter: "auto",
      default: "68px"
    }
  },
  desktopAndUp: {
    marginRight: {
      contentAlignmentCenter: "auto",
      default: "106px"
    },
    marginLeft: {
      contentAlignmentCenter: "auto",
      default: "106px"
    }
  },
  wideScreenAndUp: { marginRight: "auto", marginLeft: "auto" },
  maxWidth: fc
}, Cc = {
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  width: "100%",
  overflow: "hidden",
  backgroundColor: e.semantic.color.fill.neutralStrong
}, $c = {
  position: "absolute",
  top: "0",
  left: "0",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  backgroundColor: "transparent",
  zIndex: s.contentOverVideo - 1,
  background: e.semantic.color.fill.neutralStrong
}, wc = {
  height: "100%",
  width: "100%",
  divVideo: {
    position: "relative",
    minHeight: "100%",
    width: "100%",
    maxWidth: "none",
    objectFit: "cover",
    zIndex: s.contentOverVideo - 3
  }
}, kc = {
  ...e.semantic.typography.headline.XXL,
  color: e.semantic.color.text.onColor,
  letterSpacing: "0",
  margin: `0 0 ${e.semantic.space["5x"]}`
}, Sc = {
  ...e.semantic.typography.body.medium.M,
  letterSpacing: "0",
  color: e.semantic.color.text.onColor,
  marginBottom: e.semantic.space["12x"],
  tabletAndUp: {
    ...e.semantic.typography.body.medium.L
  }
}, Bc = {
  button: {
    width: "100%",
    marginBottom: e.semantic.space["3x"]
  },
  tabletAndUp: {
    button: {
      width: "inherit",
      marginBottom: "inherit"
    }
  }
}, Tc = {
  zIndex: s.contentOverVideo,
  position: "absolute",
  display: "flex",
  bottom: e.semantic.space["6x"],
  buttonAlignment: {
    right: "right: 26px; justify-content: flex-end;",
    left: "left: 26px; justify-content: flex-start;"
  },
  tabletAndUp: {
    bottom: "64px"
  },
  laptopAndUp: {
    bottom: "80px",
    buttonAlignment: {
      right: "68px",
      left: "68px"
    }
  },
  desktopAndUp: {
    bottom: "100px",
    buttonAlignment: {
      right: "106px",
      left: "106px"
    }
  },
  wideScreenAndUp: {
    right: "auto",
    left: "auto",
    width: "100%",
    bottom: "200px",
    div: {
      maxWidth: "1440px",
      width: "1440px",
      minWidth: "1440px",
      margin: "auto",
      position: "relative",
      cxcHeroVideoPlayButton: {
        position: "absolute",
        buttonAlignment: {
          right: "0",
          left: "0"
        }
      }
    }
  }
}, Wc = {
  Wrapper: vc,
  HeadingContent: yc,
  VideoWrapper: Cc,
  VideoOverlayWrapper: $c,
  VideoElementWrapper: wc,
  VideoTitleWrapper: kc,
  VideoBodyWrapper: Sc,
  VideoButtonsWrapper: Bc,
  VideoPlaybackButtonWrapper: Tc
}, Lc = "1440px", _c = {
  zIndex: "0",
  aspectRatio: "9/16",
  alignItems: "center",
  display: "flex",
  position: "relative",
  justifyContent: {
    contentAlignmentCenter: "center",
    contentAlignmentRight: "flex-end",
    contentAlignmentLeft: "flex-start"
  },
  tabletAndUp: {
    aspectRatio: "16/9"
  }
}, Ic = {
  position: "relative",
  zIndex: s.contentOverVideo,
  marginLeft: "26px",
  marginRight: "26px",
  width: "100%",
  letterSpacing: "0",
  textAlign: {
    contentAlignmentCenter: "center",
    contentAlignmentRight: "right",
    contentAlignmentLeft: "left"
  },
  laptopAndUp: {
    marginRight: {
      contentAlignmentCenter: "auto",
      default: "68px"
    },
    marginLeft: {
      contentAlignmentCenter: "auto",
      default: "68px"
    }
  },
  desktopAndUp: {
    marginRight: {
      contentAlignmentCenter: "auto",
      default: "106px"
    },
    marginLeft: {
      contentAlignmentCenter: "auto",
      default: "106px"
    }
  },
  wideScreenAndUp: { marginRight: "auto", marginLeft: "auto" },
  maxWidth: Lc
}, Mc = {
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  width: "100%",
  overflow: "hidden",
  backgroundColor: e.semantic.color.fill.neutralStrong
}, Dc = {
  position: "absolute",
  top: "0",
  left: "0",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  backgroundColor: "transparent",
  zIndex: s.contentOverVideo - 1,
  background: e.semantic.color.fill.neutralStrong
}, Hc = {
  height: "100%",
  width: "100%",
  divVideo: {
    position: "relative",
    minHeight: "100%",
    width: "100%",
    maxWidth: "none",
    objectFit: "cover",
    zIndex: s.contentOverVideo - 3
  }
}, Rc = {
  ...e.semantic.typography.headline.XXL,
  color: e.semantic.color.text.onColor,
  letterSpacing: "0",
  margin: `0 0 ${e.semantic.space["5x"]}`
}, zc = {
  ...e.semantic.typography.body.medium.M,
  letterSpacing: "0",
  color: e.semantic.color.text.onColor,
  marginBottom: e.semantic.space["12x"],
  tabletAndUp: {
    ...e.semantic.typography.body.medium.L
  }
}, Ac = {
  button: {
    width: "100%",
    marginBottom: e.semantic.space["3x"]
  },
  tabletAndUp: {
    button: {
      width: "inherit",
      marginBottom: "inherit"
    }
  }
}, Fc = {
  zIndex: s.contentOverVideo,
  position: "absolute",
  display: "flex",
  bottom: e.semantic.space["6x"],
  buttonAlignment: {
    right: "right: 26px; justify-content: flex-end;",
    left: "left: 26px; justify-content: flex-start;"
  },
  tabletAndUp: {
    bottom: "64px"
  },
  laptopAndUp: {
    bottom: "80px",
    buttonAlignment: {
      right: "68px",
      left: "68px"
    }
  },
  desktopAndUp: {
    bottom: "100px",
    buttonAlignment: {
      right: "106px",
      left: "106px"
    }
  },
  wideScreenAndUp: {
    right: "auto",
    left: "auto",
    width: "100%",
    bottom: "200px",
    div: {
      maxWidth: "1440px",
      width: "1440px",
      minWidth: "1440px",
      margin: "auto",
      position: "relative",
      cxcHeroVideoPlayButton: {
        position: "absolute",
        buttonAlignment: {
          right: "0",
          left: "0"
        }
      }
    }
  }
}, Pc = {
  Wrapper: _c,
  HeadingContent: Ic,
  VideoWrapper: Mc,
  VideoOverlayWrapper: Dc,
  VideoElementWrapper: Hc,
  VideoTitleWrapper: Rc,
  VideoBodyWrapper: zc,
  VideoButtonsWrapper: Ac,
  VideoPlaybackButtonWrapper: Fc
}, Oc = {
  ...o({
    btnSize: o("iconBtnSize", t.semanticMode1.fontSize[7].value),
    // 40px
    btnPadding: o("iconBtnPadding"),
    btnBorderRadius: o("iconBtnBorderRadius", t.semanticMode1.radius.full.value),
    // 400px
    btnIconSize: o("iconBtnIconSize", "100%")
  }),
  svg: {
    height: "100%",
    width: "100%"
  },
  "&--extra-small": o({
    btnPadding: o("iconBtnPadding", t.semanticMode1.space.xs.value),
    // 4px
    btnSize: o("iconBtnSize", t.semanticMode1.space.xl.value)
    // 24px
  }),
  "&--small": o({
    btnPadding: o("iconBtnPadding", "6px"),
    // 6px
    btnSize: o("iconBtnSize", t.semanticMode1.space["2xl"].value)
    // 32px
  }),
  "&--medium": o({
    btnPadding: o("iconBtnPadding", t.semanticMode1.space.sm.value),
    // 8px
    btnSize: o("iconBtnSize", t.semanticMode1.space["3xl"].value)
    // 40px
  }),
  "&--large": o({
    btnPadding: o("iconBtnPadding", t.semanticMode1.space.sm.value),
    // 8px
    btnSize: o("iconBtnSize", t.semanticMode1.fontSize[9].value)
    // 48px
  })
}, Ec = {
  ...Q,
  "&.IconButton": o({
    btnHoverBgColor: o("iconBtnHoverBgColor", "transparent")
  })
}, Vc = {
  // fallbacks
  ...o.fallback({
    btnSize: "iconBtnSize",
    btnHeight: "iconBtnHeight",
    btnWidth: "iconBtnWidth",
    btnPadding: "iconBtnPadding",
    btnBorderRadius: "iconBtnBorderRadius",
    btnIconSize: "iconBtnIconSize",
    btnTextColor: "iconBtnTextColor",
    btnHoverTextColor: "iconBtnHoverTextColor",
    btnBgColor: "iconBtnBgColor",
    btnHoverBgColor: "iconBtnHoverBgColor",
    btnBorder: "iconBtnBorder",
    btnHoverBorder: "iconBtnHoverBorder",
    btnFocusOutline: "iconBtnFocusOutline",
    btnFocusOutlineOffset: "iconBtnFocusOutlineOffset",
    btnDisabledTextColor: "iconBtnDisabledTextColor",
    btnDisabledBorder: "iconBtnDisabledBorder",
    btnDisabledBgColor: "iconBtnDisabledBgColor"
  }),
  ...Oc,
  "&--ghost": Ec
}, Gc = {
  IconButton: Vc
}, jc = {
  ...o({
    btnSize: o("iconBtnSize", e.semantic.space["6x"]),
    btnPadding: o("iconBtnPadding"),
    btnBorderRadius: o("iconBtnBorderRadius"),
    btnIconSize: o("iconBtnIconSize", "100%")
  }),
  svg: {
    height: "100%",
    width: "100%"
  },
  "&--xxxsmall": o({
    btnPadding: o("iconBtnPadding", e.semantic.borderWidth["2x"]),
    btnSize: o("iconBtnSize", e.semantic.space["4x"]),
    btnBorderRadius: o("iconBtnBorderRadius", e.semantic.radius["1x"])
  }),
  "&--extra-small": o({
    btnPadding: o("iconBtnPadding", e.semantic.borderWidth["2x"]),
    btnSize: o("iconBtnSize", e.semantic.space["6x"]),
    btnBorderRadius: o("iconBtnBorderRadius", e.semantic.radius["1x"])
  }),
  "&--small": o({
    btnPadding: o("iconBtnPadding", e.semantic.space["1x"]),
    btnSize: o("iconBtnSize", e.semantic.space["8x"]),
    btnBorderRadius: o("iconBtnBorderRadius", e.semantic.radius["2x"])
  }),
  "&--medium": o({
    btnPadding: o("iconBtnPadding", "6px"),
    btnSize: o("iconBtnSize", e.semantic.space["10x"]),
    btnBorderRadius: o("iconBtnBorderRadius", e.semantic.radius["2x"])
  }),
  "&--large": o({
    btnPadding: o("iconBtnPadding", "6px"),
    btnSize: o("iconBtnSize", e.semantic.space["12x"]),
    btnBorderRadius: o("iconBtnBorderRadius", e.semantic.radius["2x"])
  })
}, Uc = {
  "&.IconButton": {
    "&--success": o({
      btnBgColor: o("iconBtnBgColor", e.semantic.color.fill.successStrong),
      // #008200
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.action.successHover)
      // #006800
    }),
    "&--caution": o({
      btnBgColor: o("iconBtnBgColor", e.semantic.color.icon.caution),
      // #B16201
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.icon.cautionStrongest)
      // #854901
    }),
    "&--danger": o({
      btnBgColor: o("iconBtnBgColor", e.semantic.color.fill.dangerStrong),
      // #d62d0a
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.action.dangerHover)
      // #ab2408
    }),
    "&--black": o({
      btnBgColor: o("iconBtnBgColor", e.semantic.color.text.default),
      // #001025
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.text.default)
      // #001025
    })
  }
}, Xc = {
  "&.IconButton": {
    "&--success": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.fill.successStrong),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.fill.successStrong),
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.fill.successSubtlest)
    }),
    "&--caution": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.icon.caution),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.icon.cautionStrongest),
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.fill.cautionSubtlest)
    }),
    "&--danger": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.text.dangerStrong),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.text.dangerStrong),
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.action.dangerHoverSubtle)
    }),
    "&--black": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.text.default),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.text.default),
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.fill.hover)
    })
  }
}, Nc = {
  "&.IconButton": {
    "&--success": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.fill.successStrong),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.fill.successStrong),
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.fill.successSubtlest)
    }),
    "&--caution": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.icon.caution),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.icon.cautionStrongest),
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.fill.cautionSubtlest)
    }),
    "&--danger": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.text.dangerStrong),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.text.dangerStrong),
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.action.dangerHoverSubtle)
    }),
    "&--black": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.text.default),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.text.default),
      btnHoverBgColor: o("iconBtnHoverBgColor", e.semantic.color.fill.hover)
    })
  }
}, Yc = {
  ...Z,
  "&.IconButton": {
    ...o({ btnHoverBgColor: o("iconBtnHoverBgColor", "transparent") }),
    "&--success": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.fill.successStrong),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.fill.successStrong)
    }),
    "&--caution": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.icon.caution),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.icon.cautionStrongest)
    }),
    "&--danger": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.text.dangerStrong),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.text.dangerStrong)
    }),
    "&--black": o({
      btnTextColor: o("iconBtnTextColor", e.semantic.color.text.default),
      btnHoverTextColor: o("iconBtnHoverTextColor", e.semantic.color.text.default)
    })
  }
}, Zc = {
  // fallbacks
  ...o.fallback({
    btnSize: "iconBtnSize",
    btnHeight: "iconBtnHeight",
    btnWidth: "iconBtnWidth",
    btnPadding: "iconBtnPadding",
    btnBorderRadius: "iconBtnBorderRadius",
    btnIconSize: "iconBtnIconSize",
    btnTextColor: "iconBtnTextColor",
    btnHoverTextColor: "iconBtnHoverTextColor",
    btnBgColor: "iconBtnBgColor",
    btnHoverBgColor: "iconBtnHoverBgColor",
    btnBorder: "iconBtnBorder",
    btnHoverBorder: "iconBtnHoverBorder",
    btnFocusOutline: "iconBtnFocusOutline",
    btnFocusOutlineOffset: "iconBtnFocusOutlineOffset",
    btnDisabledTextColor: "iconBtnDisabledTextColor",
    btnDisabledBorder: "iconBtnDisabledBorder",
    btnDisabledBgColor: "iconBtnDisabledBgColor"
  }),
  ...jc,
  "&--primary": Uc,
  "&--secondary": Xc,
  "&--tertiary": Nc,
  "&--ghost": Yc
}, Kc = {
  IconButton: Zc
}, Qc = {
  maxWidth: "100%",
  verticalAlign: "middle",
  fontStyle: "italic",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  "&--default": {
    backgroundColor: t.primitive.color.twilight[400].value
  },
  "&--neutral": {
    backgroundColor: t.primitive.color.neutral[500].value
  }
}, qc = { position: "absolute", inset: 0 }, Jc = {
  Image: Qc,
  ImageContent: qc
}, ed = {
  maxWidth: "100%",
  verticalAlign: "middle",
  fontStyle: "italic",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  "&--default": {
    backgroundColor: e.semantic.color.stroke.default
  },
  "&--neutral": {
    backgroundColor: e.semantic.color.stroke.neutralSubtle
  }
}, td = { position: "absolute", inset: 0 }, od = {
  Image: ed,
  ImageContent: td
}, id = {
  display: "inline-flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"]
}, rd = {
  borderRadius: e.semantic.radius["2x"],
  position: "relative",
  alignItems: "center",
  justifyContent: "space-between",
  boxSizing: "border-box",
  padding: e.semantic.space["1x"],
  display: "inline-flex",
  gap: e.semantic.space["1x"],
  backgroundColor: e.semantic.color.fill.default,
  border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  textSize: {
    small: {
      height: e.semantic.space["10x"],
      width: e.semantic.space["28x"]
    },
    large: {
      height: e.semantic.space["14x"],
      width: "160px"
    },
    medium: {
      height: e.semantic.space["12x"],
      width: "136px"
    },
    default: {
      height: e.semantic.space["12x"],
      width: "136px"
    }
  }
}, ad = {
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  display: "flex",
  userSelect: "none",
  alignItems: "center",
  color: {
    isInvalid: e.semantic.color.text.dangerStrong,
    isDisabled: e.semantic.color.text.disabled,
    default: e.semantic.color.text.subtle
  },
  span: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden"
  },
  svg: {
    fill: e.semantic.color.icon.danger
  }
}, nd = {
  display: "flex",
  boxSizing: "border-box",
  padding: `${e.semantic.space["1x"]}`,
  justifyContent: "center",
  alignItems: "center",
  gap: "0",
  flexShrink: "0",
  borderRadius: `${e.semantic.radius["2x"]}`,
  overflow: "hidden",
  color: {
    disabled: e.semantic.color.text.disabled,
    default: e.semantic.color.text.default
  },
  textAlign: "center",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontStyle: "normal",
  mozAppearance: "textfield",
  border: "none",
  backgroundColor: "transparent",
  webkitInnerSpinButton: {
    display: "none"
  },
  outline: {
    error: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.danger}`,
    caution: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.caution}`,
    success: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.success}`,
    none: "none"
  },
  textSize: {
    small: {
      width: `${e.semantic.space["6x"]}`,
      height: `${e.semantic.space["6x"]}`,
      ...e.semantic.typography.body.regular.S
    },
    medium: {
      width: `${e.semantic.space["8x"]}`,
      height: `${e.semantic.space["8x"]}`,
      ...e.semantic.typography.body.regular.M
    },
    large: {
      width: `${e.semantic.space["10x"]}`,
      height: `${e.semantic.space["10x"]}`,
      ...e.semantic.typography.body.regular.L
    }
  },
  hover: {
    outline: {
      error: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.danger}`,
      caution: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.caution}`,
      success: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.success}`,
      none: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`
    }
  },
  focusVisible: {
    outline: {
      error: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.danger}`,
      caution: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.caution}`,
      success: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.success}`,
      none: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`
    }
  }
}, ld = {
  display: "flex",
  textSize: {
    small: {
      height: e.semantic.space["8x"],
      width: e.semantic.space["8x"]
    },
    large: {
      height: e.semantic.space["12x"],
      width: e.semantic.space["12x"]
    },
    medium: {
      height: e.semantic.space["10x"],
      width: e.semantic.space["10x"]
    },
    default: {
      height: e.semantic.space["10x"],
      width: e.semantic.space["10x"]
    }
  },
  focusVisible: {
    outline: "none"
  }
}, sd = {
  textSize: {
    small: {
      height: e.semantic.space["8x"],
      width: e.semantic.space["8x"]
    },
    large: {
      height: e.semantic.space["12x"],
      width: e.semantic.space["12x"]
    },
    medium: {
      height: e.semantic.space["10x"],
      width: e.semantic.space["10x"]
    },
    default: {
      height: e.semantic.space["10x"],
      width: e.semantic.space["10x"]
    }
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  position: "absolute",
  borderRadius: e.semantic.radius["2x"],
  color: e.semantic.color.text.default,
  hover: {
    backgroundColor: e.semantic.color.action.neutralHoverSubtle
  },
  focusVisible: {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: "2px"
  },
  disabled: {
    cursor: "default",
    color: e.semantic.color.text.disabled,
    hover: {
      backgroundColor: "unset"
    },
    focusVisible: {
      outline: "none"
    }
  },
  disabledPlusMinus: {
    color: e.semantic.color.text.disabled
  }
}, cd = {
  styles: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  },
  textSize: {
    small: {
      height: e.semantic.space["5x"],
      width: e.semantic.space["5x"]
    },
    large: {
      height: e.semantic.space["8x"],
      width: e.semantic.space["8x"]
    },
    medium: {
      height: e.semantic.space["6x"],
      width: e.semantic.space["6x"]
    },
    default: {
      height: e.semantic.space["6x"],
      width: e.semantic.space["6x"]
    }
  }
}, ge = {
  OuterWrapper: id,
  InnerWrapper: rd,
  HelperTextWrapper: ad,
  InputComponent: nd,
  Wrapper: ld,
  IconComponent: sd,
  GetIconCSS: cd
}, dd = ge, pd = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  padding: t.primitive.radius["4x"].value,
  gap: t.primitive.radius["3x"].value,
  boxSizing: "border-box",
  borderRadius: t.primitive.radius["3x"].value,
  alignItems: "start",
  "&--information": {
    backgroundColor: t.primitive.color.skyView[100].value,
    color: t.primitive.color.skyView[1200].value
  },
  "&--neutral": {
    backgroundColor: t.primitive.color.neutral[200].value,
    color: t.primitive.color.twilight[1200].value
  },
  "&--warning": {
    backgroundColor: t.primitive.color.amber[100].value,
    color: t.primitive.color.amber[1200].value
  },
  "&--error": {
    backgroundColor: t.primitive.color.red[100].value,
    color: t.primitive.color.red[1200].value
  },
  "&--success": {
    backgroundColor: t.primitive.color.green[100].value,
    color: t.primitive.color.green[1200].value
  },
  ".InlineAlert__close-btn": {
    height: "auto",
    alignSelf: "center",
    "&:not(&--disabled):hover": {
      backgroundColor: "transparent"
    }
  }
}, md = {
  height: t.primitive.space["5x"].value,
  width: t.primitive.space["5x"].value,
  paddingTop: t.primitive.space["1x"].value
}, ud = {
  width: "100%",
  display: "flex",
  height: "100%",
  alignSelf: "center",
  flexDirection: "column",
  gap: "2px"
}, gd = {
  margin: 0,
  "& *": {
    margin: 0
  },
  ...t.semanticMode1.body1.bold.value,
  color: t.semanticMode1.color.text.onLight.strong.value
}, xd = {
  margin: 0,
  "& *": { margin: 0 },
  ...t.semanticMode1.body1.medium.value,
  color: t.semanticMode1.color.text.onLight.strong.value,
  "b, .bold": { fontFamily: t.semanticMode1.fontFamilies.fordF1Bold.value }
}, hd = {
  height: "fit-content",
  alignItems: "unset",
  alignSelf: "center",
  "&:not(&--disabled):hover": {
    backgroundColor: "transparent"
  }
}, bd = {
  InlineAlert: pd,
  LeadingIcon: md,
  Content: ud,
  Title: gd,
  Body: xd,
  StyledCloseButton: hd
}, fd = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  padding: `var(--semantic-spacing-3-x, ${e.semantic.radius["3x"]})
  var(--semantic-spacing-4-x, ${e.semantic.radius["4x"]})`,
  gap: `var(--semantic-spacing-3-x, ${e.semantic.radius["3x"]})`,
  boxSizing: "border-box",
  borderRadius: e.semantic.radius["3x"],
  a: {
    fontFamily: `${e.semantic.typography.body.medium.S.fontFamily} !important`,
    fontWeight: `${e.semantic.typography.body.medium.S.fontWeight} !important`,
    fontSize: `${e.semantic.typography.body.medium.S.fontSize} !important`,
    lineHeight: `${e.semantic.typography.body.medium.S.lineHeight} !important`,
    color: `${e.semantic.color.text.primaryStrongest} !important`,
    "&:visited": {
      color: `${e.semantic.color.link.visited} !important`
    }
  },
  "&--information": {
    backgroundColor: e.semantic.color.fill.primarySubtlest,
    color: e.semantic.color.text.primaryStrongest,
    a: {
      color: e.semantic.color.text.primaryStrongest,
      "&:hover": {
        color: `${e.semantic.color.link.hover} !important`
      }
    }
  },
  "&--neutral": {
    backgroundColor: e.semantic.color.fill.neutralSubtle,
    color: e.semantic.color.text.default,
    a: {
      color: `${e.semantic.color.text.subtle} !important`,
      "&:hover": {
        color: `${e.semantic.color.link.onStatus.neutralHover} !important`
      }
    }
  },
  "&--warning": {
    backgroundColor: e.semantic.color.fill.cautionSubtlest,
    color: e.semantic.color.text.cautionStrongest,
    a: {
      color: `${e.semantic.color.text.cautionStrongest} !important`,
      "&:hover": {
        color: `${e.semantic.color.link.onStatus.cautionHover} !important`
      }
    }
  },
  "&--error": {
    backgroundColor: e.semantic.color.fill.dangerSubtlest,
    color: e.semantic.color.text.dangerStrongest,
    a: {
      color: `${e.semantic.color.text.dangerStrongest} !important`,
      "&:hover": {
        color: `${e.semantic.color.link.onStatus.dangerHover} !important`
      }
    }
  },
  "&--success": {
    backgroundColor: e.semantic.color.fill.successSubtlest,
    color: e.semantic.color.text.successStrongest,
    a: {
      color: `${e.semantic.color.text.successStrongest} !important`,
      "&:hover": {
        color: `${e.semantic.color.link.onStatus.successHover} !important`
      }
    }
  }
}, vd = {
  height: e.semantic.space["5x"],
  width: e.semantic.space["5x"],
  paddingTop: e.semantic.space["1x"]
}, yd = {
  fontStyle: "normal",
  width: "100%",
  display: "flex",
  height: "100%",
  alignSelf: "center",
  flexDirection: "column",
  gap: "2px"
}, Cd = {
  ...e.semantic.typography.body.semiBold.L,
  margin: 0,
  "& *": {
    margin: 0
  }
}, $d = {
  color: "inherit",
  ".InlineAlert--neutral &": {
    color: e.semantic.color.text.subtle
  },
  margin: 0,
  "& *": {
    margin: 0
  },
  ...e.semantic.typography.body.regular.S,
  "& a.Link": {
    textDecoration: `underline ${e.semantic.space[".25x"]}`,
    "&:hover": {
      textDecorationThickness: `${e.semantic.space[".5x"]}`,
      transition: "text-decoration-thickness 0.1s linear"
    }
  }
}, wd = {
  height: "fit-content",
  alignItems: "unset",
  alignSelf: "flex-start"
}, kd = {
  InlineAlert: fd,
  LeadingIcon: vd,
  Content: yd,
  Title: Cd,
  Body: $d,
  StyledCloseButton: wd
}, V = {
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontSize: t.primitive.fontSize[2].value,
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: t.primitive.lineHeights[11].value
}, Sd = {
  display: "inline-flex",
  alignItems: "flex-start",
  flexDirection: "column",
  width: "100%",
  gap: t.primitive.space["1x"].value
}, Bd = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: t.primitive.space["1x"].value
}, Td = {
  display: "flex",
  rowGap: t.primitive.space["4x"].value,
  columnGap: t.primitive.space["4x"].value,
  flexDirection: "column",
  [`@media ${i.tabletAndUp}`]: {
    flexDirection: "row"
  }
}, Wd = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  overflow: "hidden",
  height: t.primitive.space["7x"].value,
  borderRadius: t.primitive.radius["1x"].value,
  "&:hover:not(&--disabled)": {
    cursor: "pointer",
    backgroundColor: "inherit"
  },
  boxSizing: "border-box",
  "&:focus-visible": {
    outline: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus}`,
    border: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus}`,
    outlineOffset: `-${t.primitive.border["2x"].value}`
  }
}, Ld = {
  height: t.primitive.space["7x"].value,
  width: "100%",
  minWidth: "200px",
  boxSizing: "border-box",
  padding: `${t.primitive.space["2x"].value} ${t.primitive.space["4x"].value}`,
  borderRadius: t.primitive.radius["2x"].value,
  border: `${t.primitive.border["1x"].value} solid`,
  outline: "none",
  borderColor: t.semanticMode1.color.stroke.onLight.moderateDefault.value,
  ...V,
  color: t.semanticMode1.color.text.onLight.moderateDefault.value,
  backgroundColor: "transparent",
  "&:hover": {
    borderColor: t.semanticMode1.color.stroke.onLight.interactiveHover.value
  },
  "&::placeholder": {
    ...V
  },
  "&:focus": {
    outline: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactive.value}`,
    border: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactive.value}`,
    outlineOffset: `-${t.primitive.border["2x"].value}`
  },
  "&--success": {
    "&:focus": {
      outline: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.success.value}`
    },
    "&,&:focus,&:hover": {
      borderColor: t.semanticMode1.color.stroke.onLight.success.value
    }
  },
  "&--caution": {
    "&:focus": {
      outline: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.caution.value}`
    },
    "&,&:focus,&:hover": {
      borderColor: t.semanticMode1.color.stroke.onLight.caution.value
    }
  },
  "&--error": {
    "&:focus": {
      outline: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.danger.value}`
    },
    "&,&:focus,&:hover": {
      borderColor: t.semanticMode1.color.stroke.onLight.danger.value
    }
  }
}, _d = {
  display: "inline-flex",
  whiteWrap: "nowrap",
  marginRight: t.primitive.space["2x"].value,
  ...t.semanticMode1.body1.semibold.value,
  color: t.semanticMode1.color.text.onLight.moderateDefault.value,
  "&:hover:not(&--disabled)": {
    color: t.semanticMode1.color.text.onLight.interactiveHover.value
  },
  "&--disabled": {
    color: t.semanticMode1.color.stroke.onLight.disabled.value
  }
}, Id = {
  display: "inline-flex"
}, Md = {
  display: "inline-flex",
  color: t.semanticMode1.color.icon.onLight.interactive.value,
  "&--disabled": {
    color: t.semanticMode1.color.icon.onLight.subtleDisabled.value
  }
}, Dd = {
  display: "flex",
  ...t.semanticMode1.body2.regular.value,
  "& > span": {
    color: t.semanticMode1.color.text.onLight.danger.value
  }
}, Hd = {
  display: "flex",
  "&--open": {
    display: "none"
  },
  [`@media ${i.tabletAndUp}`]: {
    display: "flex",
    alignItems: "center",
    ...t.semanticMode1.caption.regular.value
  },
  "&--mobile": {
    display: "block",
    [`@media ${i.tabletAndUp}`]: {
      display: "none"
    }
  }
}, Rd = {
  marginLeft: t.primitive.space["2x"].value
}, zd = {
  display: "flex",
  marginTop: t.primitive.space["3x"].value,
  gap: t.primitive.space["4x"].value,
  [`@media ${i.tabletAndUp}`]: {
    margin: "unset"
  }
}, Ad = {
  Container: Sd,
  OpenContainer: Bd,
  InputContainer: Td,
  InLineWrapper: Wd,
  TextField: Ld,
  TextWrapper: _d,
  SaveButtonWrapper: Id,
  IconWrapper: Md,
  Label: Dd,
  HelperTextWrapper: Hd,
  ErrorMessage: Rd,
  ButtonWrapper: zd
}, Fd = {
  display: "inline-flex",
  alignItems: "flex-start",
  flexDirection: "column",
  width: "100%",
  gap: e.semantic.space["2x"]
}, Pd = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: e.semantic.space["2x"]
}, Od = {
  display: "flex",
  rowGap: e.semantic.space["2x"],
  columnGap: e.semantic.space["4x"],
  flexDirection: "column",
  "&--small": {
    columnGap: e.semantic.space["3x"]
  },
  [`@media ${i.tabletAndUp}`]: {
    flexDirection: "row"
  }
}, Ed = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  overflow: "hidden",
  height: e.semantic.space["8x"],
  padding: `0px ${e.semantic.space["2x"]} 0px ${e.semantic.space["2x"]}`,
  borderRadius: e.semantic.radius["1x"],
  boxSizing: "border-box",
  "&:hover:not(&--disabled)": {
    cursor: "pointer",
    backgroundColor: e.semantic.color.fill.hover
  },
  "&:focus-visible": {
    outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`,
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: `-${e.semantic.borderWidth["2x"]}`
  },
  "&--medium": {
    height: e.semantic.space["10x"],
    padding: `0 ${e.semantic.space["3x"]} 0 ${e.semantic.space["3x"]}`
  },
  "&--large": {
    height: e.semantic.space["12x"],
    padding: `0 ${e.semantic.space["3x"]} 0 ${e.semantic.space["3x"]}`
  }
}, Vd = {
  height: e.semantic.space["8x"],
  width: "100%",
  boxSizing: "border-box",
  paddingLeft: e.semantic.space["3x"],
  padding: `${e.semantic.space["1x"]} ${e.semantic.space["2x"]}`,
  border: `${e.semantic.borderWidth["1x"]} solid ${e.primitive.color.neutral[400]}`,
  borderRadius: e.semantic.radius["1x"],
  outline: "none",
  outlineColor: e.semantic.color.stroke.default,
  color: e.semantic.color.text.default,
  backgroundColor: e.semantic.color.fill.default,
  "&--small": {
    "&::placeholder": {
      ...e.semantic.typography.body.regular.S
    },
    ...e.semantic.typography.body.regular.S,
    paddingLeft: e.semantic.space["2x"]
  },
  "&--medium": {
    "&::placeholder": {
      ...e.semantic.typography.body.regular.M
    },
    ...e.semantic.typography.body.regular.M,
    height: e.semantic.space["10x"]
  },
  "&--large": {
    "&::placeholder": {
      ...e.semantic.typography.body.regular.L
    },
    ...e.semantic.typography.body.regular.L,
    height: e.semantic.space["12x"]
  },
  "&:hover": {
    borderColor: e.semantic.color.stroke.focus
  },
  "&:focus": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`,
    outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: `-${e.semantic.borderWidth["2x"]}`
  },
  "&--success": {
    "&:focus": {
      outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.success}`
    },
    "&,&:focus,&:hover": {
      borderColor: e.semantic.color.stroke.success
    }
  },
  "&--caution": {
    "&:focus": {
      outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.caution}`
    },
    "&,&:focus,&:hover": {
      borderColor: e.semantic.color.stroke.caution
    }
  },
  "&--error": {
    "&:focus": {
      outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.danger}`
    },
    "&,&:focus,&:hover": {
      borderColor: e.semantic.color.stroke.danger
    }
  }
}, Gd = {
  display: "inline-flex",
  whiteWrap: "nowrap",
  marginRight: e.semantic.space["2x"],
  color: e.semantic.color.text.default,
  "&--small": {
    ...e.semantic.typography.body.semiBold.S
  },
  "&--medium": {
    ...e.semantic.typography.body.semiBold.M
  },
  "&--large": {
    ...e.semantic.typography.body.semiBold.L
  },
  "&--disabled": {
    color: e.semantic.color.text.disabled
  }
}, jd = {
  display: "inline-flex"
}, Ud = {
  display: "inline-flex",
  color: e.semantic.color.icon.primary,
  "&--disabled": {
    color: e.semantic.color.text.disabled
  }
}, Xd = {
  display: "flex",
  ...e.semantic.typography.body.medium.S,
  color: e.semantic.color.text.default,
  "& > span": {
    color: e.semantic.color.text.dangerStrong
  }
}, Nd = {
  display: "flex",
  "&--open": {
    display: "none"
  },
  [`@media ${i.tabletAndUp}`]: {
    display: "flex",
    alignItems: "center",
    color: e.semantic.color.text.dangerStrong,
    ...e.semantic.typography.body.regular.S
  },
  "&--mobile": {
    display: "block",
    [`@media ${i.tabletAndUp}`]: {
      display: "none"
    }
  }
}, Yd = {
  marginLeft: e.semantic.space["2x"]
}, Zd = {
  display: "flex",
  marginTop: e.semantic.space["3x"],
  [`@media ${i.tabletAndUp}`]: {
    margin: "unset"
  },
  "&--small": {
    gap: e.semantic.space["2x"]
  },
  "&--medium": {
    gap: e.semantic.space["3x"]
  },
  "&--large": {
    gap: e.semantic.space["4x"]
  }
}, Kd = {
  Container: Fd,
  OpenContainer: Pd,
  InputContainer: Od,
  InLineWrapper: Ed,
  TextField: Vd,
  TextWrapper: Gd,
  SaveButtonWrapper: jd,
  IconWrapper: Ud,
  Label: Xd,
  HelperTextWrapper: Nd,
  ErrorMessage: Yd,
  ButtonWrapper: Zd
}, Qd = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  tabletAndUp: {
    maxWidth: "184px"
  }
}, qd = {
  display: "inline-flex",
  width: "100%",
  boxSizing: "border-box",
  alignItems: "center",
  flexShrink: 0,
  padding: e.semantic.space["4x"],
  borderLeft: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  focusVisible: {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    borderRadius: e.semantic.borderWidth["1x"],
    outlineOffset: e.semantic.borderWidth["2x"],
    position: "relative",
    zIndex: 99
  },
  borderLeftActive: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus};`,
  borderLeftInActive: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.default};`,
  cursor: { disabled: "not-allowed", default: "pointer" },
  hover: {
    borderLeftActive: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus};`,
    borderLeftInActive: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.neutralSubtle};`,
    backgroundColor: "#fafafb",
    cursor: "pointer",
    zIndex: 99
  }
}, Jd = {
  textAlign: "left",
  ...e.semantic.typography.body.medium.S,
  fontStyle: "normal",
  color: {
    disabled: e.semantic.color.text.disabled,
    active: e.semantic.color.text.default,
    default: e.semantic.color.text.subtlest
  },
  cursor: { disabled: "not-allowed", default: "pointer" },
  display: "flex",
  alignItems: "center",
  width: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  displayWebkitBox: "-webkit-box",
  webkitLineClamp: 3,
  // Limit to 3 lines
  webkitBoxOrient: "vertical"
}, ep = {
  TabsHeader: Qd,
  TabWrapper: qd,
  TabLabel: Jd
}, tp = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  tabletAndUp: {
    maxWidth: "184px"
  }
}, op = {
  display: "inline-flex",
  width: "100%",
  boxSizing: "border-box",
  alignItems: "center",
  flexShrink: 0,
  padding: e.semantic.space["4x"],
  borderLeft: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  focusVisible: {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    borderRadius: e.semantic.borderWidth["1x"],
    outlineOffset: e.semantic.borderWidth["2x"],
    position: "relative",
    zIndex: 99
  },
  borderLeftActive: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus};`,
  borderLeftInActive: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.default};`,
  cursor: { disabled: "not-allowed", default: "pointer" },
  hover: {
    borderLeftActive: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus};`,
    borderLeftInActive: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.neutralSubtle};`,
    backgroundColor: e.semantic.color.fill.neutralSubtlest,
    cursor: "pointer",
    zIndex: 99
  }
}, ip = {
  textAlign: "left",
  ...e.semantic.typography.body.medium.S,
  fontStyle: "normal",
  color: {
    disabled: e.semantic.color.text.disabled,
    active: e.semantic.color.text.default,
    default: e.semantic.color.text.subtlest
  },
  cursor: { disabled: "not-allowed", default: "pointer" },
  display: "flex",
  alignItems: "center",
  width: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  displayWebkitBox: "-webkit-box",
  webkitLineClamp: 3,
  // Limit to 3 lines
  webkitBoxOrient: "vertical"
}, rp = {
  TabsHeader: tp,
  TabWrapper: op,
  TabLabel: ip
}, ap = {
  display: "flex",
  alignItems: "center",
  alignSelf: "stretch",
  gap: e.semantic.space["3x"]
}, np = {
  display: "flex",
  alignItems: "center",
  textAlign: "left",
  flex: "1 0 0",
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.medium.S,
  fontStyle: "normal"
}, lp = {
  textAlign: "right",
  color: e.semantic.color.text.subtlest,
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  pointerEvents: "none"
}, sp = {
  display: "flex",
  color: e.semantic.color.text.subtlest,
  fontWeight: e.primitive.typography.fontWeights.inter.regular,
  lineHeight: e.primitive.typography.lineHeights[500],
  "&--tooltip": {
    "& > svg": {
      display: "flex",
      justifyContent: "end",
      color: e.semantic.color.icon.primary
    }
  },
  "&--popuptip": {
    "& > svg": {
      display: "flex",
      justifyContent: "center",
      color: e.semantic.color.icon.primary
    }
  }
}, cp = {
  color: e.semantic.color.text.dangerStrong,
  "&--required": {
    marginLeft: e.semantic.space["1x"]
  }
}, dp = {
  display: "flex",
  alignItems: "center"
}, pp = {
  color: e.semantic.color.icon.success,
  width: e.semantic.space["4x"],
  height: e.semantic.space["4x"],
  marginLeft: e.semantic.space["2x"]
}, xe = {
  Wrapper: ap,
  Text: np,
  TrailingText: lp,
  InfoIconWrapper: sp,
  RequiredWrapper: cp,
  TrailingElementWrapper: dp,
  SuccessIcon: pp
}, mp = {
  display: "flex",
  alignItems: "center",
  alignSelf: "stretch",
  gap: "12px"
}, up = {
  display: "flex",
  alignItems: "center",
  textAlign: "left",
  flex: "1 0 0",
  ...t.semanticMode1.body2.regular.value,
  fontStyle: "normal"
}, gp = {
  display: "flex",
  "&--tooltip": {
    "& > svg": {
      height: "14px",
      // This doesn't exist in the figma token
      width: "14px",
      // This doesn't exist in the figma token
      display: "flex",
      justifyContent: "end",
      color: t.primitive.color.skyView[900].value
    }
  },
  "&--popuptip": {
    "& > svg": {
      height: "14px",
      // This doesn't exist in the figma token
      width: "14px",
      // This doesn't exist in the figma token
      display: "flex",
      justifyContent: "center",
      color: t.primitive.color.skyView[900].value
    }
  }
}, xp = {
  textAlign: "right",
  ...t.semanticMode1.caption.regular.value,
  fontStyle: "normal",
  pointerEvents: "none"
}, hp = { ...xe, LabelWrapper: mp, Text: up, TrailingText: xp, InfoIconWrapper: gp }, bp = {
  boxSizing: "border-box",
  minHeight: "480px"
}, fp = {
  LandingHero: bp
}, vp = {
  boxSizing: "border-box",
  minHeight: "345px",
  borderRadius: "8px"
}, yp = {
  LandingHero: vp
}, he = {
  alignItems: "center",
  display: "flex",
  position: "relative",
  aspectRatio: "16/9",
  justifyContent: "flex-start",
  [`@media ${i.tabletAndUp}`]: {
    aspectRatio: "32/9"
  }
}, be = [
  {
    props: { $contentAlignment: "center" },
    styles: { justifyContent: "center" }
  },
  {
    props: { $contentAlignment: "right" },
    styles: { justifyContent: "right" }
  }
], fe = {
  position: "relative",
  zIndex: s.contentOverVideo,
  marginLeft: e.semantic.space["6x"],
  marginRight: e.semantic.space["6x"],
  letterSpacing: 0,
  textAlign: "left",
  [`@media ${i.laptopAndUp}`]: {
    marginLeft: e.semantic.space["12x"]
  }
}, ve = [
  {
    props: { $contentAlignment: "center" },
    styles: {
      textAlign: "center",
      [`@media ${i.laptopAndUp}`]: {
        marginRight: "auto",
        marginLeft: "auto"
      }
    }
  },
  {
    props: { $contentAlignment: "right" },
    styles: {
      textAlign: "right",
      [`@media ${i.laptopAndUp}`]: {
        marginRight: e.semantic.space["12x"]
      }
    }
  }
], ye = {
  ...e.semantic.typography.headline.XXL,
  letterSpacing: 0,
  color: e.semantic.color.text.onColor,
  margin: `0 0 ${e.semantic.space["15x"]}`,
  "& > sup": {
    fontSize: e.primitive.typography.fontSize[600]
  }
}, Ce = {
  position: "absolute",
  top: "0",
  left: "0",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  backgroundColor: e.semantic.color.fill.neutralStrong,
  borderRadius: e.semantic.radius["1x"]
}, $e = {
  zIndex: s.contentOverVideo,
  position: "absolute",
  bottom: e.semantic.space["6x"],
  left: e.semantic.space["6x"],
  [`@media ${i.laptopAndUp}`]: {
    bottom: e.semantic.space["8x"],
    left: e.semantic.space["12x"]
  }
}, we = [
  {
    props: { $buttonAlignment: "right" },
    styles: {
      right: e.semantic.space["6x"],
      left: "unset",
      [`@media ${i.laptopAndUp}`]: {
        right: e.semantic.space["12x"],
        left: "unset"
      }
    }
  }
], ke = {
  height: "100%",
  width: "100%",
  "& > div, & > video": {
    position: "relative",
    minHeight: "100%",
    width: "100%",
    maxWidth: "none",
    "-o-object-fit": "cover",
    objectFit: "cover",
    zIndex: s.contentOverVideo - 3
  }
}, Se = {
  position: "absolute",
  top: "0",
  left: "0",
  height: " 100%",
  width: " 100%",
  overflow: "hidden",
  backgroundColor: "transparent",
  zIndex: s.contentOverVideo - 1,
  background: e.semantic.color.fill.neutralStrong,
  opacity: "70%"
}, Be = [
  {
    props: { $isPlaying: !0 },
    styles: {
      opacity: "50%"
    }
  }
], Cp = {
  Component: {
    styles: {
      ...he
    },
    variants: [...be]
  },
  HeadingContent: {
    styles: {
      ...fe
    },
    variants: [...ve]
  },
  VideoTitleWrapper: {
    styles: {
      ...ye
    }
  },
  VideoWrapper: {
    styles: {
      ...Ce
    }
  },
  VideoPlaybackButtonWrapper: {
    styles: {
      ...$e
    },
    variants: [...we]
  },
  VideoElementWrapper: {
    styles: {
      ...ke
    }
  },
  VideoOverlayWrapper: {
    styles: {
      ...Se
    },
    variants: [...Be]
  }
}, $p = {
  Component: {
    styles: {
      ...he
    },
    variants: [...be]
  },
  HeadingContent: {
    styles: {
      ...fe
    },
    variants: [...ve]
  },
  VideoTitleWrapper: {
    styles: {
      ...ye
    }
  },
  VideoWrapper: {
    styles: {
      ...Ce
    }
  },
  VideoPlaybackButtonWrapper: {
    styles: {
      ...$e
    },
    variants: [...we]
  },
  VideoElementWrapper: {
    styles: {
      ...ke
    }
  },
  VideoOverlayWrapper: {
    styles: {
      ...Se
    },
    variants: [...Be]
  }
}, wp = "485px", kp = "253px", Sp = "345px", Bp = "320px", Tp = {
  alignItems: "center",
  display: "flex",
  position: "relative",
  height: wp,
  minWidth: Bp,
  tabletAndUp: {
    height: kp
  },
  laptopAndUp: {
    height: Sp
  }
}, Wp = {
  position: "relative",
  zIndex: s.contentOverVideo,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: e.semantic.space["3x"],
  alignSelf: "stretch",
  padding: `0px ${e.semantic.space["5x"]}`,
  tabletAndUp: {
    padding: `52px ${e.semantic.space["12x"]}`
  },
  laptopAndUp: {
    padding: `0px ${e.semantic.space["12x"]}`
  }
}, Lp = {
  position: "absolute",
  top: "unset",
  left: "unset",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  backgroundColor: e.semantic.color.fill.neutralStrong,
  borderRadius: e.semantic.radius["2x"]
}, _p = {
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  width: "100%",
  overflow: "hidden",
  backgroundColor: "transparent",
  zIndex: s.contentOverVideo - 1,
  background: e.semantic.color.fill.neutralStrong
}, Ip = {
  height: "100%",
  width: "100%",
  divVideo: {
    position: "relative",
    minHeight: "100%",
    width: "100%",
    maxWidth: "none",
    objectFit: "cover",
    zIndex: s.contentOverVideo - 3
  }
}, Mp = {
  ...e.semantic.typography.headline.XXL,
  fontWeight: e.primitive.typography.fontWeights.fordF1.semiBold,
  color: e.semantic.color.text.onColor,
  letterSpacing: "0"
}, Dp = {
  ...e.semantic.typography.body.medium.M,
  letterSpacing: 0,
  color: e.semantic.color.text.onColor,
  tabletAndUp: {
    ...e.semantic.typography.body.medium.M
  }
}, Hp = {
  zIndex: s.contentOverVideo
}, Rp = {
  display: "flex",
  flexDirection: "column",
  marginTop: e.semantic.space["3x"],
  gap: e.semantic.space["6x"],
  width: "100%",
  tabletAndUp: {
    display: "flex",
    flexDirection: "row",
    gap: e.semantic.space["7x"],
    marginTop: e.semantic.space["3x"],
    padding: `0px ${e.semantic.space["12x"]} ${e.semantic.space["8x"]} 0px`,
    alignItems: "center",
    alignSelf: "stretch"
  }
}, zp = {
  display: "flex",
  alignItems: "center",
  gap: e.semantic.space["7x"]
}, Te = {
  Wrapper: Tp,
  HeadingContent: Wp,
  VideoWrapper: Lp,
  VideoOverlayWrapper: _p,
  VideoElementWrapper: Ip,
  VideoTitleWrapper: Mp,
  VideoBodyWrapper: Dp,
  VideoPlaybackButtonWrapper: Hp,
  VideoButtonsWrapper: Rp,
  PlayButtonWrapperWithTextButton: zp
}, Ap = Te, I = "218px", W = "342px", Fp = {
  display: "flex",
  flexDirection: "column-reverse",
  margin: `${e.semantic.space["8x"]} ${e.semantic.space["5x"]}`,
  tabletAndUp: {
    flexDirection: {
      left: "row-reverse",
      default: "row"
    },
    margin: "88px auto 0px",
    maxWidth: "1239px"
  }
}, Pp = {
  flexBasis: "50%",
  position: "relative",
  marginTop: e.semantic.space["10x"],
  tabletAndUp: {
    maxWidth: "560px",
    marginTop: "53px"
  }
}, Op = {
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.semiBold.XS,
  textTransform: "uppercase"
}, Ep = {
  ...e.semantic.typography.headline.XL,
  marginTop: "2px",
  color: e.semantic.color.text.default
}, Vp = {
  marginTop: e.semantic.space["4x"],
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.L
}, Gp = {
  marginTop: e.semantic.space["10x"],
  button: {
    width: "100%",
    marginBottom: e.semantic.space["2x"]
  },
  tabletAndUp: {
    button: {
      width: "inherit",
      marginBottom: "inherit"
    }
  }
}, jp = {
  flexBasis: "60%",
  position: "relative",
  background: "#000",
  borderRadius: e.semantic.radius["1x"],
  maxHeight: I,
  minHeight: I,
  height: I,
  iframe: {
    borderRadius: e.semantic.radius["1x"]
  },
  tabletAndUp: {
    borderRadius: e.semantic.radius["2x"],
    minWidth: "300px",
    maxWidth: "608px",
    height: W,
    maxHeight: W,
    marginLeft: {
      left: "0px",
      default: "71px"
    },
    marginRight: {
      right: "0px",
      default: "71px"
    },
    iframe: {
      borderRadius: e.semantic.radius["2x"]
    }
  }
}, Up = {
  background: "#000",
  position: "absolute",
  borderRadius: e.semantic.radius["1x"],
  cursor: "pointer",
  maxWidth: "100%",
  width: "100%",
  objectFit: "cover",
  height: W,
  tabletAndUp: {
    borderRadius: e.semantic.radius["2x"],
    height: W,
    maxWidth: "608px"
  }
}, Xp = {
  position: "absolute",
  left: e.semantic.space["6x"],
  bottom: e.semantic.space["4x"],
  zIndex: "2",
  tabletAndUp: {
    left: e.semantic.space["8x"],
    bottom: e.semantic.space["6x"]
  }
}, Np = {
  width: "100%",
  height: "100%",
  zIndex: "1",
  position: "absolute",
  borderRadius: e.semantic.radius["1x"],
  cursor: "pointer",
  background: `linear-gradient(
    180deg,
    rgba(0, 20, 46, 0) 15.29%,
    rgba(0, 20, 46, 0.65) 100%
  )`,
  tabletAndUp: {
    borderRadius: e.semantic.radius["2x"]
  }
}, Yp = {
  Wrapper: Fp,
  HeaderContainer: Pp,
  MiniTitleWrapper: Op,
  TitleWrapper: Ep,
  BodyWrapper: Vp,
  ButtonsWrapper: Gp,
  VideoContainerWrapper: jp,
  CoverImageElement: Up,
  PlayButtonElement: Xp,
  GradientOverlay: Np
}, M = "218px", L = "342px", Zp = {
  display: "flex",
  flexDirection: "column-reverse",
  margin: `${e.semantic.space["8x"]} ${e.semantic.space["5x"]}`,
  tabletAndUp: {
    flexDirection: {
      left: "row-reverse",
      default: "row"
    },
    margin: "88px auto 0px",
    maxWidth: "1239px"
  }
}, Kp = {
  flexBasis: "50%",
  position: "relative",
  marginTop: e.semantic.space["10x"],
  tabletAndUp: {
    maxWidth: "560px",
    marginTop: "53px"
  }
}, Qp = {
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.semiBold.XS,
  textTransform: "uppercase"
}, qp = {
  ...e.semantic.typography.headline.XL,
  marginTop: "2px",
  color: e.semantic.color.text.default
}, Jp = {
  marginTop: e.semantic.space["4x"],
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.L
}, em = {
  marginTop: e.semantic.space["10x"],
  button: {
    width: "100%",
    marginBottom: e.semantic.space["2x"]
  },
  tabletAndUp: {
    button: {
      width: "inherit",
      marginBottom: "inherit"
    }
  }
}, tm = {
  flexBasis: "60%",
  position: "relative",
  background: "#000",
  borderRadius: e.semantic.radius["1x"],
  maxHeight: M,
  minHeight: M,
  height: M,
  iframe: {
    borderRadius: e.semantic.radius["1x"]
  },
  tabletAndUp: {
    borderRadius: e.semantic.radius["2x"],
    minWidth: "300px",
    maxWidth: "608px",
    height: L,
    maxHeight: L,
    marginLeft: {
      left: "0px",
      default: "71px"
    },
    marginRight: {
      right: "0px",
      default: "71px"
    },
    iframe: {
      borderRadius: e.semantic.radius["2x"]
    }
  }
}, om = {
  background: "#000",
  position: "absolute",
  borderRadius: e.semantic.radius["1x"],
  cursor: "pointer",
  maxWidth: "100%",
  width: "100%",
  objectFit: "cover",
  height: L,
  tabletAndUp: {
    borderRadius: e.semantic.radius["2x"],
    height: L,
    maxWidth: "608px"
  }
}, im = {
  position: "absolute",
  left: e.semantic.space["6x"],
  bottom: e.semantic.space["4x"],
  zIndex: "2",
  tabletAndUp: {
    left: e.semantic.space["8x"],
    bottom: e.semantic.space["6x"]
  }
}, rm = {
  width: "100%",
  height: "100%",
  zIndex: "1",
  position: "absolute",
  borderRadius: e.semantic.radius["1x"],
  cursor: "pointer",
  background: `linear-gradient(
    180deg,
    rgba(0, 20, 46, 0) 15.29%,
    rgba(0, 20, 46, 0.65) 100%
  )`,
  tabletAndUp: {
    borderRadius: e.semantic.radius["2x"]
  }
}, am = {
  Wrapper: Zp,
  HeaderContainer: Kp,
  MiniTitleWrapper: Qp,
  TitleWrapper: qp,
  BodyWrapper: Jp,
  ButtonsWrapper: em,
  VideoContainerWrapper: tm,
  CoverImageElement: om,
  PlayButtonElement: im,
  GradientOverlay: rm
}, nm = {
  display: "inline",
  ...k.a,
  "&--xsmall": {
    ...t.semanticMode1.caption.regular.value,
    color: t.semanticMode1.color.text.onLight.interactive.value
  },
  // Default
  "&--small": {
    ...t.semanticMode1.body2.regular.value,
    color: t.semanticMode1.color.text.onLight.interactive.value
  },
  "&--medium": {
    ...t.semanticMode1.body1.regular.value,
    color: t.semanticMode1.color.text.onLight.interactive.value
  },
  "&--large": {
    ...t.semanticMode1.body1.regular.value,
    color: t.semanticMode1.color.text.onLight.interactive.value
  },
  "&--onImage": {
    color: t.primitive.color.twilight[300].value,
    "&:link, &:visited, &:hover, &:active": {
      color: t.primitive.color.twilight[300].value,
      textDecoration: "none"
    },
    "&:hover": {
      color: t.primitive.color.twilight["000"].value
    },
    "&:focus-visible": {
      textDecoration: "underline",
      textDecorationColor: t.semanticMode1.color.text.onDark.interactiveHover.value,
      outlineColor: t.primitive.color.twilight["000"].value
    }
  },
  "&--disclosure": {
    textUnderlineOffset: "2px"
  },
  "&--disabled": {
    color: t.semanticMode1.color.text.onLight.subtlestDisabled.value,
    cursor: "not-allowed",
    textDecoration: "none",
    "&:link, &:visited, &:visited, &:hover, &:active": {
      textDecoration: "none",
      color: t.semanticMode1.color.text.onLight.subtlestDisabled.value
    }
  }
}, lm = {
  display: "inline-block",
  verticalAlign: "middle",
  marginTop: "calc(1ex - 1cap)",
  "--icon-gap": t.primitive.space["1x"].value,
  "--icon-size": t.primitive.space["5x"].value,
  // 24px
  width: "var(--icon-size)",
  height: "var(--icon-size)",
  "&--left": {
    paddingRight: "var(--icon-gap)"
  },
  "&--right": {
    paddingLeft: "var(--icon-gap)"
  },
  "svg,img": {
    width: "100%",
    height: "100%"
  },
  "&--xsmall, &--small": {
    "--icon-size": t.primitive.space["4x"].value
    // 16px
  }
}, sm = {
  Link: nm,
  IconWrapper: lm
}, cm = {
  display: "inline",
  ...z.a,
  "&--xsmall": {
    ...e.semantic.typography.body.medium.XS,
    textUnderlineOffset: e.semantic.space["1x"]
  },
  // Default
  "&--small": {
    ...e.semantic.typography.body.medium.S,
    textUnderlineOffset: e.semantic.space["1x"]
  },
  "&--medium": {
    ...e.semantic.typography.body.medium.M,
    textUnderlineOffset: "5px"
  },
  "&--large": {
    ...e.semantic.typography.body.medium.L,
    textUnderlineOffset: "5px"
  },
  "&--onImage": {
    color: e.semantic.color.text.onColor,
    "&:link, &:visited, &:hover, &:active": {
      color: e.semantic.color.text.onColor
    },
    "&:hover": {
      textDecoration: "none"
    }
  },
  "&--disclosure": {
    textUnderlineOffset: ut.fpds.number["050"]
  },
  "&--disabled": {
    color: e.semantic.color.link.neutral,
    cursor: "not-allowed",
    textDecoration: "none",
    "&:link, &:visited, &:hover, &:active": {
      textDecoration: "none",
      color: e.semantic.color.link.neutral
    }
  }
}, dm = {
  display: "inline-block",
  verticalAlign: "middle",
  marginTop: "calc(1ex - 1cap)",
  "--icon-gap": e.semantic.space["1x"],
  "--icon-size": e.semantic.space["5x"],
  // 20px
  width: "var(--icon-size)",
  height: "var(--icon-size)",
  "&--left": {
    paddingRight: "var(--icon-gap)"
  },
  "&--right": {
    paddingLeft: "var(--icon-gap)"
  },
  "svg,img": {
    width: "100%",
    height: "100%"
  },
  "&--xsmall, &--small": {
    "--icon-size": e.semantic.space["4x"]
    // 20px
  }
}, pm = {
  Link: cm,
  IconWrapper: dm
}, mm = {
  ol: {
    marginInlineStart: e.semantic.space["2x"],
    marginInlineEnd: "0px",
    paddingInlineStart: "0px",
    paddingInlineEnd: "0px",
    listStylePosition: "inside",
    fontFamily: e.primitive.typography.fontFamilies.inter,
    fontStyle: "normal",
    li: {
      paddingLeft: {
        small: "10px",
        large: "18px",
        default: "14px"
      },
      ol: {
        marginTop: e.semantic.space["1x"],
        marginInlineStart: {
          small: e.semantic.space["8x"],
          large: e.semantic.space["10x"],
          default: "36px"
        }
      }
    }
  },
  ul: {
    marginInlineStart: {
      none: "0px",
      default: e.semantic.space["2x"]
    },
    paddingInlineStart: {
      none: "0px",
      large: e.semantic.space["5x"],
      default: e.semantic.space["4x"]
    },
    marginInlineEnd: "0px",
    paddingInlineEnd: "0px",
    fontFamily: e.primitive.typography.fontFamilies.inter,
    fontStyle: "normal"
  },
  li: {
    position: "relative",
    marginBottom: e.semantic.space["1x"],
    lastOfType: "0px",
    ul: {
      marginInlineStart: "0px",
      marginInlineEnd: "0px"
    }
  }
}, um = {
  listStyle: "none",
  textStyle: {
    small: e.semantic.typography.body.regular.S,
    medium: e.semantic.typography.body.regular.M,
    large: e.semantic.typography.body.regular.L
  },
  bullet: {
    content: '"•"',
    position: "absolute",
    color: e.semantic.color.icon.primary,
    left: {
      large: e.semantic.space["5x"],
      default: e.semantic.space["4x"]
    }
  },
  dash: {
    content: '"-"',
    position: "absolute",
    color: e.semantic.color.icon.primary,
    left: {
      large: e.semantic.space["5x"],
      default: e.semantic.space["4x"]
    }
  },
  square: {
    content: '"■"',
    position: "absolute",
    color: e.semantic.color.icon.primary,
    left: {
      large: e.semantic.space["5x"],
      default: e.semantic.space["4x"]
    }
  }
}, gm = {
  textStyle: {
    small: e.semantic.typography.body.regular.S,
    medium: e.semantic.typography.body.regular.M,
    large: e.semantic.typography.body.regular.L
  },
  color: e.semantic.color.text.subtle,
  lowerRoman: {
    paddingLeft: "0px",
    position: "absolute",
    left: {
      samll: "10px",
      large: "18px",
      default: "14px"
    }
  },
  marker: {
    color: e.semantic.color.text.default,
    fontWeight: {
      default: e.primitive.typography.fontWeights.inter.medium,
      lowImpact: e.primitive.typography.fontWeights.inter.regular
    }
  }
}, xm = {
  color: {
    link: e.semantic.color.link.default,
    default: e.semantic.color.text.subtle
  },
  cursor: {
    link: "pointer",
    default: "default"
  },
  fontSize: "inherit",
  lineHeight: "inherit",
  fontWeight: e.primitive.typography.fontWeights.inter.regular
}, hm = {
  display: "inline-flex",
  verticalAlign: "middle",
  marginRight: e.semantic.space["3x"]
}, We = {
  ListWrapper: mm,
  UnorderedListContainer: um,
  OrderedListContainer: gm,
  ListItemContainer: xm,
  ListIconContainer: hm
}, bm = We, fm = {
  backgroundColor: e.semantic.color.fill.default,
  width: "100%",
  boxSizing: "border-box",
  borderRadius: e.semantic.space["2x"],
  padding: e.semantic.space["3x"],
  ".Label__content": {
    position: "absolute",
    display: "contents",
    ".RadioButton--hideRadio": {
      opacity: 0,
      position: "absolute",
      display: "contents"
    }
  },
  gap: e.semantic.space["2x"],
  display: "flex",
  flexWrap: "wrap",
  height: "fit-content",
  border: `1px solid ${e.semantic.color.stroke.default}`,
  "&:has(.RadioButton:checked)": {
    border: `1px solid ${e.semantic.color.stroke.focus}`,
    margin: 0
  },
  ".MapCard__Content-Description": {
    color: e.semantic.color.text.subtlest,
    "&:nth-child(2)": {
      textAlign: "end"
    }
  },
  ".MapCard__Title-text": {
    wordBreak: "break-all"
  }
}, vm = {
  display: "flex",
  width: "100%",
  flexWrap: "nowrap",
  justifyContent: "space-between",
  gap: e.semantic.space["4x"]
}, ym = {
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"],
  justifyContent: "space-between",
  ".MapCard__Content-SubTitle": {
    color: e.semantic.color.text.subtle,
    wordBreak: "break-all"
  },
  "&:nth-child(1)": {
    flex: 1
  },
  "&:nth-child(2)": {
    maxWidth: "50%",
    alignItems: "flex-end"
  },
  ".Tag__close-btn": {
    display: "none"
  }
}, Cm = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["1x"],
  justifyContent: "space-between"
}, $m = {
  display: "flex",
  gap: e.semantic.space["2x"],
  margin: 0,
  svg: {
    minWidth: gt.l
  }
}, wm = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: e.semantic.space["2x"]
}, km = {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  gap: e.semantic.space["2x"],
  ".Button": {
    boxSizing: "border-box",
    flex: 1
  },
  "&-Description": {
    wordBreak: "break-all",
    flexWrap: "nowrap",
    ".MapCard__Content-Description": {
      "&:nth-child(1)": {
        flex: 1
      },
      "&:nth-child(2)": {
        maxWidth: "50%",
        alignItems: "flex-end"
      }
    }
  }
}, Sm = {
  ".MapCard_Group .RadioGroup": {
    gap: e.semantic.space["3x"]
  }
}, Le = {
  MapCardContainer: fm,
  CardContent: ym,
  CardContentWrapper: vm,
  Title: $m,
  Footer: wm,
  ContentWrapper: km,
  ContentHeader: Cm,
  MapCardGroup: Sm
}, Bm = Le, Tm = {
  "--pinDot-icon-color": e.semantic.color.fill.default,
  "--pinDot-icon-hover-color": e.semantic.color.fill.neutralSubtle,
  "--pinDot-icon-innerDot-color": e.semantic.color.stroke.neutralStrong,
  "&--default": {
    "--pinEmpty-icon-color": e.semantic.color.fill.primaryStrong,
    "--pinEmpty-icon-hover-color": e.semantic.color.action.hover
  },
  "&--success": {
    "--pinEmpty-icon-color": e.semantic.color.fill.successStrong,
    "--pinEmpty-icon-hover-color": e.semantic.color.action.successHover
  },
  "&--caution": {
    "--pinEmpty-icon-color": e.semantic.color.icon.caution,
    "--pinEmpty-icon-hover-color": e.semantic.color.icon.cautionStrongest
  },
  "&--danger": {
    "--pinEmpty-icon-color": e.semantic.color.icon.danger,
    "--pinEmpty-icon-hover-color": e.semantic.color.icon.dangerStrongest
  },
  "&--neutral": {
    "--pinEmpty-icon-color": e.semantic.color.fill.neutralModerate,
    "--pinEmpty-icon-hover-color": e.semantic.color.icon.neutralStrong
  },
  " &--selected": {
    "--pinEmpty-icon-color": e.semantic.color.icon.default,
    "--pinEmpty-icon-hover-color": e.semantic.color.icon.default,
    "--pinDot-icon-color": e.semantic.color.icon.default,
    "--pinDot-icon-hover-color": e.semantic.color.icon.default,
    "--pinDot-icon-innerDot-color": e.semantic.color.stroke.onColor
  }
}, Wm = {
  ".PinInsert__position_relative": {
    position: "relative",
    ".PinInsert__position-absolute": {
      position: "absolute",
      top: e.semantic.space["4x"],
      left: "50%",
      translate: "-50% -50%"
    }
  }
}, Lm = {
  height: "auto",
  width: "auto",
  padding: "0",
  border: "0",
  background: "transparent",
  cursor: "pointer",
  color: e.semantic.color.text.onColor,
  "button&:hover": {
    background: "transparent",
    border: "none"
  },
  svg: {
    "&.Icon": {
      "&--pinEmpty": {
        color: "var(--pinEmpty-icon-color)",
        "&:hover, &:active, &--active": {
          color: "var(--pinEmpty-icon-hover-color)"
        }
      },
      "&--pinDot": {
        color: "var(--pinDot-icon-color)",
        "g+path": {
          stroke: "var(--pinDot-icon-innerDot-color)"
        },
        "g+path+path": {
          fill: "var(--pinDot-icon-innerDot-color)"
        },
        "&:hover, &:active, &--active": {
          color: "var(--pinDot-icon-hover-color)"
        }
      }
    }
  },
  ...Wm,
  "&.PinButton": {
    ...Tm
  }
}, _m = {
  "--poi-button-size": e.semantic.size["7x"],
  "--poi-button-icon-size": e.semantic.size["5x"]
}, Im = {
  "&--default": {
    "--_btn-bg-color": e.semantic.color.fill.primaryStrong,
    "--_btn-hover-bg-color": e.semantic.color.action.hover
  },
  "&--success": {
    "--_btn-bg-color": e.semantic.color.fill.successStrong,
    "--_btn-hover-bg-color": e.semantic.color.action.successHover
  },
  "&--caution": {
    "--_btn-bg-color": e.semantic.color.icon.caution,
    "--_btn-hover-bg-color": e.semantic.color.icon.cautionStrongest
  },
  "&--danger": {
    "--_btn-bg-color": e.semantic.color.icon.danger,
    "--_btn-hover-bg-color": e.semantic.color.icon.dangerStrongest
  },
  "&--neutral": {
    "--_btn-bg-color": e.semantic.color.fill.neutralModerate,
    "--_btn-hover-bg-color": e.semantic.color.icon.neutralStrong
  },
  "&--selected": {
    "--_btn-bg-color": e.semantic.color.icon.default,
    "--_btn-hover-bg-color": e.semantic.color.icon.default
  }
}, Mm = {
  position: "relative",
  ".PoiInsert--badge-centered": {
    position: "absolute",
    top: "50%",
    left: "50%",
    translate: "-50% -50%"
  }
}, Dm = {
  width: "var(--poi-button-size)",
  height: "var(--poi-button-size)",
  flexShrink: 0,
  borderRadius: e.semantic.radius.max,
  /* Shadow/Medium */
  boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.1)",
  padding: "0px",
  ".Button__icon-wrapper": {
    width: "var(--poi-button-icon-size)"
  },
  "&.POIButton": {
    ...Mm,
    ..._m,
    ...Im
  }
}, Hm = {
  //prevent the default Button events inside entire popupTip children
  "&.MapMarker": {
    "&--restrict-clicks": {
      pointerEvents: "none",
      "button.POIButton , button.PinButton": {
        pointerEvents: "all"
      }
    },
    "&--highlight-bg-onHover": {
      "&:hover": {
        "div.PopupTip__content , span.PopupTip__pointer": {
          backgroundColor: e.semantic.color.fill.hover
        },
        "button.POIButton": {
          backgroundColor: "var(--_btn-hover-bg-color)",
          border: "var(--_btn-hover-bg-color)"
        }
      }
    },
    "&--complex": {
      "div.PopupTip__content-wrapper--top-open div.PopupTip__content": {
        width: "308px"
      }
    },
    "&--minimised": {
      "div.PopupTip__content-wrapper--top-open div.PopupTip__content": {
        width: "152px",
        "div.PopupTip__header button.CloseButton": {
          display: "none"
        },
        "div.PopupTip__body": {
          padding: 0
        }
      }
    },
    "&--interactionType-hover": {
      "button+div.PopupTip__overlay": {
        "div.PopupTip__header button.CloseButton": {
          display: "none"
        }
      }
    },
    ".PopupTip__header + .PopupTip__body": {
      paddingTop: "0"
    },
    ".MapMarker__Insert_transparent": {
      backgroundColor: "transparent",
      pointerEvents: "none"
    }
  }
}, _e = {
  POIButton: Dm,
  PinButton: Lm,
  PopupTipWrapper: Hm
}, Rm = _e, f = {
  "&--text-left": {
    textAlign: "left"
  },
  "&--text-center": {
    textAlign: "center"
  },
  "&--text-right": {
    textAlign: "right"
  },
  "&--icon-left": {
    justifyContent: "start"
  },
  "&--icon-center": {
    justifyContent: "center"
  },
  "&--icon-right": {
    justifyContent: "end"
  }
}, Ie = {
  width: "100%",
  color: t.semanticMode1.color.text.onLight.moderateDefault.value,
  overflowWrap: "break-word",
  "&--small, &--medium, &--large": {
    ...t.semanticMode1.body1.regular.value
  },
  ...f
}, zm = {
  ...Ie,
  ".TextContainer,": {
    "&--text-left": {
      justifyContent: "flex-start"
    },
    "&--text-center": {
      justifyContent: "center"
    },
    "&--text-right": {
      justifyContent: "flex-end"
    }
  }
}, Am = {
  color: t.semanticMode1.color.text.onLight.subtle.value,
  fontSize: t.semanticMode1.fontSize[1].value,
  ...f
}, Fm = {
  display: "flex",
  flexDirection: "row",
  gap: t.primitive.space["6x"].value,
  marginTop: t.primitive.space["6x"].value,
  width: "100%"
}, Pm = {
  display: "flex",
  flexDirection: "column",
  gap: t.primitive.space["2x"].value,
  minWidth: "280px",
  maxWidth: "552px",
  [`@media ${i.tabletAndUp}`]: {
    minWidth: "unset",
    maxWidth: "unset",
    width: "100%"
  }
}, Om = {
  width: `calc(100% - ${t.primitive.space["5x"].value} - ${t.primitive.space["2x"].value})`,
  ...t.semanticMode1.body1.semibold.value,
  ...f,
  overflowWrap: "break-word",
  [`@media ${i.laptopAndUp}`]: {
    padding: `${t.primitive.space["3x"].value} ${t.primitive.space["0x"].value}`
  },
  "&--small, &--medium, &--large": {
    display: "unset",
    padding: "unset"
  },
  "&--variant-label": {
    ...t.semanticMode1.body2.regular.value,
    display: "unset",
    padding: "unset"
  },
  "&--variant--description": {
    ...t.semanticMode1.body2.regular.value,
    padding: "unset"
  },
  "&--variant-value": {
    ...t.semanticMode1.body2.regular.value
  }
}, P = {
  svg: {
    color: t.semanticMode1.color.icon.onLight.interactive.value
  }
}, Em = {
  ...f,
  display: "flex",
  width: `calc(100% - ${t.primitive.space["5x"].value} - ${t.primitive.space["2x"].value})`,
  ...P,
  [`@media ${i.laptopAndUp}`]: {
    width: "unset",
    padding: "unset"
  }
}, Vm = {
  ...f,
  display: "flex",
  width: `calc(100% - ${t.primitive.space["5x"].value} - ${t.primitive.space["2x"].value})`,
  svg: {
    color: t.semanticMode1.color.icon.onLight.subtleDisabled.value
  },
  [`@media ${i.laptopAndUp}`]: {
    width: "unset",
    padding: "unset"
  }
}, Gm = {
  ...f,
  display: "flex",
  width: `calc(100% - ${t.primitive.space["5x"].value} - ${t.primitive.space["2x"].value})`,
  svg: {
    color: t.semanticMode1.color.icon.onLight.interactive.value
  },
  [`@media ${i.laptopAndUp}`]: {
    width: "unset",
    padding: "unset"
  }
}, jm = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  gap: t.primitive.space["2x"].value
}, Um = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  paddingTop: t.primitive.space["1x"].value,
  justifyContent: "flex-start",
  ...P
}, Xm = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  alignItems: "flex-start",
  gap: t.primitive.space["6x"].value,
  alignSelf: "stretch"
}, Nm = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  alignItems: "flex-start",
  alignSelf: "stretch"
}, Ym = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  gap: t.primitive.space["6x"].value
}, Zm = {
  display: "flex",
  flexDirection: "column",
  width: `calc(50% - ${t.primitive.space["3x"].value})`,
  borderBottom: `${t.primitive.space["1x"].value} ${t.semanticMode1.color.stroke.onLight.moderateDefault.value} solid`
}, Km = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: `calc(50% - ${t.primitive.space["3x"].value})`,
  ".Image": {
    marginBottom: t.primitive.space["2x"].value
  },
  ".single-select-input": {
    width: "100%",
    marginBottom: t.primitive.space["6x"].value
  }
}, Qm = {
  display: "flex",
  flexDirection: "column",
  width: `calc(100% - ${t.primitive.space["5x"].value} - ${t.primitive.space["2x"].value})`,
  marginRight: t.primitive.space["2x"].value
}, qm = {
  display: "flex",
  flexDirection: "row",
  width: "100%"
}, Jm = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: t.primitive.space["1x"].value
}, eu = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  padding: `${t.primitive.space["3x"].value} ${t.primitive.space["0x"].value}`
}, tu = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  paddingTop: t.primitive.space["1x"].value,
  justifyContent: "flex-start",
  ...P,
  [`@media ${i.laptopAndUp}`]: {
    paddingTop: t.primitive.space["3x"].value
  }
}, ou = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  gap: t.primitive.space["2x"].value
}, iu = {
  width: `calc(50% - ${t.primitive.space["3x"].value} )!important`,
  [`@media ${i.laptopAndUp}`]: {
    width: "100% !important"
  }
}, ru = {
  display: "flex",
  height: "100%",
  flexDirection: "column"
}, au = {
  MarketingComparisonTableMobileViewContentAlignment: f,
  MarketingComparisonTableMobileViewHeaderTitle: Ie,
  MarketingComparisonTableMobileViewBodyValue: zm,
  MarketingComparisonTableMobileViewDescription: Am,
  MarketingComparisonTableMobileViewButtonWrapper: Fm,
  MarketingComparisonTableMobileViewContainer: Pm,
  TextWrapper: Om,
  InformationWrapper: Em,
  UncheckedWrapper: Vm,
  CheckedWrapper: Gm,
  MarketingComparisonTableHeaderTextContainer: jm,
  MarketingComparisonTableMobileViewHeaderTooltipContainer: Um,
  MarketingComparisonTableMobileViewHeaderContainer: Xm,
  MarketingComparisonTableMobileViewBodyContainer: Nm,
  MarketingComparisonTableMobileViewBodyWrapper: Ym,
  MarketingComparisonTableMobileViewBody: Zm,
  MarketingComparisonTableMobileViewHeader: Km,
  MarketingComparisonTableMobileViewHeaderTitleWrapper: Qm,
  MarketingComparisonTableMobileViewHeaderTitleContainer: qm,
  MarketingComparisonTableMobileViewBodyValueWrapper: Jm,
  MarketingComparisonTableMobileViewBodyValueContainer: eu,
  MarketingComparisonTableMobileViewBodyTooltipContainer: tu,
  MarketingComparisonTableValueWrapperTextContainer: ou,
  MarketingComparisonTableColumnButton: iu,
  MarketingComparisonTableHeaderContainer: ru
}, $ = {
  "&--text-left": {
    textAlign: "left"
  },
  "&--text-center": {
    textAlign: "center"
  },
  "&--text-right": {
    textAlign: "right"
  },
  "&--icon-left": {
    justifyContent: "start"
  },
  "&--icon-center": {
    justifyContent: "center"
  },
  "&--icon-right": {
    justifyContent: "end"
  }
}, Me = {
  width: "100%",
  color: e.semantic.color.text.default,
  overflowWrap: "break-word",
  "&--small": {
    ...e.semantic.typography.body.semiBold.S
  },
  "&--medium": {
    ...e.semantic.typography.body.semiBold.M
  },
  "&--large": {
    ...e.semantic.typography.body.semiBold.L
  },
  ...$
}, nu = {
  ...Me,
  ".TextContainer,": {
    "&--text-left": {
      justifyContent: "flex-start"
    },
    "&--text-center": {
      justifyContent: "center"
    },
    "&--text-right": {
      justifyContent: "flex-end"
    }
  }
}, lu = {
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.S,
  ...$
}, su = {
  display: "flex",
  flexDirection: "row",
  gap: e.semantic.space["6x"],
  marginTop: e.semantic.space["6x"],
  width: "100%"
}, cu = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"],
  minWidth: "280px",
  maxWidth: "552px",
  [`@media ${i.tabletAndUp}`]: {
    minWidth: "unset",
    maxWidth: "unset",
    width: "100%"
  }
}, du = {
  width: `calc(100% - ${e.semantic.space["5x"]} - ${e.semantic.space["2x"]})`,
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.medium.M,
  ...$,
  overflowWrap: "break-word",
  [`@media ${i.laptopAndUp}`]: {
    padding: `${e.semantic.space["3x"]} ${e.semantic.space["0x"]}`,
    ...e.semantic.typography.body.regular.S
  },
  "&--small": {
    ...e.semantic.typography.body.semiBold.S,
    display: "unset",
    padding: "unset"
  },
  "&--medium": { ...e.semantic.typography.body.semiBold.M, display: "unset", padding: "unset" },
  "&--large": { ...e.semantic.typography.body.semiBold.L, display: "unset", padding: "unset" },
  "&--variant-label": {
    color: e.semantic.color.text.subtlest,
    ...e.semantic.typography.body.regular.S,
    display: "unset",
    padding: "unset"
  },
  "&--variant--description": {
    color: e.semantic.color.text.subtle,
    ...e.semantic.typography.body.regular.S,
    padding: "unset"
  }
}, O = {
  svg: {
    color: e.semantic.color.icon.primary
  }
}, pu = {
  ...$,
  display: "flex",
  width: `calc(100% - ${e.semantic.space["5x"]} - ${e.semantic.space["2x"]})`,
  ...O,
  [`@media ${i.laptopAndUp}`]: {
    width: "unset",
    padding: "unset"
  }
}, mu = {
  ...$,
  display: "flex",
  width: `calc(100% - ${e.semantic.space["5x"]} - ${e.semantic.space["2x"]})`,
  svg: {
    color: e.semantic.color.stroke.default
  },
  [`@media ${i.laptopAndUp}`]: {
    width: "unset",
    padding: "unset"
  }
}, uu = {
  ...$,
  display: "flex",
  width: `calc(100% - ${e.semantic.space["5x"]} - ${e.semantic.space["2x"]})`,
  svg: {
    color: e.semantic.color.icon.primaryStrongest
  },
  [`@media ${i.laptopAndUp}`]: {
    width: "unset",
    padding: "unset"
  }
}, gu = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  gap: e.semantic.space["2x"]
}, xu = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  paddingTop: e.semantic.space[".5x"],
  justifyContent: "flex-start",
  ...O
}, hu = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  alignItems: "flex-start",
  gap: e.semantic.space["6x"],
  alignSelf: "stretch"
}, bu = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  alignItems: "flex-start",
  alignSelf: "stretch"
}, fu = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  gap: e.semantic.space["6x"]
}, vu = {
  display: "flex",
  flexDirection: "column",
  width: `calc(50% - ${e.semantic.space["3x"]})`,
  borderBottom: `${e.semantic.space[".5x"]} ${e.semantic.color.stroke.default} solid`
}, yu = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: `calc(50% - ${e.semantic.space["3x"]})`,
  ".Image": {
    marginBottom: e.semantic.space["2x"]
  },
  ".single-select-input": {
    width: "100%",
    marginBottom: e.semantic.space["6x"]
  }
}, Cu = {
  display: "flex",
  flexDirection: "column",
  width: `calc(100% - ${e.semantic.space["5x"]} - ${e.semantic.space["2x"]})`,
  marginRight: e.semantic.space["2x"]
}, $u = {
  display: "flex",
  flexDirection: "row",
  width: "100%"
}, wu = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: e.semantic.space["1x"]
}, ku = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  padding: `${e.semantic.space["3x"]} ${e.semantic.space["0x"]}`
}, Su = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  paddingTop: `${e.semantic.space[".5x"]}`,
  justifyContent: "flex-start",
  ...O,
  [`@media ${i.laptopAndUp}`]: {
    paddingTop: `${e.semantic.space["3x"]}`
  }
}, Bu = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  gap: `${e.semantic.space["2x"]}`
}, Tu = {
  width: `calc(50% - ${e.semantic.space["3x"]} )!important`,
  [`@media ${i.laptopAndUp}`]: {
    width: "100% !important"
  }
}, Wu = {
  display: "flex",
  height: "100%",
  flexDirection: "column"
}, Lu = {
  MarketingComparisonTableMobileViewHeaderTitle: Me,
  MarketingComparisonTableMobileViewBodyValue: nu,
  MarketingComparisonTableMobileViewDescription: lu,
  MarketingComparisonTableMobileViewButtonWrapper: su,
  MarketingComparisonTableMobileViewContainer: cu,
  TextWrapper: du,
  InformationWrapper: pu,
  UncheckedWrapper: mu,
  CheckedWrapper: uu,
  MarketingComparisonTableHeaderTextContainer: gu,
  MarketingComparisonTableMobileViewHeaderTooltipContainer: xu,
  MarketingComparisonTableMobileViewHeaderContainer: hu,
  MarketingComparisonTableMobileViewBodyContainer: bu,
  MarketingComparisonTableMobileViewBodyWrapper: fu,
  MarketingComparisonTableMobileViewBody: vu,
  MarketingComparisonTableMobileViewHeader: yu,
  MarketingComparisonTableMobileViewHeaderTitleWrapper: Cu,
  MarketingComparisonTableMobileViewHeaderTitleContainer: $u,
  MarketingComparisonTableMobileViewBodyValueWrapper: wu,
  MarketingComparisonTableMobileViewBodyValueContainer: ku,
  MarketingComparisonTableMobileViewBodyTooltipContainer: Su,
  MarketingComparisonTableValueWrapperTextContainer: Bu,
  MarketingComparisonTableColumnButton: Tu,
  MarketingComparisonTableHeaderContainer: Wu
}, _u = {
  padding: "unset",
  margin: "unset",
  height: "auto",
  display: "flex",
  gap: e.semantic.space["6x"],
  flexDirection: "column",
  [`@media ${i.tabletAndUp}`]: {
    flexDirection: "row"
  }
}, Iu = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: e.semantic.space["6x"],
  justifyContent: "center",
  [`@media ${i.tabletAndUp}`]: {
    width: "50%"
  }
}, Mu = {
  position: "relative",
  width: "100%",
  [`@media ${i.tabletAndUp}`]: {
    width: "50%"
  }
}, Du = {
  display: "flex",
  flexWrap: "wrap",
  rowGap: e.semantic.space["6x"],
  columnGap: e.semantic.space["6x"],
  [`@media ${i.tabletAndUp}`]: {
    rowGap: e.semantic.space["16x"]
  }
}, Hu = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["3x"]
}, Ru = {
  color: e.semantic.color.text.default,
  "&--extraLarge": {
    ...e.semantic.typography.headline.XL
  },
  "&--large": {
    ...e.semantic.typography.headline.L
  },
  "&--medium": {
    ...e.semantic.typography.headline.M
  }
}, zu = {
  alignSelf: "stretch",
  color: e.semantic.color.text.subtle,
  fontStyle: "normal",
  ...e.semantic.typography.body.semiBold.M
}, Au = {
  width: "100%",
  [`@media ${i.tabletAndUp}`]: {
    width: `calc(50% - ${e.semantic.space["3x"]})`
  }
}, Fu = {
  display: "flex",
  flexDirection: "column",
  borderLeft: `1px solid ${e.semantic.color.stroke.default}`,
  paddingLeft: e.semantic.space["4x"]
}, Pu = {
  ...e.semantic.typography.headline.XL,
  color: e.semantic.color.text.default
}, Ou = {
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.medium.L,
  fontStyle: "normal"
}, De = {
  MainWrapper: _u,
  MarketingListItemSection: Iu,
  MarketingListItemWrapper: Au,
  ImageWrapper: Mu,
  ChildrenWrapper: Du,
  TitleSubTitleWrapper: Hu,
  TitleWrapper: Ru,
  SubTitleWrapper: zu,
  ValueTextWrapper: Fu,
  Value: Pu,
  Text: Ou
}, Eu = De, Vu = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "auto",
  minWidth: "280px",
  gap: e.semantic.space["6x"],
  [`@media ${i.tabletAndUp}`]: {
    "&--photoSplitShort, &--photoSplitLong, &--textSplit": {
      flexDirection: "row"
    },
    "&--textSplit": { gap: "84px" }
  },
  [`@media ${i.laptopAndUp}`]: {
    "&--textSplit": { gap: "92px" }
  },
  [`@media ${i.desktopAndUp}`]: {
    "&--textSplit": { gap: "116px" }
  },
  [`@media ${i.wideScreenAndUp}`]: {
    "&--textSplit": { gap: "140px" }
  }
}, Gu = {
  display: "flex",
  flexDirection: "column",
  rowGap: e.semantic.space["6x"],
  width: "100%",
  height: "auto",
  borderRadius: e.semantic.radius["2x"],
  justifyContent: "flex-start",
  "&--textSplit": {
    justifyContent: "center"
  },
  [`@media ${i.tabletAndUp}`]: {
    "&--photoSplitShort, &--photoSplitLong": { width: "50%" }
  }
}, ju = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  gap: e.semantic.space["6x"],
  [`@media ${i.tabletAndUp}`]: {
    "&--photoSplitShort, &--photoSplitLong": { width: "50%" }
  }
}, Uu = {
  display: "flex",
  flexDirection: "column",
  rowGap: e.semantic.space["3x"]
}, Xu = {
  ...e.semantic.typography.headline.XL,
  color: e.semantic.color.text.default,
  "&--large": {
    ...e.semantic.typography.headline.L
  },
  "&--medium": {
    ...e.semantic.typography.headline.M
  }
}, Nu = {
  ...e.semantic.typography.body.semiBold.M,
  color: e.semantic.color.text.subtle
}, Yu = {
  backgroundColor: e.semantic.color.stroke.default,
  width: "1px",
  height: "auto"
}, Zu = {
  display: "inline-flex",
  verticalAlign: "middle",
  marginRight: e.semantic.space["3x"],
  marginTop: "3px"
}, Ku = {
  display: "flex",
  "&--regular": {
    ...e.semantic.typography.body.regular.L,
    color: e.semantic.color.text.subtle
  },
  "&--medium": {
    ...e.semantic.typography.body.medium.L,
    color: e.semantic.color.text.default
  }
}, Qu = {
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  listStyleType: "none",
  rowGap: e.semantic.space["4x"],
  "&--default": { rowGap: e.semantic.space["1x"] },
  width: "100%",
  [`@media ${i.tabletAndUp}`]: {
    "&--textStacked": { width: "calc(50% - 16.5px)" }
  },
  "&--dot": {
    "& > li:before": {
      content: '"•"',
      color: e.semantic.color.icon.primary,
      padding: `0 11px 0 ${e.semantic.space["2x"]}`
    }
  },
  "&--dash": {
    "& > li:before": {
      content: '"-"',
      color: e.semantic.color.icon.primary,
      padding: `0 11px 0 ${e.semantic.space["2x"]}`
    }
  }
}, qu = {
  display: "flex",
  flexDirection: "column",
  "&--textStacked": { flexDirection: "row" },
  flexWrap: "wrap",
  columnGap: e.semantic.space["4x"],
  rowGap: e.semantic.space["4x"],
  [`@media ${i.tabletAndUp}`]: {
    "&--textStacked": { rowGap: e.semantic.space["12x"] }
  }
}, Ju = {
  height: "72px",
  width: "72px",
  "&--photoSplitShort,&--photoSplitLong": { height: "auto", width: "100%" },
  position: "relative",
  overflow: "hidden"
}, eg = {
  "svg,img": {
    width: "72px",
    height: "72px"
  }
}, He = {
  Wrapper: Vu,
  ImageContainer: Gu,
  ListContainer: ju,
  TitleWrapper: Xu,
  HeadingWrapper: Uu,
  SubTitleWrapper: Nu,
  VerticalDivider: Yu,
  MarketingListIconContainer: Zu,
  MarketingListItem: Ku,
  MarketingListGroupWrapper: Qu,
  MarketingListGroupSetWrapper: qu,
  MediaWrapper: Ju,
  GraphicWrapper: eg
}, tg = He, og = {
  position: "absolute",
  zIndex: s.mediaDisclosureButton,
  height: e.semantic.space["6x"],
  minWidth: e.semantic.space["6x"],
  margin: "2px",
  bottom: e.semantic.space["4x"],
  display: "flex",
  "&--bottom-right": {
    right: "26px"
  },
  "&--bottom-left": {
    left: "20px"
  }
}, ig = {
  boxSizing: "border-box",
  textAlign: "center",
  ...e.semantic.typography.body.semiBold.XS,
  fontStyle: "normal",
  overflow: "hidden",
  display: "flex",
  minWidth: e.semantic.space["6x"],
  height: e.semantic.space["6x"],
  padding: e.semantic.space["1x"],
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  isolation: "isolate",
  gap: "0px",
  flexShrink: " 0",
  border: "none",
  cursor: "pointer",
  background: "transparent",
  color: "var(--disclosure-text-color, var(--_disclosure-text-color))",
  "&--onColor": {
    "--_disclosure-text-color": e.semantic.color.text.default,
    "--_disclosure-bg-color": "rgba(255, 255, 255, 0.9)",
    "--_disclosure-bg-hover-color": e.semantic.color.action.hoverSubtle
  },
  "&--default": {
    "--_disclosure-text-color": e.semantic.color.text.onColor,
    "--_disclosure-bg-color": e.semantic.color.text.primaryStrong,
    "--_disclosure-bg-hover-color": e.semantic.color.text.primaryStrongest
  },
  "&:after": {
    content: '""',
    borderRadius: e.semantic.space["3x"],
    background: "var(--disclosure-bg-color, var(--_disclosure-bg-color))",
    height: "100%",
    width: "100%",
    position: "absolute",
    zIndex: -1
  },
  "&:hover:after": {
    background: "var(--disclosure-bg-hover-color, var(--_disclosure-bg-hover-color))"
  },
  "&:focus-visible": {
    borderRadius: e.semantic.radius["1x"],
    outlineOffset: "2px",
    outline: `2px solid ${e.semantic.color.stroke.focus}`
  }
}, Re = {
  DisclosureButtonsContainer: og,
  DisclosureButton: ig
}, rg = Re, ag = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["4x"],
  "&:focus-visible": {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    borderRadius: e.semantic.space["2x"],
    outlineOffset: e.semantic.space["1x"]
  },
  "&:hover": {
    cursor: "pointer"
  }
}, ng = {
  width: "100%",
  ...e.semantic.typography.body.medium.S
}, lg = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"]
}, sg = {
  display: "flex",
  alignItems: "flex-start",
  alignContent: "flex-start",
  gap: e.semantic.space["6x"],
  flexWrap: "wrap",
  [`@media ${i.wideScreenAndUp}`]: {
    gap: e.semantic.space["7x"]
  },
  [`@media ${i.laptopAndUp}`]: {
    gap: e.semantic.space["7x"]
  },
  [`@media ${i.desktopAndUp}`]: {
    gap: e.semantic.space["7x"]
  }
}, cg = {
  width: "118px",
  "&& img": {
    height: "100%"
  },
  [`@media ${i.tablet}`]: {
    width: "184px"
  },
  [`@media ${i.laptopAndUp}`]: {
    width: "136px"
  },
  [`@media ${i.desktopAndUp}`]: {
    width: "160px"
  },
  [`@media ${i.ultraWideScreenAndUp}`]: {
    width: "192px"
  }
}, dg = {
  width: "fit-content"
}, pg = {
  marginTop: e.semantic.space["2x"],
  display: "block",
  width: "100%"
}, ze = {
  Main: sg,
  Content: cg,
  TagContainer: dg,
  LinkContainer: pg,
  ImageContent: ag,
  Label: ng,
  Footer: lg
}, mg = ze, ug = {
  height: e.semantic.space["10x"],
  width: e.semantic.space["10x"],
  borderRadius: e.semantic.radius["2x"],
  ".Button__icon-wrapper > svg": {
    height: e.semantic.space["4x"],
    width: e.semantic.space["4x"]
  },
  "&:hover": {
    backgroundColor: e.semantic.color.fill.hover
  },
  backgroundColor: "transparent",
  color: e.semantic.color.icon.neutralStrong,
  "&--active": {
    backgroundColor: e.semantic.color.fill.hover
  },
  "&--disabled": {
    color: e.semantic.color.icon.disabled
  },
  borderColor: "transparent",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&:focus-visible": {
    outline: `${e.semantic.borderWidth["2x"]} solid
              ${e.semantic.color.stroke.primaryStrongest}`,
    borderRadius: e.semantic.radius["2x"],
    padding: "2px",
    outlineOffset: "2px"
  }
}, gg = {
  display: "inline-flex",
  justifyContent: "flex-end",
  position: "relative"
}, xg = {
  marginBottom: e.semantic.space["1x"],
  display: "flex",
  justifyContent: "flex-end"
}, hg = {
  display: {
    menuOpen: "block",
    default: "none"
  },
  position: "absolute",
  zIndex: s.dropdown,
  boxSizing: "border-box",
  minHeight: "176px",
  width: "270px",
  border: `${e.semantic.borderWidth["1x"]} solid
    ${e.semantic.color.stroke.default}`,
  borderRadius: e.semantic.radius["3x"],
  backgroundColor: e.semantic.color.fill.default,
  boxShadow: `0 ${e.semantic.borderWidth["4x"]} ${e.semantic.borderWidth["8x"]} 0 rgba(0, 0, 0, 0.06)`,
  top: "44px",
  right: {
    leftAligned: "-234px",
    default: "0"
  }
}, bg = {
  listStyle: "none",
  margin: e.semantic.space["2x"],
  padding: 0
}, fg = {
  borderRadius: e.semantic.radius["2x"],
  backgroundColor: e.semantic.color.fill.default,
  minHeight: "24px",
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["3x"]} ${e.semantic.space["2x"]} ${e.semantic.space["3x"]}`,
  hoverNotDisabled: {
    backgroundColor: e.semantic.color.fill.hover
  },
  focusVisibleNotDisabled: {
    outline: `${e.semantic.borderWidth["2x"]} solid
      ${e.primitive.color.grabber[1e3]}`,
    borderRadius: e.semantic.radius["2x"]
  }
}, vg = {
  all: "unset",
  width: "230px",
  display: "flex",
  wordWrap: "break-word",
  cursor: { disabled: "auto", default: "pointer" },
  justifyContent: "space-between",
  color: {
    disabled: e.semantic.color.text.placeholder,
    default: e.semantic.color.text.subtle
  },
  ...e.semantic.typography.body.regular.M,
  letterSpacing: "0"
}, yg = {
  display: "flex",
  alignItems: "center",
  marginRight: e.semantic.space["2x"],
  color: e.semantic.color.text.subtle,
  svg: {
    width: e.semantic.space["4x"],
    height: e.semantic.space["4x"]
  }
}, Cg = {
  display: "inline",
  float: "right",
  color: e.semantic.color.text.subtle,
  svg: {
    width: e.semantic.space["4x"],
    height: e.semantic.space["4x"]
  }
}, $g = {
  boxSizing: "border-box",
  height: "1px",
  width: "268px",
  border: `${e.semantic.borderWidth["1x"]} solid #D1D5DB`,
  // TODO - Update this color to a token value
  margin: `${e.semantic.space["2x"]} 0px ${e.semantic.space["2x"]} -48px`
}, wg = {
  height: "20px",
  width: "59px",
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.semiBold.XS,
  letterSpacing: "1px",
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["3x"]} ${e.semantic.space["2x"]} ${e.semantic.space["3x"]}`,
  marginLeft: "-40px"
}, Ae = {
  ellipses: {
    EllipsesContainer: ug
  },
  menu: {
    MainWrapper: gg,
    TriggerWrapper: xg,
    ContentWrapper: hg,
    ContentList: bg
  },
  menuItem: {
    ListWrapper: fg,
    ItemText: vg,
    LeadingIconWrapper: yg,
    TrailingIconWrapper: Cg
  },
  MenuDivider: $g,
  MenuGroupTitle: wg
}, kg = {
  height: t.semanticMode1.space["3xl"].value,
  width: t.semanticMode1.space["3xl"].value,
  borderRadius: t.semanticMode1.space.xs.value,
  ".Button__icon-wrapper > svg": {
    height: t.semanticMode1.space.lg.value,
    width: t.semanticMode1.space.lg.value,
    color: t.semanticMode1.color.text.onLight.moderateDefault.value
  },
  "&:hover": {
    backgroundColor: t.semanticMode1.color.fill.onLight.subtlest.value
  },
  backgroundColor: "transparent",
  "&--active": {
    backgroundColor: t.semanticMode1.color.fill.onLight.subtlest.value
  },
  "&--disabled": {
    color: t.semanticMode1.color.stroke.onLight.disabled.value
  },
  borderColor: "transparent",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&:focus-visible": {
    outline: `${t.primitive.border["2x"].value} solid
              ${t.primitive.color.neutral[1200].value}`,
    borderRadius: t.semanticMode1.radius.md.value,
    padding: "2px",
    outlineOffset: "2px"
  }
}, Sg = {
  ...Ae,
  ellipses: {
    EllipsesContainer: kg
  }
}, Bg = {
  maxWidth: "900px",
  minWidth: "100px",
  maxHeight: "none",
  "--modal-content-max-height": "90dvh",
  ".ModalWindow__content": {
    gap: 0,
    paddingTop: "5px"
  },
  ".ModalWindow__body": {
    maxHeight: "none"
  },
  [`@media ${i.mobile}`]: {
    background: "transparent",
    padding: 0,
    height: "100%",
    marginTop: "10px",
    minWidth: "100%",
    top: 0,
    ".ModalWindow__content": {
      padding: 0,
      height: "auto",
      marginTop: "26px"
    }
  }
}, Tg = {
  iframe: {
    borderRadius: e.semantic.radius["2x"]
  }
}, Wg = {
  padding: "10px 0",
  [`@media ${i.mobile}`]: {
    padding: 0,
    bottom: e.semantic.space["5x"],
    position: "absolute",
    right: e.semantic.space["5x"],
    rotate: "180deg",
    div: {
      top: "-82px",
      right: `-${e.semantic.space["4x"]}`
    },
    button: {
      color: e.semantic.color.text.onColor,
      "&:hover": {
        color: e.semantic.color.icon.onColor,
        backgroundColor: e.semantic.color.opacity.scrim.white[20]
      }
    }
  }
}, Lg = {
  height: "auto",
  [`@media ${i.mobile}`]: {
    rotate: "90deg",
    overflowY: "visible",
    width: "100%"
  }
}, Fe = {
  ModalWindow: Bg,
  Container: Tg,
  ModalHeader: Wg,
  ModalBody: Lg
}, _g = Fe, Ig = {
  width: "100%",
  height: "100%",
  position: "fixed",
  isolation: "isolate",
  top: "0",
  left: "0",
  display: "flex",
  justifyContent: "center",
  boxSizing: "border-box",
  alignItems: "center",
  [`@media ${i.mobile}`]: {
    padding: "0px"
  },
  "&:not(&--fullPage)": {
    [`@media ${i.tabletAndUp}`]: {
      padding: `50px ${t.primitive.space["5x"].value}`
    }
  }
}, Mg = {
  background: "#FFFFFF",
  color: t.primitive.color.twilight[1e3].value,
  boxShadow: "0 4px 12px 0px rgba(0, 0, 0, 0.12)",
  width: "100%",
  maxWidth: "100%",
  gap: t.primitive.space["6x"].value,
  boxSizing: "border-box",
  borderRadius: t.semanticMode1.radius.xl.value,
  overflow: "hidden",
  position: "relative",
  "--modal-content-max-height": "75dvh",
  "&--x-small": { maxWidth: "320px" },
  "&--small": { maxWidth: "480px" },
  "&--medium": { maxWidth: "640px" },
  "&--large": { maxWidth: "960px" },
  "&--x-large": { maxWidth: "1440px" },
  "&--fullPage": {
    "--modal-content-max-height": "100dvh",
    borderRadius: t.semanticMode1.space.none.value,
    height: "100dvh",
    overflow: "hidden",
    maxHeight: "none",
    maxWidth: "100%"
  }
}, Dg = {
  "--modal-content-padding": t.primitive.space["5x"].value,
  "--modal-content-gap": t.primitive.space["4x"].value,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: "var(--modal-content-gap)",
  maxHeight: "calc(var(--modal-content-max-height) - (var(--modal-content-padding) * 2))",
  overflowY: "auto",
  padding: "var(--modal-content-padding)",
  ".ModalWindow__disclosure": {
    // ensures no gap between the disclosure and the content
    marginTop: "calc(-1 *  var(--modal-content-gap) / 2)"
  },
  "&--fullPage": {
    ".ModalWindow__disclosure": {
      position: "absolute",
      bottom: "var(--modal-content-gap)"
    }
  }
}, Hg = {
  display: "flex",
  justifyContent: "space-between",
  position: "relative",
  alignItems: "start",
  flex: "0 0 auto",
  ...t.semanticMode1.title.medium.value,
  "&:empty": {
    display: "none"
  }
}, Rg = {
  font: "inherit",
  lineHeight: "inherit",
  margin: 0,
  paddingRight: t.primitive.space["4x"].value,
  wordBreak: "break-word",
  "&:empty": {
    display: "none"
  }
}, zg = {
  ...ie.CloseButton["&--xsmall"],
  marginLeft: "auto"
}, Ag = {
  height: "100%",
  fontSize: t.primitive.fontSize[2].value,
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontStyle: "normal",
  fontWeight: t.primitive.fontWeights.fordF11.value,
  lineHeight: t.primitive.lineHeights[11].value,
  paddingRight: t.primitive.space["3x"].value,
  boxSizing: "border-box",
  flex: "1 1 auto",
  overflowY: "auto",
  "&:empty": {
    display: "none"
  },
  // adding 4px padding and adding -4px margin to the body to ensure we allow space for the focus visible outline.
  // overflowClipMargin cannot be given here as it works only with overflow: clip and not with overflow: auto.
  padding: t.primitive.space["1x"].value,
  margin: `-${t.primitive.space["1x"].value}`
}, Fg = {
  display: "flex",
  justifyContent: "right",
  width: "100%",
  flexWrap: "wrap",
  flex: "0 0 auto",
  gap: t.primitive.space["4x"].value,
  "&:empty": {
    display: "none"
  }
}, Pg = {
  ModalContainerWrapper: Ig,
  ModalContainer: Mg,
  ModalContent: Dg,
  ModalHeader: Hg,
  ModalTitle: Rg,
  ModalCloseButton: zg,
  ModalBody: Ag,
  ModalFooterWrapper: Fg
}, Og = {
  width: "100%",
  height: "100%",
  position: "fixed",
  isolation: "isolate",
  top: "0",
  left: "0",
  display: "flex",
  justifyContent: "center",
  boxSizing: "border-box",
  paddingTop: e.semantic.space["14x"],
  alignItems: "center",
  "&--small, &--x-small": {
    alignItems: "center",
    padding: `50px ${e.semantic.space["5x"]}`
  },
  "&--medium, &--large, &--x-large": { alignItems: "flex-end" },
  "&--fullPage": { padding: e.semantic.space["0x"] },
  [`@media ${i.tabletAndUp}`]: {
    alignItems: "center",
    padding: `50px ${e.semantic.space["5x"]}}`,
    "&--fullPage": { padding: e.semantic.space["0x"] }
  }
}, Eg = {
  background: e.semantic.color.fill.default,
  color: e.semantic.color.text.default,
  boxShadow: `0 ${e.semantic.space["1x"]} ${e.semantic.space["3x"]} 0px rgba(0, 0, 0, 0.12)`,
  width: "100%",
  maxWidth: "100%",
  gap: e.semantic.space["6x"],
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  "--modal-content-max-height": "75dvh",
  "&--small, &--x-small": {
    borderRadius: e.semantic.radius["4x"]
  },
  "&--medium, &--large, &--x-large": {
    borderTopLeftRadius: e.semantic.radius["4x"],
    borderTopRightRadius: e.semantic.radius["4x"]
  },
  "&--fullPage": {
    "--modal-content-max-height": "100dvh",
    borderRadius: e.semantic.radius["0x"],
    height: "100dvh",
    overflow: "hidden",
    maxHeight: "none",
    maxWidth: "100%"
  },
  [`@media ${i.tabletAndUp}`]: {
    borderRadius: e.semantic.radius["4x"],
    "&--small, &--x-small": { maxWidth: "384px" },
    "&--medium": { maxWidth: "590px" },
    "&--large, &--x-large": { maxWidth: "794px" },
    "&--fullPage": { borderRadius: e.semantic.radius["0x"] }
  },
  [`@media ${i.laptopAndUp}`]: {
    "&--small, &--x-small": { maxWidth: "392px" },
    "&--medium": { maxWidth: "600px" },
    "&--large": { maxWidth: "1016px" },
    "&--x-large": { maxWidth: "1728px" }
  }
}, Vg = {
  "--modal-content-padding-block": e.semantic.space["8x"],
  "--modal-content-gap": e.semantic.space["6x"],
  padding: e.semantic.space["8x"],
  paddingTop: e.semantic.space["4x"],
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: "var(--modal-content-gap)",
  ".ModalWindow__disclosure": {
    // ensures no gap between the disclosure and the content
    marginTop: "calc(-1 *  var(--modal-content-gap) / 2)"
  },
  "&--fullPage": {
    "--modal-content-padding-block": "36px",
    padding: e.semantic.space["5x"],
    paddingTop: "36px",
    ".ModalWindow__disclosure": {
      position: "absolute",
      bottom: "var(--modal-content-gap)"
    }
  },
  [`@media ${i.tabletAndUp}`]: {
    "&--fullPage": {
      "--modal-content-padding-block": e.semantic.space["16x"],
      paddingTop: e.semantic.space["16x"],
      paddingInline: e.semantic.space["12x"],
      paddingBottom: e.semantic.space["8x"]
    }
  },
  [`@media ${i.laptopAndUp}`]: {
    "&--fullPage": {
      "--modal-content-padding-block": e.semantic.space["20x"],
      paddingTop: e.semantic.space["20x"],
      paddingInline: e.semantic.space["12x"],
      paddingBottom: e.semantic.space["8x"]
    }
  },
  maxHeight: "calc(var(--modal-content-max-height) - var(--modal-content-padding-block) * 2)"
}, Gg = {
  display: "flex",
  justifyContent: "space-between",
  position: "relative",
  alignItems: "start",
  gap: e.semantic.space["4x"],
  flex: "0 0 auto",
  ...e.semantic.typography.headline.XL,
  "&:empty": {
    display: "none"
  }
}, jg = {
  font: "inherit",
  lineHeight: "inherit",
  margin: 0,
  wordBreak: "break-word",
  "&:empty": {
    display: "none"
  }
}, Ug = {
  marginLeft: "auto"
}, Xg = {
  height: "100%",
  ...e.semantic.typography.body.regular.M,
  fontStyle: "normal",
  boxSizing: "border-box",
  flex: "1 1 auto",
  overflowY: "auto",
  "&:empty": {
    display: "none"
  },
  // adding 4px padding and adding -4px margin to the body to ensure we allow space for the focus visible outline.
  // overflowClipMargin cannot be given here as it works only with overflow: clip and not with overflow: auto.
  padding: e.semantic.space["1x"],
  margin: `-${e.semantic.space["1x"]}`
}, Ng = {
  display: "flex",
  justifyContent: "left",
  width: "100%",
  flexWrap: "wrap",
  flex: "0 0 auto",
  gap: e.semantic.space["2x"],
  "&:empty": {
    display: "none"
  }
}, Yg = {
  ModalContainerWrapper: Og,
  ModalContainer: Eg,
  ModalContent: Vg,
  ModalHeader: Gg,
  ModalTitle: jg,
  ModalCloseButton: Ug,
  ModalBody: Xg,
  ModalFooterWrapper: Ng
}, Zg = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["4x"]
}, Kg = {
  titleSize: {
    extraLarge: e.semantic.typography.headline.XL,
    large: e.semantic.typography.headline.L,
    medium: e.semantic.typography.headline.M
  },
  color: e.semantic.color.text.default
}, Qg = {
  display: "flex",
  flexDirection: "column",
  rowGap: e.semantic.space["4x"],
  justifyContent: "space-around",
  padding: e.semantic.space["6x"] + " 0px 0px 0px",
  background: {
    hide: "transparent",
    default: e.semantic.color.fill.default
  },
  laptopAndUp: {
    padding: `${e.semantic.space["6x"]} 0px 0px 0px`
  },
  desktopAndUp: {
    padding: `${e.semantic.space["6x"]} 0px 0px 0px`
  },
  wideScreenAndUp: {
    padding: `${e.semantic.space["6x"]} 0px 0px 0px`
  }
}, qg = {
  display: "flex",
  justifyContent: "space-between"
}, Jg = {
  display: "flex",
  gap: e.semantic.space["4x"],
  flexDirection: "column",
  button: {
    width: "100%"
  },
  tabletAndUp: {
    flexDirection: "row",
    gap: e.semantic.space["6x"]
  }
}, ex = {
  alignSelf: "stretch",
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.medium.L,
  fontStyle: "normal"
}, tx = {
  alignSelf: "stretch",
  color: e.semantic.color.text.subtlest,
  ...e.semantic.typography.body.regular.M,
  fontStyle: "normal"
}, ox = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["1x"]
}, Pe = {
  PageHeaderWrapper: Zg,
  TitleWrapper: Kg,
  PageHeaderContainer: Qg,
  TitleContainer: qg,
  ActionButtonWrapper: Jg,
  SubTitleWrapper: ex,
  DescriptionWrapper: tx,
  TitleSubTitleWrapper: ox
}, ix = Pe, rx = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  tabletAndUp: {
    display: "none"
  }
}, ax = {
  gap: e.semantic.space["4x"],
  mobile: {
    maxWidth: "560px"
  },
  button: {
    width: "50%",
    minWidth: "50%",
    minHeight: "40px",
    padding: `${e.semantic.space["1x"]} ${e.semantic.space["6x"]}`,
    ...e.semantic.typography.body.medium.M,
    gap: e.semantic.space["2x"],
    div: {
      margin: "unset"
    }
  }
}, nx = {
  gap: e.semantic.space["2x"]
}, lx = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  ...e.semantic.typography.body.medium.M,
  color: e.semantic.color.text.subtlest
}, sx = {
  display: "none",
  margin: "unset",
  padding: "unset",
  tabletAndUp: {
    display: "flex",
    alignItems: "center",
    listStyleType: "none",
    gap: e.semantic.space["2x"]
  }
}, cx = {
  height: e.semantic.space["10x"],
  width: e.semantic.space["10x"]
}, dx = {
  padding: e.semantic.space["3x"],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "unset",
  borderRadius: e.semantic.radius["2x"],
  cursor: "pointer",
  color: e.semantic.color.icon.primary,
  border: "unset",
  focusVisible: {
    outline: `${e.semantic.borderWidth["2x"]} solid
      ${e.semantic.color.stroke.focus}`
  },
  disabled: {
    cursor: "auto",
    color: e.semantic.color.text.disabled
  },
  hoverNotDisabled: {
    backgroundColor: e.semantic.color.action.hoverSubtle
  }
}, px = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["4x"]}`,
  cursor: "pointer",
  borderRadius: e.semantic.radius["2x"],
  color: e.semantic.color.text.primaryStrong,
  ...e.semantic.typography.body.medium.M,
  focusVisible: {
    active: {
      outline: `${e.semantic.borderWidth["2x"]} solid  ${e.semantic.color.stroke.focus}`,
      outlineOffset: "-2px"
    }
  },
  isActive: {
    backgroundColor: e.semantic.color.action.default,
    color: e.semantic.color.text.onColor
  },
  hover: {
    backgroundColor: {
      active: e.semantic.color.action.hoverSubtle
    }
  }
}, mx = {
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
  height: " 100%",
  width: "100%",
  borderRadius: e.semantic.radius["3x"],
  color: e.semantic.color.text.subtlest,
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["4x"]}`,
  boxSizing: "border-box",
  svg: {
    transform: "rotate(90deg)"
  }
}, ux = {
  MobileWrapper: rx,
  MobileWithButton: ax,
  MobileDefaultView: nx,
  TextWrapper: lx,
  ListWrapper: sx,
  ListItem: cx,
  NavButton: dx,
  PageLink: px,
  DotsContainer: mx
}, gx = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  tabletAndUp: {
    display: "none"
  }
}, xx = {
  gap: e.semantic.space["4x"],
  mobile: {
    maxWidth: "560px"
  },
  button: {
    width: "50%",
    minWidth: "50%",
    minHeight: "40px",
    padding: `${e.semantic.space["1x"]} ${e.semantic.space["6x"]}`,
    ...e.semantic.typography.body.medium.M,
    gap: e.semantic.space["2x"],
    div: {
      margin: "unset"
    }
  }
}, hx = {
  gap: e.semantic.space["2x"]
}, bx = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  ...e.semantic.typography.body.medium.M,
  color: e.semantic.color.text.subtlest
}, fx = {
  display: "none",
  margin: "unset",
  padding: "unset",
  tabletAndUp: {
    display: "flex",
    alignItems: "center",
    listStyleType: "none",
    gap: e.semantic.space["2x"]
  }
}, vx = {
  height: e.semantic.space["10x"],
  width: e.semantic.space["10x"]
}, yx = {
  padding: e.semantic.space["2x"],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "unset",
  borderRadius: e.semantic.radius["2x"],
  cursor: "pointer",
  color: e.semantic.color.icon.primary,
  border: "unset",
  focusVisible: {
    outline: `${e.semantic.borderWidth["2x"]} solid
      ${e.semantic.color.stroke.focus}`
  },
  disabled: {
    cursor: "auto",
    color: e.semantic.color.text.disabled
  },
  hoverNotDisabled: {
    backgroundColor: e.semantic.color.action.hoverSubtle
  }
}, Cx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["4x"]}`,
  cursor: "pointer",
  borderRadius: e.semantic.radius["2x"],
  color: e.semantic.color.text.primaryStrong,
  ...e.semantic.typography.body.medium.M,
  focusVisible: {
    active: {
      outline: `${e.semantic.borderWidth["2x"]} solid  ${e.semantic.color.stroke.focus}`,
      outlineOffset: "-2px"
    }
  },
  isActive: {
    backgroundColor: e.semantic.color.action.default,
    color: e.semantic.color.text.onColor
  },
  hover: {
    backgroundColor: {
      active: e.semantic.color.action.hoverSubtle
    }
  }
}, $x = {
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
  height: " 100%",
  width: "100%",
  borderRadius: e.semantic.radius["3x"],
  color: e.semantic.color.text.subtlest,
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["4x"]}`,
  boxSizing: "border-box",
  svg: {
    transform: "rotate(90deg)"
  }
}, wx = {
  MobileWrapper: gx,
  MobileWithButton: xx,
  MobileDefaultView: hx,
  TextWrapper: bx,
  ListWrapper: fx,
  ListItem: vx,
  NavButton: yx,
  PageLink: Cx,
  DotsContainer: $x
}, kx = {
  flexDirection: "column",
  gap: "4px",
  fontFamily: t.semanticMode1.fontFamilies.fordF1Regular.value,
  width: "100%",
  "&--medium, &--small, &--large": {
    "&, .react-tel-input": {
      ...t.semanticMode1.body1.regular.value
    },
    "& .react-tel-input": {
      height: "40px"
    },
    "&& .selected-flag .flag::before": {
      top: "42% !important"
    }
  },
  ".flag-dropdown": {
    width: "100%",
    borderRadius: `${t.semanticMode1.radius.md.value} !important`,
    backgroundColor: `${t.semanticMode1.color.fill.onLight.highContrastDefault.value} !important`,
    border: "unset !important",
    outline: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.moderateDefault.value}`,
    "&:hover": {
      outline: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactiveHover.value} !important`
    },
    "&:focus-within": {
      outline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactiveHover.value}`
    },
    "&.open": {
      borderColor: `${t.semanticMode1.color.stroke.onLight.interactiveHover.value} !important`,
      outline: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactiveHover.value} !important`
    },
    "&.open .selected-flag": {
      background: "none !important"
    }
  },
  ".country-list": {
    overflowX: "clip",
    backgroundColor: `${t.semanticMode1.color.fill.onLight.highContrastDefault.value} !important`,
    boxSizing: "border-box",
    border: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.moderateDefault.value} !important`,
    borderRadius: `${t.semanticMode1.radius.md.value} !important`,
    boxShadow: `0 ${t.primitive.space["2x"].value} ${t.primitive.space["4x"].value} 0 rgba(0, 20, 46, 0.1) !important`,
    padding: `${t.primitive.space["2x"].value} ${t.primitive.space["2x"].value} ${t.primitive.space["3x"].value} ${t.primitive.space["2x"].value} !important`,
    li: {
      fontFamily: t.semanticMode1.fontFamilies.fordF1Regular.value,
      cursor: "pointer",
      letterSpacing: 0,
      display: "block",
      height: "auto",
      padding: `${t.primitive.space["2x"].value} !important`,
      borderRadius: t.semanticMode1.radius.md.value,
      color: t.semanticMode1.color.text.onLight.moderateDefault.value,
      ".flag": {
        display: "none !important"
      },
      ".dial-code": {
        color: `${t.semanticMode1.color.text.onLight.moderateDefault.value} !important`
      },
      "&.country:hover": {
        backgroundColor: t.semanticMode1.color.text.onLight.interactiveHover.value
      },
      "&.country.highlight": {
        backgroundColor: t.semanticMode1.color.fill.onLight.interactiveHover.value
      },
      "&.divider": {
        padding: `0 ${t.primitive.space["2x"].value} ${t.primitive.space["5x"].value} ${t.primitive.space["2x"].value} !important`
      }
    }
  },
  "&&": {
    ".selected-flag": {
      width: "100%",
      background: "none !important",
      padding: "unset",
      "&:hover": {
        background: "none"
      },
      ".flag": {
        backgroundImage: "none",
        position: "static",
        width: "100%",
        ".arrow": {
          position: "absolute",
          left: "inherit",
          right: "20px",
          width: t.primitive.space["2x"].value,
          height: t.primitive.space["2x"].value,
          borderRight: "none",
          borderTop: "none",
          borderLeft: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.strong.value}`,
          borderBottom: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.strong.value}`,
          transform: "rotate(-45deg)",
          "&.up": {
            top: "63%",
            transform: "rotate(135deg)"
          }
        },
        "&::before": {
          position: "absolute",
          top: "40%",
          lineHeight: "100%",
          paddingLeft: t.primitive.space["3x"].value,
          color: t.semanticMode1.color.text.onLight.moderateDefault.value
        }
      }
    }
  },
  "&--show-country-flags .country-list li .flag": {
    display: "inline-block !important"
  },
  "&--disabled": {
    ".flag-dropdown": {
      backgroundColor: `${t.semanticMode1.color.fill.onLight.disabled.value} !important`,
      "&:hover, &:focus-within": {
        outline: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.moderateDefault.value} !important`
      }
    },
    "&& .selected-flag .flag::before": {
      color: t.semanticMode1.color.text.onLight.subtlestDisabled.value
    }
  }
}, Sx = {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  "&--row": {
    flexDirection: "row"
  },
  "&--column": {
    flexDirection: "column"
  },
  gap: t.primitive.space["5x"].value
}, Bx = {
  Wrapper: Sx,
  CountryCodeWrapper: kx
}, Tx = {
  flexDirection: "column",
  gap: "8px",
  fontFamily: e.primitive.typography.fontFamilies.inter,
  width: "100%",
  ".flag-dropdown": {
    width: "100%",
    borderRadius: `${e.semantic.space["2x"]} !important`,
    backgroundColor: `${e.semantic.color.fill.default} !important`,
    border: "unset !important",
    outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
    "&:hover": {
      outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus} !important`
    },
    "&:focus-within": {
      outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`
    },
    "&.open": {
      borderColor: `${e.semantic.color.stroke.focus} !important`,
      outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus} !important`
    },
    "&.open .selected-flag": {
      background: "none !important"
    }
  },
  ".country-list": {
    overflowX: "clip",
    backgroundColor: `${e.semantic.color.fill.default} !important`,
    boxSizing: "border-box",
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default} !important`,
    borderRadius: `${e.semantic.space["2x"]} !important`,
    boxShadow: `0 ${e.semantic.space["2x"]} ${e.semantic.space["4x"]} 0 rgba(0, 20, 46, 0.1) !important`,
    padding: `${e.semantic.space["2x"]} ${e.semantic.space["2x"]} ${e.semantic.space["3x"]} ${e.semantic.space["2x"]} !important`,
    li: {
      fontFamily: e.primitive.typography.fontFamilies.inter,
      cursor: "pointer",
      letterSpacing: 0,
      display: "block",
      height: "auto",
      padding: `${e.semantic.space["2x"]} !important`,
      borderRadius: e.semantic.radius["1x"],
      color: e.semantic.color.text.default,
      ".flag": {
        display: "none !important"
      },
      ".dial-code": {
        color: `${e.semantic.color.text.default} !important`
      },
      "&.country:hover": {
        backgroundColor: e.semantic.color.action.neutralHoverSubtle
      },
      "&.country.highlight": {
        backgroundColor: e.semantic.color.fill.hover
      },
      "&.divider": {
        padding: `0 ${e.semantic.space["2x"]} ${e.semantic.space["5x"]} ${e.semantic.space["2x"]} !important`
      }
    }
  },
  "&&": {
    ".selected-flag": {
      width: "100%",
      background: "none !important",
      padding: "unset",
      "&:hover": {
        background: "none"
      },
      ".flag": {
        backgroundImage: "none",
        position: "static",
        width: "100%",
        ".arrow": {
          position: "absolute",
          left: "inherit",
          right: "20px",
          width: e.semantic.space["2x"],
          height: e.semantic.space["2x"],
          borderRight: "none",
          borderTop: "none",
          borderLeft: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.neutralStrong}`,
          borderBottom: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.neutralStrong}`,
          transform: "rotate(-45deg)",
          "&.up": {
            top: "63%",
            transform: "rotate(135deg)"
          }
        },
        "&::before": {
          position: "absolute",
          paddingLeft: e.semantic.space["3x"],
          color: e.semantic.color.text.default
        }
      }
    }
  },
  "&--show-country-flags .country-list li .flag": {
    display: "inline-block !important"
  },
  "&--small": {
    "&, .react-tel-input": {
      ...e.semantic.typography.body.regular.S
    },
    "& .react-tel-input": {
      height: "32px"
    },
    "&& .selected-flag .flag::before": {
      top: "36%"
    }
  },
  "&--medium": {
    "&, .react-tel-input": {
      ...e.semantic.typography.body.regular.M
    },
    "& .react-tel-input": {
      height: "40px"
    },
    "&& .selected-flag .flag::before": {
      top: "34%"
    }
  },
  "&--large": {
    "&, .react-tel-input": {
      ...e.semantic.typography.body.regular.L
    },
    "& .react-tel-input": {
      height: "48px"
    },
    "&& .selected-flag .flag::before": {
      top: "33%"
    }
  },
  "&--disabled": {
    ".flag-dropdown": {
      backgroundColor: `${e.semantic.color.fill.disabled} !important`,
      "&:hover, &:focus-within": {
        outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default} !important`
      }
    },
    "&& .selected-flag .flag::before": {
      color: e.semantic.color.text.onDisabledStrong
    }
  }
}, Wx = {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  "&--row": {
    flexDirection: "row"
  },
  "&--column": {
    flexDirection: "column"
  },
  gap: e.semantic.space["6x"]
}, Lx = {
  Wrapper: Wx,
  CountryCodeWrapper: Tx
}, _x = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["6x"]
}, Ix = {
  width: "100%",
  height: "100%",
  cursor: "pointer",
  "&:focus-visible": {
    borderRadius: e.semantic.radius["2x"],
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: "2px"
  }
}, Oe = {
  PhotoGalleryWrapper: _x,
  PhotoGalleryThumbnailItemWrapper: Ix
}, Mx = Oe, Dx = {
  position: "relative",
  display: "flex",
  width: "100%",
  flexDirection: "column",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  alignSelf: "stretch",
  borderRadius: e.semantic.radius["4x"],
  background: e.semantic.color.fill.default,
  gap: e.semantic.radius["6x"]
}, Hx = {
  display: "flex",
  padding: `${e.semantic.space["4x"]} ${e.semantic.space["5x"]} 0px ${e.semantic.space["5x"]}`,
  justifyContent: "flex-end",
  alignItems: "flex-start",
  alignSelf: "stretch",
  background: "rgba(0, 20, 46, 0.3)",
  borderRadius: "unset",
  tabletAndUp: {
    padding: `${e.semantic.space["4x"]} ${e.semantic.space["8x"]} 0px ${e.semantic.space["8x"]}`,
    background: "#fff",
    borderRadius: `${e.semantic.radius["5x"]} ${e.semantic.radius["5x"]} 0px 0px`
  }
}, Rx = {
  position: "relative",
  width: "100%",
  background: "rgba(0, 20, 46, 0.3)",
  img: {
    position: "absolute",
    objectFit: "cover"
  }
}, zx = {
  display: "flex",
  padding: `0px ${e.semantic.space["5x"]} ${e.semantic.space["8x"]} ${e.semantic.space["5x"]}`,
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  gap: e.semantic.space["1x"],
  tabletAndUp: {
    padding: "unset"
  }
}, Ax = {
  color: e.semantic.color.text.default,
  ...e.semantic.typography.headline.XL,
  fontStyle: "normal"
}, Fx = {
  width: "100%",
  ...e.semantic.typography.body.medium.L,
  fontStyle: "normal",
  color: e.semantic.color.text.default,
  alignSelf: "stretch",
  overflow: "hidden",
  textOverflow: "ellipsis"
}, Px = {
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "5px"
}, Ox = {
  position: "absolute",
  zIndex: "1",
  top: "45%",
  flag: {
    left: "left: 3%;",
    default: "right: 3%;"
  },
  height: "48px",
  width: "48px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "none",
  borderRadius: e.semantic.space["2x"],
  cursor: "pointer",
  backgroundColor: e.semantic.color.action.default,
  color: e.semantic.color.text.onColor,
  focusVisible: {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: e.semantic.borderWidth["2x"]
  },
  disabled: {
    cursor: "auto",
    color: e.semantic.color.text.onDisabledStrong
  },
  hover: {
    backgroundColor: e.semantic.color.action.hover,
    color: e.semantic.color.text.onColor
  },
  mobile: {
    display: "none"
  }
}, Ex = {
  padding: "unset",
  boxShadow: "unset",
  borderRadius: e.semantic.radius["4x"],
  mobile: {
    borderRadius: `${e.semantic.radius["4x"]} ${e.semantic.radius["4x"]} 0 0`,
    minWidth: "100vw",
    gap: e.semantic.space["2x"]
  },
  tabletAndUp: {
    padding: `${e.semantic.space["4x"]} ${e.semantic.space["8x"]} ${e.semantic.space["8x"]} ${e.semantic.space["8x"]}`
  },
  modalWindowBody: {
    maxHeight: "none",
    padding: `0 ${e.semantic.radius["3x"]} 0 0`
  }
}, Vx = {
  ...e.semantic.typography.body.regular.XS,
  paddingTop: e.semantic.radius["5x"],
  color: e.semantic.color.text.subtlest
}, Gx = {
  mobile: {
    padding: `${e.semantic.space["2x"]} ${e.semantic.space["8x"]} ${e.semantic.space["0x"]} ${e.semantic.space["8x"]}`
  }
}, Ee = {
  MainWrapper: Dx,
  Header: Hx,
  ImgWrapper: Rx,
  ContaintWrapper: zx,
  TitleWrapper: Ax,
  DescriptionWrapper: Fx,
  ImageCount: Px,
  NavButton: Ox,
  PhotoLightboxModalWindow: Ex,
  Disclosures: Vx,
  StyledModalHeader: Gx
}, jx = Ee, Ux = {
  width: "100%",
  height: "auto",
  display: "flex",
  flexDirection: "row",
  gap: e.semantic.space["6x"],
  flexWrap: "wrap",
  tabletAndUp: {
    flexWrap: "nowrap"
  }
}, Xx = {
  display: "flex",
  flexDirection: "column",
  gap: "inherit",
  mobile: {
    flexDirection: "row"
  }
}, Nx = {
  borderRadius: e.semantic.radius["2x"],
  overflow: "hidden",
  gap: "inherit",
  height: "100%",
  img: {
    transition: "transform 0.3s ease",
    hover: {
      transform: "scale(1.1)"
    }
  }
}, Ve = {
  PhotoGalleryThumbnailContainer: Ux,
  PhotoGalleryThumbnailWrapper: Xx,
  PhotoGalleryThumbnailAspectRatio: Nx
}, Yx = Ve, Ge = 5, Zx = {
  position: "relative",
  display: "inline-flex",
  cursor: "pointer",
  [`@media ${i.mobile}`]: {
    display: "contents"
  },
  [`@container Hero ${i.mobile}`]: {
    display: "contents"
  }
}, Kx = {
  [`@media ${i.mobile}`]: {
    position: "fixed",
    isolation: "isolate",
    inset: 0,
    display: "grid",
    placeItems: "center",
    pointerEvents: "none"
  }
}, Qx = {
  "--border-color": t.primitive.color.fordBlue[1e3].value,
  "--border-size": t.primitive.border["1x"].value,
  "--background-color": "inherit",
  "--pointer-gap": `calc(${Ge}px + 1rem)`,
  zIndex: 1,
  transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
  border: `${t.primitive.border["1x"].value} solid var(--border-color)`,
  borderRadius: t.semanticMode1.radius.md.value,
  boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.06)",
  opacity: 0,
  display: "none",
  pointerEvents: "all",
  "&--open": {
    opacity: 1,
    display: "block"
  },
  [`@media ${i.tabletAndUp}`]: {
    position: "absolute",
    ["&--auto, &--top"]: {
      left: "50%",
      bottom: "calc(100% + var(--pointer-gap))",
      transform: "translate(-50%, -8px)",
      "&-open": {
        transform: "translate(-50%, 8px)"
      }
    },
    ["&--top-start"]: {
      right: "50%",
      bottom: "calc(100% + var(--pointer-gap))",
      transform: "translate(0, -8px)",
      "&-open": {
        transform: "translate(0, 8px)"
      }
    },
    ["&--top-end"]: {
      left: "50%",
      bottom: "calc(100% + var(--pointer-gap))",
      transform: "translate(0, -8px)",
      "&-open": {
        transform: "translate(0, 8px)"
      }
    },
    ["&--bottom"]: {
      left: "50%",
      top: "calc(100% + var(--pointer-gap))",
      transform: "translate(-50%, 8px)",
      "&-open": {
        transform: "translate(-50%, -8px)"
      }
    },
    ["&--bottom-start"]: {
      right: "50%",
      top: "calc(100% + var(--pointer-gap))",
      transform: "translate(0, 8px)",
      "&-open": {
        transform: "translate(0, -8px)"
      }
    },
    ["&--bottom-end"]: {
      left: "50%",
      top: "calc(100% + var(--pointer-gap))",
      transform: "translate(0, 8px)",
      "&-open": {
        transform: "translate(0, -8px)"
      }
    },
    ["&--left"]: {
      top: "50%",
      right: "calc(100% + var(--pointer-gap))",
      transform: "translate(-8px, -50%)",
      "&-open": {
        transform: "translate(8px,-50%)"
      }
    },
    ["&--left-start"]: {
      bottom: "50%",
      right: "calc(100% + var(--pointer-gap))",
      transform: "translate(-8px, 15%)",
      "&-open": {
        transform: "translate(8px, 15%)"
      }
    },
    ["&--left-end"]: {
      top: "50%",
      right: "calc(100% + var(--pointer-gap))",
      transform: "translate(-8px, -15%)",
      "&-open": {
        transform: "translate(8px, -15%)"
      }
    },
    ["&--right"]: {
      top: "50%",
      left: "calc(100% + var(--pointer-gap))",
      transform: "translate(8px, -50%)",
      "&-open": {
        transform: "translate(-8px, -50%)"
      }
    },
    ["&--right-start"]: {
      bottom: "50%",
      left: "calc(100% + var(--pointer-gap))",
      transform: "translate(8px, 15%)",
      "&-open": {
        transform: "translate(-8px, 15%)"
      }
    },
    ["&--right-end"]: {
      top: "50%",
      left: "calc(100% + var(--pointer-gap))",
      transform: "translate(8px, -15%)",
      "&-open": {
        transform: "translate(-8px, -15%)"
      }
    },
    "&--overflown": {
      position: "fixed",
      ["&-top-start"]: {
        transform: "translate(-100%, 8px)",
        "&-open": {
          transform: "translate(`100%, -8px)"
        }
      },
      ["&-bottom-start"]: {
        transform: "translate(-100%, -8px)",
        "&-open": {
          transform: "translate(`-100%, 8px)"
        }
      },
      ["&-left-start"]: {
        transform: "translate(8px, -84%)",
        "&-open": {
          transform: "translate(-8px, -84%)"
        }
      },
      ["&-right-start"]: {
        transform: "translate(-8px, -84%)",
        "&-open": {
          transform: "translate(8px, -84%)"
        }
      }
    }
  }
}, qx = {
  zIndex: 1,
  backgroundColor: t.primitive.color.twilight["000"].value,
  color: t.primitive.color.twilight[800].value,
  padding: t.semanticMode1.space.lg.value,
  borderRadius: t.semanticMode1.radius.md.value,
  position: "relative",
  transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
  width: "358px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  boxSizing: "border-box",
  letterSpacing: 0,
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: t.semanticMode1.radius.md.value,
  [`@media ${i.mobile}`]: {
    width: "100%"
  }
}, Jx = {
  display: "flex",
  gap: t.semanticMode1.space.lg.value,
  flexDirection: "row",
  justifyContent: "space-between",
  whiteSpace: "normal",
  wordWrap: "break-word",
  alignItems: "center",
  boxSizing: "border-box"
}, eh = {
  display: "flex",
  flexDirection: "column"
}, th = {
  ...t.semanticMode1.body1.bold.value,
  color: t.semanticMode1.color.text.onLight.moderateDefault.value,
  fontStyle: "normal",
  textAlign: "left",
  [`@media ${i.mobile}`]: t.semanticMode1.title.medium.value,
  "&:empty": {
    display: "none"
  }
}, oh = {
  display: "none"
}, ih = {
  ...t.semanticMode1.body1.regular.value,
  ...o({ textColor: t.semanticMode1.color.text.onLight.moderateDefault.value }),
  color: o("textColor"),
  fontStyle: "normal",
  maxHeight: "20dvh",
  wordBreak: "break-word",
  textAlign: "left",
  whiteSpace: "normal",
  scrollbarGutter: "stable",
  overflow: "auto",
  paddingInline: t.semanticMode1.space.lg.value,
  marginInline: `-${t.semanticMode1.space.lg.value}`,
  "&:first-child": {
    padding: t.semanticMode1.space.lg.value,
    margin: `-${t.semanticMode1.space.lg.value}`
  },
  "&--disable-scroll": {
    maxHeight: "none"
  },
  "&::-webkit-scrollbar": {
    width: t.primitive.space["2x"].value,
    height: t.primitive.space["1x"].value
  },
  "&::-webkit-scrollbar-corner": {
    background: "rgba(0, 0, 0, 0)"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: t.primitive.color.neutral[500].value,
    borderRadius: t.primitive.radius["2x"].value,
    transform: "translateX(calc(100% - 10px))"
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: t.primitive.color.neutral[300].value,
    borderRadius: t.primitive.radius["2x"].value
  },
  [`@media ${i.mobile}`]: {
    "&--disable-scroll": {
      maxHeight: "50dvh"
    }
  },
  "&:empty": {
    display: "none"
  }
}, rh = {
  display: "none"
}, ah = {
  zIndex: 0,
  position: "absolute",
  border: `${t.primitive.border["1x"].value} solid var(--border-color)`,
  display: "inline-block",
  width: `${Ge + 2}px`,
  aspectRatio: "1/1",
  translate: "-50% -50%",
  background: t.primitive.color.neutral["000"].value,
  rotate: "45deg",
  ["&--auto, &--top"]: {
    top: "100%"
  },
  ["&--bottom"]: {
    top: "0"
  },
  ["&--left"]: {
    left: "100%"
  },
  ["&--right"]: {
    left: "0"
  },
  ["&--top, &--bottom"]: {
    left: "50%",
    "&-start": {
      left: "85%"
    },
    "&-end": {
      left: "15%"
    }
  },
  ["&--left, &--right"]: {
    top: "50%",
    "&-start": {
      top: "85%"
    },
    "&-end": {
      top: "15%"
    }
  },
  [`@media ${i.mobile}`]: {
    display: "none"
  }
}, nh = {
  position: "relative",
  display: "inline-flex",
  padding: t.primitive.space["3x"].value
}, lh = {
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontSize: t.primitive.fontSize[1].value,
  color: t.primitive.color.grabber[1e3].value,
  textDecoration: "none",
  hover: {
    textDecoration: "underline"
  }
}, sh = {
  margin: "0 0.5rem",
  color: t.primitive.color.twilight[600].value
}, ch = {
  PopupTip: Zx,
  MobileFixedOverlay: Kx,
  ContentWrapper: Qx,
  Content: qx,
  Header: Jx,
  TitleWrapper: eh,
  Title: th,
  Subtitle: oh,
  Body: ih,
  Footer: rh,
  Pointer: ah,
  LinksWrapper: nh,
  Link: lh,
  DividerLink: sh
}, je = 5, dh = {
  position: "relative",
  display: "inline-flex",
  cursor: "pointer",
  [`@media ${i.mobile}`]: {
    display: "contents"
  },
  [`@container Hero ${i.mobile}`]: {
    display: "contents"
  }
}, ph = {
  [`@media ${i.mobile}`]: {
    position: "fixed",
    inset: 0,
    display: "grid",
    placeItems: "center",
    pointerEvents: "none"
  }
}, mh = {
  "--border-color": e.semantic.color.stroke.neutralStrong,
  "--border-size": e.semantic.borderWidth["1x"],
  "--background-color": "inherit",
  "--pointer-gap": `calc(${je}px + .7rem)`,
  zIndex: 1,
  transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
  border: `${e.semantic.borderWidth["1x"]} solid var(--border-color)`,
  borderRadius: e.semantic.radius["1x"],
  boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.08)",
  opacity: 0,
  display: "none",
  pointerEvents: "all",
  "&--open": {
    opacity: 1,
    display: "block"
  },
  [`@media ${i.tabletAndUp}`]: {
    position: "absolute",
    ["&--auto, &--top"]: {
      left: "50%",
      bottom: "calc(100% + var(--pointer-gap))",
      transform: "translate(-50%, -8px)",
      "&-open": {
        transform: "translate(-50%, 8px)"
      }
    },
    ["&--top-start"]: {
      right: "50%",
      bottom: "calc(100% + var(--pointer-gap))",
      transform: "translate(0, -8px)",
      "&-open": {
        transform: "translate(0, 8px)"
      }
    },
    ["&--top-end"]: {
      left: "50%",
      bottom: "calc(100% + var(--pointer-gap))",
      transform: "translate(0, -8px)",
      "&-open": {
        transform: "translate(0, 8px)"
      }
    },
    ["&--bottom"]: {
      left: "50%",
      top: "calc(100% + var(--pointer-gap))",
      transform: "translate(-50%, 8px)",
      "&-open": {
        transform: "translate(-50%, -8px)"
      }
    },
    ["&--bottom-start"]: {
      right: "50%",
      top: "calc(100% + var(--pointer-gap))",
      transform: "translate(0, 8px)",
      "&-open": {
        transform: "translate(0, -8px)"
      }
    },
    ["&--bottom-end"]: {
      left: "50%",
      top: "calc(100% + var(--pointer-gap))",
      transform: "translate(0, 8px)",
      "&-open": {
        transform: "translate(0, -8px)"
      }
    },
    ["&--left"]: {
      top: "50%",
      right: "calc(100% + var(--pointer-gap))",
      transform: "translate(-8px, -50%)",
      "&-open": {
        transform: "translate(8px,-50%)"
      }
    },
    ["&--left-start"]: {
      bottom: "50%",
      right: "calc(100% + var(--pointer-gap))",
      transform: "translate(-8px, 15%)",
      "&-open": {
        transform: "translate(8px, 15%)"
      }
    },
    ["&--left-end"]: {
      top: "50%",
      right: "calc(100% + var(--pointer-gap))",
      transform: "translate(-8px, -15%)",
      "&-open": {
        transform: "translate(8px, -15%)"
      }
    },
    ["&--right"]: {
      top: "50%",
      left: "calc(100% + var(--pointer-gap))",
      transform: "translate(8px, -50%)",
      "&-open": {
        transform: "translate(-8px, -50%)"
      }
    },
    ["&--right-start"]: {
      bottom: "50%",
      left: "calc(100% + var(--pointer-gap))",
      transform: "translate(8px, 15%)",
      "&-open": {
        transform: "translate(-8px, 15%)"
      }
    },
    ["&--right-end"]: {
      top: "50%",
      left: "calc(100% + var(--pointer-gap))",
      transform: "translate(8px, -15%)",
      "&-open": {
        transform: "translate(-8px, -15%)"
      }
    },
    "&--overflown": {
      position: "fixed",
      ["&-top-start"]: {
        transform: "translate(-100%, 8px)",
        "&-open": {
          transform: "translate(`100%, -8px)"
        }
      },
      ["&-bottom-start"]: {
        transform: "translate(-100%, -8px)",
        "&-open": {
          transform: "translate(`-100%, 8px)"
        }
      },
      ["&-left-start"]: {
        transform: "translate(8px, -84%)",
        "&-open": {
          transform: "translate(-8px, -84%)"
        }
      },
      ["&-right-start"]: {
        transform: "translate(-8px, -84%)",
        "&-open": {
          transform: "translate(8px, -84%)"
        }
      }
    }
  }
}, uh = {
  zIndex: 1,
  backgroundColor: e.semantic.color.fill.default,
  color: e.semantic.color.text.subtle,
  position: "relative",
  transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
  width: "240px",
  whiteSpace: "nowrap",
  borderRadius: e.semantic.radius["1x"],
  overflow: "hidden",
  textOverflow: "ellipsis",
  boxSizing: "border-box",
  letterSpacing: 0,
  textAlign: "center",
  ...e.semantic.typography.body.regular.S,
  [`@media ${i.mobile}`]: {
    width: "100%"
  }
}, gh = {
  display: "flex",
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["3x"]}`,
  gap: e.semantic.space["1x"],
  flexDirection: "row",
  justifyContent: "space-between",
  whiteSpace: "normal",
  wordWrap: "break-word",
  alignItems: "start",
  boxSizing: "border-box"
}, xh = {
  display: "flex",
  flexDirection: "column"
}, hh = {
  ...e.semantic.typography.body.medium.M,
  fontStyle: "normal",
  color: e.semantic.color.text.default,
  textAlign: "left",
  overflow: "hidden"
}, bh = {
  ...e.semantic.typography.body.medium.S,
  fontStyle: "normal",
  color: e.semantic.color.text.subtle,
  textAlign: "left",
  overflow: "hidden"
}, fh = {
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["3x"]}`,
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  maxHeight: "20vh",
  wordBreak: "break-word",
  textAlign: "left",
  whiteSpace: "normal",
  scrollbarGutter: "stable",
  color: e.semantic.color.text.subtle,
  overflow: "auto",
  "&::-webkit-scrollbar": {
    width: e.semantic.space["2x"],
    height: e.semantic.space["1x"]
  },
  "&::-webkit-scrollbar-corner": {
    background: "rgba(0, 0, 0, 0)"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: e.semantic.color.stroke.neutralSubtle,
    borderRadius: e.semantic.radius["2x"],
    transform: "translateX(calc(100% - 10px))"
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: e.semantic.color.fill.neutralSubtle,
    borderRadius: e.semantic.radius["2x"]
  }
}, vh = {
  padding: `${e.semantic.space["1x"]} ${e.semantic.space["3x"]} ${e.semantic.space["3x"]} ${e.semantic.space["3x"]}`,
  display: "flex",
  justifySelf: "center",
  alignItems: "center",
  width: "100%",
  boxSizing: "border-box"
}, yh = {
  zIndex: 0,
  position: "absolute",
  border: `${e.semantic.borderWidth["1x"]} solid var(--border-color)`,
  display: "inline-block",
  width: `${je + 3}px`,
  aspectRatio: "1/1",
  translate: "-50% -50%",
  background: e.semantic.color.fill.default,
  rotate: "45deg",
  ["&--auto, &--top"]: {
    top: "100%",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  ["&--bottom"]: {
    top: "0",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  ["&--left"]: {
    left: "100%",
    borderRadius: `0 ${e.semantic.borderWidth["2x"]}`
  },
  ["&--right"]: {
    left: "0",
    borderRadius: `0 ${e.semantic.borderWidth["2x"]}`
  },
  ["&--top, &--bottom"]: {
    left: "50%",
    "&-start": {
      left: "85%"
    },
    "&-end": {
      left: "15%"
    }
  },
  ["&--left, &--right"]: {
    top: "50%",
    "&-start": {
      top: "85%"
    },
    "&-end": {
      top: "15%"
    }
  },
  [`@media ${i.mobile}`]: {
    display: "none"
  }
}, Ch = {
  position: "relative",
  display: "inline-flex",
  padding: e.semantic.space["3x"]
}, $h = {
  fontFamily: e.primitive.typography.fontFamilies.inter,
  fontSize: e.primitive.typography.fontSize[350],
  //14px
  color: e.semantic.color.text.tertiaryStrong,
  textDecoration: "none",
  hover: {
    textDecoration: "underline"
  }
}, wh = {
  margin: "0 0.5rem",
  color: e.semantic.color.stroke.neutralModerate
}, kh = {
  PopupTip: dh,
  MobileFixedOverlay: ph,
  ContentWrapper: mh,
  Content: uh,
  Header: gh,
  TitleWrapper: xh,
  Title: hh,
  Subtitle: bh,
  Body: fh,
  Footer: vh,
  Pointer: yh,
  LinksWrapper: Ch,
  Link: $h,
  DividerLink: wh
}, Sh = {
  display: "flex",
  flexDirection: "column",
  ...t.semanticMode1.body2.regular.value,
  width: "100%",
  gap: t.semanticMode1.space.sm.value,
  //8px
  ".Label__trailing-text": {
    ...t.semanticMode1.body2.regular.value
  },
  ".Label__info-icon svg": {
    width: t.semanticMode1.space.lg.value,
    height: t.semanticMode1.space.lg.value
  }
}, Bh = {
  "&--success": {
    color: t.semanticMode1.color.stroke.onLight.success.value
  },
  "&--error": {
    color: t.semanticMode1.color.text.onLight.danger.value
  }
}, Th = {
  "--_progressbar-width": "100%",
  "--_progressbar-border-radius": "var(--progressbar-border-radius, 1rem)",
  "--_progressbar-color": t.semanticMode1.color.stroke.onLight.interactive.value,
  "--_progressbar-background": "#00142E1A",
  width: "var(--progressbar-width, var(--_progressbar-width))",
  height: "var(--progressbar-height, var(--_progressbar-height))",
  margin: 0,
  borderRadius: "var(--_progressbar-border-radius)",
  "&::-webkit-progress-bar": {
    backgroundColor: "var(--progressbar-background, var(--_progressbar-background))",
    borderRadius: "var(--_progressbar-border-radius)"
  },
  "&[value]::-webkit-progress-value": {
    backgroundColor: "var(--progressbar-color, var(--_progressbar-color))",
    borderRadius: "var(--_progressbar-border-radius)"
  },
  "&--success": {
    "--_progressbar-color": t.semanticMode1.color.stroke.onLight.success.value
  },
  "&--error": {
    "--_progressbar-color": t.semanticMode1.color.text.onLight.danger.value
  },
  "&--small": {
    "--_progressbar-height": t.semanticMode1.space.sm.value
    // 8px
  },
  "&--medium": {
    "--_progressbar-height": t.semanticMode1.space.lg.value
    // 16px
  },
  "&--large": {
    "--_progressbar-height": t.semanticMode1.space.xl.value
    // 24px
  }
}, Wh = {
  Container: Sh,
  LabelIcon: Bh,
  ProgressBar: Th
}, Lh = {
  display: "flex",
  flexDirection: "column",
  fontFamily: e.primitive.typography.fontFamilies.inter,
  width: "100%",
  gap: e.semantic.space["2x"]
}, _h = {
  "&--success": {
    color: e.semantic.color.fill.successStrong
  },
  "&--error": {
    color: e.semantic.color.fill.dangerStrong
  }
}, Ih = {
  "--_progressbar-width": "var(--progressbar-width, 100%)",
  "--_progressbar-height": `var(--progressbar-height, ${e.semantic.space["2x"]})`,
  // 8px
  "--_progressbar-border-radius": "var(--progressbar-border-radius, 1rem)",
  "--_progressbar-color": e.semantic.color.fill.primaryStrong,
  "--_progressbar-background": e.semantic.color.fill.neutralSubtle,
  width: "var(--_progressbar-width)",
  height: "var(--_progressbar-height)",
  margin: 0,
  borderRadius: "var(--_progressbar-border-radius)",
  "&::-webkit-progress-bar": {
    backgroundColor: "var(--progressbar-background, var(--_progressbar-background))",
    borderRadius: "var(--_progressbar-border-radius)"
  },
  "&[value]::-webkit-progress-value": {
    backgroundColor: "var(--progressbar-color, var(--_progressbar-color))",
    borderRadius: "var(--_progressbar-border-radius)"
  },
  "&--success": {
    "--_progressbar-color": e.semantic.color.fill.successStrong
  },
  "&--error": {
    "--_progressbar-color": e.semantic.color.fill.dangerStrong
  }
}, Mh = {
  Container: Lh,
  LabelIcon: _h,
  ProgressBar: Ih
}, x = "ProgressTracker", Dh = {
  ...o({ _trackerContainer: `${x} / inline-size` }),
  boxSizing: "border-box",
  width: "100%",
  container: o.fallback("_trackerContainer"),
  "&--horizontal": {
    overflow: "clip",
    overflowClipMargin: t.semanticMode1.space.xs.value
    // 4px
  },
  "&--animate&--vertical": {
    height: "100%",
    overflow: "hidden"
  },
  "&--disableContainerQuery": o({ _trackerContainer: `_${x} / inline-size` })
}, Hh = {
  listStyle: "none",
  display: "grid",
  alignItems: "flex-start",
  width: "100%",
  position: "relative",
  transition: "all 0.3s ease-in-out",
  boxSizing: "border-box",
  overflow: "hidden",
  margin: 0,
  padding: t.semanticMode1.space.xs.value,
  // 4px
  ...o({
    _trackerLineDefaultThickness: t.primitive.border["2x"].value,
    // 2px
    _trackerLineCompleteThickness: t.primitive.border["2x"].value,
    // 2px
    _trackerLineDefaultColor: t.semanticMode1.color.stroke.onLight.moderateDefault.value,
    // #808080
    _trackerLineCompleteColor: t.semanticMode1.color.stroke.onLight.interactive.value,
    // #0562d2
    _trackerStepDotSize: t.semanticMode1.space["2xl"].value,
    // 32px
    _trackerStepDotIconSize: t.primitive.lineHeights[12].value,
    // 20px
    _trackerStepMinWidth: "fit-content",
    _trackerStepDotAndLineGap: t.semanticMode1.space.xs.value,
    // 4px
    _trackerStepDotAndLabelGap: t.semanticMode1.space.lg.value,
    // 16px
    _trackerLineMinHeight: t.semanticMode1.space.xl.value,
    // 24px
    _trackerStepMinHeight: `calc(${o.fallback("_trackerStepDotSize")} + (${o.fallback(
      "_trackerStepDotAndLineGap"
    )} * 2) + ${o.fallback("_trackerLineMinHeight")})`,
    _trackerLineGapCalc: `calc(( ${o.fallback("_trackerStepDotSize")} / 2 ) + ${o.fallback("_trackerStepDotAndLineGap")})`
  }),
  ...p(i.tabletAndDown, x, {
    display: "flex",
    ...o({
      _trackerStepDotAndLabelGap: t.semanticMode1.space.sm.value,
      // 8px
      _trackerStepDotSize: t.semanticMode1.space.xl.value,
      // 24px
      _trackerStepDotIconSize: t.semanticMode1.space.lg.value
      // 16px
    })
  }),
  "&--horizontal": { gridTemplateColumns: `repeat(${o("_trackerStepCount")}, 1fr)` },
  "&--vertical": { flexDirection: "column" },
  "&--overflow": { overflow: "auto" },
  "&--animate": { overflow: "visible" }
}, Rh = {
  position: "relative",
  boxSizing: "border-box",
  width: "100%",
  flex: 1,
  minWidth: o.fallback("_trackerStepMinWidth"),
  "&--vertical": {
    display: "flex",
    flexDirection: "row",
    minHeight: o.fallback("_trackerStepMinHeight")
  },
  ...p(i.tabletAndDown, x, { "&--lastStep": { flexGrow: 0 } })
}, zh = {
  position: "relative",
  isolation: "isolate",
  textAlign: "center",
  "&:not(&--lastStep):after, &:not(&--lastStep):before": {
    content: "''",
    display: "inline-block",
    position: "absolute"
  },
  "&:after": {
    zIndex: -2,
    backgroundColor: o.fallback("_trackerLineDefaultColor")
  },
  "&:before": {
    zIndex: -1,
    borderRadius: "5px",
    transition: "width 0.3s ease-in-out",
    backgroundColor: o.fallback("_trackerLineCompleteColor")
  },
  "&--horizontal&": {
    "&:not(&--lastStep):after, &:not(&--lastStep):before": {
      left: `calc(50% + ${o("_trackerLineGapCalc")})`,
      height: o.fallback("_trackerLineDefaultThickness"),
      transition: "width 0.3s ease-in-out"
    },
    "&:after": {
      top: "50%",
      width: `calc(100% - (${o("_trackerLineGapCalc")} * 2))`
    },
    "&:before": {
      top: "50%",
      width: "0px"
    },
    "&--pastStep:before": {
      width: `calc(100% - (${o("_trackerLineGapCalc")} * 2))`
    }
  },
  "&--vertical&": {
    width: "auto",
    "&:not(&--lastStep):after, &:not(&--lastStep):before": {
      top: `calc(${o.fallback("_trackerStepDotSize")} + ${o.fallback("_trackerStepDotAndLineGap")})`,
      width: o.fallback("_trackerLineDefaultThickness"),
      transition: "height 0.3s ease-in-out"
    },
    "&::after": {
      left: "50%",
      height: `calc(100% - (${o("_trackerLineGapCalc")} * 2))`
    },
    "&:before": {
      left: "50%",
      height: "0px"
    },
    "&--pastStep:before": {
      height: `calc(100% - (${o("_trackerLineGapCalc")} * 2))`
    }
  },
  ...p(i.tabletAndDown, x, {
    textAlign: "left",
    "&--horizontal&": {
      "&:not(&--lastStep):after, &:not(&--lastStep):before": {
        left: `calc(${o.fallback("_trackerStepDotSize")} + ${o.fallback("_trackerStepDotAndLineGap")})`
      }
    }
  })
}, Ah = {
  borderWidth: "2px",
  ...o({
    btnSize: o.fallback("_trackerStepDotSize"),
    btnPadding: 0,
    btnBorderRadius: "50%",
    btnHoverTextColor: o("_btnTextColor")
  }),
  ...p(i.tabletAndDown, x, {
    ...t.semanticMode1.caption.regular.value,
    color: o.fallback("_btnTextColor")
  }),
  "&.Button--secondary": o({
    btnBgColor: t.semanticMode1.color.fill.onLight.highContrastDefault.value,
    // #ffffff
    btnHoverBgColor: t.semanticMode1.color.fill.onLight.highContrastDefault.value
    // #ffffff
  }),
  "&--idle:not(&--activeStep).Button--secondary": o({
    btnTextColor: t.semanticMode1.color.stroke.onLight.moderateDefault.value,
    // #808080
    btnHoverTextColor: t.semanticMode1.color.stroke.onLight.moderateDefault.value
    // #808080
  }),
  "&:not(&--clickable)": {
    cursor: "default",
    pointerEvents: "none"
  },
  svg: {
    height: o.fallback("_trackerStepDotIconSize"),
    width: o.fallback("_trackerStepDotIconSize")
  }
}, Fh = {
  display: "block",
  width: "100%",
  textAlign: "center",
  boxSizing: "border-box",
  padding: t.semanticMode1.space.sm.value,
  // 8px
  "&--pastStep": {
    ...t.semanticMode1.body1.medium.value,
    color: t.semanticMode1.color.text.onLight.moderateDefault.value
    // #333333
  },
  "&--activeStep": {
    ...t.semanticMode1.body1.bold.value,
    color: t.semanticMode1.color.text.onLight.moderateDefault.value
    // #333333
  },
  "&--futureStep": {
    ...t.semanticMode1.body1.medium.value,
    color: t.semanticMode1.color.text.onLight.subtle.value
    // #666666
  },
  ...p(i.tabletAndDown, x, {
    "&--horizontal": {
      display: "none"
    }
  }),
  "&--vertical": {
    textAlign: "left",
    padding: 0,
    margin: 0,
    marginTop: `calc((${o.fallback("_trackerStepDotSize")} / 2) - (1lh / 2))`
  }
}, Ph = {
  fontFamily: "inherit",
  color: "inherit",
  ".ProgressStep__content": {
    "&-label": {
      margin: 0,
      ...t.semanticMode1.body1.medium.value,
      color: t.semanticMode1.color.text.onLight.moderateDefault.value,
      // #333333
      display: "none"
    },
    "&-text": {
      ...t.semanticMode1.body2.regular.value,
      color: t.primitive.color.neutral[800].value,
      // #4d4d4d
      display: "none"
    }
  },
  ...p(i.tabletAndDown, x, {
    ".ProgressStep__content": {
      "&-label": { display: "block" },
      "&-text": { display: "block" }
    }
  })
}, Oh = {
  flex: 1,
  fontFamily: "inherit",
  color: "inherit",
  paddingLeft: o.fallback("_trackerStepDotAndLabelGap"),
  ".ProgressStep__content": {
    paddingBlock: t.semanticMode1.space["2xl"].value,
    // 32px
    paddingLeft: t.semanticMode1.lineHeights[6].value,
    // 48px
    ...p(i.mobile, x, {
      paddingBlock: t.semanticMode1.space.xl.value,
      // 24px
      paddingLeft: t.semanticMode1.space.lg.value
      // 16px
    }),
    "&--no-label": {
      paddingTop: 0,
      paddingLeft: 0
    }
  }
}, Eh = {
  ProgressTracker: Dh,
  Steps: Hh,
  ProgressStep: Rh,
  StepDotWrapper: zh,
  StepDot: Ah,
  StepLabel: Fh,
  HorizontalContent: Ph,
  VerticalContent: Oh
}, h = "ProgressTracker", Vh = {
  ...o({ _trackerContainer: `${h} / inline-size` }),
  boxSizing: "border-box",
  width: "100%",
  container: o.fallback("_trackerContainer"),
  "&--horizontal": {
    overflow: "clip",
    overflowClipMargin: e.semantic.space["1x"]
    // 4px
  },
  "&--animate&--vertical": {
    height: "100%",
    overflow: "hidden"
  },
  "&--disableContainerQuery": o({ _trackerContainer: `_${h} / inline-size` })
}, Gh = {
  listStyle: "none",
  display: "grid",
  alignItems: "flex-start",
  width: "100%",
  position: "relative",
  transition: "all 0.3s ease-in-out",
  boxSizing: "border-box",
  overflow: "hidden",
  margin: 0,
  padding: e.semantic.space["1x"],
  // 4px
  ...o({
    _trackerLineDefaultThickness: e.semantic.space[".5x"],
    // 2px
    _trackerLineCompleteThickness: e.semantic.space[".5x"],
    // 2px
    _trackerLineDefaultColor: e.semantic.color.stroke.neutralModerate,
    // #6b7786
    _trackerLineCompleteColor: e.semantic.color.stroke.primaryStrong,
    // #066fef
    _trackerStepDotSize: e.semantic.space["8x"],
    // 32px
    _trackerStepDotIconSize: e.semantic.space["5x"],
    // 20px
    _trackerStepMinWidth: "fit-content",
    _trackerStepDotAndLineGap: e.semantic.space["1x"],
    // 4px
    _trackerStepDotAndLabelGap: e.semantic.space["4x"],
    // 16px
    _trackerLineMinHeight: e.semantic.space["14x"],
    // 56px
    _trackerStepMinHeight: `calc(${o.fallback("_trackerStepDotSize")} + (${o.fallback(
      "_trackerStepDotAndLineGap"
    )} * 2) + ${o.fallback("_trackerLineMinHeight")})`,
    _trackerLineGapCalc: `calc(( ${o.fallback("_trackerStepDotSize")} / 2 ) + ${o.fallback("_trackerStepDotAndLineGap")})`
  }),
  ...p(i.tabletAndDown, h, {
    display: "flex",
    ...o({
      _trackerStepDotSize: e.semantic.space["6x"],
      // 24px
      _trackerStepDotIconSize: e.semantic.space["4x"],
      // 20px
      _trackerStepDotAndLabelGap: e.semantic.space["2x"],
      // 8px
      _trackerLineMinHeight: e.semantic.space["6x"]
      // 24px
    })
  }),
  "&--horizontal": { gridTemplateColumns: `repeat(${o("_trackerStepCount")}, 1fr)` },
  "&--vertical": { flexDirection: "column" },
  "&--overflow": { overflow: "auto" },
  "&--animate": { overflow: "visible" }
}, jh = {
  position: "relative",
  boxSizing: "border-box",
  width: "100%",
  flex: 1,
  minWidth: o.fallback("_trackerStepMinWidth"),
  "&--vertical": {
    display: "flex",
    flexDirection: "row",
    minHeight: o.fallback("_trackerStepMinHeight")
  },
  ...p(i.tabletAndDown, h, { "&--lastStep": { flexGrow: 0 } })
}, Uh = {
  position: "relative",
  isolation: "isolate",
  textAlign: "center",
  "&:not(&--lastStep):after, &:not(&--lastStep):before": {
    content: "''",
    display: "inline-block",
    position: "absolute"
  },
  "&:after": {
    zIndex: -2,
    backgroundColor: o.fallback("_trackerLineDefaultColor")
  },
  "&:before": {
    zIndex: -1,
    borderRadius: "5px",
    transition: "width 0.3s ease-in-out",
    backgroundColor: o.fallback("_trackerLineCompleteColor")
  },
  "&--horizontal&": {
    "&:not(&--lastStep):after, &:not(&--lastStep):before": {
      left: `calc(50% + ${o("_trackerLineGapCalc")})`,
      height: o.fallback("_trackerLineDefaultThickness"),
      transition: "width 0.3s ease-in-out"
    },
    "&:after": {
      top: "50%",
      width: `calc(100% - (${o("_trackerLineGapCalc")} * 2))`
    },
    "&:before": {
      top: "50%",
      width: "0px"
    },
    "&--pastStep:before": {
      width: `calc(100% - (${o("_trackerLineGapCalc")} * 2))`
    }
  },
  "&--vertical&": {
    width: "auto",
    "&:not(&--lastStep):after, &:not(&--lastStep):before": {
      top: `calc(${o.fallback("_trackerStepDotSize")} + ${o.fallback("_trackerStepDotAndLineGap")})`,
      width: o.fallback("_trackerLineDefaultThickness"),
      transition: "height 0.3s ease-in-out"
    },
    "&::after": {
      left: "50%",
      height: `calc(100% - (${o("_trackerLineGapCalc")} * 2))`
    },
    "&:before": {
      left: "50%",
      height: "0px"
    },
    "&--pastStep:before": {
      height: `calc(100% - (${o("_trackerLineGapCalc")} * 2))`
    }
  },
  ...p(i.tabletAndDown, h, {
    textAlign: "left",
    "&--horizontal&": {
      "&:not(&--lastStep):after, &:not(&--lastStep):before": {
        left: `calc(${o.fallback("_trackerStepDotSize")} + ${o.fallback("_trackerStepDotAndLineGap")})`
      }
    }
  })
}, Xh = {
  ...o({
    btnSize: o.fallback("_trackerStepDotSize"),
    btnPadding: 0,
    btnBorderRadius: "50%",
    btnHoverTextColor: o("_btnTextColor"),
    btnHoverBgColor: o("_btnBgColor")
  }),
  ...p(i.tabletAndDown, h, e.semantic.typography.body.medium.XS),
  "&.Button--secondary": o({
    btnBgColor: e.semantic.color.fill.default,
    btnHoverBgColor: e.semantic.color.fill.default
  }),
  "&.Button--secondary.Button--caution": o({
    btnTextColor: e.semantic.color.icon.caution,
    btnHoverTextColor: e.semantic.color.icon.caution
  }),
  "&.Button--primary.Button--caution": o({
    btnBgColor: e.semantic.color.icon.caution,
    btnHoverBgColor: e.semantic.color.icon.caution
  }),
  "&--idle:not(&--activeStep).Button--secondary": o({
    btnTextColor: e.semantic.color.stroke.neutralModerate,
    btnHoverTextColor: e.semantic.color.stroke.neutralModerate
  }),
  "&:not(&--clickable)": {
    cursor: "default",
    pointerEvents: "none"
  },
  svg: {
    height: o.fallback("_trackerStepDotIconSize"),
    width: o.fallback("_trackerStepDotIconSize")
  }
}, Nh = {
  display: "block",
  width: "100%",
  textAlign: "center",
  boxSizing: "border-box",
  padding: e.semantic.space["2x"],
  // 8px
  "&--pastStep, &--activeStep": {
    color: e.semantic.color.text.default
  },
  "&--futureStep": {
    color: e.semantic.color.text.subtlest
  },
  ...p(i.tabletAndDown, h, {
    "&--horizontal": {
      display: "none"
    }
  }),
  "&--vertical": {
    textAlign: "left",
    padding: 0,
    margin: 0,
    marginTop: `calc((${o.fallback("_trackerStepDotSize")} / 2) - (1lh / 2))`
  }
}, Yh = {
  fontFamily: "inherit",
  color: "inherit",
  ".ProgressStep__content": {
    "&-label": {
      margin: 0,
      ...e.semantic.typography.body.medium.M,
      color: e.semantic.color.text.default,
      display: "none"
    },
    "&-text": {
      ...e.semantic.typography.body.medium.S,
      color: e.semantic.color.text.subtlest,
      display: "none"
    }
  },
  ...p(i.tabletAndDown, h, {
    ".ProgressStep__content": {
      "&-label": { display: "block" },
      "&-text": { display: "block" }
    }
  })
}, Zh = {
  flex: 1,
  fontFamily: "inherit",
  color: "inherit",
  paddingLeft: o.fallback("_trackerStepDotAndLabelGap"),
  ".ProgressStep__content": {
    paddingBlock: "36px",
    paddingLeft: e.semantic.space["18x"],
    // 72px
    ...p(i.mobile, h, {
      paddingBlock: e.semantic.space["6x"],
      // 24px
      paddingLeft: e.semantic.space["4x"]
      // 16px
    }),
    "&--no-label": {
      paddingTop: 0,
      paddingLeft: 0
    }
  }
}, Kh = {
  ProgressTracker: Vh,
  Steps: Gh,
  ProgressStep: jh,
  StepDotWrapper: Uh,
  StepDot: Xh,
  StepLabel: Nh,
  HorizontalContent: Yh,
  VerticalContent: Zh
}, Qh = {
  ...e.semantic.typography.body.medium.M
}, qh = {
  ...e.semantic.typography.body.medium.XS
}, Jh = {
  display: "flex",
  flexDirection: "column",
  flexGrow: {
    visible: 0,
    default: 1
  },
  height: {
    visibleOrLastStep: "unset",
    default: "100%"
  }
}, eb = {
  display: "flex",
  gap: e.semantic.space["2x"],
  alignItems: "center",
  width: "max-content",
  tabletAndUp: {
    gap: e.semantic.space["4x"]
  }
}, tb = {
  width: "24px",
  height: "24px",
  borderRadius: e.semantic.radius["8x"],
  boxSizing: "border-box",
  border: {
    errorActive: `2px solid ${e.semantic.color.stroke.danger}`,
    editable: `2px solid ${e.semantic.color.stroke.focus}`,
    error: `2px solid ${e.semantic.color.stroke.danger}`,
    activeCompleted: `2px solid ${e.semantic.color.stroke.focus}`,
    default: `2px solid ${e.semantic.color.stroke.neutralModerate}`
  },
  backgroundColor: {
    errorActive: e.semantic.color.fill.dangerStrong,
    activeOrEditable: e.semantic.color.fill.primaryStrong,
    default: "unset"
  },
  color: {
    editable: e.semantic.color.text.onColor,
    errorNotActive: e.semantic.color.text.dangerStrong,
    active: e.semantic.color.text.onColor,
    completed: e.semantic.color.icon.primary,
    default: e.semantic.color.text.placeholder
  },
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  transition: "background-color, border-color",
  transitionDuration: "0.2s",
  cursor: {
    editable: "pointer",
    default: "default"
  },
  tabletAndUp: {
    height: "32px",
    width: "32px"
  }
}, ob = {
  position: "relative",
  left: "11px",
  width: "2px",
  borderRadius: e.semantic.radius["4x"],
  backgroundColor: {
    default: e.semantic.color.stroke.neutralModerate,
    active: e.semantic.color.fill.primaryStrong
  },
  margin: `${e.semantic.space["1x"]} 0`,
  transition: "background-color",
  transitionDuration: "0.2s",
  tabletAndUp: {
    left: "15px"
  }
}, ib = {
  display: "flex",
  height: "100%"
}, rb = {
  height: "100%",
  display: "flex",
  flexDirection: "column"
}, ab = {
  color: {
    editable: e.semantic.color.text.primaryStrong,
    completed: e.semantic.color.text.default,
    default: e.semantic.color.text.subtlest
  },
  cursor: {
    editable: "pointer",
    default: "default"
  }
}, nb = {
  display: {
    visible: "block",
    default: "none"
  },
  margin: "36px 0 36px 39px",
  width: "100%",
  tabletAndUp: {
    marginLeft: "104px"
  }
}, lb = {
  display: "flex",
  height: "100%",
  width: "100%",
  minHeight: { visible: "unset", default: "200px" }
}, sb = {
  ProgressWrapper: Jh,
  ProgressStepWrapper: eb,
  ProgressStepIndicator: tb,
  Connector: ob,
  ContentWrapper: ib,
  Wrapper: rb,
  LabelWrapper: ab,
  ChildrenWrapper: nb,
  ChildrenContainer: lb,
  commonTypoGraphy: Qh,
  mobileTypoGraphy: qh
}, cb = {
  ...e.semantic.typography.body.medium.M
}, db = {
  ...e.semantic.typography.body.medium.XS
}, pb = {
  display: "flex",
  flexDirection: "column",
  flexGrow: {
    visible: 0,
    default: 1
  },
  height: {
    visibleOrLastStep: "unset",
    default: "100%"
  }
}, mb = {
  display: "flex",
  gap: e.semantic.space["2x"],
  alignItems: "center",
  width: "max-content",
  tabletAndUp: {
    gap: e.semantic.space["4x"]
  }
}, ub = {
  width: "24px",
  height: "24px",
  borderRadius: e.semantic.radius["8x"],
  boxSizing: "border-box",
  border: {
    errorActive: `2px solid ${e.semantic.color.stroke.danger}`,
    editable: `2px solid ${e.semantic.color.stroke.focus}`,
    error: `2px solid ${e.semantic.color.stroke.danger}`,
    activeCompleted: `2px solid ${e.semantic.color.stroke.focus}`,
    default: `2px solid ${e.semantic.color.stroke.neutralModerate}`
  },
  backgroundColor: {
    errorActive: e.semantic.color.fill.dangerStrong,
    activeOrEditable: e.semantic.color.fill.primaryStrong,
    default: "unset"
  },
  color: {
    editable: e.semantic.color.text.onColor,
    errorNotActive: e.semantic.color.text.dangerStrong,
    active: e.semantic.color.text.onColor,
    completed: e.semantic.color.icon.primary,
    default: e.semantic.color.text.placeholder
  },
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  transition: "background-color, border-color",
  transitionDuration: "0.2s",
  cursor: {
    editable: "pointer",
    default: "default"
  },
  tabletAndUp: {
    height: "32px",
    width: "32px"
  }
}, gb = {
  position: "relative",
  left: "11px",
  width: "2px",
  borderRadius: e.semantic.radius["4x"],
  backgroundColor: {
    default: e.semantic.color.stroke.neutralModerate,
    active: e.semantic.color.fill.primaryStrong
  },
  margin: `${e.semantic.space["1x"]} 0`,
  transition: "background-color",
  transitionDuration: "0.2s",
  tabletAndUp: {
    left: "15px"
  }
}, xb = {
  display: "flex",
  height: "100%"
}, hb = {
  height: "100%",
  display: "flex",
  flexDirection: "column"
}, bb = {
  color: {
    editable: e.semantic.color.text.primaryStrong,
    completed: e.semantic.color.text.default,
    default: e.semantic.color.text.subtlest
  },
  cursor: {
    editable: "pointer",
    default: "default"
  }
}, fb = {
  display: {
    visible: "block",
    default: "none"
  },
  margin: "36px 0 36px 39px",
  width: "100%",
  tabletAndUp: {
    marginLeft: "104px"
  }
}, vb = {
  display: "flex",
  height: "100%",
  width: "100%",
  minHeight: { visible: "unset", default: "200px" }
}, yb = {
  ProgressWrapper: pb,
  ProgressStepWrapper: mb,
  ProgressStepIndicator: ub,
  Connector: gb,
  ContentWrapper: xb,
  Wrapper: hb,
  LabelWrapper: bb,
  ChildrenWrapper: fb,
  ChildrenContainer: vb,
  commonTypoGraphy: cb,
  mobileTypoGraphy: db
}, Cb = {
  display: "flex",
  alignItems: "flex-start",
  gap: t.primitive.space["2x"].value,
  "&:not(:disabled):focus-visible": {
    outline: "none",
    ".RadioButton": {
      outline: `2px solid ${t.primitive.color.neutral[1200].value}`
    }
  }
}, $b = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "12px"
}, wb = {
  margin: "unset",
  position: "relative",
  marginTop: "2px",
  appearance: "none",
  height: t.primitive.space["5x"].value,
  width: t.primitive.space["5x"].value,
  alignSelf: "unset",
  flexShrink: 0,
  transition: "border 120ms ease-in",
  borderRadius: t.primitive.radius["3x"].value,
  border: `1px solid ${t.primitive.color.neutral[600].value}`,
  "&:not(:disabled):hover": {
    cursor: "pointer",
    border: `2px solid ${t.componentMode1.radio.onLight.hover.value}`
  },
  "&:checked": {
    boxShadow: `inset 0px 0px 0px 2px ${t.primitive.color.twilight["000"].value}`,
    border: `1px solid ${t.primitive.color.skyView[900].value}`,
    backgroundColor: t.componentMode1.radio.onLight.default.value,
    "&:not(:disabled):hover": {
      border: `1px solid ${t.componentMode1.radio.onLight.hover.value}`,
      backgroundColor: t.componentMode1.radio.onLight.hover.value
    }
  },
  "&--error": {
    border: `1px solid ${t.primitive.color.red[1e3].value}`,
    "&:not(:disabled):hover": {
      border: `2px solid ${t.primitive.color.red[1200].value}`
    },
    "&:checked": {
      border: `1px solid ${t.primitive.color.red[1e3].value}`,
      backgroundColor: t.primitive.color.red[1e3].value,
      "&:not(:disabled):hover": {
        border: `1px solid ${t.primitive.color.red[1200].value}`,
        backgroundColor: t.primitive.color.red[1200].value
      }
    }
  },
  "&:disabled": {
    border: `1px solid ${t.primitive.color.neutral[600].value}`,
    backgroundColor: t.primitive.color.neutral[200].value,
    transition: "border 0.25s, backgroundColor 0.25s",
    transitionTimingFunction: "ease-in",
    "&:hover": {
      cursor: "default"
    },
    "&:checked": {
      border: `1px solid ${t.primitive.color.neutral[600].value}`,
      backgroundColor: t.primitive.color.neutral[600].value
    }
  }
}, kb = {
  color: t.primitive.color.neutral[900].value,
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontSize: t.primitive.fontSize[1].value,
  lineHeight: t.primitive.lineHeights[12].value,
  fontStyle: "normal",
  fontWeight: 400,
  cursor: "pointer",
  userSelect: "none",
  marginTop: t.primitive.space["1x"].value,
  "&--disabled": {
    color: t.primitive.color.neutral[600].value,
    cursor: "default"
  },
  "&--horizontal": {
    paddingRight: t.primitive.space["2x"].value
  },
  "&--hideRadio": {
    marginLeft: t.primitive.space["4x"].value,
    "&-media": {
      width: "224px !important"
    }
  },
  "&--media": {
    width: "196px"
  }
}, Sb = {
  display: "flex",
  flexDirection: "column",
  gap: t.primitive.space["3x"].value,
  margin: 0,
  padding: 0,
  border: 0,
  legend: { marginBottom: t.primitive.space["3x"].value },
  "& .RadioGroup__legend": {
    width: "100%"
  }
}, Bb = {
  flexDirection: "column",
  display: "flex",
  gap: t.primitive.space["4x"].value,
  "&--horizontal": {
    flexDirection: "row"
  }
}, Tb = {
  display: "block",
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontSize: t.primitive.fontSize[1].value,
  lineHeight: t.primitive.lineHeights[12].value,
  color: t.primitive.color.neutral[700].value,
  fontWeight: 500,
  fontStyle: "normal",
  letterSpacing: 0,
  margin: 0,
  "&--error": {
    color: t.primitive.color.red[1e3].value
  }
}, Wb = {
  display: "none"
}, Lb = {}, _b = {
  Label: Cb,
  LabelContent: $b,
  RadioButton: wb,
  Content: kb,
  RadioGroupFieldSet: Sb,
  RadioGroup: Bb,
  RadioGroupHelperText: Tb,
  Media: Wb,
  TileImage: Lb
}, Ib = {
  display: "flex",
  alignItems: "flex-start",
  gap: e.semantic.space["3x"],
  "&:focus-visible": {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    borderRadius: e.semantic.radius["2x"],
    outlineOffset: e.semantic.borderWidth["2x"],
    ".RadioButton": {
      outline: "none"
    }
  },
  "&--tile": {
    "--_radio-tile-padding-inline": `var(--radio-tile-padding-inline, ${e.semantic.space["4x"]} )`,
    "--_radio-tile-padding-block": `var(--radio-tile-padding-block, ${e.semantic.space["6x"]} )`,
    "--_radio-tile-width": "var(--radio-tile-width, 362px)",
    display: "flex",
    alignItems: "center",
    borderRadius: e.semantic.space["2x"],
    border: `${e.semantic.space[".25x"]} solid ${e.semantic.color.stroke.neutralSubtle}`,
    paddingInline: "var(--_radio-tile-padding-inline)",
    paddingBlock: "var(--_radio-tile-padding-block)",
    gap: "32px",
    width: `calc(
          var(--_radio-tile-width) - 
          calc(var(--_radio-tile-padding-inline) * 2)
           - ${e.semantic.space[".5x"]})`,
    justifyContent: "space-between",
    "&:has(.RadioButton:checked)": {
      border: `${e.semantic.space[".5x"]} solid ${e.semantic.color.stroke.focus}`,
      backgroundColor: e.semantic.color.fill.primarySubtlest,
      margin: "-1px"
    },
    "&:has(.RadioButton--error)": {
      border: `${e.semantic.space[".25x"]} solid ${e.semantic.color.stroke.danger}`,
      outline: "0px"
    },
    "&:has(.RadioButton:disabled)": {
      border: `${e.semantic.space[".25x"]} solid ${e.semantic.color.stroke.disabled}`,
      outline: "0px"
    },
    "&:has(.RadioButton:disabled):hover": {
      backgroundColor: "transparent"
    },
    "&:has(.RadioButton:focus-visible)": {
      outline: `${e.semantic.space[".5x"]} solid ${e.semantic.color.stroke.focus}`,
      outlineOffset: e.semantic.borderWidth["2x"]
    },
    "&:has(.RadioButton:checked.RadioButton--error)": {
      border: `${e.semantic.space[".5x"]} solid ${e.semantic.color.stroke.danger}`,
      backgroundColor: e.semantic.color.fill.dangerSubtlest
    },
    "&:hover": {
      backgroundColor: e.semantic.color.fill.hover
    },
    [`@media ${i.mobile}`]: {
      width: "100%"
    }
  },
  "&--tile&:not(&--disabled)": {
    cursor: "pointer"
  }
}, Mb = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: e.semantic.space["3x"]
}, Db = {
  margin: "unset",
  position: "relative",
  marginTop: "2px",
  appearance: "none",
  boxSizing: "border-box",
  alignSelf: "unset",
  borderRadius: "50%",
  flexShrink: 0,
  transition: "border 120ms ease-in",
  border: `1px solid ${e.semantic.color.stroke.neutralSubtle}`,
  backgroundColor: e.semantic.color.fill.default,
  "&:not(:disabled):hover": {
    cursor: "pointer",
    border: `2px solid ${e.semantic.color.stroke.focus}`,
    backgroundColor: e.semantic.color.fill.default
  },
  "&--small": {
    height: e.semantic.space["5x"],
    width: e.semantic.space["5x"],
    transition: "border 0.25s, backgroundColor 0.25s",
    transitionTimingFunction: "ease-in",
    "&:checked": {
      border: `7px solid ${e.semantic.color.stroke.focus}`,
      backgroundColor: e.semantic.color.fill.default,
      "&:not(:disabled):hover": {
        border: `7px solid ${e.semantic.color.stroke.primaryStrongest}`,
        backgroundColor: e.semantic.color.fill.default
      }
    }
  },
  "&--medium": {
    height: e.semantic.space["6x"],
    width: e.semantic.space["6x"],
    transition: "border 0.25s, backgroundColor 0.25s",
    transitionTimingFunction: "ease-in",
    "&:checked": {
      border: `${e.semantic.space["2x"]} solid ${e.semantic.color.stroke.focus}`,
      backgroundColor: e.semantic.color.fill.default,
      "&:not(:disabled):hover": {
        border: `${e.semantic.space["2x"]} solid ${e.semantic.color.stroke.primaryStrongest}`,
        backgroundColor: e.semantic.color.fill.default
      }
    }
  },
  "&--large": {
    height: e.semantic.space["8x"],
    width: e.semantic.space["8x"],
    transition: "border 0.25s, backgroundColor 0.25s",
    transitionTimingFunction: "ease-in",
    "&:checked": {
      border: `10px solid ${e.semantic.color.stroke.focus}`,
      backgroundColor: e.semantic.color.fill.default,
      "&:not(:disabled):hover": {
        border: `10px solid ${e.semantic.color.stroke.primaryStrongest}`,
        backgroundColor: e.semantic.color.fill.default
      }
    }
  },
  "&--error": {
    transition: "border 0.25s, backgroundColor 0.25s",
    transitionTimingFunction: "ease-in",
    borderColor: e.semantic.color.stroke.danger,
    "&:checked": {
      borderColor: e.semantic.color.stroke.danger,
      "&:not(:disabled):hover": {
        borderColor: e.semantic.color.action.dangerHover,
        backgroundColor: e.semantic.color.fill.default
      }
    },
    "&:not(:disabled):hover": {
      borderColor: e.semantic.color.action.dangerHover
    }
  },
  "&:disabled": {
    borderColor: e.semantic.color.stroke.disabled,
    backgroundColor: e.semantic.color.fill.disabled,
    transition: "border 0.25s, backgroundColor 0.25s",
    transitionTimingFunction: "ease-in",
    "&:hover": {
      cursor: "default"
    },
    "&:checked": {
      borderColor: e.semantic.color.stroke.disabled,
      "&:not(:disabled):hover": {
        borderColor: e.semantic.color.action.dangerHover,
        backgroundColor: e.semantic.color.fill.disabled
      }
    },
    "&:active": {
      "&:checked": {
        border: `${e.semantic.borderWidth["8x"]} solid rgba(214, 45, 10, 0.5)`
      }
    },
    "&:not(:disabled):hover": {
      borderColor: e.semantic.color.stroke.disabled
    }
  },
  "&--hideRadio": {
    opacity: 0,
    position: "absolute"
  }
}, Hb = {
  color: e.semantic.color.text.default,
  "&--small": {
    ...e.semantic.typography.body.regular.M
  },
  "&--medium": {
    ...e.semantic.typography.body.regular.M
  },
  "&--large": {
    ...e.semantic.typography.body.regular.L
  },
  fontStyle: "normal",
  cursor: "pointer",
  userSelect: "none",
  "&--disabled": {
    color: e.semantic.color.text.disabled,
    cursor: "default"
  },
  "&--horizontal": {
    paddingRight: e.semantic.space["4x"]
  },
  "&--tile&": {
    ".title": {
      ...e.semantic.typography.body.semiBold.M
    },
    ".HelperText": {
      color: e.semantic.color.text.subtle
    },
    "&--disabled": {
      ".HelperText": {
        color: e.semantic.color.text.disabled
      }
    }
  }
}, Rb = {
  display: "flex",
  width: e.semantic.space["18x"],
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  "&--disabled": {
    opacity: "0.7"
  }
}, zb = {
  height: e.semantic.space["12x"],
  width: e.semantic.space["12x"]
}, Ab = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["3x"],
  margin: 0,
  padding: 0,
  border: 0,
  "&--tile": {
    width: "fit-content",
    ".RadioGroup": {
      gap: ` ${e.semantic.space["6x"]}`,
      flexWrap: "wrap"
    }
  },
  ".RadioGroup__legend": {
    width: "100%",
    marginBottom: e.semantic.space["3x"]
  },
  [`@media ${i.mobile}`]: {
    width: "100%"
  }
}, Fb = {
  flexDirection: "column",
  display: "flex",
  "&--small": {
    gap: e.semantic.space["4x"]
  },
  "&--medium": {
    gap: e.semantic.space["5x"]
  },
  "&--large": {
    gap: e.semantic.space["6x"]
  },
  alignItems: "self-start",
  "&--horizontal": {
    flexDirection: "row",
    display: "flex",
    alignItems: "stretch"
  }
}, Pb = {
  display: "block",
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  color: e.semantic.color.text.default,
  letterSpacing: 0,
  margin: 0,
  "&--error": {
    color: e.semantic.color.text.dangerStrong
  }
}, Ob = {
  Label: Ib,
  LabelContent: Mb,
  RadioButton: Db,
  Content: Hb,
  RadioGroupFieldSet: Ab,
  RadioGroup: Fb,
  RadioGroupHelperText: Pb,
  TileImage: zb,
  Media: Rb
}, Eb = {
  display: "flex",
  flexDirection: "row",
  gap: `${e.semantic.space["6x"]}`,
  height: "max-content",
  width: "100%"
}, Vb = {
  borderRadius: `${e.semantic.radius["2x"]}`,
  boxShadow: `0 2px ${e.semantic.space["2x"]} 0 rgba(0, 0, 0, 0.1)`,
  width: "100%",
  boxSizing: "border-box",
  border: `1px solid ${e.semantic.color.stroke.default}`,
  backgroundColor: `${e.semantic.color.fill.default}`
}, Gb = {
  Wrapper: Eb,
  ChildWrapper: Vb
}, jb = {
  display: "flex",
  flexDirection: "row",
  gap: `${e.semantic.space["6x"]}`,
  height: "max-content",
  width: "100%"
}, Ub = {
  borderRadius: `${e.semantic.radius["2x"]}`,
  boxShadow: `0 2px ${e.semantic.space["2x"]} 0 rgba(0, 0, 0, 0.1)`,
  width: "100%",
  boxSizing: "border-box",
  border: `1px solid ${e.semantic.color.stroke.default}`,
  backgroundColor: `${e.semantic.color.fill.default}`
}, Xb = {
  Wrapper: jb,
  ChildWrapper: Ub
}, Nb = {
  "&--Expanded": { gap: e.semantic.space["10x"] },
  "&--SuperCondensed": { gap: e.semantic.space["6x"] },
  "&--Condensed": { gap: e.semantic.space["8x"] },
  display: "flex",
  flexDirection: "column",
  width: "100%"
}, Yb = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"]
}, Zb = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"],
  color: e.semantic.color.text.default,
  ...e.semantic.typography.headline.L
}, Kb = {
  display: "flex",
  color: e.semantic.color.text.subtlest,
  ...e.semantic.typography.body.semiBold.S
}, Qb = {
  display: "flex",
  color: e.semantic.color.text.subtlest,
  ...e.semantic.typography.body.medium.M
}, qb = {
  display: "flex",
  color: e.semantic.color.text.subtlest
}, Jb = {
  display: "flex",
  ...e.semantic.typography.body.medium.L,
  color: e.semantic.color.text.default
}, e0 = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"],
  svg: {
    color: e.semantic.color.icon.neutralStrong
  }
}, t0 = {
  color: e.semantic.color.text.subtlest,
  ...e.semantic.typography.body.medium.S
}, o0 = {
  display: "flex",
  alignItems: "center",
  gap: e.semantic.space["1x"]
}, i0 = {
  "&--Expanded": { rowGap: e.semantic.space["16x"] },
  "&--SuperCondensed": { rowGap: e.semantic.space["5x"] },
  "&--Condensed": { rowGap: e.semantic.space["10x"] }
}, Ue = {
  MainWrapper: Nb,
  GridContent: i0,
  HeaderSection: Yb,
  SectionTitle: Zb,
  Subtitle: Kb,
  Description: Qb,
  SecondaryLabel: qb,
  ContentWrapper: Jb,
  RowItemWrapper: e0,
  RowItemTitle: t0,
  RowTitleWrapper: o0
}, r0 = Ue, a0 = {
  height: "100%",
  width: "100%",
  minHeight: "350px",
  overflowX: "auto"
}, n0 = {
  Wrapper: a0
}, l0 = {
  width: "100%",
  "> div": {
    width: "100%"
  }
}, s0 = {
  display: "flex",
  alignItems: "center",
  svg: {
    color: e.semantic.color.icon.neutralStrong
  },
  padding: "unset",
  backgroundColor: "unset",
  border: "unset",
  "&.IconWrapper--CloseButtonWrapper": {
    padding: e.semantic.space["1x"],
    borderRadius: e.semantic.radius["2x"]
  },
  "&--disabled": {
    svg: {
      color: e.semantic.color.icon.disabled
    }
  }
}, c0 = {
  cursor: "pointer",
  height: e.semantic.space["4x"],
  width: e.semantic.space["4x"]
}, Xe = {
  InputAndSuggWrapper: l0,
  IconWrapper: s0,
  IconStyle: c0
}, d0 = Xe, p0 = {
  width: "100%",
  "> div": {
    width: "100%"
  }
}, m0 = {
  display: "flex",
  alignItems: "center",
  svg: {
    color: e.semantic.color.icon.neutralStrong
  },
  padding: "unset",
  backgroundColor: "unset",
  border: "unset",
  "&.IconWrapper--CloseButtonWrapper": {
    padding: e.semantic.space["1x"],
    borderRadius: e.semantic.radius["2x"]
  }
}, u0 = {
  cursor: "pointer",
  height: e.semantic.space["4x"],
  width: e.semantic.space["4x"]
}, Ne = {
  InputAndSuggestionWrapper: p0,
  IconWrapper: m0,
  IconStyle: u0
}, g0 = Ne, R = {
  width: "100%",
  backgroundColor: t.primitive.color.neutral[100].value,
  minWidth: "400px"
}, Ye = {
  "--_secondaryNav-container-padding-block": "var(--secondaryNav-container-padding-block, 16px)",
  "--_secondaryNav-container-padding-inline": "var(--secondaryNav-container-padding-inline, 56px)",
  "--_secondaryNav-container-max-width": `var(--secondaryNav-container-max-width, ${j.desktopMin}px)`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "row",
  backgroundColor: "inherit",
  paddingInline: "var(--_secondaryNav-container-padding-inline)",
  paddingBlock: "var(--_secondaryNav-container-padding-block)",
  maxWidth: "var(--_secondaryNav-container-max-width)",
  marginInline: "auto",
  gap: "16px",
  height: "72px",
  boxSizing: "border-box",
  flexShrink: 0,
  [`@media ${i.mobile}`]: {
    padding: "16px",
    flexWrap: "wrap",
    position: "relative"
  }
}, x0 = {
  display: "flex",
  flexGrow: 0,
  flexShrink: 0,
  whiteSpace: "nowrap",
  ...t.semanticMode1.body1.bold.value,
  "& .Button": {
    padding: 0,
    "&--tertiary": {
      ...t.semanticMode1.body1.bold.value
    }
  }
}, h0 = {
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  gap: "inherit",
  minWidth: 0,
  flexGrow: 1
}, b0 = {
  display: "inline-flex",
  alignItems: "center",
  flexGrow: 1,
  flexShrink: 0,
  gap: "24px",
  "& .Link": {
    padding: "8px 0px",
    color: t.semanticMode1.color.text.onLight.moderateDefault.value,
    "&--active:not(&--disabled)": {
      color: t.semanticMode1.color.text.onLight.interactive.value,
      borderBottom: "4px solid",
      borderBottomColor: t.semanticMode1.color.stroke.onLight.interactive.value,
      paddingBottom: "4px"
    },
    "&:hover:not(&--disabled)": {
      color: t.semanticMode1.color.text.onLight.interactiveHover.value,
      textDecoration: "none",
      borderBottomColor: t.semanticMode1.color.stroke.onLight.interactiveHover.value
    },
    "&--disabled": {
      color: t.semanticMode1.color.text.onLight.subtlestDisabled.value
    }
  },
  [`@media ${i.mobile}`]: {
    display: "none"
  }
}, f0 = {
  display: "flex",
  flexGrow: 0,
  flexShrink: 0,
  justifyContent: "flex-end",
  gap: "16px",
  "& .Button": {
    [`@media ${i.mobile}`]: {
      width: "unset"
    }
  }
}, v0 = {
  width: "1px",
  height: "24px",
  backgroundColor: t.primitive.color.neutral[600].value,
  flexShrink: 0,
  [`@media ${i.mobile}`]: {
    display: "none"
  }
}, y0 = {
  backgroundColor: R.backgroundColor,
  minWidth: `calc(${R.minWidth} - 32px)`,
  margin: 0,
  overflow: "hidden",
  height: 0,
  display: "flex",
  flexDirection: "column",
  padding: 0,
  "&--expanded": {
    height: "auto",
    maxHeight: "400px",
    padding: "16px",
    paddingTop: 0,
    overflow: "auto",
    position: "absolute",
    left: 0,
    right: 0,
    top: Ye.height,
    zIndex: 10001
  },
  [`@media ${i.tabletAndUp}`]: {
    display: "none"
  }
}, C0 = {
  borderBottom: "1px solid",
  borderColor: t.semanticMode1.color.stroke.onLight.subtleDividers.value,
  height: "48px",
  display: "flex",
  flexShrink: 0,
  flexGrow: 0,
  alignItems: "center",
  "&:link, &:visited": {
    textDecoration: "none",
    color: t.semanticMode1.color.text.onLight.moderateDefault.value,
    outlineOffset: "0px"
  },
  "&--active:not(:disabled)": {
    "&:visited": {
      color: t.semanticMode1.color.text.onLight.interactive.value
    },
    color: t.semanticMode1.color.text.onLight.interactive.value,
    borderColor: t.semanticMode1.color.text.onLight.interactive.value
  },
  "&:disabled": {
    borderColor: t.semanticMode1.color.stroke.onLight.disabled.value
  }
}, Ze = {
  Root: R,
  Container: Ye,
  Title: x0,
  OverflowContainer: h0,
  NavLinksContainer: b0,
  ButtonContainer: f0,
  Divider: v0,
  MobileNavLinksContainer: y0,
  MobileNavLink: C0
}, $0 = {
  height: t.primitive.lineHeights[7].value,
  width: "auto",
  overflowX: "visible",
  padding: 0,
  scrollBehavior: "smooth",
  isolation: "isolate",
  "&::-webkit-scrollbar": {
    display: "none"
  }
}, w0 = {
  position: "relative",
  isolation: "isolate",
  display: "flex",
  padding: t.primitive.space["1x"].value,
  alignItems: "center",
  gap: t.primitive.space["3x"].value,
  flexShrink: 0,
  boxShadow: `0px 0px 0px 1px inset ${t.primitive.color.neutral[600].value}`,
  boxSizing: "border-box",
  transition: "translate 0.5s ease",
  width: "fit-content",
  "&--small": {
    "--border-radius": t.primitive.space["5x"].value,
    gap: "8px"
  },
  "&--medium, &--large": {
    "--border-radius": t.primitive.space["5x"].value
  },
  borderRadius: "var(--border-radius)"
}, k0 = {
  position: "absolute",
  borderRadius: "var(--border-radius)",
  background: t.componentMode1.segmentedControl.onLight.default.value,
  zIndex: -1,
  left: 0,
  width: 0,
  height: 0,
  transition: "left 0.5s ease"
}, S0 = {
  whiteSpace: "nowrap",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: t.primitive.space["2x"].value,
  boxSizing: "border-box",
  borderRadius: "var(--border-radius)",
  color: t.primitive.color.neutral[900].value,
  border: 0,
  background: "transparent",
  height: t.primitive.space["7x"].value,
  padding: `${t.primitive.space["2x"].value} ${t.primitive.space["5x"].value}`,
  maxWidth: "var(--max-width)",
  width: "var(--max-width)",
  "&--auto-width": {
    width: "auto"
  },
  "&--small": {
    "--max-width": "128px"
  },
  "&--medium, &--large": {
    "--max-width": "200px"
  },
  "&--with-icon": {
    maxWidth: `calc(var(--max-width) + ${t.primitive.space["5x"].value})`,
    paddingInline: "10px"
  },
  "&--fixed": {
    flexBasis: "100%"
  },
  "&--active": {
    color: t.primitive.color.neutral["000"].value
  },
  "&:hover:not(&--disabled)": {
    background: t.componentMode1.segmentedControl.onLight.hover.value,
    color: t.primitive.color.neutral["000"].value,
    cursor: "pointer"
  },
  "&:hover:not(&--active)": {
    background: t.semanticMode1.color.fill.onLight.subtlest.value,
    color: t.primitive.color.neutral[900].value,
    cursor: "pointer"
  },
  "&--disabled": {
    color: t.primitive.color.neutral[600].value,
    background: t.primitive.color.neutral[200].value,
    zIndex: 2
  },
  "&:focus-visible": {
    outline: `2px solid ${t.primitive.color.skyView[1e3].value}`,
    outlineOffset: "2px"
  }
}, B0 = {
  position: "relative",
  zIndex: 1,
  overflow: "hidden",
  margin: 0,
  padding: 0,
  color: "inherit",
  textOverflow: "ellipsis",
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontSize: t.primitive.fontSize[2].value,
  lineHeight: t.primitive.lineHeights[11].value,
  fontWeight: 500,
  fontStyle: "normal",
  cursor: "inherit"
}, T0 = {
  position: "relative",
  zIndex: 1,
  flexShrink: 0,
  display: "flex",
  "svg, img": {
    width: t.primitive.space["5x"].value,
    height: t.primitive.space["5x"].value
  },
  "&--left": {
    marginRight: "var(--icon-margin)"
  },
  color: "inherit"
}, W0 = {
  SegmentControlWrapper: $0,
  SegmentControl: w0,
  SegmentControlItem: S0,
  SegmentIndicator: k0,
  SegmentControlLabel: B0,
  SegmentControlItemIcon: T0
}, L0 = {
  width: "100%",
  overflowX: "visible",
  padding: 0,
  scrollBehavior: "smooth",
  isolation: "isolate",
  "&::-webkit-scrollbar": {
    display: "none"
  }
}, _0 = {
  position: "relative",
  display: "inline-flex",
  padding: e.semantic.space["1x"],
  alignItems: "flex-start",
  gap: e.semantic.space["2x"],
  flexShrink: 0,
  borderRadius: e.semantic.radius["3x"],
  boxShadow: `0px 0px 0px 1px inset ${e.semantic.color.stroke.neutralSubtle}`,
  boxSizing: "border-box",
  transition: "translate 0.5s ease",
  height: e.semantic.space["10x"]
}, I0 = {
  position: "absolute",
  borderRadius: e.semantic.radius["2x"],
  background: e.semantic.color.action.default,
  zIndex: 1,
  left: 0,
  height: 0,
  width: 0,
  transition: "left 0.5s ease"
}, M0 = {
  whiteSpace: "nowrap",
  height: e.semantic.space["8x"],
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: e.semantic.space["2x"],
  boxSizing: "border-box",
  padding: `${e.semantic.space["1x"]} ${e.semantic.space["4x"]}`,
  borderRadius: e.semantic.radius["2x"],
  color: e.semantic.color.text.default,
  border: 0,
  background: "transparent",
  "&--small": {
    width: "128px"
  },
  "&--medium, &--large": {
    width: "200px"
  },
  "&--active": {
    color: e.semantic.color.text.onColor
  },
  "&--disabled": {
    color: e.semantic.color.text.onColor,
    background: e.semantic.color.action.disabled,
    cursor: "not-allowed",
    zIndex: 2
  },
  "&:not(&--disabled):hover": {
    background: e.semantic.color.fill.hover,
    cursor: "pointer"
  },
  "&:focus-visible": {
    outline: `2px solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: "2px"
  },
  "&--active:hover": {
    background: `${e.semantic.color.action.default}`,
    cursor: "pointer"
  }
}, D0 = {
  position: "relative",
  zIndex: 1,
  overflow: "hidden",
  margin: 0,
  padding: 0,
  color: "inherit",
  textOverflow: "ellipsis",
  ...e.semantic.typography.body.medium.S,
  fontStyle: "normal",
  cursor: "inherit"
}, H0 = {
  position: "relative",
  zIndex: 1,
  width: e.semantic.space["5x"],
  height: e.semantic.space["5x"],
  display: "flex",
  "svg, img": {
    width: e.semantic.space["5x"],
    height: e.semantic.space["5x"]
  },
  "&--left": {
    marginRight: "var(--icon-margin)"
  },
  color: "inherit"
}, R0 = {
  SegmentControlWrapper: L0,
  SegmentControl: _0,
  SegmentControlItem: M0,
  SegmentIndicator: I0,
  SegmentControlLabel: D0,
  SegmentControlItemIcon: H0
}, z0 = {
  display: "flex",
  flexDirection: "column",
  gap: t.semanticMode1.space.sm.value,
  //8px
  cursor: "pointer",
  ".TextInput__input-container": {
    border: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.moderateDefault.value}`,
    "&--caution:not(.TextInput__input-container--disabled)": {
      border: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.icon.onLight.caution.value}`
    },
    "&--caution:not(.TextInput__input-container--disabled):focus-within": {
      outline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.icon.onLight.caution.value}`
    }
  },
  input: {
    cursor: "pointer"
  },
  "&--cursor-text": {
    cursor: "text",
    input: {
      cursor: "text"
    }
  }
}, A0 = {
  cursor: "pointer",
  paddingTop: "5px"
}, F0 = {
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  "&:focus": {
    outline: "none",
    svg: {
      outline: `${t.primitive.border["2x"].value} solid
        ${t.primitive.color.skyView[900].value}`,
      outlineOffset: `${t.primitive.border["2x"].value}`,
      borderRadius: `${t.primitive.radius["1x"].value}`
    }
  }
}, P0 = {
  marginLeft: `-${t.semanticMode1.space.xl.value}`,
  //24px
  height: `${t.semanticMode1.space.lg.value} !important`,
  width: `${t.semanticMode1.space.lg.value} !important`,
  padding: `0 ${t.semanticMode1.space.xs.value}`,
  background: `${t.semanticMode1.color.fill.onLight.highContrastDefault.value}`,
  color: `${t.semanticMode1.color.fill.onDark.subtlest.value} !important`,
  boxSizing: "content-box"
}, O0 = {
  cursor: "pointer",
  display: "flex",
  color: t.semanticMode1.color.fill.onDark.subtlest.value
}, E0 = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"],
  div: {
    marginBottom: "unset !important"
  }
}, V0 = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: e.semantic.space["2x"],
  position: "relative",
  width: "auto",
  backgroundColor: e.semantic.color.fill.default,
  // minHeight: fpds.semantic.space['10x'],
  // boxShadow: `0px 0px 0px 1px ${fpds.semantic.color.stroke.default}`,
  cursor: "pointer",
  border: `1px solid ${e.semantic.color.stroke.default}`,
  "&--small": {
    minHeight: e.semantic.space["8x"]
  },
  "&--medium": {
    minHeight: e.semantic.space["10x"]
  },
  "&--large": {
    minHeight: e.semantic.space["12x"]
  },
  "&--disabled": {
    backgroundColor: e.semantic.color.fill.disabled,
    cursor: "default",
    borderColor: e.semantic.color.stroke.disabled
  },
  "&--error": {
    borderColor: `${e.semantic.color.stroke.danger} !important`,
    outlineColor: `${e.semantic.color.stroke.danger} !important`
  },
  "&--caution": {
    outlineColor: `${e.semantic.color.stroke.caution} !important`,
    borderColor: `${e.semantic.color.stroke.caution} !important`
  },
  "&--success": {
    outlineColor: `${e.semantic.color.stroke.success} !important`,
    borderColor: `${e.semantic.color.stroke.success} !important`
  },
  borderRadius: e.semantic.radius["2x"],
  padding: `${e.semantic.space["1x"]} ${e.semantic.space["3x"]}`,
  boxSizing: "border-box",
  "&--isOpen": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`
  },
  "&--isOpen&--error": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.danger}`
  },
  "&--caution&--isOpen": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.caution}`
  },
  "&--success&--isOpen": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.success}`
  },
  "&:not(&--isOpen):hover": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`
  },
  "&:focus-within": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`,
    outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus} `,
    outlineOffset: `-${e.semantic.borderWidth["2x"]}`
  }
}, G0 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flexWrap: "wrap",
  gap: e.semantic.space["3x"],
  div: {
    marginBottom: "0px"
  }
}, j0 = {
  ...e.semantic.typography.body.regular.M,
  "&--small": {
    ...e.semantic.typography.body.regular.S
  },
  "&--medium": {
    ...e.semantic.typography.body.regular.M
  },
  "&--large": {
    ...e.semantic.typography.body.regular.L
  },
  border: "none",
  backgroundColor: "transparent",
  color: e.semantic.color.text.default,
  "&:focus": {
    outline: "none"
  },
  "&--disabled": {
    color: e.semantic.color.text.onDisabledStrong,
    cursor: "default"
  },
  "&::placeholder": {
    color: e.semantic.color.text.placeholder
  },
  "&--small::placeholder": {
    ...e.semantic.typography.body.regular.S
  },
  "&--medium::placeholder": {
    ...e.semantic.typography.body.regular.M
  },
  "&--large::placeholder": {
    ...e.semantic.typography.body.regular.L
  },
  [`@media ${i.mobile}`]: {
    width: "100%"
  },
  cursor: "pointer",
  input: {
    cursor: "pointer"
  },
  "&--cursor-text": {
    cursor: "text",
    input: {
      cursor: "text"
    }
  }
}, U0 = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: e.semantic.space["6x"],
  width: e.semantic.space["6x"],
  color: e.semantic.color.icon.neutralStrong,
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer",
  padding: e.semantic.space["1x"],
  "&:disabled": {
    cursor: "auto"
  },
  "&:focus-visible": {
    borderRadius: e.semantic.radius["2x"],
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    "&--offset": {
      outlineOffset: "2px"
    }
  }
}, X0 = {
  pointerEvents: "none",
  "&--small": {
    height: e.semantic.space["5x"],
    width: e.semantic.space["5x"],
    svg: {
      height: e.semantic.space["5x"]
    }
  },
  "&--medium": {
    height: e.semantic.space["6x"],
    width: e.semantic.space["6x"],
    svg: {
      height: e.semantic.space["6x"]
    }
  },
  "&--large": {
    height: e.semantic.space["6x"],
    width: e.semantic.space["6x"],
    svg: {
      height: e.semantic.space["6x"]
    }
  },
  color: e.semantic.color.text.default,
  "&--disabled": {
    color: `${e.semantic.color.text.disabled} !important`
  },
  display: "flex",
  cursor: "pointer",
  backgroundColor: "transparent",
  border: "none",
  padding: "0px",
  justifyContent: "center",
  alignItems: "center",
  "&:disabled": {
    cursor: "auto"
  },
  "&:focus-visible": {
    border: "none",
    outline: "none"
  }
}, N0 = {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  rowGap: e.semantic.space["3x"],
  columnGap: e.semantic.space["2x"],
  alignItems: "center",
  cursor: "pointer",
  "&--disabled": {
    cursor: "auto"
  },
  "&::-webkit-scrollbar": {
    display: "none"
  },
  scrollbarWidth: "none"
}, Y0 = {
  closeButtonStyle: {
    width: e.semantic.space["4x"],
    height: e.semantic.space["4x"]
  }
}, Z0 = {
  display: "flex",
  gap: e.semantic.space["2x"],
  alignItems: "center"
}, K0 = {
  display: "flex",
  justifyContent: "space-between",
  flex: "1"
}, Q0 = {
  singleSelectInput: {
    Container: z0,
    EndAdornmentWrapper: A0,
    CloseIconWrapper: F0,
    CloseIcon: P0,
    LeadIconWrapper: O0
  },
  multiSelectInput: {
    Container: E0,
    MultiSelectContainer: V0,
    Selections: G0,
    Search: j0,
    ClearButton: U0,
    DropdownIcon: X0,
    SearchSectionContainer: N0,
    IconWrapper: Z0,
    InlineStyles: Y0,
    InputWrapper: K0
  }
}, q0 = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"],
  cursor: "pointer",
  input: {
    cursor: "pointer"
  },
  "&--cursor-text": {
    cursor: "text",
    input: {
      cursor: "text"
    }
  }
}, J0 = {
  cursor: "pointer"
}, ef = {
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  "&:focus": {
    outline: "none",
    svg: {
      outline: `${e.semantic.borderWidth["2x"]} solid
        ${e.semantic.color.stroke.focus}`,
      outlineOffset: `${e.semantic.borderWidth["2x"]}`,
      borderRadius: `${e.semantic.radius["1x"]}`
    }
  }
}, tf = {
  marginLeft: `-${e.semantic.space["6x"]}`,
  height: `${e.semantic.space["4x"]} !important`,
  width: `${e.semantic.space["4x"]} !important`,
  padding: `0 ${e.semantic.space["1x"]}`,
  background: `${e.semantic.color.fill.default}`,
  color: `${e.semantic.color.icon.neutralStrong} !important`,
  boxSizing: "content-box"
}, of = {
  cursor: "pointer",
  display: "flex",
  color: e.semantic.color.icon.neutralStrong
}, rf = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"],
  div: {
    marginBottom: "unset !important"
  }
}, af = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: e.semantic.space["2x"],
  position: "relative",
  width: "auto",
  backgroundColor: e.semantic.color.fill.default,
  // minHeight: fpds.semantic.space['10x'],
  // boxShadow: `0px 0px 0px 1px ${fpds.semantic.color.stroke.default}`,
  cursor: "pointer",
  border: `1px solid ${e.semantic.color.stroke.default}`,
  "&--small": {
    minHeight: e.semantic.space["8x"]
  },
  "&--medium": {
    minHeight: e.semantic.space["10x"]
  },
  "&--large": {
    minHeight: e.semantic.space["12x"]
  },
  "&--disabled": {
    backgroundColor: e.semantic.color.fill.disabled,
    cursor: "default",
    borderColor: e.semantic.color.stroke.disabled
  },
  "&--error": {
    borderColor: `${e.semantic.color.stroke.danger} !important`,
    outlineColor: `${e.semantic.color.stroke.danger} !important`
  },
  "&--caution": {
    outlineColor: `${e.semantic.color.stroke.caution} !important`,
    borderColor: `${e.semantic.color.stroke.caution} !important`
  },
  "&--success": {
    outlineColor: `${e.semantic.color.stroke.success} !important`,
    borderColor: `${e.semantic.color.stroke.success} !important`
  },
  borderRadius: e.semantic.radius["2x"],
  padding: `${e.semantic.space["1x"]} ${e.semantic.space["3x"]}`,
  boxSizing: "border-box",
  "&--isOpen": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`
  },
  "&--isOpen&--error": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.danger}`
  },
  "&--caution&--isOpen": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.caution}`
  },
  "&--success&--isOpen": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.success}`
  },
  "&:not(&--isOpen):hover": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`
  },
  "&:focus-within": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`,
    outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus} `,
    outlineOffset: `-${e.semantic.borderWidth["2x"]}`
  }
}, nf = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flexWrap: "wrap",
  gap: e.semantic.space["3x"],
  div: {
    marginBottom: "0px"
  }
}, lf = {
  ...e.semantic.typography.body.regular.M,
  "&--small": {
    ...e.semantic.typography.body.regular.S
  },
  "&--medium": {
    ...e.semantic.typography.body.regular.M
  },
  "&--large": {
    ...e.semantic.typography.body.regular.L
  },
  border: "none",
  backgroundColor: "transparent",
  color: e.semantic.color.text.default,
  "&:focus": {
    outline: "none"
  },
  "&--disabled": {
    color: e.semantic.color.text.onDisabledStrong,
    cursor: "default"
  },
  "&::placeholder": {
    color: e.semantic.color.text.placeholder
  },
  "&--small::placeholder": {
    ...e.semantic.typography.body.regular.S
  },
  "&--medium::placeholder": {
    ...e.semantic.typography.body.regular.M
  },
  "&--large::placeholder": {
    ...e.semantic.typography.body.regular.L
  },
  [`@media ${i.mobile}`]: {
    width: "100%"
  },
  cursor: "pointer",
  input: {
    cursor: "pointer"
  },
  "&--cursor-text": {
    cursor: "text",
    input: {
      cursor: "text"
    }
  }
}, sf = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: e.semantic.space["6x"],
  width: e.semantic.space["6x"],
  color: e.semantic.color.icon.neutralStrong,
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer",
  padding: e.semantic.space["1x"],
  "&:disabled": {
    cursor: "auto"
  },
  "&:focus-visible": {
    borderRadius: e.semantic.radius["2x"],
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    "&--offset": {
      outlineOffset: "2px"
    }
  }
}, cf = {
  pointerEvents: "none",
  "&--small": {
    height: e.semantic.space["5x"],
    width: e.semantic.space["5x"],
    svg: {
      height: e.semantic.space["5x"]
    }
  },
  "&--medium": {
    height: e.semantic.space["6x"],
    width: e.semantic.space["6x"],
    svg: {
      height: e.semantic.space["6x"]
    }
  },
  "&--large": {
    height: e.semantic.space["6x"],
    width: e.semantic.space["6x"],
    svg: {
      height: e.semantic.space["6x"]
    }
  },
  color: e.semantic.color.text.default,
  "&--disabled": {
    color: `${e.semantic.color.text.disabled} !important`
  },
  display: "flex",
  cursor: "pointer",
  backgroundColor: "transparent",
  border: "none",
  padding: "0px",
  justifyContent: "center",
  alignItems: "center",
  "&:disabled": {
    cursor: "auto"
  },
  "&:focus-visible": {
    border: "none",
    outline: "none"
  }
}, df = {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  rowGap: e.semantic.space["3x"],
  columnGap: e.semantic.space["2x"],
  alignItems: "center",
  cursor: "pointer",
  "&--disabled": {
    cursor: "auto"
  },
  "&::-webkit-scrollbar": {
    display: "none"
  },
  scrollbarWidth: "none"
}, pf = {
  closeButtonStyle: {
    width: e.semantic.space["4x"],
    height: e.semantic.space["4x"]
  }
}, mf = {
  display: "flex",
  gap: e.semantic.space["2x"],
  alignItems: "center"
}, uf = {
  display: "flex",
  justifyContent: "space-between",
  flex: "1"
}, gf = {
  singleSelectInput: {
    Container: q0,
    EndAdornmentWrapper: J0,
    CloseIconWrapper: ef,
    CloseIcon: tf,
    LeadIconWrapper: of
  },
  multiSelectInput: {
    Container: rf,
    MultiSelectContainer: af,
    Selections: nf,
    Search: lf,
    ClearButton: sf,
    DropdownIcon: cf,
    SearchSectionContainer: df,
    IconWrapper: mf,
    InlineStyles: pf,
    InputWrapper: uf
  }
}, xf = "392px", hf = "280px", bf = {
  width: "fit-content",
  border: `${t.primitive.border["1x"].value} solid ${t.semanticMode1.color.stroke.onLight.subtleDividers.value}`,
  borderRadius: t.primitive.border["5x"].value,
  // 8px
  background: t.primitive.color.twilight["000"].value,
  "&--selected": {
    backgroundColor: t.primitive.color.twilight["000"].value,
    outline: `${t.primitive.border["2x"].value} solid ${t.primitive.color.skyView[1e3].value}`
  },
  "&--invalid": {},
  "&:not(&--disabled):hover": {
    cursor: "pointer",
    backgroundColor: t.semanticMode1.color.fill.onLight.subtlest.value
  },
  "&:not(&--disabled):focus-visible": {
    outline: `${t.primitive.border["2x"].value} solid ${t.primitive.color.skyView[1e3].value}`,
    outlineOffset: `${t.primitive.border["2x"].value}`
    //2px
  }
}, ff = {
  width: xf,
  minWidth: "320px",
  borderRadius: t.primitive.border["5x"].value,
  // 8px
  boxShadow: "0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A",
  boxSizing: "border-box",
  position: "relative",
  padding: t.primitive.space["5x"].value,
  //24px
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: "100%",
  "&--imageContainer": {
    gap: t.semanticMode1.space.md.value
    //12px
  },
  "&--centerAligned": {
    alignItems: "center"
  },
  "&--leftAligned": {
    alignItems: "flex-start"
  },
  gap: t.semanticMode1.space.md.value,
  //12px
  "&--disabled": {
    cursor: "not-allowed",
    backgroundColor: t.semanticMode1.color.fill.onLight.disabled.value,
    "&& > *": {
      "&::after": {
        borderRadius: t.primitive.space["2x"].value,
        //8px
        content: '""',
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.5)"
      }
    }
  },
  [`@media ${i.mobile}`]: {
    width: "100%",
    minWidth: hf
  }
}, vf = {
  margin: 0,
  ...t.semanticMode1.headline4.semibold.large.value,
  "&--xlarge": {
    ...t.semanticMode1.headline3.semibold.large.value
  }
}, yf = {
  margin: "unset !important",
  ...t.semanticMode1.body2.regular.value,
  color: t.primitive.color.twilight[800].value,
  "& p": {
    marginBlock: 0
  }
}, Cf = {
  position: "relative",
  width: "100%",
  "&--with-radius": {
    borderRadius: `${t.primitive.space["1x"].value} ${t.primitive.space["1x"].value} 0 0`
  },
  "&--fixed-container": {
    height: "72px",
    width: "72px"
  },
  overflow: "hidden"
}, $f = {
  width: "100%",
  boxSizing: "border-box",
  gap: t.primitive.space["3x"].value,
  //12px
  display: "flex",
  flexDirection: "column",
  "&--centerAligned": {
    alignItems: "center",
    "h1,h2,h3,h4,h5,h6,p": {
      textAlign: "center"
    }
  },
  "&--leftAligned": {
    alignItems: "left",
    "h1,h2,h3,h4,h5,h6,p": {
      textAlign: "start"
    }
  }
}, wf = {
  "&--xxLarge": {
    svg: {
      height: "72px ",
      width: "72px"
    }
  }
}, kf = {
  width: "100%"
}, Sf = {
  SelectionsBase: bf,
  SelectionCard: ff,
  Title: vf,
  Description: yf,
  Media: Cf,
  Body: $f,
  IconContainer: wf,
  TrailingElementWrapper: kf
}, Bf = "392px", Tf = {
  width: "fit-content",
  border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  borderRadius: e.semantic.radius["2x"],
  background: e.semantic.color.fill.default,
  "&--selected": {
    backgroundColor: e.semantic.color.fill.primarySubtlest,
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`,
    outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`
  },
  "&--invalid": {
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.danger}`
  },
  "&:not(&--disabled):hover": {
    cursor: "pointer",
    backgroundColor: e.semantic.color.action.neutralHoverSubtle
  },
  "&:not(&--disabled):focus-visible": {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: `${e.semantic.borderWidth["2x"]}`
  }
}, Wf = {
  width: Bf,
  position: "relative",
  borderRadius: e.semantic.radius["2x"],
  boxShadow: "0px 2px 8px 0px #0000001a",
  boxSizing: "border-box",
  padding: e.semantic.space["6x"],
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: "100%",
  "&--imageContainer": {
    gap: e.semantic.space["3x"]
  },
  "&--centerAligned": {
    alignItems: "center"
  },
  "&--leftAligned": {
    alignItems: "flex-start"
  },
  gap: e.semantic.space["6x"],
  "&--disabled": {
    cursor: "not-allowed",
    "&& > *": {
      color: `${e.semantic.color.text.disabled} !important`,
      "&::after": {
        borderRadius: e.semantic.radius["2x"],
        content: '""',
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.5)"
      }
    }
  }
}, Lf = {
  margin: 0,
  ...e.semantic.typography.headline.L,
  color: e.semantic.color.text.default,
  "&--xlarge": {
    ...e.semantic.typography.headline.XL
  }
}, _f = {
  margin: "unset !important",
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.S,
  "& p": {
    marginBlock: 0
  }
}, If = {
  position: "relative",
  width: "100%",
  "&--with-radius": {
    borderRadius: `${e.semantic.radius["2x"]} ${e.semantic.radius["2x"]} 0 0`
  },
  "&--fixed-container": {
    height: "96px",
    width: "96px"
  },
  overflow: "hidden"
}, Mf = {
  width: "100%",
  boxSizing: "border-box",
  gap: e.semantic.space["3x"],
  display: "flex",
  flexDirection: "column",
  "&--centerAligned": {
    alignItems: "center",
    "h1,h2,h3,h4,h5,h6,p": {
      textAlign: "center"
    }
  },
  "&--leftAligned": {
    alignItems: "left",
    "h1,h2,h3,h4,h5,h6,p": {
      textAlign: "start"
    }
  },
  "&--disabled": {
    "&& > *": {
      color: e.semantic.color.text.disabled
    }
  }
}, Df = {
  "&--xxLarge": {
    svg: {
      height: "72px ",
      width: "72px"
    }
  }
}, Hf = {
  width: "100%"
}, Rf = {
  SelectionsBase: Tf,
  SelectionCard: Wf,
  Title: Lf,
  Description: _f,
  Media: If,
  Body: Mf,
  IconContainer: Df,
  TrailingElementWrapper: Hf
}, zf = "64px", Af = {
  width: zf,
  padding: `${e.semantic.space["3x"]} ${e.semantic.space["2x"]}`,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  textAlign: "center",
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.semiBold.M,
  "&--disabled": {
    color: e.semantic.color.text.disabled
  }
}, Ff = {
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: e.semantic.space["4x"],
  flexWrap: "wrap"
}, Pf = {
  display: "flex",
  gap: e.semantic.space["3x"],
  flexDirection: "column"
}, Ke = {
  SelectionTileCompact: Af,
  SelectionTileCompactGroup: Ff,
  MainWrapper: Pf
}, Of = Ke, Ef = {
  width: "fit-content",
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["1x"]
}, Vf = {
  display: "flex",
  flexDirection: "row",
  gap: e.semantic.space["1x"]
}, Gf = {
  ".PopupTip__header": {
    display: "none"
  },
  ".PopupTip__footer": {
    display: "none"
  },
  ".PopupTip__content": {
    width: "fit-content"
  },
  ".PopupTip": {
    height: "24px"
  },
  ".PopupTip__body": {
    whiteSpace: "nowrap"
  }
}, jf = {
  "--divider-color": e.primitive.color.twilight[1200]
}, Qe = {
  ShareLinks: Ef,
  Links: Vf,
  PopupTip: Gf,
  Divider: jf
}, Uf = Qe, Xf = {
  display: "flex",
  height: e.semantic.space["10x"],
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["4x"]}`,
  "&--inline": {
    display: "inline-flex",
    height: e.semantic.space["6x"],
    padding: "0px"
  },
  "&--left": {
    padding: `${e.semantic.space["2x"]} ${e.semantic.space["4x"]} ${e.semantic.space["2x"]} 0px`
  },
  "&--center": {
    margin: "0px auto",
    justifyContent: "center"
  },
  boxSizing: "border-box",
  width: "fit-content",
  ".Button": {
    color: e.semantic.color.action.default,
    border: "none"
  },
  ".Button:hover": {
    backgroundColor: "transparent !important",
    textDecoration: "underline",
    color: e.semantic.color.action.hover,
    cursor: "pointer"
  },
  "&:hover": {
    ".Button__icon-wrapper svg": {
      color: e.semantic.color.icon.primaryStrongest,
      cursor: "pointer"
    }
  },
  "&--disabled": {
    pointerEvents: "none",
    ".Button": {
      color: e.semantic.color.action.disabled
    },
    "&:hover": {
      ".Button__icon-wrapper .show-more-icon": {
        color: e.semantic.color.action.disabled,
        cursor: "unset"
      }
    }
  },
  "&:focus-visible": {
    "&& > div": {
      outline: `2px solid ${e.semantic.color.stroke.primaryStrongest}`,
      borderRadius: e.semantic.radius["2x"],
      padding: "2px",
      outlineOffset: "2px"
    },
    outline: "none"
  }
}, Nf = {
  "> p": {
    display: "unset",
    margin: "unset"
  },
  "&--inline": {
    display: "inline-block"
  }
}, Yf = {
  padding: "unset",
  backgroundColor: "transparent",
  "&--disabled": {
    color: e.semantic.color.action.disabled,
    pointerEvents: "none",
    ".show-more-icon": {
      color: e.semantic.color.action.disabled
    },
    "&:hover": {
      textDecoration: "unset",
      color: e.semantic.color.action.disabled,
      cursor: "unset"
    }
  }
}, qe = {
  ShowMoreLessWrapper: Xf,
  BodyContentContainer: Nf,
  ShowMoreLessContainer: Yf
}, Zf = qe, Kf = {
  ...e.semantic.typography.body.semiBold.S,
  padding: `${e.semantic.space["4x"]} ${e.semantic.space["2x"]} ${e.semantic.space["2x"]} ${e.semantic.space["2x"]}`,
  display: "block",
  margin: "0px",
  "&.MobileMenu__NavHeader": {
    padding: `0px ${e.semantic.space["1x"]} ${e.semantic.space["2x"]} ${e.semantic.space["3x"]}`
  }
}, Qf = {
  paddingLeft: "0px",
  margin: "0px",
  display: "flex",
  flexDirection: "column"
}, qf = {
  listStyle: "none"
}, Jf = {
  ...e.semantic.typography.body.regular.S,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  textAlign: "left",
  padding: `${e.semantic.space["4x"]} ${e.semantic.space["2x"]} ${e.semantic.space["4x"]} ${e.semantic.space["4x"]}`,
  border: "none",
  background: "none",
  color: `${e.semantic.color.text.default} `,
  borderLeft: `${e.semantic.space[".5x"]} solid ${e.semantic.color.fill.neutralSubtle}`,
  borderRadius: "0",
  textDecoration: "none",
  "&:hover": {
    background: `${e.semantic.color.fill.hover}`,
    border: "0px",
    borderLeft: `${e.semantic.space[".5x"]} solid ${e.semantic.color.fill.neutralSubtle}`,
    color: `${e.semantic.color.text.default} `
  },
  "&--active, &.active": {
    borderLeft: `${e.semantic.space[".5x"]} solid ${e.semantic.color.fill.primaryStrong}`,
    background: `${e.semantic.color.fill.primarySubtlest}`,
    "&:hover": {
      borderLeft: `${e.semantic.space[".5x"]} solid ${e.semantic.color.fill.primaryStrong}`,
      background: `${e.semantic.color.fill.primarySubtlest}`
    }
  },
  "&:focus-visible": {
    outlineOffset: "-1px"
  },
  "&[href]": {
    color: `${e.semantic.color.text.primaryStrongest}`,
    "&:hover": {
      color: `${e.semantic.color.text.primaryStrongest} `
    }
  }
}, ev = {
  cursor: "pointer",
  "&[open] > summary .icon": {
    transform: "rotate(90deg)"
  },
  "& .SidePanel__Section-Details": { paddingLeft: `${e.semantic.space["3x"]}`, cursor: "pointer" },
  "& .SidePanel__NavLists": {
    paddingLeft: `${e.semantic.space["3x"]}`
  }
}, tv = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  listStyle: "none",
  padding: `${e.semantic.space["3x"]} ${e.semantic.space["2x"]} ${e.semantic.space["3x"]} ${e.semantic.space["3x"]}`,
  "&:hover": {
    background: `${e.semantic.color.fill.hover}`,
    borderRadius: `${e.semantic.space["1x"]}`
  }
}, ov = {
  display: "flex",
  alignItems: "center",
  gap: `${e.semantic.space["2x"]}`,
  ...e.semantic.typography.body.regular.S
}, iv = {
  display: "block"
}, rv = {
  padding: `${e.semantic.space["3x"]} 0`,
  ".Drawer__TitleWrapper": {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    gap: `${e.semantic.space["3x"]}`,
    margin: "0",
    alignItems: "center",
    padding: ` ${e.semantic.space[".5x"]} ${e.semantic.space["4x"]}   ${e.semantic.space[".5x"]} ${e.semantic.space["4x"]}`
  },
  ".Drawer__Title": {
    ...e.semantic.typography.headline.S
  },
  ".Drawer__Title.SidePanel__Header--Title-accordion": {
    ...e.semantic.typography.headline.M
  }
}, av = {
  padding: "0",
  "&--accordion": {
    padding: `0 ${e.semantic.space["2x"]}`,
    ".SidePanel__NavItem": {
      border: "none",
      padding: `${e.semantic.space["3x"]} ${e.semantic.space["2x"]} ${e.semantic.space["3x"]} ${e.semantic.space["3x"]}`,
      borderRadius: `${e.semantic.space["1x"]}`,
      "&:active , &--active": {
        background: `${e.semantic.color.fill.primarySubtlest}`,
        color: `${e.semantic.color.text.primaryStrongest}`
      }
    },
    ".SidePanel__NavItem--active, .SidePanel__NavItem .active": {
      background: `${e.semantic.color.fill.primarySubtlest}`,
      color: `${e.semantic.color.text.primaryStrongest}`,
      borderLeft: "none"
    },
    ".SidePanel__NavItem:hover": {
      border: "none",
      color: `${e.semantic.color.text.default}`
    },
    ".SidePanel__NavItem--active:hover": {
      color: `${e.semantic.color.text.primaryStrongest}`
    }
  },
  "&--default": {
    ".SidePanel__NavItem--disabled": {
      color: `${e.semantic.color.text.disabled}`,
      borderLeft: `${e.semantic.space[".5x"]} solid ${e.semantic.color.fill.disabled}`,
      pointerEvents: "none"
    },
    ".SidePanel__NavItem": {
      "&:active , &--active": {
        background: `${e.semantic.color.fill.primarySubtlest}`,
        color: `${e.semantic.color.text.default}`
      }
    }
  }
}, nv = {
  padding: "0"
}, lv = {
  width: "100dvw",
  ".DropdownBase__Content-list": {
    padding: `0 ${e.semantic.space["2x"]}`,
    ".SidePanel__NavItem": {
      border: "none",
      padding: `${e.semantic.space["3x"]} ${e.semantic.space["2x"]} ${e.semantic.space["3x"]} ${e.semantic.space["3x"]}`,
      borderRadius: `${e.semantic.space["1x"]}`,
      "&--active": {
        color: `${e.semantic.color.text.primaryStrongest}`
      }
    },
    ".SidePanel__MobileMenu-NavItem-ItemText": {
      padding: `${e.semantic.space["3x"]} ${e.semantic.space["2x"]} ${e.semantic.space["3x"]} ${e.semantic.space["3x"]}`,
      borderRadius: `${e.semantic.space["1x"]}`,
      "&--active": {
        background: `${e.semantic.color.fill.primarySubtlest}`,
        color: `${e.semantic.color.text.primaryStrongest}`
      }
    }
  }
}, Je = {
  Header: rv,
  Content: av,
  Footer: nv,
  NavHeader: Kf,
  NavLists: Qf,
  ListItem: qf,
  NavItem: Jf,
  SectionDetails: ev,
  SectionSummary: tv,
  SummaryContent: ov,
  DropdownItem: iv,
  MobileMenuDropdownMenuBase: lv
}, sv = Je, D = {
  CIRCULAR: "circular",
  RECTANGULAR: "rectangular",
  ROUNDED: "rounded",
  TEXT: "text"
}, d = { XS: "xs", S: "s", M: "m", L: "l", XL: "xl", XXL: "xxl" }, G = { HEADLINE: "headline", EYEBROW: "eyebrow", BODY: "body" }, C = ["10px", "14px", "18px"], r = [e.semantic.color.fill.neutralSubtle, e.semantic.color.fill.neutralSubtlest, e.semantic.color.fill.hover], cv = {
  "0%, 20%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[1]} 10% 20%, ${r[2]} 100%)`
  },
  "25%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[1]} 10% 20%, ${r[2]} 100%)`
  },
  "30%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[1]} 20% 30%, ${r[2]} 100%)`
  },
  "35%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[1]} 30% 40%, ${r[2]} 100%)`
  },
  "40%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[1]} 40% 50%, ${r[2]} 100%)`
  },
  "45%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[1]} 50% 60%, ${r[2]} 100%)`
  },
  "50%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[1]} 60% 70%, ${r[2]} 100%)`
  },
  "55%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[1]} 70% 80%, ${r[2]} 100%)`
  },
  "60%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[1]} 80% 90%, ${r[2]} 100%)`
  },
  "65%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[1]} 90% 100%, ${r[2]} 100%)`
  },
  "70%, 100%": {
    background: `linear-gradient(-245deg, ${r[0]} 0%, ${r[2]} 100%)`
  }
}, dv = {
  position: "relative",
  color: "transparent",
  background: `linear-gradient(116.57deg, ${r[1]} 13.33%, ${r[0]} 102.5%)`,
  "& > *": { visibility: "hidden" },
  "&--animation": {
    animation: "SkeletonKeyframes 2000ms ease-in-out infinite",
    "@keyframes SkeletonKeyframes": cv
  },
  width: "max-content",
  height: "max-content",
  [`&--${d.L}`]: {
    width: e.semantic.space["12x"],
    height: e.semantic.space["12x"]
  },
  [`&--${d.M}`]: {
    width: e.semantic.space["10x"],
    height: e.semantic.space["10x"]
  },
  [`&--${d.S}`]: {
    width: e.semantic.space["8x"],
    height: e.semantic.space["8x"]
  },
  [`&--${d.XS}`]: {
    width: e.semantic.space["6x"],
    height: e.semantic.space["6x"]
  },
  [`&--${D.CIRCULAR}`]: {
    borderRadius: "50%"
  },
  [`&--${D.ROUNDED}`]: {
    borderRadius: "8px"
  },
  [`&--${D.TEXT}&`]: {
    width: "100%",
    height: "max-content",
    [`&--${d.XXL}`]: {
      height: e.semantic.space["7x"]
    },
    [`&--${d.XL}`]: {
      height: e.semantic.space["6x"]
    },
    [`&--${d.L}`]: {
      height: C[2]
    },
    [`&--${d.M}`]: {
      height: e.semantic.space["4x"]
    },
    [`&--${d.S}`]: {
      height: C[1]
    },
    [`&--${d.XS}`]: {
      height: e.semantic.space["3x"]
    },
    [`&--${G.EYEBROW}`]: {
      height: C[0]
    },
    [`&--${G.BODY}&`]: {
      height: C[0],
      [`&--${d.L}`]: {
        height: e.semantic.space["4x"]
      },
      [`&--${d.M}`]: {
        height: C[1]
      },
      [`&--${d.S}`]: {
        height: e.semantic.space["3x"]
      },
      [`&--${d.XS}`]: {
        height: C[0]
      }
    }
  }
}, et = {
  Skeleton: dv
}, pv = et, mv = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  boxSizing: "border-box",
  justifyContent: "center",
  width: "100%",
  position: "relative",
  thumbWebkitSliderThumb: {
    "-webkit-appearance": "none",
    "-webkit-tap-highlight-color": "transparent"
  },
  thumb: {
    pointerEvents: "none",
    position: "absolute",
    height: "0",
    width: "100%",
    outline: "none"
  },
  webkitSliderThumb: {
    backgroundColor: e.semantic.color.fill.default,
    border: `2px solid ${e.semantic.color.stroke.focus}`,
    borderRadius: "50%",
    cursor: {
      default: "pointer"
    },
    height: e.semantic.space["6x"],
    width: e.semantic.space["6x"],
    marginTop: "unset",
    pointerEvents: "all",
    position: "relative",
    hover: {
      backgroundColor: e.semantic.color.action.hoverSubtle
    },
    active: {
      backgroundColor: e.semantic.color.action.default
    }
  },
  thumbFocusVisibleWebkitSliderThumb: {
    outline: `3px solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: "2px"
  },
  inputDisabled: {
    thumbWebkitSliderThumb: {
      backgroundColor: e.semantic.color.fill.default,
      border: `2px solid ${e.semantic.color.stroke.disabled}`,
      hover: {
        backgroundColor: e.semantic.color.fill.default,
        pointer: "none"
      }
    }
  },
  thumbMozRangeThumb: {
    backgroundColor: e.semantic.color.fill.default,
    border: `2px solid ${e.semantic.color.stroke.focus}`,
    borderRadius: "50%",
    cursor: "pointer",
    height: e.semantic.space["6x"],
    width: e.semantic.space["6x"],
    marginTop: "unset",
    pointerEvents: "all",
    position: "relative",
    hover: {
      backgroundColor: e.semantic.color.action.hoverSubtle
    },
    active: {
      backgroundColor: e.semantic.color.action.default
    }
  }
}, uv = {
  zIndex: {
    inputTypeFirst: "3",
    default: "4"
  },
  display: "none",
  marginLeft: {
    inputTypeFirst: "-2px",
    default: "0px"
  }
}, gv = {
  position: "relative",
  width: "100%",
  margin: `${e.semantic.space["3x"]} 0px`,
  tooltipLeft: {
    width: "100%",
    position: "absolute",
    divRoleTooltip: {
      bottom: "35px"
    }
  },
  tooltipRight: {
    width: "100%",
    position: "absolute",
    divRoleTooltip: {
      bottom: "35px"
    }
  }
}, xv = {
  backgroundColor: {
    disabled: e.semantic.color.action.disabled,
    default: e.semantic.color.stroke.neutralSubtle
  },
  borderRadius: e.semantic.radius["2x"],
  height: e.semantic.space["1x"],
  width: "100%",
  position: "absolute",
  zIndex: "1"
}, hv = {
  backgroundColor: {
    disabled: e.semantic.color.action.disabled,
    default: e.semantic.color.stroke.focus
  },
  borderRadius: e.semantic.radius["2x"],
  height: e.semantic.space["1x"],
  position: "absolute",
  zIndex: 2
}, bv = {
  display: "flex",
  boxSizing: "border-box",
  borderRadius: e.semantic.radius["2x"],
  border: `1px solid ${e.semantic.color.stroke.default}`,
  background: {
    disabled: e.semantic.color.fill.disabled,
    default: e.semantic.color.fill.default
  },
  width: "88px",
  padding: `${e.semantic.space["1x"]} ${e.semantic.space["3x"]}`,
  alignItems: "center",
  justifyContent: "center",
  margin: "1px",
  inputFocus: {
    border: `2px solid ${e.semantic.color.stroke.focus}`,
    margin: "unset"
  }
}, fv = {
  display: "flex",
  flexDirection: {
    categoryInputField: "column",
    default: "row"
  },
  justifyContent: "space-between",
  width: "100%",
  marginBottom: e.semantic.space["4x"],
  ...e.semantic.typography.body.regular.M,
  fontStyle: "normal",
  color: e.semantic.color.text.default,
  alignItems: "center"
}, vv = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  color: {
    disabled: e.semantic.color.text.disabled,
    default: e.semantic.color.text.subtle
  },
  marginTop: e.semantic.space["2x"],
  padding: "0 4px"
}, yv = {
  display: "flex",
  justifyContent: "space-between"
}, Cv = {
  width: "2px",
  height: "6px",
  background: {
    disabled: e.semantic.color.action.disabled,
    default: e.semantic.color.stroke.neutralSubtle
  },
  borderRadius: `0 0 ${e.semantic.radius["2x"]} ${e.semantic.radius["2x"]}`
}, $v = {
  display: "flex",
  justifyContent: "space-between",
  width: `calc(100% - ${e.semantic.space["6x"]})`,
  marginBottom: e.semantic.space["2x"],
  marginLeft: "2px",
  marginTop: "-6px"
}, wv = {
  marginBottom: e.semantic.space["2x"],
  ...e.semantic.typography.body.medium.M,
  fontStyle: "normal",
  color: e.semantic.color.text.default
}, kv = {
  marginBottom: e.semantic.space["2x"],
  ...e.semantic.typography.body.regular.M,
  fontStyle: "normal",
  color: {
    disabled: e.semantic.color.text.disabled,
    default: e.semantic.color.text.default
  }
}, Sv = {
  width: "100%",
  letterSpacing: "unset",
  ...e.semantic.typography.body.regular.M,
  fontStyle: "normal",
  backgroundColor: "transparent",
  color: {
    disabled: e.semantic.color.text.onDisabledStrong,
    default: e.semantic.color.text.subtle
  },
  borderStyle: "none",
  outlineStyle: "none"
}, Bv = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"]
}, Tv = e.semantic.color.text.dangerStrong, Wv = {
  SliderContainer: mv,
  SliderInput: uv,
  SliderWrapper: gv,
  SliderTrack: xv,
  SliderRange: hv,
  InputContainer: bv,
  LabelWrapper: fv,
  ValueLabelWrapper: vv,
  InputWrapper: yv,
  DiscreteTick: Cv,
  TricksWrapper: $v,
  Label: wv,
  RangeLabel: kv,
  BaseTextInput: Sv,
  LabelRequiredIndicatorColor: Tv,
  StyledSlider: Bv
}, Lv = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  boxSizing: "border-box",
  justifyContent: "center",
  width: "100%",
  position: "relative",
  thumbWebkitSliderThumb: {
    "-webkit-appearance": "none",
    "-webkit-tap-highlight-color": "transparent"
  },
  thumb: {
    pointerEvents: "none",
    position: "absolute",
    height: "0",
    width: "100%",
    outline: "none"
  },
  webkitSliderThumb: {
    backgroundColor: e.semantic.color.fill.default,
    border: `2px solid ${e.semantic.color.stroke.focus}`,
    borderRadius: "50%",
    cursor: {
      default: "pointer"
    },
    height: e.semantic.space["6x"],
    width: e.semantic.space["6x"],
    marginTop: "unset",
    pointerEvents: "all",
    position: "relative",
    hover: {
      backgroundColor: e.semantic.color.action.hoverSubtle
    },
    active: {
      backgroundColor: e.semantic.color.action.default
    }
  },
  thumbFocusVisibleWebkitSliderThumb: {
    outline: `3px solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: "2px"
  },
  inputDisabled: {
    thumbWebkitSliderThumb: {
      backgroundColor: e.semantic.color.fill.default,
      border: `2px solid ${e.semantic.color.stroke.disabled}`,
      hover: {
        backgroundColor: e.semantic.color.fill.default,
        pointer: "none"
      }
    }
  },
  thumbMozRangeThumb: {
    backgroundColor: e.semantic.color.fill.default,
    border: `2px solid ${e.semantic.color.stroke.focus}`,
    borderRadius: "50%",
    cursor: "pointer",
    height: e.semantic.space["6x"],
    width: e.semantic.space["6x"],
    marginTop: "unset",
    pointerEvents: "all",
    position: "relative",
    hover: {
      backgroundColor: e.semantic.color.action.hoverSubtle
    },
    active: {
      backgroundColor: e.semantic.color.action.default
    }
  }
}, _v = {
  zIndex: {
    inputTypeFirst: "3",
    default: "4"
  },
  display: "none",
  marginLeft: {
    inputTypeFirst: "-2px",
    default: "0px"
  }
}, Iv = {
  position: "relative",
  width: "100%",
  margin: `${e.semantic.space["3x"]} 0px`,
  tooltipLeft: {
    width: "100%",
    position: "absolute",
    divRoleTooltip: {
      bottom: "35px"
    }
  },
  tooltipRight: {
    width: "100%",
    position: "absolute",
    divRoleTooltip: {
      bottom: "35px"
    }
  }
}, Mv = {
  backgroundColor: {
    disabled: e.semantic.color.action.disabled,
    default: e.semantic.color.stroke.neutralSubtle
  },
  borderRadius: e.semantic.radius["2x"],
  height: e.semantic.space["1x"],
  width: "100%",
  position: "absolute",
  zIndex: "1"
}, Dv = {
  backgroundColor: {
    disabled: e.semantic.color.action.disabled,
    default: e.semantic.color.stroke.focus
  },
  borderRadius: e.semantic.radius["2x"],
  height: e.semantic.space["1x"],
  position: "absolute",
  zIndex: 2
}, Hv = {
  display: "flex",
  boxSizing: "border-box",
  borderRadius: e.semantic.radius["2x"],
  border: `1px solid ${e.semantic.color.stroke.default}`,
  background: {
    disabled: e.semantic.color.fill.disabled,
    default: e.semantic.color.fill.default
  },
  width: "88px",
  padding: `${e.semantic.space["1x"]} ${e.semantic.space["3x"]}`,
  alignItems: "center",
  justifyContent: "center",
  margin: "1px",
  inputFocus: {
    border: `2px solid ${e.semantic.color.stroke.focus}`,
    margin: "unset"
  }
}, Rv = {
  display: "flex",
  flexDirection: {
    categoryInputField: "column",
    default: "row"
  },
  justifyContent: "space-between",
  width: "100%",
  marginBottom: e.semantic.space["4x"],
  ...e.semantic.typography.body.medium.S,
  fontStyle: "normal",
  color: e.semantic.color.text.default,
  alignItems: "center"
}, zv = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  color: {
    disabled: e.semantic.color.text.disabled,
    default: e.semantic.color.text.subtle
  },
  marginTop: e.semantic.space["2x"],
  padding: "0 4px"
}, Av = {
  display: "flex",
  justifyContent: "space-between"
}, Fv = {
  width: "2px",
  height: "6px",
  background: {
    disabled: e.semantic.color.action.disabled,
    default: e.semantic.color.stroke.neutralSubtle
  },
  borderRadius: `0 0 ${e.semantic.radius["2x"]} ${e.semantic.radius["2x"]}`
}, Pv = {
  display: "flex",
  justifyContent: "space-between",
  width: `calc(100% - ${e.semantic.space["6x"]})`,
  marginBottom: e.semantic.space["2x"],
  marginLeft: "2px",
  marginTop: "-6px"
}, Ov = {
  marginBottom: e.semantic.space["2x"],
  ...e.semantic.typography.body.medium.S,
  fontStyle: "normal",
  color: e.semantic.color.text.default
}, Ev = {
  marginBottom: e.semantic.space["2x"],
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  color: {
    disabled: e.semantic.color.text.disabled,
    default: e.semantic.color.text.default
  }
}, Vv = {
  width: "100%",
  letterSpacing: "unset",
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  backgroundColor: "transparent",
  color: {
    disabled: e.semantic.color.text.onDisabledStrong,
    default: e.semantic.color.text.subtle
  },
  borderStyle: "none",
  outlineStyle: "none"
}, Gv = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"]
}, jv = e.semantic.color.text.dangerStrong, Uv = {
  SliderContainer: Lv,
  SliderInput: _v,
  SliderWrapper: Iv,
  SliderTrack: Mv,
  SliderRange: Dv,
  InputContainer: Hv,
  LabelWrapper: Rv,
  ValueLabelWrapper: zv,
  InputWrapper: Av,
  DiscreteTick: Fv,
  TricksWrapper: Pv,
  Label: Ov,
  RangeLabel: Ev,
  BaseTextInput: Vv,
  LabelRequiredIndicatorColor: jv,
  StyledSlider: Gv
}, Xv = {
  display: "flex",
  padding: t.semanticMode1.space.lg.value,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  border: `1px dashed ${t.semanticMode1.color.stroke.onLight.interactive.value}`,
  background: "#0562D21A"
}, Nv = {
  textAlign: "center",
  ...t.semanticMode1.body1.bold.value,
  color: t.semanticMode1.color.stroke.onLight.interactive.value,
  fontStyle: "normal"
}, Yv = {
  ...t.semanticMode1.caption.regular.value,
  color: t.semanticMode1.color.stroke.onLight.interactive.value,
  fontStyle: "normal",
  textAlign: "center"
}, Zv = {
  SlotWrapper: Xv,
  SlotTitle: Nv,
  SlotPlaceHolder: Yv
}, Kv = {
  display: "flex",
  padding: e.semantic.space["4x"],
  flexDirection: "column",
  boxSizing: "border-box",
  justifyContent: "center",
  alignItems: "center",
  border: `1px dashed ${e.semantic.color.stroke.primaryStrongest}`,
  background: e.semantic.color.fill.primarySubtlest
}, Qv = {
  color: e.semantic.color.text.primaryStrongest,
  textAlign: "center",
  ...e.semantic.typography.body.semiBold.L,
  fontStyle: "normal"
}, qv = {
  color: e.semantic.color.text.primaryStrongest,
  textAlign: "center",
  ...e.semantic.typography.body.regular.XS,
  fontStyle: "normal"
}, Jv = {
  SlotWrapper: Kv,
  SlotTitle: Qv,
  SlotPlaceHolder: qv
}, ey = {
  position: "fixed",
  inset: "0",
  transition: "all 0.3s ease-in-out",
  display: "flex",
  pointerEvents: "none",
  flexDirection: "column",
  placeContent: "end",
  placeItems: "center",
  paddingBlock: "80px",
  maxWidth: "100%",
  maxHeight: "100dvh",
  overflow: "clip",
  overflowClipMargin: "content-box",
  "&--pile": {
    display: "grid",
    placeItems: "center",
    justifyContent: "normal",
    alignContent: "end"
  }
}, ty = {
  animation: "openSnackbar 0.3s ease-in-out",
  animationDelay: "0s",
  "@keyframes openSnackbar": {
    from: {
      opacity: "0",
      transform: "translateY(100%)"
    },
    to: {
      opacity: "1"
    }
  }
}, oy = {
  animation: "closeSnackbar 0.3s forwards",
  animationDelay: "0s",
  "@keyframes closeSnackbar": {
    from: {
      opacity: "1"
    },
    to: {
      opacity: "0",
      transform: "translateY(100%)"
    }
  }
}, iy = {
  transition: "all 0.3s ease-in-out",
  "&--fadeOut": oy,
  ...ty,
  overflow: "clip",
  gridArea: "1/1",
  [`@media ${i.laptopAndUp} `]: {
    maxWidth: "60%"
  }
}, ry = {
  marginTop: "16px",
  pointerEvents: "all",
  gap: t.semanticMode1.space.md.value,
  //12px
  display: "flex",
  width: "fit-content",
  position: "relative",
  paddingBlock: t.semanticMode1.space.sm.value,
  // 8px
  paddingInline: t.semanticMode1.space.lg.value,
  // 16px
  boxSizing: "border-box",
  justifyContent: "space-around",
  alignItems: "center",
  minHeight: t.primitive.lineHeights[7].value,
  //48px
  borderRadius: t.semanticMode1.space.xs.value,
  //4px
  backgroundColor: t.semanticMode1.color.fill.onLight.strongest.value,
  color: t.semanticMode1.color.text.onDark.moderateDefault.value,
  flexShrink: 0,
  flexGrow: 0,
  "&--error": {
    backgroundColor: t.semanticMode1.color.fill.onLight.dangerStrong.value
  },
  ".Snackbar__Icon": {
    flexShrink: 0,
    color: "inherit",
    height: "32px"
  },
  ".Snackbar__button": o({
    btnFocusOutline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onDark.strong.value}`
  }),
  ".Snackbar__close-button.CloseButton": o({
    closeBtnTextColor: t.primitive.color.twilight[300].value,
    closeBtnHoverTextColor: t.primitive.color.twilight["000"].value,
    closeBtnBgColor: "transparent",
    closeBtnHoverBgColor: "transparent"
  })
}, ay = {
  paddingBlock: t.semanticMode1.space.sm.value,
  // 8px
  paddingInline: t.semanticMode1.space.xs.value
  // 4px
}, ny = {
  margin: 0,
  ...t.semanticMode1.body2.regular.value,
  color: t.semanticMode1.color.text.onDark.moderateDefault.value,
  letterSpacing: 0
}, ly = {
  height: t.semanticMode1.space["3xl"].value,
  //32px
  gap: t.semanticMode1.space.sm.value,
  //8px
  width: "auto",
  ...t.semanticMode1.body2.regular.value,
  color: t.semanticMode1.color.text.onDark.moderateDefault.value,
  cursor: "pointer"
}, sy = {
  Container: ey,
  SnackbarWrapper: iy,
  Snackbar: ry,
  Content: ay,
  Body: ny,
  Button: ly
}, cy = {
  position: "fixed",
  inset: "0",
  transition: "all 0.3s ease-in-out",
  display: "flex",
  pointerEvents: "none",
  flexDirection: "column",
  justifyContent: "end",
  placeItems: "center",
  paddingBlock: "80px",
  maxWidth: "100%",
  maxHeight: "100dvh",
  overflow: "clip",
  overflowClipMargin: "content-box",
  "&--pile": {
    display: "grid",
    placeItems: "center",
    justifyContent: "normal",
    alignContent: "end"
  }
}, dy = {
  animation: "openSnackbar 0.3s ease-in-out",
  animationDelay: "0s",
  "@keyframes openSnackbar": {
    from: {
      opacity: "0",
      transform: "translateY(100%)"
    },
    to: {
      opacity: "1"
    }
  }
}, py = {
  animation: "closeSnackbar 0.3s forwards",
  animationDelay: "0s",
  "@keyframes closeSnackbar": {
    from: {
      opacity: "1"
    },
    to: {
      opacity: "0",
      transform: "translateY(100%)"
    }
  }
}, my = {
  transition: "all 0.3s ease-in-out",
  "&--fadeOut": py,
  ...dy,
  overflow: "clip",
  gridArea: "1/1",
  [`@media ${i.laptopAndUp}`]: {
    maxWidth: "60%"
  }
}, uy = {
  marginTop: e.semantic.space["4x"],
  pointerEvents: "all",
  gap: e.semantic.space["2x"],
  display: "flex",
  position: "relative",
  paddingBlock: e.semantic.space["2x"],
  paddingInline: e.semantic.space["4x"],
  paddingInlineEnd: e.semantic.space["2x"],
  boxSizing: "border-box",
  justifyContent: "space-around",
  alignItems: "start",
  minHeight: e.semantic.space["12x"],
  borderRadius: e.semantic.radius["2x"],
  backgroundColor: e.semantic.color.text.default,
  color: e.semantic.color.text.onColor,
  flexShrink: 0,
  flexGrow: 0,
  "&--error": {
    backgroundColor: e.semantic.color.fill.dangerStrong
  },
  ".Snackbar__Icon": {
    flexShrink: 0,
    color: "inherit",
    height: e.semantic.space["8x"]
  }
}, gy = {
  padding: e.semantic.space["1x"],
  paddingInlineEnd: e.semantic.space["3x"],
  boxSizing: "border-box",
  minHeight: e.semantic.space["8x"]
}, xy = {
  margin: 0,
  minHeight: e.semantic.space["6x"],
  color: e.semantic.color.text.onColor,
  ...e.semantic.typography.body.medium.M,
  letterSpacing: 0
}, hy = {
  height: e.semantic.space["8x"],
  padding: `2px ${e.semantic.space["4x"]}`,
  width: "auto",
  fontFamily: e.primitive.typography.fontFamilies.inter,
  fontWeight: e.primitive.typography.fontWeights.inter.medium,
  color: e.semantic.color.text.onColor,
  borderRadius: e.semantic.radius["2x"],
  cursor: "pointer"
}, by = {
  Container: cy,
  SnackbarWrapper: my,
  Snackbar: uy,
  Content: gy,
  Body: xy,
  Button: hy
}, fy = {
  "&.vertical-spacing-small": {
    marginBottom: t.primitive.space["5x"].value,
    [`@media ${i.mobile}`]: {
      marginBottom: t.primitive.space["4x"].value
    }
  },
  "&.vertical-spacing-medium": {
    marginBottom: "48px",
    [`@media ${i.mobile}`]: {
      marginBottom: t.primitive.space["5x"].value
    }
  },
  "&.vertical-spacing-large": {
    marginBottom: t.primitive.space["11x"].value,
    [`@media ${i.mobile}`]: {
      marginBottom: t.primitive.space["7x"].value
    }
  }
}, vy = {
  AemSpacer: fy
}, yy = {
  ...o({
    _circleDiameter: e.semantic.space["6x"],
    _lineWeight: e.semantic.space["1x"],
    _backgroundColor: e.semantic.color.opacity.scrim.black[10],
    _progressBarColor: e.semantic.color.stroke.focus
  }),
  position: "relative",
  flex: "none",
  width: `${o.fallback("circleDiameter")}`,
  height: `${o.fallback("circleDiameter")}`,
  "&--large": {
    ...o({ circleDiameter: "64px" })
  },
  "&--medium": {
    ...o({ circleDiameter: e.semantic.space["8x"] })
  },
  "&--xsmall": {
    ...o({ circleDiameter: e.semantic.space["5x"], lineWeight: "3px" })
  },
  "&--xxsmall": {
    ...o({ circleDiameter: e.semantic.space["4x"], lineWeight: "2px" })
  },
  "&--onColor": {
    ...o({
      _backgroundColor: e.semantic.color.opacity.surface.default[40],
      _progressBarColor: e.semantic.color.stroke.onColor
    })
  },
  "&::before": {
    position: "absolute",
    top: "0",
    left: "50%",
    bottom: "0",
    right: "0",
    boxSizing: "border-box",
    border: `${o.fallback("lineWeight")} solid ${o.fallback("backgroundColor")}`,
    content: '""',
    width: `${o.fallback("circleDiameter")}`,
    height: `${o.fallback("circleDiameter")}`,
    marginLeft: `calc((${o.fallback("circleDiameter")}) / -2)`,
    borderRadius: `${o.fallback("circleDiameter")}`
  }
}, Cy = {
  "100%": {
    transform: "rotate(360deg)"
  }
}, $y = {
  position: "relative",
  "&::before": {
    position: "absolute",
    left: "50%",
    boxSizing: "border-box",
    border: `${o.fallback("lineWeight")} solid ${o.fallback("backgroundColor")}`,
    borderTop: `${o.fallback("lineWeight")} solid ${o.fallback("progressBarColor")}`,
    transform: "rotate(0deg)",
    animationName: "circularindetermiate",
    animationIterationCount: "infinite",
    animationDuration: "1s",
    animationTimingFunction: "linear",
    content: '""',
    width: `${o.fallback("circleDiameter")}`,
    height: `${o.fallback("circleDiameter")}`,
    marginLeft: `calc((${o.fallback("circleDiameter")}) / -2)`,
    borderRadius: `${o.fallback("circleDiameter")}`
  },
  "@keyframes circularindetermiate": Cy
}, tt = {
  SpinnerCircle: yy,
  SpinnerCircleProgressBar: $y
}, wy = tt, ky = {
  display: "inline-flex",
  flexDirection: "column",
  gap: t.primitive.space["2x"].value
}, Sy = {
  ...o({
    _switchCheckedBgColor: o("switchCheckedBgColor", t.componentMode1.toggle.onLight.default.value),
    _switchUncheckedBgColor: o("switchUncheckedBgColor", t.primitive.color.neutral[500].value),
    _switchBgColor: o("_switchUncheckedBgColor"),
    _switchCheckedColor: o("switchCheckedColor", t.componentMode1.toggle.onLight.default.value),
    _switchUncheckedColor: o("switchUncheckedColor", t.primitive.color.neutral[500].value),
    _switchColor: o("_switchUncheckedColor"),
    _switchDisabledBgColor: o("switchDisabledBgColor", t.primitive.color.neutral[200].value),
    _switchDisabledColor: o("switchDisabledColor", t.primitive.color.neutral[200].value),
    _switchBorderRadius: `max(${o.fallback("_switchSize")}, ${t.primitive.space["4x"].value})`,
    // 16px
    _switchFocusOutlineColor: t.primitive.color.neutral[1200].value
  }),
  "&--medium": o({
    _switchInlineGap: o("switchInlineGap", t.primitive.border["2x"].value),
    // 2px
    _switchSize: o("switchSize", o("switchSize", t.primitive.space["5x"].value)),
    // 24px
    _switchWidth: o("switchWidth", `calc(${o("_switchSize")} * 2)`)
  }),
  "&--large": o({
    _switchInlineGap: o("switchInlineGap", t.semanticMode1.space.xs.value),
    // 4px
    _switchSize: o("switchSize", t.primitive.space["6x"].value),
    // 32px
    _switchWidth: o("switchWidth", `calc((${o("_switchSize")} * 2) - calc(${o("_switchInlineGap")} * 2))`)
  }),
  "&:has(.Switch__input:focus-visible)": {
    outlineWidth: t.primitive.border["2x"].value,
    // 2px
    outlineStyle: "solid",
    outlineColor: o.fallback("_switchFocusOutlineColor")
  },
  "&:has(.Switch__input:checked)": {
    ...o({
      _switchBgColor: o("_switchCheckedBgColor"),
      _switchColor: o("_switchCheckedColor")
    }),
    ".Switch__slider": {
      left: `calc(100% - calc(${o("switchSliderWidth", o.fallback("_switchSliderSize"))} + ${o("_switchInlineGap")}))`
    }
  },
  "&:has(.Switch__input:disabled)": {
    ...o({
      _switchBgColor: o("_switchDisabledBgColor"),
      _switchColor: o("_switchDisabledColor")
    }),
    cursor: "default",
    outline: "none"
  },
  "&:has(.Switch__input:not(:checked)) .Switch__slider-icon--checked": { display: "none" },
  "&:has(.Switch__input:checked) .Switch__slider-icon--unchecked": { display: "none" },
  display: "inline-flex",
  alignItems: "center",
  height: o.fallback("switchHeight", "_switchSize"),
  width: o("_switchWidth"),
  backgroundColor: o.fallback("_switchBgColor"),
  color: o.fallback("_switchColor"),
  borderRadius: o.fallback("_switchBorderRadius"),
  position: "relative",
  transition: "background-color 150ms linear",
  cursor: "pointer"
}, By = {
  opacity: 0,
  position: "absolute",
  width: 0,
  height: 0,
  overflow: "hidden"
}, Ty = {
  ...o({
    _switchSliderSize: `calc(${o("_switchSize")} - calc(${o("_switchInlineGap")} * 2))`,
    _switchSliderBgColor: t.primitive.color.twilight["000"].value
  }),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  transition: "left 150ms linear",
  backgroundColor: o.fallback("_switchSliderBgColor"),
  height: o("switchSliderHeight", o.fallback("_switchSliderSize")),
  width: o("switchSliderWidth", o.fallback("_switchSliderSize")),
  borderRadius: o.fallback("_switchSliderBorderRadius", "_switchBorderRadius"),
  left: o("_switchInlineGap")
}, Wy = {
  ...o({ _switchSliderIconSize: `calc(${o("_switchSliderSize")} - ${o("_switchInlineGap")})` }),
  display: "inline",
  width: o("switchSliderIconWidth", o.fallback("_switchSliderIconSize")),
  height: o("switchSliderIconHeight", o.fallback("_switchSliderIconSize"))
}, Ly = {
  Switch: ky,
  SwitchInputWrapper: Sy,
  SwitchInput: By,
  SwitchSlider: Ty,
  SwitchSliderIcon: Wy
}, _y = {
  display: "inline-flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"]
}, Iy = {
  "--_switch-size": `var(--switch-size, ${e.semantic.space["7x"]})`,
  // 28px
  "--_switch-inline-gap": `var(--switch-inline-gap, ${e.semantic.space["1x"]})`,
  // 4px
  "--_switch-disabled-color": `var(--switch-disabled-color, ${e.semantic.color.action.disabled})`,
  ...o({
    _switchCheckedBgColor: o("switchCheckedBgColor", e.semantic.color.action.default),
    _switchUncheckedBgColor: o("switchUncheckedBgColor", e.semantic.color.fill.neutralModerate),
    _switchBgColor: o("_switchUncheckedBgColor"),
    _switchCheckedColor: o("switchCheckedColor", e.semantic.color.icon.primary),
    _switchUncheckedColor: o("switchUncheckedColor", e.semantic.color.text.placeholder),
    _switchColor: o("_switchUncheckedColor"),
    _switchDisabledBgColor: o("switchDisabledBgColor", e.semantic.color.action.disabled),
    _switchDisabledColor: o("switchDisabledColor", e.semantic.color.text.disabled),
    _switchBorderRadius: `max(${o.fallback("_switchSize")}, ${e.semantic.space["7x"]})`,
    // 28px
    _switchFocusOutlineColor: e.semantic.color.stroke.focus,
    _switchInlineGap: o("switchInlineGap", e.semantic.space["1x"]),
    // 4px
    _switchWidth: o("switchWidth", `calc((${o("_switchSize")} * 2) - calc(${o("_switchInlineGap")} * 2))`)
  }),
  "&--medium": o({
    _switchSize: o("switchSize", o("switchSize", e.semantic.space["7x"]))
    // 28px
  }),
  "&--large": o({
    _switchSize: o("switchSize", o("switchSize", e.semantic.space["8x"]))
    // 32px
  }),
  "&:has(.Switch__input:focus-visible)": {
    outlineOffset: e.semantic.space["1x"],
    // 4px
    outlineWidth: e.semantic.borderWidth["2x"],
    // 2px
    outlineStyle: "solid",
    outlineColor: o.fallback("_switchFocusOutlineColor")
  },
  "&:has(.Switch__input:checked)": {
    ...o({
      _switchBgColor: o("_switchCheckedBgColor"),
      _switchColor: o("_switchCheckedColor")
    }),
    ".Switch__slider": {
      left: `calc(100% - calc(${o("switchSliderWidth", o.fallback("_switchSliderSize"))} + ${o("_switchInlineGap")}))`
    }
  },
  "&:has(.Switch__input:disabled)": {
    ...o({
      _switchBgColor: o("_switchDisabledBgColor"),
      _switchColor: o("_switchDisabledColor")
    }),
    cursor: "default",
    outline: "none"
  },
  "&:has(.Switch__input:not(:checked)) .Switch__slider-icon--checked": { display: "none" },
  display: "inline-flex",
  alignItems: "center",
  height: o.fallback("switchHeight", "_switchSize"),
  width: o("_switchWidth"),
  backgroundColor: o.fallback("_switchBgColor"),
  color: o.fallback("_switchColor"),
  borderRadius: o.fallback("_switchBorderRadius"),
  position: "relative",
  transition: "background-color 150ms linear",
  cursor: "pointer"
}, My = {
  opacity: 0,
  position: "absolute",
  width: 0,
  height: 0,
  overflow: "hidden"
}, Dy = {
  ...o({
    _switchSliderSize: `calc(${o("_switchSize")} - calc(${o("_switchInlineGap")} * 2))`,
    _switchSliderBgColor: e.semantic.color.fill.default
  }),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  transition: "left 150ms linear",
  backgroundColor: o.fallback("_switchSliderBgColor"),
  height: o("switchSliderHeight", o.fallback("_switchSliderSize")),
  width: o("switchSliderWidth", o.fallback("_switchSliderSize")),
  borderRadius: o.fallback("_switchSliderBorderRadius", "_switchBorderRadius"),
  left: o("_switchInlineGap")
}, Hy = {
  display: "inline",
  ...o({ _switchSliderIconSize: `calc(${o("_switchSliderSize")} - ${o("_switchInlineGap")})` }),
  width: o("switchSliderIconWidth", o.fallback("_switchSliderIconSize")),
  height: o("switchSliderIconHeight", o.fallback("_switchSliderIconSize")),
  "&--unchecked": { display: "none" }
}, Ry = {
  Switch: _y,
  SwitchInputWrapper: Iy,
  SwitchSlider: Dy,
  SwitchInput: My,
  SwitchSliderIcon: Hy
}, zy = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: {
    boxVariation: e.semantic.space["3x"],
    default: "0px"
  }
}, Ay = {
  display: "flex",
  flexDirection: "column",
  borderBottom: `${e.semantic.borderWidth["1x"]} solid
    ${e.semantic.color.stroke.default}`,
  background: {
    boxVariationDisabled: e.semantic.color.fill.disabled,
    default: e.semantic.color.fill.default
  },
  hover: {
    borderBottomDisabled: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.disabled}`,
    borderBottomDefault: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`
  },
  focusVisible: {
    outline: "none",
    borderBottom: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`
  },
  boxVariation: {
    borderRadius: e.semantic.radius["2x"],
    outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
    borderBottom: "unset",
    hover: {
      outlineDisabled: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.disabled}`,
      outlineDefault: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`,
      borderBottom: "unset"
    },
    focusVisible: {
      outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
      borderBottom: "unset"
    }
  }
}, Fy = {
  display: "flex",
  padding: `${e.semantic.space["4x"]} ${e.semantic.space["8x"]}`,
  flexDirection: "row",
  alignItems: {
    isDropDownMenu: "center",
    default: "flex-start"
  },
  gap: e.semantic.space["4x"],
  alignSelf: "stretch",
  cursor: {
    disabled: "not-allowed",
    default: "pointer"
  },
  background: {
    boxVariationDisabled: e.semantic.color.fill.disabled,
    default: e.semantic.color.fill.default
  },
  border: "none"
}, Py = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: e.semantic.space["1x"],
  flex: "1 0 0"
}, Oy = {
  color: {
    disabled: e.semantic.color.text.onDisabledStrong,
    default: e.semantic.color.text.default
  },
  ...e.semantic.typography.body.medium.M,
  fontStyle: "normal"
}, Ey = {
  color: {
    disabled: e.semantic.color.text.onDisabledStrong,
    default: e.semantic.color.text.subtle
  },
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal"
}, Vy = {
  display: "flex",
  minHeight: e.semantic.space["6x"],
  justifyContent: "center",
  alignItems: "center",
  svg: {
    width: e.semantic.space["5x"],
    height: e.semantic.space["5x"],
    color: {
      disabled: e.semantic.color.icon.disabled,
      default: e.semantic.color.icon.default
    }
  }
}, Gy = {
  display: "flex",
  width: e.semantic.space["6x"],
  height: e.semantic.space["6x"],
  justifyContent: "center",
  alignItems: "center",
  transform: {
    accordionOpen: "rotate(0deg)",
    accordionClose: "rotate(-180deg)"
  },
  transition: {
    animate: "transform 0.3s ease-in-out",
    default: "transform 0s ease-in-out"
  },
  svg: {
    color: {
      disabled: e.semantic.color.icon.disabled,
      default: e.semantic.color.icon.primary
    }
  }
}, jy = {
  animate: {
    defaultHeight: "0px",
    overflow: "hidden",
    transition: "all 0.3s ease-in-out"
  },
  display: {
    accordionOpen: "flex",
    default: "none"
  },
  padding: `0px ${e.semantic.space["8x"]}`
}, Uy = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: {
    dropdownMenu: "center",
    default: "flex-start"
  },
  gap: "8px"
}, Xy = {
  display: "flex",
  width: "100%",
  justifyContent: "flex-start",
  paddingBottom: e.semantic.space["6x"]
}, Ny = {
  width: "100%",
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.M,
  letterSpacing: "0"
}, ot = {
  AccordionContainer: zy,
  AccordionItemWrapper: Ay,
  HeaderWrapper: Fy,
  HeaderContentWrapper: Py,
  TitleWrapper: Oy,
  SubtitleWrapper: Ey,
  LeadingIconWrapper: Vy,
  ToggleIconWrapper: Gy,
  ContentWrapper: jy,
  AccordionItemEnd: Uy,
  PanelContentWrapper: Xy,
  PanelContent: Ny
}, Yy = ot, Zy = {
  flex: 1,
  maxWidth: "100%"
}, Ky = {
  padding: "5px"
}, Qy = {
  scrollBehavior: "smooth",
  width: "fit-content",
  display: "inline-flex",
  position: "relative",
  isolation: "isolate",
  "--tabs-list-height": t.semanticMode1.space["2xl"].value,
  "--tabs-list-gap": t.semanticMode1.space.lg.value,
  height: "var(--tabs-list-height)",
  gap: "var(--tabs-list-gap)",
  boxSizing: "border-box",
  userSelect: "none",
  "&--fullWidth": {
    width: "100%"
  },
  [`@media ${i.mobile}`]: {
    "--tabs-list-gap": t.semanticMode1.space.sm.value
  },
  "&:hover .TabList__indicator": {
    borderBottom: `${t.primitive.border["4x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactiveHover.value}`
  }
}, qy = {
  zIndex: "-1",
  height: `var(--tabs-list-height, ${t.primitive.border["4x"].value})`,
  width: "var(--tabs-indicator-width, 0)",
  transform: "var(--tabs-indicator-position, translateX(0))",
  position: "absolute",
  transition: "width 0.3s, transform 0.3s",
  boxSizing: "border-box",
  pointerEvents: "none",
  borderBottom: `${t.primitive.border["4x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactive.value}`
}, Jy = {
  border: "none",
  background: "transparent",
  display: "inline-flex",
  alignItems: "center",
  flexShrink: 0,
  boxSizing: "border-box",
  height: "100%",
  gap: t.semanticMode1.space.sm.value,
  cursor: "pointer",
  margin: 0,
  padding: 0,
  position: "relative",
  minWidth: "145px",
  paddingBottom: t.semanticMode1.space.sm.value,
  borderBottom: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.strong.value}`,
  ...t.semanticMode1.subtitle.regular.value,
  color: t.semanticMode1.color.text.onLight.moderateDefault.value,
  ".Tab__Badge": {
    display: "none"
  },
  "&:focus-visible": {
    outline: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.strongestFocus.value}`,
    outlineOffset: t.primitive.border["2x"].value
  },
  "&--active:not(&--disabled)": {
    color: t.semanticMode1.color.text.onLight.interactive.value,
    borderBottom: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactive.value}`,
    "&:hover": {
      color: t.semanticMode1.color.text.onLight.interactiveHover.value,
      borderBottom: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactiveHover.value}`
    }
  },
  "&:hover:not(&--disabled)": {
    color: t.semanticMode1.color.text.onLight.interactiveHover.value,
    "&::after": {
      content: '" "',
      position: "absolute",
      borderBottom: `${t.primitive.border["4x"].value} solid ${t.semanticMode1.color.stroke.onLight.interactiveHover.value}`,
      width: "100%",
      bottom: "-2px"
    }
  },
  [`@media ${i.mobile}`]: {
    minWidth: "168px"
  },
  "&--disabled": {
    color: t.semanticMode1.color.text.onLight.subtlestDisabled.value,
    borderBottom: `${t.primitive.border["2x"].value} solid ${t.semanticMode1.color.stroke.onLight.disabled.value}`,
    cursor: "not-allowed",
    "&:focus-visible": {
      outline: "none"
    }
  }
}, e1 = {
  textAlign: "center",
  fontStyle: "normal",
  cursor: "inherit",
  color: "inherit",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden"
}, t1 = {
  display: "flex",
  flexDirection: "column"
}, o1 = {
  ...t.semanticMode1.body1.regular.value
}, i1 = {
  Tabs: Zy,
  CarouselContent: Ky,
  TabList: Qy,
  Indicator: qy,
  Tab: Jy,
  Label: e1,
  TabPanels: t1,
  TabPanel: o1
}, r1 = {
  flex: 1,
  maxWidth: "100%"
}, a1 = {
  padding: e.semantic.borderWidth["2x"]
}, n1 = {
  scrollBehavior: "smooth",
  width: "fit-content",
  display: "inline-flex",
  position: "relative",
  isolation: "isolate",
  boxSizing: "border-box",
  fontFamily: e.primitive.typography.fontFamilies.inter,
  "--tabs-list-height": e.semantic.space["10x"],
  "--tabs-list-gap": e.semantic.space["5x"],
  height: "var(--tabs-list-height)",
  gap: "var(--tabs-list-gap)",
  "&--fullWidth": {
    width: "100%"
  },
  "&--small": {
    "--tabs-list-height": e.semantic.space["8x"],
    "--tabs-list-gap": e.semantic.space["4x"]
  },
  "&--medium": {
    "--tabs-list-height": e.semantic.space["10x"],
    "--tabs-list-gap": e.semantic.space["5x"]
  },
  "&--large": {
    "--tabs-list-height": e.semantic.space["12x"],
    "--tabs-list-gap": e.semantic.space["6x"]
  },
  "&--borderBottom": {
    borderBottom: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`
  }
}, l1 = {
  height: "var(--tabs-list-height, 0)",
  width: "var(--tabs-indicator-width, 0)",
  transform: "var(--tabs-indicator-position, translateX(0))",
  position: "absolute",
  transition: "none",
  boxSizing: "border-box",
  pointerEvents: "none",
  borderBottom: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`
}, s1 = {
  background: "transparent",
  display: "inline-flex",
  alignItems: "center",
  flexShrink: 0,
  boxSizing: "border-box",
  height: "100%",
  gap: e.semantic.space["2x"],
  cursor: "pointer",
  padding: 0,
  border: `${e.semantic.borderWidth["2x"]} solid transparent`,
  color: e.semantic.color.text.subtlest,
  borderRadius: e.semantic.radius["1x"],
  "&:focus-visible": {
    border: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    outline: "none"
  },
  "&--disabled": {
    color: e.semantic.color.text.disabled,
    cursor: "not-allowed",
    "&:focus-visible": {
      outline: "none"
    }
  },
  "&--active:not(&--disabled)": {
    color: e.semantic.color.text.default
  },
  "&--small": {
    ...e.semantic.typography.body.medium.S
  },
  "&--medium": {
    ...e.semantic.typography.body.medium.M
  },
  "&--large": {
    ...e.semantic.typography.body.medium.L
  },
  "&:hover:not(&--active):not(&--disabled)": {
    borderBottom: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.neutralSubtle}`
  }
}, c1 = {
  textAlign: "center",
  fontStyle: "normal",
  cursor: "inherit",
  color: "inherit"
}, d1 = {
  display: "flex",
  flexDirection: "column"
}, p1 = {
  fontFamily: e.primitive.typography.fontFamilies.inter,
  color: e.semantic.color.text.subtlest
}, m1 = {
  Tabs: r1,
  CarouselContent: a1,
  TabList: n1,
  Indicator: l1,
  Tab: s1,
  Label: c1,
  TabPanels: d1,
  TabPanel: p1
}, u1 = {
  flex: 0,
  "&--large": {
    padding: `0px ${t.primitive.space["3x"].value}`,
    ...t.semanticMode1.body1.regular.value
  },
  "&--medium": {
    padding: `0px ${t.primitive.space["2x"].value}`,
    ...t.semanticMode1.body2.regular.value
  },
  "&--small": {
    padding: `${t.primitive.space["0x"].value} ${t.primitive.space["1x"].value}`,
    ...t.semanticMode1.caption.regular.value
  },
  display: "inline-flex",
  alignItems: "center",
  whiteSpace: "nowrap",
  gap: t.primitive.space["1x"].value,
  background: t.primitive.color.neutral[200].value,
  margin: 0,
  borderRadius: t.primitive.radius["1x"].value,
  color: `${t.semanticMode1.color.text.onLight.moderateDefault.value} !important`,
  "&--default": {
    backgroundColor: t.semanticMode1.color.fill.onLight.subtle.value
  },
  "&--accent": {
    backgroundColor: t.semanticMode1.color.fill.onLight.subtle.value
  },
  "&--success": {
    backgroundColor: t.semanticMode1.color.fill.onLight.successSubtle.value
  },
  "&--caution": {
    backgroundColor: t.semanticMode1.color.fill.onLight.cautionSubtle.value
  },
  "&--danger": {
    backgroundColor: t.semanticMode1.color.fill.onLight.dangerSubtle.value
  }
}, g1 = {
  display: "inline-block",
  textAlign: "center"
}, x1 = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "svg,img": {
    width: t.primitive.space["4x"].value,
    height: t.primitive.space["4x"].value
  }
}, h1 = {
  "&--small": o({ closeBtnSize: "10px" }),
  "&--medium": o({ closeBtnSize: t.primitive.space["3x"].value }),
  "&--large": o({ closeBtnSize: t.primitive.space["4x"].value }),
  "&--info": o({
    closeBtnTextColor: t.semanticMode1.color.fill.onLight.strongest.value,
    closeBtnHoverTextColor: t.semanticMode1.color.fill.onLight.strong.value
  }),
  ...o({
    closeBtnFocusOutlineOffset: "0px",
    closeBtnBgColor: t.primitive.color.neutral["000"].value,
    closeBtnHoverBgColor: "transparent"
  })
}, b1 = {
  display: "flex",
  flexWrap: "wrap",
  gap: `${t.primitive.space["4x"].value} ${t.primitive.space["2x"].value}`
}, f1 = {
  ...t.semanticMode1.body2.regular.value,
  padding: `0 ${t.primitive.space["2x"].value}`,
  minHeight: "20px",
  border: "none",
  borderRadius: t.primitive.border["4x"].value,
  color: `${t.semanticMode1.color.text.onLight.moderateDefault.value} !important`,
  cursor: "pointer",
  "&:focus-visible": {
    outline: `2px solid ${t.semanticMode1.color.stroke.onLight.strongestFocus.value}`
  },
  "&--default": {
    backgroundColor: t.primitive.color.neutral[200].value
  },
  "&--accent": {
    backgroundColor: t.primitive.color.neutral[200].value
  },
  "&--success": {
    backgroundColor: t.primitive.color.green[100].value
  },
  "&--caution": {
    backgroundColor: t.primitive.color.amber[100].value
  },
  "&--danger": {
    backgroundColor: t.primitive.color.red[100].value
  },
  "&--small": {
    minHeight: t.primitive.space["4x"].value,
    padding: `${t.primitive.space["0x"].value} ${t.primitive.space["1x"].value}`,
    ...t.semanticMode1.caption.regular.value
  }
}, v1 = {
  Container: u1,
  TitleWrapper: g1,
  IconWrapper: x1,
  CloseIconWrapper: h1,
  TagGroupContainer: b1,
  OverflowButton: f1
}, y1 = {
  flex: 0,
  "&--medium, &--large": {
    height: e.semantic.space["6x"],
    padding: `${e.semantic.space["0x"]} ${e.semantic.space["2x"]}`,
    ...e.semantic.typography.body.regular.S
  },
  "&--small": {
    height: e.semantic.space["5x"],
    padding: `${e.semantic.space["0x"]} ${e.semantic.space["1x"]}`,
    ...e.semantic.typography.body.regular.XS
  },
  "&--stroke": {
    borderWidth: e.semantic.space[".25x"]
  },
  display: "inline-flex",
  width: "fit-content",
  alignItems: "center",
  whiteSpace: "nowrap",
  height: `${e.semantic.space["6x"]}`,
  padding: `${e.semantic.space["0x"]} ${e.semantic.space["2x"]}`,
  gap: e.semantic.space["1x"],
  margin: 0,
  borderRadius: e.semantic.radius["1x"],
  color: e.semantic.color.text.default,
  backgroundColor: e.semantic.color.fill.neutralSubtle,
  border: `solid ${e.semantic.space["0x"]} ${e.semantic.color.text.placeholder}`,
  boxSizing: "border-box",
  "&--accent": {
    color: e.semantic.color.text.primaryStrongest,
    backgroundColor: e.semantic.color.fill.primarySubtlest,
    borderColor: e.semantic.color.text.primaryStrongest
  },
  "&--success": {
    color: e.semantic.color.text.successStrongest,
    backgroundColor: e.semantic.color.fill.successSubtlest,
    borderColor: e.semantic.color.text.successStrongest
  },
  "&--caution": {
    color: e.semantic.color.text.cautionStrongest,
    backgroundColor: e.semantic.color.fill.cautionSubtlest,
    borderColor: e.semantic.color.text.cautionStrongest
  },
  "&--danger": {
    color: e.semantic.color.text.dangerStrongest,
    borderColor: e.semantic.color.text.dangerStrongest,
    backgroundColor: e.semantic.color.fill.dangerSubtlest
  }
}, C1 = {
  display: "inline-block"
}, $1 = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "svg,img": {
    width: e.semantic.space["4x"],
    height: e.semantic.space["4x"]
  }
}, w1 = {
  "&--info": o({
    closeBtnHoverBgColor: e.semantic.color.fill.primarySubtle,
    closeBtnHoverTextColor: e.semantic.color.text.primaryStrongest
  }),
  "&--success": o({
    closeBtnHoverTextColor: e.semantic.color.text.successStrongest,
    closeBtnHoverBgColor: e.semantic.color.fill.successSubtle
  }),
  "&--caution": o({
    closeBtnHoverTextColor: e.semantic.color.text.cautionStrongest,
    closeBtnHoverBgColor: e.semantic.color.fill.cautionSubtle
  }),
  "&--danger": o({
    closeBtnHoverTextColor: e.semantic.color.text.dangerStrongest,
    closeBtnHoverBgColor: e.semantic.color.fill.dangerSubtle
  })
}, k1 = {
  display: "flex",
  boxSizing: "border-box",
  flexWrap: "wrap",
  gap: `${e.semantic.space["4x"]} ${e.semantic.space["2x"]}`,
  "&:empty": {
    display: "none"
  }
}, S1 = {
  ...e.semantic.typography.body.regular.S,
  padding: `${e.semantic.space["0x"]} ${e.semantic.space["2x"]}`,
  height: e.semantic.space["6x"],
  borderRadius: e.semantic.radius["1x"],
  cursor: "pointer",
  color: e.semantic.color.text.default,
  backgroundColor: e.semantic.color.fill.neutralSubtle,
  border: `solid ${e.semantic.space["0x"]} ${e.semantic.color.text.placeholder}`,
  "&--stroke": {
    borderWidth: e.semantic.space[".25x"]
  },
  "&:focus-visible": {
    outline: `2px solid ${e.semantic.color.stroke.focus}`
  },
  "&--accent": {
    color: e.semantic.color.text.primaryStrongest,
    backgroundColor: e.semantic.color.fill.primarySubtlest,
    borderColor: e.semantic.color.text.primaryStrongest
  },
  "&--success": {
    color: e.semantic.color.text.successStrongest,
    backgroundColor: e.semantic.color.fill.successSubtlest,
    borderColor: e.semantic.color.text.successStrongest
  },
  "&--caution": {
    color: e.semantic.color.text.cautionStrongest,
    backgroundColor: e.semantic.color.fill.cautionSubtlest,
    borderColor: e.semantic.color.text.cautionStrongest
  },
  "&--danger": {
    color: e.semantic.color.text.dangerStrongest,
    borderColor: e.semantic.color.text.dangerStrongest,
    backgroundColor: e.semantic.color.fill.dangerSubtlest
  },
  "&--small": {
    ...e.semantic.typography.body.regular.XS,
    padding: `${e.semantic.space["0x"]} ${e.semantic.space["1x"]}`,
    height: e.semantic.space["5x"]
  }
}, B1 = {
  Container: y1,
  TitleWrapper: C1,
  IconWrapper: $1,
  CloseIconWrapper: w1,
  TagGroupContainer: k1,
  OverflowButton: S1
}, T1 = {
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: t.primitive.space["1x"].value,
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value
}, W1 = {
  label: {
    color: t.primitive.color.neutral[900].value,
    fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
    ".Label__required-asterisk": {
      display: "none"
    }
  },
  "&--disabled": {
    label: {
      color: t.primitive.color.neutral[600].value
    }
  }
}, L1 = {
  display: "flex",
  minHeight: t.primitive.lineHeights[7].value,
  alignItems: "flex-start",
  gap: t.primitive.space["2x"].value,
  alignSelf: "stretch",
  boxSizing: "border-box",
  position: "relative",
  width: "100%",
  minWidth: "250px",
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontWeight: 400,
  border: `1px solid ${t.primitive.color.neutral[600].value}`,
  borderRadius: t.primitive.radius["2x"].value,
  backgroundColor: t.primitive.color.twilight["000"].value,
  color: t.primitive.color.neutral[1200].value,
  letterSpacing: 0,
  lineHeight: t.primitive.lineHeights[11].value,
  fontSize: t.primitive.fontSize[2].value,
  outline: "none",
  "&::placeholder": {
    opacity: 1,
    color: t.primitive.color.twilight[600].value
  },
  "&:not(&--disabled):hover": {
    border: `1px solid ${t.primitive.color.neutral[1200].value}`
  },
  "&:not(&--disabled):focus-within": {
    border: `1px solid ${t.primitive.color.neutral[1200].value}`,
    outline: `1px solid ${t.primitive.color.neutral[1200].value}`,
    outlineOffset: `-${t.primitive.border["2x"].value}`
  },
  "&--invalid": {
    border: `1px solid ${t.primitive.color.red[1e3].value}`,
    "&:not(&--disabled):hover": {
      border: `1px solid ${t.primitive.color.red[1e3].value}`
    },
    "&:not(&--disabled):focus-within": {
      outline: `2px solid ${t.primitive.color.red[1e3].value}`
    }
  },
  "&--error": {
    border: `1px solid ${t.primitive.color.red[1e3].value}`,
    "&:not(&--disabled):hover": {
      border: `1px solid ${t.primitive.color.red[1e3].value}`
    },
    "&:not(&--disabled):focus-within": {
      outline: `2px solid ${t.primitive.color.red[1e3].value}`
    }
  },
  "&--success": {
    border: `1px solid ${t.primitive.color.green[1e3].value}`,
    "&:not(&--disabled):hover": {
      border: `1px solid ${t.primitive.color.green[1e3].value}`
    },
    "&:not(&--disabled):focus-within": {
      outline: `2px solid ${t.primitive.color.green[1e3].value}`
    }
  },
  "&--caution": {
    border: `1px solid ${t.primitive.color.amber[1e3].value}`,
    "&:not(&--disabled):hover": {
      border: `1px solid ${t.primitive.color.amber[1e3].value}`
    },
    "&:not(&--disabled):focus-within": {
      outline: `2px solid ${t.primitive.color.amber[1e3].value}`
    }
  },
  "&--disabled": {
    cursor: "not-allowed",
    backgroundColor: t.primitive.color.neutral[200].value,
    color: t.primitive.color.twilight["000"].value
  },
  "&--small, &--medium, &--large": {
    fontSize: t.primitive.fontSize[2].value,
    paddingBlock: t.primitive.space["2x"].value,
    paddingInline: t.primitive.space["4x"].value,
    lineHeight: t.primitive.lineHeights[11].value
  }
}, _1 = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  gap: t.primitive.space["2x"].value
}, it = {
  display: "flex",
  color: t.primitive.color.neutral[900].value,
  "&--invalid": {
    color: t.primitive.color.red[1e3].value
  },
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontSize: t.primitive.fontSize[0].value,
  letterSpacing: 0,
  lineHeight: t.primitive.lineHeights[13].value,
  webkitBoxVariant: "vertical",
  webkitLineClamp: "2",
  overflow: "hidden"
}, I1 = {
  ...it,
  whiteSpace: "nowrap",
  overflow: "visible"
}, M1 = {
  TextAreaWrapper: T1,
  Label: W1,
  TextArea: L1,
  HelperText: it,
  CharLimit: I1,
  Footer: _1
}, D1 = {
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: e.semantic.space["2x"],
  fontFamily: e.primitive.typography.fontFamilies.inter
}, H1 = {}, R1 = {
  display: "flex",
  minHeight: "120px",
  padding: `${e.semantic.space["1x"]} ${e.semantic.space["3x"]}`,
  alignItems: "flex-start",
  gap: e.semantic.space["2x"],
  alignSelf: "stretch",
  boxSizing: "border-box",
  position: "relative",
  width: "100%",
  minWidth: "250px",
  border: `1px solid ${e.semantic.color.stroke.default}`,
  borderRadius: e.semantic.radius["2x"],
  backgroundColor: e.semantic.color.fill.default,
  color: e.semantic.color.text.default,
  letterSpacing: 0,
  "&::placeholder": {
    opacity: 1,
    color: e.semantic.color.text.placeholder
  },
  "&:not(&--disabled):hover": {
    border: `1px solid ${e.semantic.color.stroke.focus}`
  },
  "&:focus-within": {
    outline: `1px solid ${e.semantic.color.stroke.focus}`,
    border: `1px solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: `-${e.semantic.borderWidth["2x"]}`
  },
  "&--invalid": {
    border: `1px solid ${e.semantic.color.stroke.danger}`,
    "&:not(&--disabled):hover": {
      border: `1px solid ${e.semantic.color.stroke.danger}`
    },
    "&:focus-within": {
      outline: `1px solid ${e.semantic.color.stroke.danger}`,
      border: `1px solid ${e.semantic.color.stroke.danger}`
    }
  },
  "&--caution": {
    border: `1px solid ${e.semantic.color.stroke.caution}`,
    "&:not(&--disabled):hover": {
      border: `1px solid ${e.semantic.color.stroke.caution}`
    },
    "&:focus-within": {
      outline: `1px solid ${e.semantic.color.stroke.caution}`,
      border: `1px solid ${e.semantic.color.stroke.caution}`
    }
  },
  "&--success": {
    border: `1px solid ${e.semantic.color.stroke.success}`,
    "&:not(&--disabled):hover": {
      border: `1px solid ${e.semantic.color.stroke.success}`
    },
    "&:focus-within": {
      outline: `1px solid ${e.semantic.color.stroke.success}`,
      border: `1px solid ${e.semantic.color.stroke.success}`
    }
  },
  "&--disabled": {
    cursor: "not-allowed",
    backgroundColor: e.semantic.color.fill.neutralSubtle,
    border: `1px solid ${e.semantic.color.stroke.disabled}`,
    color: e.semantic.color.text.placeholder
  },
  "&--small": {
    ...e.semantic.typography.body.regular.S,
    paddingLeft: e.semantic.space["2x"],
    paddingRight: e.semantic.space["3x"]
  },
  "&--medium": {
    ...e.semantic.typography.body.regular.M,
    paddingLeft: e.semantic.space["3x"],
    paddingRight: e.semantic.space["3x"]
  },
  "&--large": {
    ...e.semantic.typography.body.regular.L,
    paddingLeft: e.semantic.space["3x"],
    paddingRight: e.semantic.space["3x"]
  }
}, z1 = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  gap: e.semantic.space["2x"]
}, rt = {
  display: "flex",
  color: e.semantic.color.text.placeholder,
  "&--invalid": {
    color: e.semantic.color.text.subtlest
  },
  ...e.semantic.typography.body.regular.S,
  letterSpacing: 0,
  marginTop: e.semantic.space["2x"],
  webkitBoxVariant: "vertical",
  webkitLineClamp: "2",
  overflow: "hidden"
}, A1 = {
  ...rt,
  whiteSpace: "nowrap",
  overflow: "visible"
}, F1 = {
  TextAreaWrapper: D1,
  Label: H1,
  TextArea: R1,
  HelperText: rt,
  CharLimit: A1,
  Footer: z1
}, P1 = {
  display: "flex",
  flexDirection: "column",
  gap: t.primitive.space["5x"].value
}, O1 = {
  display: "flex",
  flexDirection: "column",
  gap: t.primitive.space["5x"].value
}, E1 = {
  ...t.semanticMode1.body1.bold.value,
  color: "#666666",
  margin: "0"
}, V1 = {
  display: "flex",
  gap: t.primitive.space["2x"].value,
  "&:focus-visible": {
    outline: `2px solid ${t.primitive.color.skyView[900].value}`,
    borderRadius: t.primitive.radius["1x"].value,
    outlineOffset: "2px"
  }
}, G1 = {
  ...t.semanticMode1.caption.regular.value
}, j1 = {
  display: "flex",
  flexDirection: "column",
  gap: t.primitive.space["1x"].value,
  ...t.semanticMode1.caption.regular.value,
  color: "#666666"
}, U1 = {
  ...t.semanticMode1.caption.regular.value,
  color: "#666666",
  "&:focus-visible": {
    outline: `2px solid ${t.primitive.color.skyView[900].value}`,
    borderRadius: t.primitive.radius["1x"].value,
    outlineOffset: "2px"
  }
}, X1 = {
  TextDisclosureWrapper: P1,
  TextDisclosureItems: O1,
  TextDisclosureTitle: E1,
  TextDisclosureContentWrapper: V1,
  TextDisclosureBullet: G1,
  TextDisclosureContentContainer: j1,
  GlobalDisclosureWrapper: U1
}, N1 = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["6x"],
  "a:not(.Button, .Button, .Link--disclosure)": {
    textDecoration: "underline !important",
    textDecorationColor: `${e.semantic.color.link.default} !important`,
    textUnderlineOffset: "5px !important",
    fontSize: "inherit"
  }
}, Y1 = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["2x"]
}, Z1 = {
  ...e.semantic.typography.headline.S,
  color: e.semantic.color.text.subtle,
  margin: "0"
}, K1 = {
  display: "flex",
  gap: e.semantic.space["2x"],
  "&:focus-visible": {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    borderRadius: e.semantic.radius["1x"],
    outlineOffset: "2px"
  }
}, Q1 = {
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.XS
}, q1 = {
  display: "flex",
  flexDirection: "column",
  gap: e.semantic.space["1x"],
  ...e.semantic.typography.body.regular.XS,
  color: e.semantic.color.text.subtlest
}, J1 = {
  ...e.semantic.typography.body.regular.XS,
  color: "#666666",
  "&:focus-visible": {
    outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
    borderRadius: e.semantic.radius["1x"],
    outlineOffset: "2px"
  }
}, eC = {
  TextDisclosureWrapper: N1,
  TextDisclosureItems: Y1,
  TextDisclosureTitle: Z1,
  TextDisclosureContentWrapper: K1,
  TextDisclosureBullet: Q1,
  TextDisclosureContentContainer: q1,
  GlobalDisclosureWrapper: J1
}, tC = {
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: t.primitive.space["1x"].value,
  boxSizing: "border-box"
}, oC = {
  display: "flex",
  boxSizing: "border-box",
  padding: `${t.primitive.space["2x"].value} ${t.primitive.space["4x"].value}`,
  alignItems: "center",
  gap: t.primitive.space["2x"].value,
  alignSelf: "stretch",
  borderRadius: t.primitive.radius["2x"].value,
  backgroundColor: t.primitive.color.twilight["000"].value,
  border: `1px solid ${t.primitive.color.neutral[600].value}`,
  "&:not(&--disabled):hover": {
    border: `1px solid ${t.primitive.color.neutral[1200].value}`
  },
  "&:not(&--disabled):focus-within": {
    outline: `1px solid ${t.primitive.color.neutral[1200].value}`,
    border: `1px solid ${t.primitive.color.neutral[1200].value}`,
    outlineOffset: "-2px"
  },
  "&--error:not(&--disabled)": {
    border: `1px solid ${t.primitive.color.red[1e3].value}`,
    "&:hover": {
      border: `1px solid ${t.primitive.color.red[1e3].value}`
    },
    "&:focus-within": {
      outline: `2px solid ${t.primitive.color.red[1e3].value}`
    }
  },
  "&--caution:not(&--disabled)": {
    border: `1px solid ${t.primitive.color.amber[1e3].value}`,
    "&:hover": {
      border: `1px solid ${t.primitive.color.amber[1e3].value}`
    },
    "&:focus-within": {
      outline: `2px solid ${t.primitive.color.amber[1e3].value}`
    }
  },
  "&--success:not(&--disabled)": {
    border: `1px solid ${t.primitive.color.green[1e3].value}`,
    "&:hover": {
      border: `1px solid ${t.primitive.color.green[1e3].value}`
    },
    "&:focus-within": {
      outline: `2px solid ${t.primitive.color.green[1e3].value}`
    }
  },
  "&--disabled": {
    backgroundColor: t.primitive.color.neutral[200].value
  },
  "&--small, &--medium, &--large": {
    height: t.primitive.space["7x"].value,
    "--svg-wrapper-width": t.primitive.space["5x"].value,
    "--svg-wrapper-height": t.primitive.space["5x"].value,
    input: {
      fontSize: t.primitive.fontSize[2].value,
      lineHeight: t.primitive.lineHeights[11].value
    },
    span: {
      fontSize: t.primitive.fontSize[2].value
    }
  }
}, iC = {
  flex: "1 0 0",
  width: "100%",
  padding: "0",
  background: "var(--opacity-dark-00, rgba(255, 255, 255, 0))",
  borderStyle: "none",
  outlineStyle: "none",
  color: t.primitive.color.neutral[1200].value,
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  fontSize: t.primitive.fontSize[2].value,
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: t.primitive.lineHeights[11].value,
  "&:disabled": {
    color: t.primitive.color.neutral[600].value
  },
  "&::placeholder": {
    color: t.primitive.color.neutral[600].value,
    fontWeight: 400
  }
}, rC = {
  width: "var(--svg-wrapper-width-global, var(--svg-wrapper-width))",
  height: "auto",
  display: "flex",
  color: t.primitive.color.twilight[600].value,
  "svg, img": {
    width: "var(--svg-wrapper-width-global, var(--svg-wrapper-width))",
    height: "var(--svg-wrapper-height-global, var(--svg-wrapper-height))"
  },
  "&--start": {
    marginRight: "var(--icon-margin)"
  },
  "&--end": {
    marginLeft: "var(--icon-margin)"
  }
}, aC = {
  TextInputWrapper: tC,
  InputContainer: oC,
  BaseTextInput: iC,
  AdornmentWrapper: rC
}, nC = {
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: e.semantic.space["2x"],
  boxSizing: "border-box"
}, lC = {
  display: "flex",
  boxSizing: "border-box",
  padding: `${e.semantic.space["1x"]} ${e.semantic.space["3x"]}`,
  alignItems: "center",
  gap: e.semantic.space["2x"],
  alignSelf: "stretch",
  borderRadius: e.semantic.radius["2x"],
  backgroundColor: e.semantic.color.fill.default,
  border: `1px solid ${e.semantic.color.stroke.default}`,
  "&:not(&--disabled):hover": {
    border: `1px solid ${e.semantic.color.stroke.focus}`
  },
  "&:not(&--disabled):focus-within": {
    outline: `1px solid ${e.semantic.color.stroke.focus}`,
    border: `1px solid ${e.semantic.color.stroke.focus}`,
    outlineOffset: "-2px"
  },
  "&--error:not(&--disabled)": {
    border: `1px solid ${e.semantic.color.stroke.danger}`,
    "&:hover": {
      border: `1px solid ${e.semantic.color.stroke.danger}`
    },
    "&:focus-within": {
      outline: `2px solid ${e.semantic.color.stroke.danger}`
    }
  },
  "&--caution:not(&--disabled)": {
    border: `1px solid ${e.semantic.color.stroke.caution}`,
    "&:hover": {
      border: `1px solid ${e.semantic.color.stroke.caution}`
    },
    "&:focus-within": {
      outline: `2px solid ${e.semantic.color.stroke.caution}`
    }
  },
  "&--success:not(&--disabled)": {
    border: `1px solid ${e.semantic.color.stroke.success}`,
    "&:hover": {
      border: `1px solid ${e.semantic.color.stroke.success}`
    },
    "&:focus-within": {
      outline: `2px solid ${e.semantic.color.stroke.success}`
    }
  },
  "&--disabled": {
    backgroundColor: e.semantic.color.fill.disabled
  },
  input: {
    fontWeight: e.primitive.typography.fontWeights.inter.regular,
    "&::placeholder": {
      color: e.semantic.color.text.placeholder,
      fontWeight: e.primitive.typography.fontWeights.inter.regular
    }
  },
  "&--small": {
    height: e.semantic.space["8x"],
    "--svg-wrapper-width": e.semantic.space["5x"],
    "--svg-wrapper-height": e.semantic.space["5x"],
    input: {
      ...e.semantic.typography.body.regular.S
    },
    span: {
      fontSize: e.primitive.typography.fontSize[350]
    }
  },
  "&--medium": {
    height: e.semantic.space["10x"],
    "--svg-wrapper-width": e.semantic.space["6x"],
    "--svg-wrapper-height": e.semantic.space["6x"],
    input: {
      ...e.semantic.typography.body.regular.M
    },
    span: {
      fontSize: e.primitive.typography.fontSize[400]
    }
  },
  "&--large": {
    height: e.semantic.space["12x"],
    "--svg-wrapper-width": e.semantic.space["6x"],
    "--svg-wrapper-height": e.semantic.space["6x"],
    input: {
      ...e.semantic.typography.body.regular.L
    },
    span: {
      fontSize: e.primitive.typography.fontSize[450]
      //18px
    }
  }
}, sC = {
  height: e.semantic.space["6x"],
  width: "100%",
  flex: "1 0 0",
  padding: "0",
  background: "var(--opacity-dark-00, rgba(255, 255, 255, 0))",
  borderStyle: "none",
  outlineStyle: "none",
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.regular.S,
  fontStyle: "normal",
  "&:disabled": {
    color: e.semantic.color.text.onDisabledStrong
  },
  "&::placeholder": {
    color: e.semantic.color.text.placeholder,
    fontWeight: e.primitive.typography.fontWeights.inter.semiBold
  }
}, cC = {
  width: "var(--svg-wrapper-width-global, var(--svg-wrapper-width))",
  height: "var(--svg-wrapper-height-global, var(--svg-wrapper-height))",
  display: "flex",
  color: e.semantic.color.text.placeholder,
  "&--disabled": {
    pointerEvents: "none"
  },
  "svg, img": {
    width: "var(--svg-wrapper-width-global, var(--svg-wrapper-width))",
    height: "var(--svg-wrapper-height-global, var(--svg-wrapper-height))"
  },
  "&--start": {
    marginRight: "var(--icon-margin)"
  },
  "&--end": {
    marginLeft: "var(--icon-margin)"
  }
}, dC = {
  TextInputWrapper: nC,
  InputContainer: lC,
  BaseTextInput: sC,
  AdornmentWrapper: cC
}, pC = {
  display: "flex",
  width: "100%",
  padding: "0px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: e.semantic.space["2x"],
  filter: "unset",
  opacity: "unset",
  pointerEvents: "auto",
  svg: {
    color: {
      disabled: e.semantic.color.icon.disabled,
      default: e.semantic.color.icon.default
    }
  },
  input: {
    disabledPlaceholder: {
      color: e.semantic.color.text.onDisabledStrong
    }
  }
}, mC = {
  display: "flex",
  height: e.semantic.space["6x"],
  width: e.semantic.space["6x"],
  padding: e.semantic.space["1x"],
  justifyContent: "center",
  alignItems: "center",
  gap: "0px",
  color: e.semantic.color.icon.neutralStrong,
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer",
  borderRadius: e.semantic.radius["2x"],
  disabled: {
    cursor: "auto"
  },
  svg: {
    height: e.semantic.space["4x"],
    width: e.semantic.space["4x"]
  }
}, uC = {
  display: "flex",
  alignItems: "center",
  gap: e.semantic.space["2x"],
  marginLeft: e.semantic.space["8x"]
}, gC = {
  display: "flex",
  ...e.semantic.typography.body.regular.S,
  color: e.semantic.color.text.dangerStrong
}, xC = {
  display: "flex",
  ...e.semantic.typography.body.regular.S,
  color: e.semantic.color.text.placeholder
}, hC = {
  icons: {
    defaultColor: {
      clockIcon: e.semantic.color.icon.default,
      caretUp: e.semantic.color.icon.default,
      caretDown: e.semantic.color.icon.default
    },
    disableColor: {
      clockIcon: e.semantic.color.icon.disabled,
      caretUp: e.semantic.color.icon.disabled,
      caretDown: e.semantic.color.icon.disabled
    }
  }
}, at = {
  Wrapper: pC,
  ClearButton: mC,
  ErrorMessage: gC,
  HelperText: xC,
  IconWrapper: uC,
  InlineStyles: hC
}, bC = at, nt = 5, n = {
  AUTO: "auto",
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
  TOP_START: "top-start",
  TOP_END: "top-end",
  BOTTOM_START: "bottom-start",
  BOTTOM_END: "bottom-end",
  RIGHT_START: "right-start",
  RIGHT_END: "right-end",
  LEFT_START: "left-start",
  LEFT_END: "left-end"
}, fC = {
  position: "relative",
  display: "inline-flex",
  cursor: "pointer"
}, vC = {
  "--border-size": t.primitive.border["1x"].value,
  "--border-color": t.primitive.color.twilight[600].value,
  "--background-color": t.primitive.color.twilight["000"].value,
  "--pointer-gap": `calc(${nt}px + 1rem)`,
  zIndex: 1,
  position: "absolute",
  transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
  border: `${t.primitive.border["1x"].value} solid var(--border-color)`,
  borderRadius: t.primitive.radius["1x"].value,
  opacity: 0,
  "&--open": {
    opacity: 1
  },
  "&--exceed": {
    position: "fixed"
  },
  [`&--${n.AUTO},&--${n.TOP}`]: {
    left: "50%",
    bottom: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-50%)"
    }
  },
  [`&--${n.TOP_START}`]: {
    left: "50%",
    bottom: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-95%)"
    }
  },
  [`&--${n.TOP_END}`]: {
    left: "50%",
    bottom: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-5%)"
    }
  },
  [`&--${n.BOTTOM}`]: {
    left: "50%",
    top: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-50%)"
    }
  },
  [`&--${n.BOTTOM_START}`]: {
    left: "50%",
    top: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-95%)"
    }
  },
  [`&--${n.BOTTOM_END}`]: {
    left: "50%",
    top: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-5%)"
    }
  },
  [`&--${n.LEFT}`]: {
    top: "50%",
    right: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(0,-50%)"
    }
  },
  [`&--${n.LEFT_START}`]: {
    top: "50%",
    right: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(0, -80%)"
    }
  },
  [`&--${n.LEFT_END}`]: {
    top: "50%",
    right: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(0, -20%)"
    }
  },
  [`&--${n.RIGHT}`]: {
    top: "50%",
    left: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(0, -50%)"
    }
  },
  [`&--${n.RIGHT_START}`]: {
    top: "50%",
    left: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-8px, -80%)"
    }
  },
  [`&--${n.RIGHT_END}`]: {
    top: "50%",
    left: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(0, -20%)"
    }
  }
}, yC = {
  zIndex: 1,
  maxWidth: "250px",
  backgroundColor: t.primitive.color.twilight["000"].value,
  color: t.primitive.color.twilight[900].value,
  position: "relative",
  transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
  width: "100%",
  whiteSpace: "nowrap",
  padding: `${t.primitive.space["2x"].value}`,
  borderRadius: t.primitive.radius["1x"].value,
  boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.06)",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontFamily: t.primitive.fontFamilies.fordF1Regular.value,
  boxSizing: "border-box",
  letterSpacing: 0,
  textAlign: "center",
  fontSize: t.primitive.fontSize[1].value,
  fontWeight: 400,
  lineHeight: t.primitive.lineHeights[12].value
}, CC = {
  zIndex: 0,
  position: "absolute",
  transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
  border: `${t.primitive.border["1x"].value} solid var(--border-color)`,
  display: "inline-block",
  width: `${nt + 2}px`,
  aspectRatio: "1/1",
  translate: "-50% -50%",
  background: t.primitive.color.neutral["000"].value,
  rotate: "45deg",
  [`&--${n.AUTO},&--${n.TOP}`]: {
    top: "100%",
    left: "50%",
    transform: "translateY(calc(var(--border-size) * 0))"
  },
  [`&--${n.TOP_START}`]: {
    top: "100%",
    left: "90%",
    transform: "translateY(calc(var(--border-size) * -1))"
  },
  [`&--${n.TOP_END}`]: {
    top: "100%",
    left: "10%",
    transform: "translateY(calc(var(--border-size) * -1))"
  },
  [`&--${n.BOTTOM}`]: {
    bottom: "100%",
    left: "50%",
    transform: "rotate(180deg) translateY(calc(var(--border-size) * 0))",
    translate: "-50% 50%"
  },
  [`&--${n.BOTTOM_START}`]: {
    bottom: "100%",
    left: "90%",
    transform: "rotate(180deg) translateY(calc(var(--border-size) * -1))",
    translate: "-50% 50%"
  },
  [`&--${n.BOTTOM_END}`]: {
    bottom: "100%",
    left: "10%",
    transform: "rotate(180deg) translateY(calc(var(--border-size) * -1))",
    translate: "-50% 50%"
  },
  [`&--${n.LEFT}`]: {
    left: "100%",
    top: "50%",
    transform: "rotate(270deg) translateY(calc(var(--border-size) * 0))"
  },
  [`&--${n.LEFT_START}`]: {
    left: "100%",
    top: "75%",
    transform: "rotate(270deg) translateY(calc(var(--border-size) * -1))"
  },
  [`&--${n.LEFT_END}`]: {
    left: "100%",
    top: "25%",
    transform: "rotate(270deg) translateY(calc(var(--border-size) * -1))"
  },
  [`&--${n.RIGHT}`]: {
    right: "100%",
    top: "50%",
    transform: "rotate(90deg) translateY(calc(var(--border-size) * -1))",
    translate: "50% -50%"
  },
  [`&--${n.RIGHT_START}`]: {
    right: "100%",
    top: "75%",
    transform: "rotate(90deg) translateY(calc(var(--border-size) * 0))",
    translate: "50% -50%"
  },
  [`&--${n.RIGHT_END}`]: {
    right: "100%",
    top: "25%",
    transform: "rotate(90deg) translateY(calc(var(--border-size) * 0))",
    translate: "50% -50%"
  }
}, $C = {
  Tooltip: fC,
  ContentWrapper: vC,
  Content: yC,
  Pointer: CC
}, lt = 5, l = {
  AUTO: "auto",
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
  TOP_START: "top-start",
  TOP_END: "top-end",
  BOTTOM_START: "bottom-start",
  BOTTOM_END: "bottom-end",
  RIGHT_START: "right-start",
  RIGHT_END: "right-end",
  LEFT_START: "left-start",
  LEFT_END: "left-end"
}, wC = {
  position: "relative",
  display: "inline-flex",
  cursor: "pointer"
}, kC = {
  "--border-color": e.semantic.color.stroke.neutralStrong,
  "--border-size": e.semantic.borderWidth["1x"],
  "--background-color": "inherit",
  "--pointer-gap": `calc(${lt}px + .5rem)`,
  zIndex: 1,
  position: "absolute",
  transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
  border: `${e.semantic.borderWidth["1x"]} solid var(--border-color)`,
  borderRadius: e.semantic.radius["1x"],
  opacity: 0,
  "&--open": {
    opacity: 1
  },
  "&--exceed": {
    position: "fixed"
  },
  [`&--${l.AUTO}, &--${l.TOP}`]: {
    left: "50%",
    bottom: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-50%)"
    }
  },
  [`&--${l.TOP_START}`]: {
    left: "50%",
    bottom: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-95%)"
    }
  },
  [`&--${l.TOP_END}`]: {
    left: "50%",
    bottom: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-5%)"
    }
  },
  [`&--${l.BOTTOM}`]: {
    left: "50%",
    top: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-50%)"
    }
  },
  [`&--${l.BOTTOM_START}`]: {
    left: "50%",
    top: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-95%)"
    }
  },
  [`&--${l.BOTTOM_END}`]: {
    left: "50%",
    top: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-5%)"
    }
  },
  [`&--${l.LEFT}`]: {
    top: "50%",
    right: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(0,-50%)"
    }
  },
  [`&--${l.LEFT_START}`]: {
    top: "50%",
    right: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(0, -80%)"
    }
  },
  [`&--${l.LEFT_END}`]: {
    top: "50%",
    right: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(0, -20%)"
    }
  },
  [`&--${l.RIGHT}`]: {
    top: "50%",
    left: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(0, -50%)"
    }
  },
  [`&--${l.RIGHT_START}`]: {
    top: "50%",
    left: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(-2px, -80%)"
    }
  },
  [`&--${l.RIGHT_END}`]: {
    top: "50%",
    left: "calc(100% + var(--pointer-gap))",
    "&-open": {
      transform: "translate(0, -20%)"
    }
  }
}, SC = {
  zIndex: 1,
  maxWidth: "250px",
  backgroundColor: e.semantic.color.fill.default,
  color: e.semantic.color.text.default,
  position: "relative",
  transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
  width: "100%",
  whiteSpace: "nowrap",
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["3x"]}`,
  borderRadius: e.semantic.radius["1x"],
  boxShadow: `0  ${e.semantic.space["1x"]}  ${e.semantic.space["2x"]} 0 rgba(0, 0, 0, 0.06)`,
  overflow: "hidden",
  textOverflow: "ellipsis",
  boxSizing: "border-box",
  letterSpacing: 0,
  textAlign: "center",
  ...e.semantic.typography.body.regular.S
}, BC = {
  zIndex: 0,
  position: "absolute",
  transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
  border: `${e.semantic.borderWidth["1x"]} solid var(--border-color)`,
  display: "inline-block",
  width: `${lt + 3}px`,
  aspectRatio: "1/1",
  translate: "-50% -50%",
  background: e.semantic.color.fill.default,
  rotate: "45deg",
  [`&--${l.AUTO}, &--${l.TOP}`]: {
    top: "100%",
    left: "50%",
    transform: "translateY(calc(var(--border-size) * 0))",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.TOP_START}`]: {
    top: "100%",
    left: "90%",
    transform: "translateY(calc(var(--border-size) * -1))",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.TOP_END}`]: {
    top: "100%",
    left: "10%",
    transform: "translateY(calc(var(--border-size) * -1))",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.BOTTOM}`]: {
    bottom: "100%",
    left: "50%",
    transform: "rotate(180deg) translateY(calc(var(--border-size) * 0))",
    translate: "-50% 50%",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.BOTTOM_START}`]: {
    bottom: "100%",
    left: "90%",
    transform: "rotate(180deg) translateY(calc(var(--border-size) * -1))",
    translate: "-50% 50%",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.BOTTOM_END}`]: {
    bottom: "100%",
    left: "10%",
    transform: "rotate(180deg) translateY(calc(var(--border-size) * -1))",
    translate: "-50% 50%",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.LEFT}`]: {
    left: "100%",
    top: "50%",
    transform: "rotate(270deg) translateY(calc(var(--border-size) * 0))",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.LEFT_START}`]: {
    left: "100%",
    top: "75%",
    transform: "rotate(270deg) translateY(calc(var(--border-size) * -1))",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.LEFT_END}`]: {
    left: "100%",
    top: "25%",
    transform: "rotate(270deg) translateY(calc(var(--border-size) * -1))",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.RIGHT}`]: {
    right: "100%",
    top: "50%",
    transform: "rotate(90deg) translateY(calc(var(--border-size) * -1))",
    translate: "50% -50%",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.RIGHT_START}`]: {
    right: "100%",
    top: "75%",
    transform: "rotate(90deg) translateY(calc(var(--border-size) * 0))",
    translate: "50% -50%",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  },
  [`&--${l.RIGHT_END}`]: {
    right: "100%",
    top: "25%",
    transform: "rotate(90deg) translateY(calc(var(--border-size) * 0))",
    translate: "50% -50%",
    borderRadius: `${e.semantic.borderWidth["2x"]} 0`
  }
}, TC = {
  Tooltip: wC,
  ContentWrapper: kC,
  Content: SC,
  Pointer: BC
}, WC = {
  containerType: "inline-size",
  display: "flex",
  flex: "1",
  flexDirection: "column",
  padding: "12px 20px",
  overflow: "hidden",
  position: "relative",
  "&--primary": {
    backgroundColor: t.semanticMode1.color.fill.onLight.interactive.value
  },
  "&--neutral": {
    backgroundColor: t.semanticMode1.color.fill.onLight.brandStrongestTwilight.value
  },
  "&--warning": {
    backgroundColor: t.semanticMode1.color.fill.onLight.cautionStrong.value
  },
  "&--error": {
    backgroundColor: t.semanticMode1.color.fill.onLight.dangerStrong.value
  }
}, LC = {
  display: "flex",
  boxSizing: "border-box",
  minHeight: t.semanticMode1.lineHeights[0].value,
  //32px
  paddingBlock: t.semanticMode1.space.xs.value,
  [`@container ${i.tabletAndUp}`]: {
    paddingLeft: "62px",
    paddingRight: "62px"
  },
  [`@container ${i.laptopAndUp}`]: {
    paddingLeft: "100px",
    paddingRight: "100px"
  },
  [`@container ${i.desktopAndUp}`]: {
    paddingLeft: "240px",
    paddingRight: "240px"
  }
}, _C = {
  display: "flex",
  width: t.semanticMode1.lineHeights[11].value,
  //20px
  height: t.semanticMode1.lineHeights[11].value,
  //20px
  flexShrink: "0",
  color: t.semanticMode1.color.text.onDark.strong.value,
  marginRight: t.primitive.space["5x"].value
  //24px
}, IC = {
  flex: 1,
  ...t.semanticMode1.body2.medium.value,
  color: t.semanticMode1.color.text.onDark.strong.value,
  wordBreak: "break-word"
}, MC = {
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: t.primitive.space["1x"].value,
  //4px,
  height: t.primitive.space["6x"].value,
  //32px
  width: t.primitive.space["6x"].value,
  backgroundColor: "transparent",
  marginLeft: t.primitive.space["2x"].value,
  //8px
  marginBlock: "-4px",
  "&:hover": {
    backgroundColor: "transparent"
  }
}, DC = {
  textAlign: "left",
  overflow: "hidden",
  wordBreak: "break-word",
  display: "flex",
  margin: 0,
  ...t.semanticMode1.body2.medium.value,
  color: t.semanticMode1.color.text.onDark.strong.value,
  ".ShowMoreLessWrapper .Button": {
    ...t.semanticMode1.body2.medium.value,
    color: t.semanticMode1.color.text.onDark.strong.value,
    height: "auto",
    opacity: "0.5",
    border: "0",
    svg: {
      color: "inherit"
    }
  },
  ".ShowMoreLessWrapper .Button:hover": {
    opacity: "1"
  },
  ".Text, .Text b, .Text strong, b, strong": {
    font: "inherit",
    color: "inherit",
    margin: 0
  },
  "*:is(h1, h2, h3, h4, h5, h6, p, a, span)": {
    font: "inherit",
    color: t.semanticMode1.color.text.onDark.strong.value,
    margin: 0
  },
  "a, a.Link, a.Button, a.Button": {
    color: t.semanticMode1.color.text.onDark.strong.value,
    textDecorationColor: t.semanticMode1.color.text.onDark.strong.value,
    svg: {
      color: "inherit"
    },
    opacity: "0.5",
    transition: "0.1s opacity linear",
    "&:hover": {
      opacity: 1
    }
  }
}, HC = {
  Container: WC,
  TopBanner: LC,
  NotifyIcon: _C,
  Content: IC,
  CloseButton: MC,
  Body: DC
}, RC = {
  containerType: "inline-size",
  display: "flex",
  flex: "1",
  flexDirection: "column",
  padding: "12px 20px",
  overflow: "hidden",
  position: "relative",
  "&--primary": {
    backgroundColor: e.semantic.color.fill.primaryStrong
  },
  "&--neutral": {
    backgroundColor: e.semantic.color.fill.neutralStrong
  },
  "&--warning": {
    backgroundColor: e.semantic.color.fill.cautionStrong
  },
  "&--error": {
    backgroundColor: e.semantic.color.fill.dangerStrong
  }
}, zC = {
  display: "flex",
  boxSizing: "border-box",
  minHeight: e.semantic.space["8x"],
  paddingBlock: e.semantic.space["1x"],
  [`@container ${i.tabletAndUp}`]: {
    paddingLeft: "62px",
    paddingRight: "62px"
  },
  [`@container ${i.laptopAndUp}`]: {
    paddingLeft: "100px",
    paddingRight: "100px"
  },
  [`@container ${i.desktopAndUp}`]: {
    paddingLeft: "240px",
    paddingRight: "240px"
  }
}, AC = {
  display: "flex",
  width: e.semantic.space["5x"],
  height: e.semantic.space["5x"],
  flexShrink: "0",
  color: e.semantic.color.text.onColor,
  marginRight: e.semantic.space["6x"]
}, FC = {
  flex: 1,
  ...e.semantic.typography.body.medium.S,
  color: e.semantic.color.text.onColor,
  wordBreak: "break-word",
  "& .ShowMoreLessContainer": {
    color: e.semantic.color.text.onColor
  }
}, PC = {
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: e.semantic.space["1x"],
  height: e.semantic.space["8x"],
  width: e.semantic.space["8x"],
  marginLeft: e.semantic.space["2x"],
  marginBlock: "-4px",
  "&:hover": {
    backgroundColor: "transparent"
  }
}, OC = {
  textAlign: "left",
  overflow: "clip",
  overflowClipMargin: "4px",
  wordBreak: "break-word",
  display: "flex",
  margin: 0,
  fontSize: e.primitive.typography.fontSize[350],
  color: e.semantic.color.text.onColor,
  ".ShowMoreLessWrapper .Button": {
    textDecoration: `underline ${e.semantic.space[".25x"]} solid ${e.semantic.color.text.onColor}`,
    font: "inherit",
    color: e.semantic.color.text.onColor,
    svg: {
      color: e.semantic.color.text.onColor
    },
    "&:hover": {
      textDecorationThickness: `${e.semantic.space[".5x"]}`,
      transition: "text-decoration-thickness 0.1s linear"
    }
  },
  ".Text, .Text b, .Text strong": {
    ...e.semantic.typography.body.medium.S,
    color: "inherit",
    margin: 0
  },
  "*:is(h1, h2, h3, h4, h5, h6, p, a, span)": {
    fontSize: "inherit",
    whiteSpace: "pre-wrap",
    margin: 0
  },
  a: {
    color: e.semantic.color.text.onColor,
    textDecoration: `underline ${e.semantic.space[".25x"]} solid ${e.semantic.color.text.onColor}`,
    focus: {
      outlineOffset: "0.5px",
      outlineColor: e.semantic.color.stroke.onColor,
      outlineStyle: "solid",
      outlineWidth: "1px",
      borderRadius: e.semantic.radius["1x"],
      textDecoration: "none"
    },
    "&:hover": {
      textDecorationThickness: `${e.semantic.space[".5x"]}`,
      transition: "text-decoration-thickness 0.1s linear"
    }
  },
  "& .Link": {
    textDecoration: `underline ${e.semantic.space[".25x"]} solid ${e.semantic.color.text.onColor}`
  },
  strong: {
    color: "inherit",
    fontWeight: e.primitive.typography.fontWeights.inter.semiBold
  },
  b: {
    color: "inherit",
    fontWeight: e.primitive.typography.fontWeights.inter.semiBold
  }
}, EC = {
  Container: RC,
  TopBanner: zC,
  NotifyIcon: AC,
  Content: FC,
  CloseButton: PC,
  Body: OC
}, VC = {
  "--thumbSize": e.semantic.space["3x"],
  "--volumeBarWidth": e.semantic.space["14x"],
  display: "flex",
  position: "relative",
  maxWidth: "fit-content",
  maxHeight: "fit-content",
  video: {
    webkitMediaControls: {
      display: "none"
    }
  },
  hover: {
    div: {
      opacity: 1
    }
  }
}, GC = {
  maxWidth: "100%",
  maxHeight: "100%"
}, jC = {
  opacity: 0,
  overflow: "hidden",
  transition: "opacity 0.35s ease-out",
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "rgba(0, 20, 46, 0.7)",
  color: e.semantic.color.text.onColor,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["5x"]} ${e.semantic.space["2x"]} ${e.semantic.space["5x"]}`,
  flexDirection: "column",
  focusWithin: {
    opacity: 1
  }
}, UC = {
  backgroundColor: "transparent",
  border: "none",
  color: e.semantic.color.text.onColor,
  marginRight: e.semantic.space["5x"],
  padding: "5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  svg: {
    width: e.semantic.space["5x"],
    height: e.semantic.space["5x"]
  },
  notDisabled: {
    cursor: "pointer",
    hover: {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderRadius: e.semantic.radius["2x"]
    },
    focusVisible: {
      outline: "none",
      boxShadow: `0 0 0 2px ${e.semantic.color.stroke.focus}`,
      borderRadius: e.semantic.radius["2x"]
    }
  },
  disabled: {
    color: "rgba(255, 255, 255, 0.4)"
  }
}, XC = {
  borderBottom: "2px solid transparent",
  padding: "5px 5px 3px 5px",
  notDisabled: {
    showSubtitles: {
      borderBottom: `2px solid ${e.semantic.color.stroke.focus}`,
      borderBottomLeftRadius: "initial",
      borderBottomRightRadius: "initial"
    }
  }
}, NC = {
  position: "relative",
  width: "100%",
  height: e.semantic.space["1x"],
  overflow: "hidden",
  marginBottom: e.semantic.space["2x"],
  background: "rgba(255, 255, 255, 0.4)",
  borderRadius: e.semantic.radius["2x"],
  cursor: "pointer",
  focusVisible: {
    outline: `${e.semantic.color.stroke.focus} solid 2px`,
    outlineOffset: "3px"
  },
  div: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    borderRadius: e.semantic.radius["2x"],
    width: 0,
    transition: "width 0.1s ease-out",
    nthOfType1: {
      background: e.semantic.color.action.default,
      zIndex: 1
    },
    nthOfType2: {
      background: "rgba(255, 255, 255, 0.4)"
    }
  }
}, YC = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-between"
}, ZC = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
}, KC = {
  display: "flex",
  alignItems: "center",
  ...e.semantic.typography.body.medium.XS,
  fontStyle: "normal",
  color: e.semantic.color.text.onColor
}, QC = {
  webkitAppearance: "none",
  maxWidth: 0,
  width: 0,
  height: "2px",
  transition: "all 0.3s ease-out",
  background: e.semantic.color.fill.default,
  cursor: "pointer",
  marginRight: 0,
  webkitSliderThumb: {
    WebkitAppearance: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: 0,
    height: 0,
    transition: "all 0.3s ease-out",
    background: e.semantic.color.fill.default,
    border: "none"
  },
  mozRangeThumb: {
    webkitAppearance: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: 0,
    height: 0,
    transition: "all 0.3s ease-out",
    background: e.semantic.color.fill.default,
    border: "none"
  },
  focus: {
    outline: "none"
  },
  tabletAndUp: {
    hover: {
      focusVisible: {
        outline: `${e.semantic.color.stroke.focus} solid 2px`,
        outlineOffset: "10px",
        width: "var(--volumeBarWidth)",
        maxWidth: "var(--volumeBarWidth)",
        marginRight: "18px",
        borderRadius: e.semantic.radius["2x"],
        webkitSliderThumb: {
          width: "var(--thumbSize)",
          height: "var(--thumbSize)"
        },
        mozRangeThumb: {
          width: "var(--thumbSize)",
          height: "var(--thumbSize)"
        }
      }
    }
  }
}, qC = {
  display: "flex",
  alignItems: "center",
  tabletAndUp: {
    hover: {
      inputTypeRange: {
        width: "var(--volumeBarWidth)",
        maxWidth: "var(--volumeBarWidth)",
        marginRight: "18px",
        webkitSliderThumb: {
          width: "var(--thumbSize)",
          height: "var(--thumbSize)"
        },
        mozRangeThumb: {
          width: "var(--thumbSize)",
          height: "var(--thumbSize)"
        }
      }
    }
  }
}, JC = {
  VolumeContainerButtonElement: { marginRight: "10px" },
  TimeContainer: {
    minWidth: "30px",
    marginRight: e.semantic.space["1x"]
  },
  SubtitlesButton: {
    width: "26px",
    height: e.semantic.space["5x"]
  },
  FullScreenButtonElement: {
    marginRight: 0
  }
}, e$ = {
  VideoPlayerContainer: VC,
  VideoPlayerElement: GC,
  VideoControls: jC,
  ButtonElement: UC,
  SubtitlesButton: XC,
  ProgressBar: NC,
  VideoButtonsContainer: YC,
  VideoButtonsSection: ZC,
  TimeContainer: KC,
  VolumeBar: QC,
  VolumeContainer: qC,
  InlineStyles: JC
}, t$ = {
  "--thumbSize": e.semantic.space["3x"],
  "--volumeBarWidth": e.semantic.space["14x"],
  display: "flex",
  position: "relative",
  maxWidth: "fit-content",
  maxHeight: "fit-content",
  video: {
    webkitMediaControls: {
      display: "none"
    }
  },
  hover: {
    div: {
      opacity: 1
    }
  }
}, o$ = {
  maxWidth: "100%",
  maxHeight: "100%"
}, i$ = {
  opacity: 0,
  overflow: "hidden",
  transition: "opacity 0.35s ease-out",
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "rgba(0, 20, 46, 0.7)",
  color: e.semantic.color.text.onColor,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: `${e.semantic.space["2x"]} ${e.semantic.space["5x"]} ${e.semantic.space["2x"]} ${e.semantic.space["5x"]}`,
  flexDirection: "column",
  focusWithin: {
    opacity: 1
  }
}, r$ = {
  backgroundColor: "transparent",
  border: "none",
  color: e.semantic.color.text.onColor,
  marginRight: e.semantic.space["5x"],
  padding: "5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  svg: {
    width: e.semantic.space["5x"],
    height: e.semantic.space["5x"]
  },
  notDisabled: {
    cursor: "pointer",
    hover: {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderRadius: e.semantic.radius["2x"]
    },
    focusVisible: {
      outline: "none",
      boxShadow: `0 0 0 2px ${e.semantic.color.stroke.focus}`,
      borderRadius: e.semantic.radius["2x"]
    }
  },
  disabled: {
    color: "rgba(255, 255, 255, 0.4)"
  }
}, a$ = {
  borderBottom: "2px solid transparent",
  padding: "5px 5px 3px 5px",
  notDisabled: {
    showSubtitles: {
      borderBottom: `2px solid ${e.semantic.color.stroke.focus}`,
      borderBottomLeftRadius: "initial",
      borderBottomRightRadius: "initial"
    }
  }
}, n$ = {
  position: "relative",
  width: "100%",
  height: e.semantic.space["1x"],
  overflow: "hidden",
  marginBottom: e.semantic.space["2x"],
  background: "rgba(255, 255, 255, 0.4)",
  borderRadius: e.semantic.radius["2x"],
  cursor: "pointer",
  focusVisible: {
    outline: `${e.semantic.color.stroke.focus} solid 2px`,
    outlineOffset: "3px"
  },
  div: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    borderRadius: e.semantic.radius["2x"],
    width: 0,
    transition: "width 0.1s ease-out",
    nthOfType1: {
      background: e.semantic.color.action.default,
      zIndex: 1
    },
    nthOfType2: {
      background: "rgba(255, 255, 255, 0.4)"
    }
  }
}, l$ = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-between"
}, s$ = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
}, c$ = {
  display: "flex",
  alignItems: "center",
  ...e.semantic.typography.body.medium.XS,
  fontStyle: "normal",
  color: e.semantic.color.text.onColor
}, d$ = {
  webkitAppearance: "none",
  maxWidth: 0,
  width: 0,
  height: "2px",
  transition: "all 0.3s ease-out",
  background: e.semantic.color.fill.default,
  cursor: "pointer",
  marginRight: 0,
  webkitSliderThumb: {
    WebkitAppearance: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: 0,
    height: 0,
    transition: "all 0.3s ease-out",
    background: e.semantic.color.fill.default,
    border: "none"
  },
  mozRangeThumb: {
    webkitAppearance: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: 0,
    height: 0,
    transition: "all 0.3s ease-out",
    background: e.semantic.color.fill.default,
    border: "none"
  },
  focus: {
    outline: "none"
  },
  tabletAndUp: {
    hover: {
      focusVisible: {
        outline: `${e.semantic.color.stroke.focus} solid 2px`,
        outlineOffset: "10px",
        width: "var(--volumeBarWidth)",
        maxWidth: "var(--volumeBarWidth)",
        marginRight: "18px",
        borderRadius: e.semantic.radius["2x"],
        webkitSliderThumb: {
          width: "var(--thumbSize)",
          height: "var(--thumbSize)"
        },
        mozRangeThumb: {
          width: "var(--thumbSize)",
          height: "var(--thumbSize)"
        }
      }
    }
  }
}, p$ = {
  display: "flex",
  alignItems: "center",
  tabletAndUp: {
    hover: {
      inputTypeRange: {
        width: "var(--volumeBarWidth)",
        maxWidth: "var(--volumeBarWidth)",
        marginRight: "18px",
        webkitSliderThumb: {
          width: "var(--thumbSize)",
          height: "var(--thumbSize)"
        },
        mozRangeThumb: {
          width: "var(--thumbSize)",
          height: "var(--thumbSize)"
        }
      }
    }
  }
}, m$ = {
  VolumeContainerButtonElement: { marginRight: "10px" },
  TimeContainer: {
    minWidth: "30px",
    marginRight: e.semantic.space["1x"]
  },
  SubtitlesButton: {
    width: "26px",
    height: e.semantic.space["5x"]
  },
  FullScreenButtonElement: {
    marginRight: 0
  }
}, u$ = {
  VideoPlayerContainer: t$,
  VideoPlayerElement: o$,
  VideoControls: i$,
  ButtonElement: r$,
  SubtitlesButton: a$,
  ProgressBar: n$,
  VideoButtonsContainer: l$,
  VideoButtonsSection: s$,
  TimeContainer: c$,
  VolumeBar: d$,
  VolumeContainer: p$,
  InlineStyles: m$
}, st = {
  mapCard: Bm,
  iconButton: Gc,
  landingHero: fp,
  secondaryNav: Ze,
  tableAccordion: Yy,
  accordion: fo,
  bulkActionBar: si,
  aspectRatio: yo,
  avatar: So,
  badge: Mo,
  barChart: Ao,
  blogVideo: Xo,
  breadcrumb: Qo,
  buttonGroup: di,
  button: Ht,
  card: b,
  cardIllustration: bi,
  cardIllustrationSection: Wi,
  carousel: Ai,
  charts: Xi,
  checkbox: xr,
  chip: Ar,
  closeButton: ie,
  columnChart: ia,
  creditCardInput: sa,
  ctaButton: xa,
  currencyInput: fa,
  dataList: Da,
  dataTable: xn,
  datePicker: Fn,
  disclosure: On,
  divider: jn,
  donutChart: Yn,
  drawer: ll,
  dropdownMenu: cl,
  dropdownMenuBase: Bl,
  featureText: Nl,
  fileUpload: ds,
  filter: Ss,
  flexContainer: Ts,
  globalAttributeBar: Fs,
  grid: Gs,
  heatMapChart: Qs,
  helperText: rc,
  hero: bc,
  heroVideo: Wc,
  image: Jc,
  incrementSelector: dd,
  inLineAlert: bd,
  inLineText: Ad,
  jumplink: ep,
  label: hp,
  landingHeroVideo: Cp,
  landingHeroVideoV1: Ap,
  landingPageVideo: Yp,
  link: sm,
  list: bm,
  mapMarker: Rm,
  marketingComparisonTable: au,
  marketingDataList: Eu,
  marketingList: tg,
  mediaDisclosureButton: rg,
  megaMenu: mg,
  menu: Sg,
  modalVideo: _g,
  modalWindow: Pg,
  pageHeader: ix,
  pagination: ux,
  phoneInput: Bx,
  photoGallery: Mx,
  photoGalleryLightbox: jx,
  photoGalleryThumbnail: Yx,
  popupTip: ch,
  progressBar: Wh,
  progressTracker: Eh,
  progressTrackerVertical: sb,
  radio: _b,
  raisedSurface: Gb,
  readOnlySection: r0,
  richText: k,
  spacer: vy,
  scatterPlotChart: n0,
  search: d0,
  searchInputLocation: g0,
  segmentControl: W0,
  selectInput: Q0,
  selectionCard: Sf,
  shareLinks: Uf,
  selectionTileCompact: Of,
  showMoreLess: Zf,
  sidePanel: sv,
  skeleton: pv,
  slider: Wv,
  slot: Zv,
  snackbar: sy,
  spinner: wy,
  switch: Ly,
  tabs: i1,
  tag: v1,
  textArea: M1,
  textDisclosure: X1,
  textInput: aC,
  timePickerInput: bC,
  tooltip: $C,
  topBanner: HC,
  videoPlayer: e$
}, g$ = {
  card: no,
  button: Wt,
  richText: xt
}, x$ = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  "&--box": {
    gap: e.semantic.space["3x"]
  }
}, h$ = {
  display: "flex",
  flexDirection: "column",
  borderBottom: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  background: e.semantic.color.background.default,
  "&:not(&--disabled):not(&--inactive).AccordionItem": {
    "&:hover": {
      borderBottom: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`
    },
    "&:has(.AccordionItem__summary:focus-visible)": {
      outlineOffset: `${e.semantic.borderWidth["2x"]}`,
      outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
      zIndex: 1,
      borderRadius: e.semantic.radius["2x"]
    },
    "&--inactive": {
      "&:hover": {
        borderBottom: `${e.semantic.borderWidth["1x"]} solid  ${e.semantic.color.stroke.default}`
      },
      "&:has(.AccordionItem__summary:focus-visible)": {
        borderBottom: 0
      }
    },
    "&--box": {
      "&:hover": {
        border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`
      },
      "&:has(.AccordionItem__summary:focus-visible)": {
        outlineOffset: `${e.semantic.borderWidth["2x"]}`,
        outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`
      }
    },
    "&--inactive&--box": {
      "&:hover": {
        outline: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`
      },
      "&:has(.AccordionItem__summary:focus-visible)": {
        outlineColor: e.semantic.color.stroke.default
      }
    }
  },
  "&--box": {
    borderRadius: e.semantic.radius["2x"],
    border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`
  },
  "&--disabled&--box": {
    background: e.semantic.color.fill.disabled
  },
  "&--disabled, &--inactive": {
    cursor: "not-allowed",
    "&:has(.AccordionItem__summary:focus-visible)": {
      outlineOffset: `${e.semantic.borderWidth["2x"]}`,
      outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
      zIndex: 1,
      borderRadius: e.semantic.radius["2x"]
    }
  }
}, b$ = {
  display: "flex",
  padding: `${e.semantic.space["4x"]} ${e.semantic.space["8x"]}`,
  background: e.semantic.color.background.default,
  flexDirection: "row",
  alignItems: "start",
  alignSelf: "stretch",
  cursor: "pointer",
  border: "none",
  ...e.semantic.typography.body.regular.S,
  "&:focus-visible": {
    outline: "none"
  },
  "&--box": {
    borderRadius: e.semantic.radius["2x"],
    borderBottom: "none"
  },
  ".AccordionItem__summary-dropdown": {
    marginRight: `-${e.semantic.space["2x"]}`
  },
  "&--dropdown": {
    alignItems: "center"
  },
  "&--disabled, &--inactive": {
    cursor: "not-allowed"
  },
  "&--disabled&--box": {
    background: e.semantic.color.fill.disabled
  }
}, ct = {
  display: "flex",
  alignItems: "start",
  gap: e.semantic.space["4x"],
  flex: 1,
  "--title-color": e.semantic.color.text.default,
  "--sub-title-color": e.semantic.color.text.subtle,
  "--leading-icon-color": e.semantic.color.icon.default,
  "--trailing-icon-color": e.semantic.color.icon.primary,
  color: "var(--title-color)",
  "&--dropdown": {
    alignItems: "center"
  },
  "&--disabled": {
    "--title-color": e.semantic.color.text.onDisabledStrong,
    "--sub-title-color": e.semantic.color.text.onDisabledStrong,
    "--leading-icon-color": e.semantic.color.icon.disabled,
    "--trailing-icon-color": e.semantic.color.icon.disabled
  }
}, f$ = {
  display: "flex",
  minHeight: e.semantic.space["6x"],
  justifyContent: "center",
  alignItems: "center",
  color: "var(--leading-icon-color)",
  svg: {
    width: e.semantic.space["5x"],
    height: e.semantic.space["5x"],
    color: ct.color
  }
}, v$ = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: 1,
  flexShrink: 0,
  ...e.semantic.typography.body.medium.M,
  fontStyle: "normal",
  "& .accordion-title-tag": {
    marginBottom: e.semantic.space["1x"]
  },
  h6: {
    "&:first-of-type": {
      marginTop: e.semantic.space["1x"]
    },
    margin: 0,
    ...e.semantic.typography.body.regular.S,
    color: "var(--sub-title-color)"
  },
  ".Accordion__title-content": {
    margin: 0,
    font: "inherit",
    color: "var(--title-color)",
    ...e.semantic.typography.body.medium.M
  }
}, y$ = {
  margin: 0
}, C$ = {
  display: "flex",
  width: e.semantic.space["6x"],
  height: e.semantic.space["6x"],
  justifyContent: "center",
  alignItems: "center",
  transition: "none",
  transform: "rotate(-180deg)",
  color: "var(--trailing-icon-color)",
  "&--animate": {
    transition: "transform 0.3s ease-in-out"
  },
  "&--open": {
    transform: "rotate(0deg)"
  }
}, $$ = {
  overflow: "hidden",
  boxSizing: "border-box",
  "&--disabled": {
    pointerEvents: "none"
  }
}, w$ = {
  width: "100%",
  boxSizing: "border-box",
  color: e.semantic.color.text.subtle,
  ...e.semantic.typography.body.regular.M,
  letterSpacing: "0",
  padding: `0px ${e.semantic.space["8x"]}`,
  paddingBottom: e.semantic.space["6x"]
}, k$ = {
  AccordionContainer: x$,
  AccordionItem: h$,
  Summary: b$,
  LeadingIcon: f$,
  TitleWrapper: ct,
  Title: v$,
  TrailingIcon: C$,
  Content: $$,
  AccordionPanel: w$,
  TitleContent: y$
}, S$ = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: e.semantic.space["4x"],
  [`@media ${i.tabletAndUp}`]: {
    flexDirection: "row",
    gap: e.semantic.space["6x"]
  },
  "&:empty": {
    display: "none"
  }
}, B$ = {
  Container: S$
}, T$ = {
  position: "relative",
  maxWidth: "100%",
  width: "fit-content",
  overflow: "hidden",
  flex: 1,
  boxSizing: "border-box",
  isolation: "isolate",
  "--carousel-gradient-width": e.semantic.space["5x"],
  display: "flex",
  alignItems: "center",
  "&--left": {
    "&::after": {
      content: '" "',
      position: "absolute",
      width: "var(--carousel-gradient-width)",
      height: "100%",
      top: 0,
      left: 0,
      backgroundImage: "linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%)"
    }
  },
  "&--right": {
    "&::before": {
      content: '" "',
      position: "absolute",
      width: "var(--carousel-gradient-width)",
      height: "100%",
      top: 0,
      right: 0,
      backgroundImage: "linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0) 100%)",
      zIndex: 1
    }
  },
  "&--centered": {
    margin: "auto"
  }
}, W$ = {
  zIndex: 1,
  "&.IconButton--primary.IconButton--oncolor": o({
    iconBtnHeight: "100%",
    iconBtnHoverBgColor: o("btnColor"),
    iconBtnBorderRadius: "none"
  })
}, L$ = {
  zIndex: 1,
  "&.IconButton--primary.IconButton--oncolor": o({
    iconBtnHeight: "100%",
    iconBtnHoverBgColor: o("btnColor"),
    iconBtnBorderRadius: "none"
  })
}, _$ = {
  overflowX: "auto",
  scrollBehavior: "smooth",
  overscrollBehavior: "contain",
  "&::-webkit-scrollbar": {
    display: "none"
  },
  "-ms-overflow-style": "none",
  scrollbarWidth: "none"
}, I$ = {
  Carousel: T$,
  PreviousButton: W$,
  NextButton: L$,
  CarouselContent: _$
}, M$ = {
  backgroundColor: "rgba(0 , 0, 0, 0)",
  width: "100vw",
  height: "100vh",
  zIndex: 0,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  position: "fixed"
}, D$ = {
  position: "relative",
  display: "inline-block",
  paddingBottom: "0",
  width: "fit-content",
  minWidth: "252px",
  "&--fullwidth": {
    width: "100%"
  },
  "&--small": {
    minWidth: "224px"
  },
  "&--large": {
    minWidth: "281px"
  }
}, H$ = {
  "--svg-wrapper-width-global": e.semantic.space["5x"],
  "--svg-wrapper-height-global": e.semantic.space["5x"],
  "&& input": {
    "&::placeholder": {
      color: e.semantic.color.text.placeholder
    },
    "&:hover:not(:disabled)": {
      cursor: "pointer"
    }
  },
  "&--disabled": {
    "&& input::placeholder": {
      color: e.semantic.color.text.onDisabledStrong
    },
    "& div[textsize] svg": {
      color: e.semantic.color.icon.disabled
    }
  },
  "&--editable": {
    "&& input:hover:not(:disabled)": {
      cursor: "text"
    }
  },
  "& div[textsize] svg": {
    color: e.semantic.color.icon.neutralStrong
  }
}, R$ = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: e.semantic.space["5x"],
  width: e.semantic.space["5x"],
  "& > svg": {
    color: e.semantic.color.icon.neutralStrong,
    "&:focus": {
      borderRadius: e.semantic.radius["1x"],
      outline: `${e.semantic.borderWidth["2x"]} solid ${e.semantic.color.stroke.focus}`,
      outlineOffset: e.semantic.space[".5x"]
    }
  },
  "& .DatePicker__Input--icon": {
    cursor: "pointer",
    zIndex: 1,
    height: `${e.semantic.space["4x"]}`,
    width: `${e.semantic.space["4x"]}`
  }
}, z$ = {
  display: "flex",
  alignItems: "center",
  fontSize: e.primitive.typography.fontSize[350],
  padding: `${e.semantic.space["2x"]} 0`,
  [`@media ${i.tabletAndUp}`]: {
    padding: 0
  }
}, A$ = {
  lineHeight: 0,
  zIndex: 1,
  opacity: 1,
  cursor: "pointer",
  transition: "opacity 0.2s, transform 0.2s",
  background: "transparent",
  "&--hidden": {
    opacity: 0,
    pointerEvents: "none"
  }
}, F$ = {
  flex: 1,
  position: "relative"
}, P$ = {
  display: "flex",
  alignItems: "center",
  position: "absolute",
  top: 0,
  bottom: 0,
  left: "50%",
  willChange: "transform, opacity",
  backfaceVisibility: "hidden",
  transform: "translateZ(0)",
  transition: "opacity var(--animation-duration), transform var(--animation-duration)",
  lineHeight: 1,
  "& > *": {
    padding: "0.2em, 0.5em",
    border: "1px solid transparent",
    display: "flex",
    justifyContent: "content",
    alignItems: "center",
    transform: "translateX(0) scale(1)",
    willChange: "transform",
    borderRadius: "5px"
  },
  "&.-hiddenNext": {
    opacity: 0,
    transform: "translateX(50%)"
  },
  "&.-hiddenPrevious": {
    opacity: 0,
    transform: "translateX(-150%)"
  },
  "&.-shown": {
    opacity: 1,
    marginTop: "auto",
    marginBottom: "auto",
    transform: "translateX(-50%)"
  },
  "&.-shownAnimated": {
    animation: "var(--animation-duration) fadeTextToCenter forwards"
  },
  "&:not(.-shown) > *, > *.-hidden": {
    cursor: "default",
    pointerEvents: "none"
  },
  "&:not(.-shown) > *": {
    pointerEvents: "none"
  }
}, O$ = {
  "&.Calendar__yearText.-hidden": {
    transform: "translateX(50%)",
    opacity: 0
  },
  "&.Calendar__monthText.-hidden": {
    transform: "translateX(-50%)",
    opacity: 0
  },
  width: "fit-content"
}, E$ = {
  position: "absolute",
  width: "100%",
  height: "84%",
  right: 0,
  left: 0,
  bottom: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  borderRadius: `0 0 ${e.semantic.radius["3x"]} ${e.semantic.radius["3x"]}`,
  "&.-open": {
    zIndex: 10,
    borderTop: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`
  }
}, V$ = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, G$ = {
  display: "flex",
  flexWrap: "wrap",
  position: "relative",
  zIndex: 2,
  gap: e.semantic.space["1x"],
  backgroundColor: e.semantic.color.fill.default,
  transform: "translateY(-150%)",
  willChange: "transform",
  transition: "transform 0.6s",
  height: "100%",
  alignContent: "flex-start",
  scrollBarWidth: "none",
  overflow: "scroll",
  width: "100%",
  padding: `0 ${e.semantic.space["2x"]}`,
  "-ms-overflow-style": "none",
  "&::-webkit-scrollbar": {
    display: "none"
  },
  [`@media ${i.tabletAndUp}`]: {
    padding: `0 ${e.semantic.space["4x"]}`
  },
  "&.-open": {
    transform: "translateY(0)"
  },
  "&.monthSelector": {
    alignContent: "center",
    borderRadius: `0 0 ${e.semantic.radius["3x"]} ${e.semantic.radius["3x"]}`,
    padding: `0 ${e.semantic.space["2x"]}`,
    [`@media ${i.tabletAndUp}`]: {
      padding: `0 ${e.semantic.space["4x"]}`
    }
  }
}, j$ = {
  width: "calc(25% - 3px)",
  display: "flex",
  justifyContent: "center",
  "&:not(.-active) .Calendar__yearSelectorText:not(:disabled)": {
    "&:hover, &:focus": {
      borderRadius: e.semantic.radius["1x"],
      border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.focus}`
    }
  },
  "&.-active .Calendar__yearSelectorText": {
    backgroundColor: e.semantic.color.fill.primaryStrong,
    color: e.semantic.color.text.onColor,
    "&:focus-visible": {
      outline: `2px solid ${e.semantic.color.stroke.focus} !important`,
      outlineOffset: "2px"
    }
  }
}, U$ = {
  border: "none",
  height: "40px",
  width: "73px",
  fontSize: e.primitive.typography.fontSize[350],
  fontFamily: e.primitive.typography.fontFamilies.inter,
  cursor: "pointer",
  background: "none",
  borderRadius: e.semantic.radius["1x"],
  color: e.semantic.color.text.default,
  transition: "opacity 0.3s, transform 0.3s",
  "&:focus": {
    background: "none"
  },
  "&:disabled": {
    opacity: 0.5,
    cursor: "default"
  }
}, X$ = {
  width: "calc(25% - 3px)",
  display: "flex",
  justifyContent: "center",
  borderRadius: e.semantic.radius["1x"],
  borderWidth: e.semantic.borderWidth["1x"],
  "&:not(.-active) .Calendar__monthSelectorItemText:not(:disabled)": {
    "&:hover, &:focus": {
      borderRadius: e.semantic.radius["1x"],
      border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.onColor}`
    }
  },
  "&.-active .Calendar__monthSelectorItemText": {
    backgroundColor: e.semantic.color.fill.primaryStrong,
    color: e.semantic.color.text.onColor,
    "&:focus-visible": {
      outline: `2px solid ${e.semantic.color.stroke.focus}`,
      outlineOffset: "2px"
    }
  }
}, N$ = {
  position: "relative",
  overflow: "hidden",
  minHeight: "260px"
}, Y$ = {
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  top: 0,
  left: 0,
  gap: e.semantic.space["1x"],
  width: "100%",
  willChange: "transform, opacity",
  transform: "translateZ(0)",
  backfaceVisibility: "hidden",
  transition: "var(--animation-duration)",
  "&.-hiddenPrevious": {
    opacity: "0.5",
    transform: "translateX(-100%)"
  },
  "&.-hiddenNext": {
    opacity: "0.5",
    transform: "translateX(100%)"
  },
  "&.-shown": {
    opacity: "1",
    transform: "translateX(0)"
  },
  "&.-shownAnimated": {
    animation: "var(--animation-duration) FadeContentToCenter forwards"
  }
}, Z$ = {
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  "&:last-of-type": {
    justifyContent: "flex-start",
    ".Calendar__day": {
      marginRight: "0",
      [`@media ${i.tabletAndUp}`]: {
        marginRight: "3.5px"
      }
    }
  }
}, K$ = {
  minWidth: e.semantic.space["10x"],
  height: e.semantic.space["10x"],
  textAlign: "center",
  padding: 0,
  margin: 0,
  transition: "background 0.2s, transform 0.2s, opacity 0.2s",
  border: "1px solid transparent",
  color: e.semantic.color.text.default,
  ...e.semantic.typography.body.regular.S,
  borderRadius: e.semantic.radius["1x"],
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  position: "relative",
  "&:not(.-blank):not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween):not(.-selected)": {
    "&:focus": {
      borderRadius: e.semantic.radius["1x"],
      borderColor: e.semantic.color.stroke.focus,
      borderWidth: e.semantic.borderWidth["1x"]
    },
    "&:not(.-disabled)&:hover": {
      borderRadius: e.semantic.radius["1x"],
      borderColor: e.semantic.color.stroke.focus,
      borderWidth: e.semantic.borderWidth["1x"]
    }
  },
  "&.-selected, &.-selectedStart, &.-selectedEnd": {
    color: e.semantic.color.text.onColor,
    backgroundColor: e.semantic.color.fill.primaryStrong
  },
  "&.-ltr.-selectedStart, &.-rtl.-selectedStart": {
    selectedBorderRadius: "100em 0 0 100em"
  },
  "&.-selectedBetween": {
    backgroundColor: e.semantic.color.fill.primaryStrong,
    borderRadius: 0
  },
  "&.-selectedEnd": {
    "&.-ltr": {
      borderTopRightRadius: "100em",
      borderBottomRightRadius: "100em"
    },
    "&.-rtl": {
      borderTopLeftRadius: "100em",
      borderBottomLeftRadius: "100em"
    }
  },
  "&.-selectedStart": {
    "&.-rtl": {
      borderTopRightRadius: "100em",
      borderBottomRightRadius: "100em"
    },
    "&.-ltr": {
      borderTopLeftRadius: "100em",
      borderBottomLeftRadius: "100em"
    }
  },
  [`&.-weekend:not(.-selected):not(.-blank):not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween), 
    &.-outofmonth:not(.-selected):not(.-blank):not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween)`]: {
    color: e.semantic.color.text.placeholder
  },
  [`&.-weekend.-today:not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween)::after,  
    &.-outofmonth.-today:not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween)::after`]: {
    background: e.semantic.color.text.placeholder
  },
  "&.-disabled ": {
    cursor: "not-allowed",
    pointerEvents: "all",
    backgroundColor: e.semantic.color.action.disabled,
    borderRadius: e.semantic.radius["1x"],
    color: e.semantic.color.text.onDisabledStrong,
    borderColor: "transparent"
  },
  "&.-selected": {
    borderRadius: e.semantic.radius["1x"],
    borderWidth: e.semantic.borderWidth["1x"],
    backgroundColor: e.semantic.color.fill.primaryStrong
  },
  "&.-today": {
    "&:not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween)": {
      borderRadius: e.semantic.radius["1x"],
      position: "relative",
      borderWidth: e.semantic.borderWidth["1x"],
      "&:not(&.-text) ::after": {
        content: "'•' / ''",
        position: "absolute",
        background: "transparent",
        top: "22px",
        left: "16.5px",
        fontSize: e.primitive.typography.fontSize[300],
        opacity: 1
      }
    },
    "&:hover:not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween)::after": {
      opacity: 0
    }
  },
  "&.-blank": {
    color: "transparent",
    cursor: "default",
    pointerEvents: "none"
  },
  "&.-text": {
    "& > div:first-child": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      "& > span.Calendar__day--text-marker": {
        fontSize: "10px",
        lineHeight: "14px",
        maxWidth: "40px",
        overflow: "hidden",
        textOverflow: "clip",
        whiteSpace: "nowrap"
      }
    }
  }
}, dt = {
  margin: 0,
  boxSizing: "border-box",
  direction: "rtl",
  "--animation-duration": "0.4s",
  fontSize: "11px",
  background: e.semantic.color.fill.default,
  boxShadow: "0 1em 4em rgba(0, 0, 0, 0.07)",
  border: `${e.semantic.borderWidth["1x"]} solid ${e.semantic.color.stroke.default}`,
  borderRadius: e.semantic.radius["3x"],
  position: "relative",
  userSelect: "none",
  display: "flex",
  flexDirection: "column",
  zIndex: 10,
  gap: e.semantic.space["2x"],
  padding: e.semantic.space["2x"],
  width: "298px",
  [`@media ${i.tabletAndUp}`]: {
    padding: e.semantic.space["2x"],
    width: "320px"
  },
  "*": {
    margin: 0,
    boxSizing: "border-box",
    direction: "ltr"
  },
  "&.-rtl *": {
    direction: "rtl"
  },
  "&.-rtl .Calendar__section.-hiddenPrevious": {
    transform: "translateX(100%)"
  },
  "&.-rtl .Calendar__section.-hiddenNext": {
    transform: "translateX(-100%)"
  },
  "&.-noFocusOutline *:focus": {
    outline: "none"
  },
  "&.-rtl .Calendar__monthArrowWrapper.-left": {
    transform: "rotate(-90deg)"
  },
  "&.-rtl .Calendar__monthArrowWrapper.-right": {
    transform: "rotate(90deg)"
  },
  "&.-rtl .Calendar__monthYear.-hiddenNext": {
    transform: "translateX(-150%)"
  },
  "&.-rtl .Calendar__monthYear.-hiddenPrevious": {
    transform: "translateX(50%)"
  },
  "&.-rtl .Calendar__monthText:hover": {
    transform: "translateX(0.2em) scale(0.95)"
  },
  "&.-rtl .Calendar__yearText:hover": {
    transform: "translateX(-0.2em) scale(0.95)"
  },
  "&.-rtl .Calendar__monthYear .Calendar__yearText.-hidden": {
    transform: "translateX(-50%)"
  },
  "&.-rtl .Calendar__monthYear .Calendar__monthText.-hidden": {
    transform: "translateX(50%)"
  }
}, Q$ = {
  display: "flex",
  justifyContent: "space-between",
  color: e.semantic.color.text.placeholder,
  ...e.semantic.typography.body.semiBold.S,
  padding: 0,
  position: "relative"
}, q$ = {
  minWidth: e.semantic.space["10x"],
  height: e.semantic.space["5x"],
  display: "block",
  padding: e.semantic.space[".5x"],
  textAlign: "center",
  textDecoration: "none"
}, J$ = {
  position: "absolute",
  "&--exceedOverflow": {
    position: "fixed",
    width: dt.width
  },
  top: `calc(100% + ${e.semantic.space["2x"]})`,
  transform: "translateY(2.5em)",
  opacity: 1,
  animation: "fadeCalendar 0.3s forwards",
  zIndex: 2,
  "&.-top": {
    top: "auto",
    bottom: "calc(100% - 20px)"
  },
  left: "unset !important"
}, ew = {
  // Component styles
  StyledTransparentBackground: M$,
  StyledDatePickerWrapper: D$,
  StyledDatePickerCalenderContainer: J$,
  // Calendar Input
  StyledCalendarPickerInput: H$,
  StyledIconWrapper: R$,
  // Calender Header
  StyledCalenderHeader: z$,
  StyledIconButton: A$,
  StyledMonthYearContainer: F$,
  StyledMonthYearWrapper: P$,
  StyledButton: O$,
  // Calender Selector
  StyledCalendarSelectorAnimationWrapper: E$,
  StyledCalendarSelectorWrapper: V$,
  StyledCalendarSelector: G$,
  StyledCalendarYearSelectorItem: j$,
  StyledCalendarSelectorText: U$,
  StyledCalenderMonthSelectorItem: X$,
  // DayList
  StyledCalendarSectionWrapper: N$,
  StyledCalendarSection: Y$,
  StyledCalendarWeekRow: Z$,
  StyledCalendarDay: K$,
  // Calender
  StyledCalendar: dt,
  StyledCalendarWeekDays: Q$,
  StyledCalendarWeekDay: q$
}, tw = {
  "--_hero-container": "var(--hero-container, Hero / inline-size)",
  "--_hero-min-height": "var(--hero-min-height, 640px)",
  display: "flex",
  width: "100%",
  height: "auto",
  position: "relative",
  overflow: "hidden",
  isolation: "isolate",
  container: "var(--_hero-container)",
  minHeight: "var(--_hero-min-height)",
  [`@media ${i.mobile}`]: {
    "--_hero-min-height": "var(--hero-min-height, 650px)"
  },
  "&--dark": {
    "--_hero-text-color": `var(--hero-text-color, ${e.semantic.color.text.onColor})`,
    "--_hero-bg-color": `var(--hero-bg-color, ${e.semantic.color.fill.neutralStrong})`
  },
  "&--light": {
    "--_hero-text-color": `var(--hero-text-color, ${e.semantic.color.text.default})`,
    "--_hero-bg-color": `var(--hero-bg-color, ${e.semantic.color.fill.onColor})`
  }
}, ow = {
  position: "absolute",
  inset: 0,
  zIndex: 0,
  width: "100%",
  height: "100%",
  background: `color-mix(
    in srgb, 
    var(--_hero-overlay-color), 
    transparent var(--_hero-overlay-color-opacity)
  )`,
  "&--dark": {
    "--_hero-overlay-color": `var(--hero-overlay-color, ${e.semantic.color.fill.neutralStrong})`,
    "--_hero-overlay-color-opacity": "var(--hero-overlay-color-opacity, 30%)"
  },
  "&--dark&--playing": {
    "--_hero-overlay-color-opacity": "var(--hero-overlay-playing-color-opacity, 50%)"
  },
  "&--light": {
    "--_hero-overlay-color": `var(--hero-overlay-color, ${e.semantic.color.fill.onColor})`,
    "--_hero-overlay-color-opacity": "var(--hero-overlay-color-opacity, 70%)"
  },
  "&--light&--playing": {
    "--_hero-overlay-color-opacity": "var(--hero-overlay-playing-color-opacity, 90%)"
  }
}, iw = {
  "--_hero-content-gap": `var(--hero-content-gap, ${e.semantic.space["3x"]})`,
  "--_hero-content-padding-block": "var(--hero-content-padding-block, 56px)",
  "--_hero-content-padding-inline": "var(--hero-content-padding-inline, 26px)",
  "--_hero-navbar-height": "var(--hero-navbar-height, 80px)",
  "--_hero-content-max-width": "var(--hero-content-max-width, 100%)",
  position: "relative",
  display: "inline-flex",
  flexDirection: "column",
  zIndex: 1,
  boxSizing: "border-box",
  width: "100%",
  paddingInline: "var(--_hero-content-padding-inline, 26px)",
  paddingBlock: "var(--_hero-content-padding-block, 56px)",
  gap: "var(--_hero-content-gap)",
  overflow: "hidden",
  color: "var(--_hero-text-color)",
  maxWidth: "var(--_hero-content-max-width)",
  "&--left, &--top-left, &--bottom-left": {
    textAlign: "left",
    alignItems: "start"
  },
  "&--right, &--top-right, &--bottom-right": {
    textAlign: "right",
    alignItems: "end"
  },
  "&--center, &--top, &--bottom": {
    alignItems: "center",
    textAlign: "center"
  },
  "&--cover-navbar&": {
    marginTop: "var(--_hero-navbar-height)"
  },
  [`@container Hero ${i.laptopAndUp}`]: {
    "--_hero-content-padding-inline": "var(--hero-content-padding-inline, 68px)",
    paddingInline: "var(--_hero-content-padding-inline, 68px)"
  },
  [`@container Hero ${i.mobile}`]: {
    "--_hero-content-padding-block": "var(--hero-content-padding-block, 56px)",
    paddingBlock: "var(--_hero-content-padding-block, 56px)"
  },
  [`@container Hero ${i.wideScreenAndUp}`]: {
    "--_hero-content-padding-inline": "var(--hero-content-padding-inline, 3rem)",
    "--_hero-content-max-width": "var(--hero-content-max-width, calc(1440px + var(--_hero-content-padding-inline, 0)))",
    marginInline: "auto"
  },
  ".Text": {
    textWrap: "pretty",
    color: "inherit"
  },
  ">*:only-child, >*:first-child": {
    margin: 0
  },
  "&:empty": {
    display: "none"
  }
}, rw = {
  ...e.semantic.typography.headline.XXL,
  margin: 0,
  textWrap: "balance",
  color: "inherit",
  maxWidth: "var(--_hero-content-title-max-width)",
  "--_hero-content-title-max-width": "var(--hero-content-title-max-width, 100%)",
  [`@container Hero ${i.tabletAndUp}`]: {
    "--_hero-content-title-max-width": "var(--hero-content-title-max-width, max(67%, 800px))"
  }
}, aw = {
  ...e.semantic.typography.body.medium.L,
  margin: 0,
  textWrap: "pretty",
  color: "inherit",
  maxWidth: "var(--_hero-content-body-max-width)",
  "--_hero-content-body-max-width": "var(--hero-content-body-max-width, 100%)",
  [`@container Hero ${i.tabletAndUp}`]: {
    "--_hero-content-body-max-width": "var(--hero-content-body-max-width, max(67%, 800px))"
  },
  [`@container Hero ${i.mobile}`]: {
    ...e.semantic.typography.body.regular.M
  }
}, nw = {
  "--_hero-btn-group-gap": `var(--hero-button-group-gap, ${e.semantic.space["7x"]})`,
  display: "inline-flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  marginTop: e.semantic.space["3x"],
  gap: "var(--_hero-btn-group-gap)",
  [`@container Hero ${i.mobile}`]: {
    width: "100%",
    marginBottom: e.semantic.space["3x"],
    "--_hero-btn-group-gap": `var(--hero-button-group-gap, ${e.semantic.space["6x"]})`,
    ".Button:not(.IconButton)": {
      width: "100%",
      textAlign: "center",
      whiteSpace: "normal"
    }
  },
  "&:empty": {
    display: "none"
  }
}, lw = {
  "&--floating": {
    position: "absolute",
    zIndex: "1",
    inset: "var(--_hero-floating-playback-button-position)",
    "--_hero-floating-playback-button-position": `var(--hero-floating-playback-button-position, auto auto ${e.semantic.space["6x"]} ${e.semantic.space["6x"]})`
  }
}, sw = {
  inset: "var(--_hero-disclosure-position)",
  "--_hero-disclosure-position": "var(--hero-disclosure-position, auto 20px 8px auto)",
  [`@container Hero ${i.laptopAndUp}`]: {
    "--_hero-disclosure-position": "var(--hero-disclosure-position, auto 108px 25px auto)"
  }
}, cw = {
  Hero: tw,
  PlaybackButton: lw,
  DisclosureButtons: sw,
  MediaOverlay: ow,
  Contents: iw,
  Title: rw,
  Body: aw,
  ButtonGroup: nw
}, dw = {
  height: "100%",
  width: "100%",
  minHeight: "350px",
  overflowX: "auto"
}, pw = {
  Wrapper: dw
}, mw = {
  "&.vertical-spacing-small": {
    marginBottom: e.semantic.space["6x"],
    [`@media ${i.mobile}`]: {
      marginBottom: e.semantic.space["4x"]
    }
  },
  "&.vertical-spacing-medium": {
    marginBottom: "48px",
    [`@media ${i.mobile}`]: {
      marginBottom: e.semantic.space["6x"]
    }
  },
  "&.vertical-spacing-large": {
    marginBottom: e.semantic.space["24x"],
    [`@media ${i.mobile}`]: {
      marginBottom: e.semantic.space["12x"]
    }
  }
}, uw = {
  AemSpacer: mw
}, pt = {
  mapCard: Le,
  iconButton: Kc,
  landingHero: yp,
  secondaryNav: Ze,
  tableAccordion: ot,
  accordion: k$,
  bulkActionBar: oe,
  aspectRatio: $o,
  avatar: Wo,
  badge: J,
  barChart: ee,
  blogVideo: te,
  breadcrumb: oi,
  buttonGroup: B$,
  button: K,
  card: q,
  cardIllustration: ki,
  cardIllustrationSection: Mi,
  carousel: I$,
  charts: tr,
  checkbox: Wr,
  chip: Xr,
  closeButton: ea,
  columnChart: na,
  creditCardInput: re,
  ctaButton: ae,
  currencyInput: Ca,
  dataList: ja,
  dataTable: F,
  datePicker: ew,
  disclosure: Vn,
  divider: Xn,
  donutChart: se,
  drawer: ce,
  dropdownMenu: pl,
  dropdownMenuBase: El,
  featureText: Jl,
  fileUpload: ys,
  filter: me,
  flexContainer: Ls,
  globalAttributeBar: ue,
  grid: Ys,
  heatMapChart: ec,
  helperText: sc,
  hero: cw,
  heroVideo: Pc,
  image: od,
  incrementSelector: ge,
  inLineAlert: kd,
  inLineText: Kd,
  jumplink: rp,
  label: xe,
  landingHeroVideo: $p,
  landingHeroVideoV1: Te,
  landingPageVideo: am,
  link: pm,
  list: We,
  mapMarker: _e,
  marketingComparisonTable: Lu,
  marketingDataList: De,
  marketingList: He,
  mediaDisclosureButton: Re,
  megaMenu: ze,
  menu: Ae,
  modalVideo: Fe,
  modalWindow: Yg,
  pageHeader: Pe,
  pagination: wx,
  phoneInput: Lx,
  photoGallery: Oe,
  photoGalleryLightbox: Ee,
  photoGalleryThumbnail: Ve,
  popupTip: kh,
  progressBar: Mh,
  progressTracker: Kh,
  progressTrackerVertical: yb,
  radio: Ob,
  raisedSurface: Xb,
  readOnlySection: Ue,
  richText: z,
  spacer: uw,
  scatterPlotChart: pw,
  search: Xe,
  sidePanel: Je,
  searchInputLocation: Ne,
  segmentControl: R0,
  selectInput: gf,
  selectionCard: Rf,
  shareLinks: Qe,
  selectionTileCompact: Ke,
  showMoreLess: qe,
  skeleton: et,
  slider: Uv,
  slot: Jv,
  snackbar: by,
  spinner: tt,
  switch: Ry,
  tabs: m1,
  tag: B1,
  textArea: F1,
  textDisclosure: eC,
  textInput: dC,
  timePickerInput: at,
  tooltip: TC,
  topBanner: EC,
  videoPlayer: u$
};
var gw = /* @__PURE__ */ ((a) => (a.FORD_PRO = "pro", a.FORD_CREDIT = "credit", a))(gw || {}), xw = /* @__PURE__ */ ((a) => (a.DARK_MODE = "dark", a.LIGHT_MODE = "light", a))(xw || {});
const hw = {
  themeName: "pro",
  mode: "light",
  componentStyles: U,
  globalStyles: Y,
  components: pt,
  icons: {},
  colors: {
    page: {
      backgroundColor: e.semantic.color.background.neutral,
      color: e.semantic.color.text.default,
      subtleFill: e.semantic.color.fill.neutralSubtle
    }
  },
  fonts: {
    ...e.semantic.typography.body.regular.M,
    color: e.semantic.color.text.default
  }
}, bw = {
  themeName: "pro",
  mode: "dark",
  componentStyles: U,
  globalStyles: Y,
  components: {
    ...pt,
    ...g$
  },
  icons: {},
  colors: {
    page: {
      backgroundColor: e.semantic.color.fill.neutralStrong,
      color: e.semantic.color.text.onColor,
      subtleFill: e.semantic.color.fill.neutralSubtle
    }
  },
  fonts: {
    ...e.semantic.typography.body.regular.M,
    color: e.semantic.color.text.onColor
  }
}, fw = {
  light: hw,
  dark: bw
}, vw = {
  themeName: "credit",
  mode: "light",
  componentStyles: X,
  globalStyles: N,
  components: st,
  icons: {},
  colors: {
    page: {
      backgroundColor: t.primitive.color.twilight["000"].value,
      color: t.primitive.color.twilight[1e3].value,
      subtleFill: t.semanticMode1.color.fill.onLight.subtle.value
    }
  },
  fonts: {
    ...t.semanticMode1.body1.regular.value,
    color: t.primitive.color.neutral[1e3].value
  }
}, yw = {
  themeName: "credit",
  mode: "dark",
  componentStyles: X,
  globalStyles: N,
  components: {
    ...st,
    ...lo
  },
  icons: {},
  colors: {
    page: {
      backgroundColor: t.primitive.color.twilight[1e3].value,
      color: t.primitive.color.twilight["000"].value,
      subtleFill: t.semanticMode1.color.fill.onDark.subtle.value
    }
  },
  fonts: {
    ...t.semanticMode1.body1.regular.value,
    color: t.primitive.color.twilight["000"].value
  }
}, Cw = {
  light: vw,
  dark: yw
}, Lw = {
  pro: fw,
  credit: Cw
};
export {
  xw as M,
  Lw as T,
  gw as a,
  bw as b,
  fw as c,
  vw as d,
  yw as e,
  Cw as f,
  H as g,
  Tw as h,
  _ as i,
  p as j,
  Ww as m,
  hw as p,
  s as z
};
